// ═══════════════════════════════════════════════════════════════
// MNL GLOBAL — script transversal (toutes pages)
// ═══════════════════════════════════════════════════════════════
//
// VAGUE 189 — API PUBLIQUE EXPOSÉE (window.mnl*) — référence pour intégrations
// ───────────────────────────────────────────────────────────────
//
// CART / PRODUIT
//   window.MNL_PRODUCT_URL       — URL pre-workout résolue par Liquid (jamais 404, fallback /collections/all)
//   window.MNL_PRODUCT_HANDLE    — handle Shopify (string, si produit existe)
//   window.mnlCartOpen()         — ouvre le drawer cart canonique (header)
//   window.mnlCartClose()        — ferme le drawer cart
//   window.mnlFlyToCart(img)     — animation fly-to-cart depuis img source
//
// WISHLIST MULTI-LISTES (vagues 174-183)
//   window.mnlGetWishlist()                              — items de la liste active (backward compat)
//   window.mnlGetWishlistLists()                         — [{id, name, icon, count, active}, ...]
//   window.mnlGetActiveWishlistId()                      — id de la liste active
//   window.mnlSetActiveWishlistId(id)                    — switch active list
//   window.mnlCreateWishlistList(name, icon)             — crée une nouvelle liste (cap 10)
//   window.mnlRenameWishlistList(id, newName)            — renomme une liste
//   window.mnlDeleteWishlistList(id)                     — supprime (refuse la dernière)
//   window.mnlMoveWishlistItem(handle, fromId, toId)     — déplace un item entre listes
//   window.mnlReorderWishlistItems(listId, newOrder)     — réordonne items (newOrder = handles[])
//   window.mnlEncodeWishlistList(listId)                 — encode liste en base64 URL-safe (sharing)
//   window.mnlDecodeWishlistList(b64)                    — decode + sanitize
//   window.mnlImportSharedWishlist(decoded)              — importe la liste partagée (cap 10)
//   window.mnlGetWishlistSnapshots()                     — historique snapshots (undo)
//   window.mnlRestoreWishlistSnapshot(ts)                — restaure un snapshot par timestamp
//   window.mnlClearWishlistSnapshots()                   — wipe historique
//
// ÉVÉNEMENTS WISHLIST (document.dispatchEvent)
//   mnl:wishlist:updated         { detail: items[] }       — items liste active modifiés
//   mnl:wishlist:lists:updated   { detail: state }         — listes (création/suppression/switch)
//   mnl:wishlist:added           { detail: {handle, title} } — item ajouté
//   mnl:wishlist:removed         { detail: {handle, title} } — item retiré
//
// LOYALTY / POINTS (vague 113+)
//   window.mnlAddLoyaltyPoints(n, reason)    — ajoute des points + toast tier-up
//
// UTILITAIRES
//   window.mnlLockScroll() / mnlUnlockScroll()   — lock/unlock body scroll (modals)
//   window.mnlToast({icon, title, sub, type, duration, actionLabel, action})
//   window.mnlToastError(title, sub)
//   window.mnlConfirm({icon, title, message, confirmLabel, cancelLabel, onConfirm})
//   ── PANNEAUX (V1237, 04/08/2026) : plus aucune boîte native sur les pages boutique.
//   window.mnlConfirm({title, messageText, confirmText, cancelText, type, dismissible}) → Promise<bool>
//        type:'danger' ⇒ NI Échap NI clic à côté : il faut choisir un bouton (action irréversible)
//   window.mnlPrompt({title, label, hint, placeholder, required, validate, maxLength}) → Promise<string|null>
//   window.mnlPromptFields({title, fields:[{name,label,hint,required,optional}]})       → Promise<obj|null>
//   window.mnlAlert({title, messageText, type})                                          → Promise<void>
//        `messageText` est ÉCHAPPÉ ; `message` reste un emplacement HTML (usage auteur seulement)
//   window.mnlHaptic('tick'|'success'|'warn')
//   window.mnlConfetti({count, colors})
//   window.mnlSetTheme('dark'|'light')
//   window.mnlOnDomChange(fn, debounceMs)         — observer DOM mutations
//   window.mnlSafeLS                              — localStorage safe wrapper (gère QuotaExceeded)
//   window.mnlTrackEvent(name, params)            — GA4/dataLayer tracking
//
// ═══════════════════════════════════════════════════════════════

// AUTO-DÉTECTION URL produit pré-workout — priorité au VRAI handle MNL
// Vague 150 : élargi les fallbacks (handles FR/anglais variants) + fallback ultime = /collections/all (toujours valide)
// au lieu d'une URL hardcodée qui peut être 404 sur certains stores.(function(){ try { window.MNL_PRODUCT_URL = "\/collections\/all"; } catch(_){} })();// ════════════ MNL FETCH DISPATCHER (vague 56) ════════════
// Centralise UN SEUL wrap de window.fetch pour dispatcher des events `mnl:cart:mutated`.
// Avant : 2-3 wraps en chaîne (cart-drawer + free-shipping + others) → coût latence + risk de stack.
// Maintenant : tous les consumers écoutent l'event au lieu de re-wrapper.
// Doit être PLACÉ AVANT toute autre code qui touche window.fetch.
(function(){
  if (window.__mnlFetchPatched) return;
  window.__mnlFetchPatched = true;
  var origFetch = window.fetch;
  if (!origFetch) return;
  window.fetch = function(){
    var args = arguments;
    var p = origFetch.apply(this, args);
    try {
      var url = args[0];
      var urlStr = (typeof url === 'string') ? url : (url && url.url) || '';
      // Détecte les mutations cart Shopify
      if (/\/cart\/(add|change|update|clear)/.test(urlStr)) {
        p.then(function(resp){
          // Dispatch event avec resp clonée pour permettre aux consumers de lire le body
          try {
            var detail = { url: urlStr, action: urlStr.match(/\/cart\/(\w+)/)[1] };
            try { detail.resp = resp.clone(); } catch(_){}
            document.dispatchEvent(new CustomEvent('mnl:cart:mutated', { detail: detail }));
          } catch(_){}
        }).catch(function(){});
      }
    } catch(_){}
    return p;
  };
})();

(function () {
  'use strict';

  // ════════════ V326 — FADE-IN PAGE RETIRÉ (bug user "charge deux fois") ════════════
  // AVANT : `body.mnl-page-loading{opacity:0}` ajouté au JS start (ligne 118), retiré sur `window.load`.
  // PROBLÈME : window.load fire APRÈS que TOUTES les images, fonts, scripts async, vidéos soient chargés.
  // Sur pages denses (comparator table, notre-histoire 505 lignes, engagements 413 lignes) cela prend
  // 500ms-1.5s. Pendant ce temps, body est opacity:0 → page totalement INVISIBLE même si le DOM est prêt.
  // Puis fade-in .25s déclenche → user perçoit : flash bref → blanc → fade-in = "anime/charge deux fois".
  // MAINTENANT : on n'applique plus du tout `mnl-page-loading` au boot. La page apparaît instantanément
  // avec le rendu natif du browser (= comportement standard de tous les sites modernes).
  // Le fade-out `body.mnl-page-leaving` reste pour la transition sortante (V324).
  // Si quelqu'un veut ré-activer un fade-in custom, il faudra le faire via class explicite + timer JS court.

  // ════════════ UNIFIED DOM-CHANGE OBSERVER (mnlOnDomChange) ════════════
  // Défini en TÊTE de l'IIFE pour que tous les setupX puissent l'utiliser.
  // Au lieu de 60+ MutationObservers indépendants, expose un seul observer partagé.
  // Usage : mnlOnDomChange(function(){ /* re-bind */ }, 200);
  // Vague 70 : protections anti-leak — singleton + cap callbacks max + cleanup au unload + dedup par ref
  if ('MutationObserver' in window && !window._mnlDomObserver) {
    var domChangeCallbacks = [];
    var MAX_CALLBACKS = 100; // garde-fou : si on dépasse 100, on warn (signal d'un script qui bind en boucle)
    function fireDomChange() {
      domChangeCallbacks.forEach(function (entry) {
        clearTimeout(entry._timer);
        entry._timer = setTimeout(entry.fn, entry.debounce);
      });
    }
    window._mnlDomObserver = new MutationObserver(fireDomChange);
    window._mnlDomObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });
    window.mnlOnDomChange = function (fn, debounceMs) {
      if (typeof fn !== 'function') return;
      // Vague 70 : dedup — si la même fn est déjà enregistrée, ne pas la rebind
      if (domChangeCallbacks.some(function(e){ return e.fn === fn; })) return;
      if (domChangeCallbacks.length >= MAX_CALLBACKS) {
        try { console.warn('[MNL] mnlOnDomChange : max ' + MAX_CALLBACKS + ' callbacks atteint, ajout ignoré'); } catch (_) {}
        return;
      }
      domChangeCallbacks.push({ fn: fn, debounce: debounceMs || 200, _timer: null });
      // Trigger immédiat pour la première bind
      try { fn(); } catch (_) {}
    };
    window.mnlDomChangeCount = function () { return domChangeCallbacks.length; };
    // Vague 70 : cleanup au unload (anti-leak workers/iframes)
    window.addEventListener('pagehide', function (event) {
      try {
        if (window._mnlDomObserver) window._mnlDomObserver.disconnect();
        domChangeCallbacks.forEach(function(e){ if (e._timer) clearTimeout(e._timer); });
        if (!event.persisted) domChangeCallbacks.length = 0;
      } catch (_) {}
    });
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      window._mnlDomObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });
      fireDomChange();
    });
  }

  // ════════════ "BIENTÔT" → WAITLIST (V566) — capture email taggée par produit (waitlist-<slug>) ════════════
  // Avant : simple toast. Maintenant : modale de capture → POST /contact (form_type=customer) avec tag
  // « waitlist,waitlist-intra-workout » (ou post-workout) → liste segmentable pour annoncer le lancement.
  // Succès waitlist au retour (form NATIF → reload avec ?customer_posted=true). Le drapeau session
  // distingue une inscription waitlist d'une inscription newsletter (footer), qui partagent ce param.
  // Retry : mnlToast peut être défini après ce point → on attend qu'il soit prêt avant de consommer le drapeau.
  try {
    if (/[?&]customer_posted=(true|1)/i.test(location.search) && sessionStorage.getItem('mnl-wl-pending')) {
      var _wlTries = 0;
      var _wlShow = function(){
        if (window.mnlToast) {
          try { sessionStorage.removeItem('mnl-wl-pending'); } catch(_){}
          window.mnlToast({ icon: '✓', title: MNL_T('global.waitlist_ok_title', 'Inscrit·e à la liste !'), sub: MNL_T('global.waitlist_ok_sub', 'Tu seras prévenu·e en avant-première au lancement'), type: 'success', duration: 5000 });
        } else if (_wlTries++ < 40) { setTimeout(_wlShow, 200); }
      };
      _wlShow();
    }
  } catch(_){}
  function mnlOpenWaitlist(productName){
    var slug = (productName || 'produit').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
    var ov = document.getElementById('mnl-waitlist');
    if (!ov) {
      ov = document.createElement('div');
      ov.id = 'mnl-waitlist';
      ov.setAttribute('role','dialog');
      ov.setAttribute('aria-modal','true');
      ov.setAttribute('aria-label',MNL_T('global.waitlist_dialog_label', 'Liste d’attente'));
      ov.style.cssText = 'position:fixed;inset:0;z-index:100000;display:none;align-items:center;justify-content:center;padding:20px;background:rgba(15,23,42,.6);backdrop-filter:blur(6px);';
      ov.innerHTML = '<div style="background:#fff;border-radius:20px;max-width:420px;width:100%;padding:28px 24px;box-shadow:0 30px 80px rgba(0,0,0,.35);position:relative;font-family:inherit;text-align:center;">'
        + MNL_T('global.waitlist_close_html', '<button type="button" class="mnl-wl__close" aria-label="Fermer" style="position:absolute;top:12px;right:12px;width:32px;height:32px;border:0;border-radius:50%;background:rgba(15,23,42,.06);color:#475569;font-size:18px;cursor:pointer;line-height:1;">×</button>')
        + '<div aria-hidden="true" style="line-height:1;margin-bottom:10px;"><svg viewBox="0 0 24 24" width="42" height="42" fill="none" stroke="#FF6B00" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block"><path d="M6 3h12M6 21h12"/><path d="M7.5 3v3.4L12 11l4.5-4.6V3"/><path d="M7.5 21v-3.4L12 13l4.5 4.6V21"/></svg></div>'
        + '<h3 class="mnl-wl__title" style="font-size:20px;font-weight:900;color:#0f172a;margin:0 0 6px;"></h3>'
        + MNL_T('global.waitlist_intro_html', '<p style="font-size:14px;color:#64748b;margin:0 0 18px;line-height:1.5;">Laisse ton email : tu seras prévenu·e en avant-première au lancement.</p>')
        + '<form class="mnl-wl__form" method="post" action="/contact" accept-charset="UTF-8" style="display:flex;flex-direction:column;gap:10px;">'
        + '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" class="mnl-wl__tags" value="waitlist">'
        + MNL_T('global.waitlist_email_input_html', '<input type="email" name="contact[email]" class="mnl-wl__email" required placeholder="toi@email.com" autocomplete="email" inputmode="email" maxlength="254" aria-label="Adresse email" style="padding:13px 16px;border:1px solid #e2e8f0;border-radius:12px;font-size:16px;font-family:inherit;outline:none;box-sizing:border-box;">')
        + MNL_T('global.waitlist_submit_html', '<button type="submit" class="mnl-wl__submit" style="padding:13px 18px;border:0;border-radius:12px;background:#E84E1B;color:#fff;font-weight:800;font-size:15px;cursor:pointer;font-family:inherit;">Préviens-moi</button>')
        + '</form>'
        + MNL_T('global.waitlist_nospam_html', '<p style="font-size:11px;color:#94a3b8;margin:12px 0 0;">Pas de spam.</p>')
        + '</div>';
      document.body.appendChild(ov);
      var closeWl = function(){ ov.style.display = 'none'; };
      ov.addEventListener('click', function(ev){ if (ev.target === ov || (ev.target.closest && ev.target.closest('.mnl-wl__close'))) closeWl(); });
      document.addEventListener('keydown', function(ev){ if (ev.key === 'Escape' && ov.style.display !== 'none') closeWl(); });
      // Soumission NATIVE Shopify (le fetch /contact est rejeté en 400) → on pose juste un drapeau
      // session pour le toast de succès au retour ; le navigateur valide l'email (required + type=email).
      ov.querySelector('.mnl-wl__form').addEventListener('submit', function(){
        try { sessionStorage.setItem('mnl-wl-pending', ov.dataset.slug || '1'); } catch(_){}
      });
    }
    ov.dataset.slug = slug;
    var tagsEl = ov.querySelector('.mnl-wl__tags');
    if (tagsEl) tagsEl.value = 'waitlist,waitlist-' + slug;
    ov.querySelector('.mnl-wl__title').textContent = productName + MNL_T('global.waitlist_title_suffix', ' arrive bientôt');
    ov.style.display = 'flex';
    setTimeout(function(){ var em = ov.querySelector('.mnl-wl__email'); if (em) em.focus(); }, 60);
  }
  document.addEventListener('click', function (e) {
    var soon = e.target.closest('[data-mnl-soon]');
    if (!soon) return;
    e.preventDefault();
    e.stopPropagation();
    mnlOpenWaitlist(soon.dataset.mnlSoon || MNL_T('global.waitlist_default_product', 'Ce produit'));
  });

  // ════════════ LAZY-LOAD IMAGES (smooth fade-in) ════════════
  document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    if (img.complete) return;
    img.classList.add('mnl-lazy');
    img.addEventListener('load', function () { img.classList.add('is-loaded'); });
    img.addEventListener('error', function () { img.classList.add('is-loaded'); });
  });

  // ════════════ SCROLL-TRIGGERED REVEALS ════════════
  if ('IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          revealObs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    // Auto-reveal sur tous les <section> et certains classes courantes + tout élément avec data-mnl-reveal
    document.querySelectorAll('.mnl-reveal, [data-mnl-reveal], .mnl-ath-card, .mnl-pp3-fact, .mnl-pp3-press-card, .mnl-foot__main > div').forEach(function (el) {
      el.classList.add('mnl-reveal');
      // Optional delay via data-mnl-reveal-delay="200" → CSS var
      var delay = el.getAttribute('data-mnl-reveal-delay');
      if (delay) el.style.setProperty('--mnl-reveal-delay', delay + 'ms');
      revealObs.observe(el);
    });
  }

  // [SUPPRIMÉ] Floating coach button — doublon avec le bouton Coach IA de la mobile bottom nav.
  // Si tu veux le réactiver, remets le code (cherche "FLOATING COACH BUTTON" dans l'historique git).

  // ════════════ NEWSLETTER POPUP (exit intent + delay 30s) ════════════
  // Vague 89 BUG fix : DÉSACTIVÉ — faisait DOUBLE popup avec l'exit-intent (.mnl-exit, plus bas).
  // V1092 (MAJ commentaire) : la promo de bienvenue active du site est MNL10 (−10 € dès 39 € d'achat),
  // servie par l'exit-intent email-gated ci-dessous — l'ancien WELCOME15 (−15 %) n'existe plus.
  // Ce popup newsletter (−10 € MNL10 via inscription email) faisait donc doublon + impression spammy.
  // Si tu veux le re-activer un jour : supprime la ligne `var DISABLE_NEWSLETTER_POPUP = true;`
  var DISABLE_NEWSLETTER_POPUP = true;
  var newsKey = 'mnl-news-popup-shown';
  var newsAlready = DISABLE_NEWSLETTER_POPUP;
  try { if (!DISABLE_NEWSLETTER_POPUP) newsAlready = !!localStorage.getItem(newsKey); } catch (_) {}

  function showNewsletterPopup() {
    if (DISABLE_NEWSLETTER_POPUP) return; // Vague 89 : kill switch
    if (newsAlready) return;
    if (document.getElementById('mnl-news-popup')) return;
    newsAlready = true;
    try { localStorage.setItem(newsKey, '1'); } catch (_) {}

    var popup = document.createElement('div');
    popup.id = 'mnl-news-popup';
    popup.className = 'mnl-news-popup';
    popup.setAttribute('role', 'dialog');
    popup.innerHTML = MNL_T('global.news_popup_html', '\
      <div class="mnl-news-popup__panel">\
        <button type="button" class="mnl-news-popup__close" aria-label="Fermer">×</button>\
        <div class="mnl-news-popup__icon"></div>\
        <h3 class="mnl-news-popup__title">−10€ sur ta <em>première formule</em></h3>\
        <p class="mnl-news-popup__sub">Inscris-toi à la newsletter MNL et reçois ton code MNL10 instantanément. Tips coach + drops actifs en avant-première.</p>\
        <form class="mnl-news-popup__form">\
          <input type="email" class="mnl-news-popup__input" placeholder="toi@email.com" required maxlength="100">\
          <button type="submit" class="mnl-news-popup__btn">Recevoir mon code MNL10</button>\
        </form>\
        <p class="mnl-news-popup__msg"></p>\
        <button type="button" class="mnl-news-popup__no">Non merci</button>\
      </div>');
    document.body.appendChild(popup);

    requestAnimationFrame(function () { popup.classList.add('is-open'); });

    function close() {
      popup.classList.remove('is-open');
      setTimeout(function () { if (popup.parentNode) popup.parentNode.removeChild(popup); }, 400);
    }
    popup.querySelector('.mnl-news-popup__close').addEventListener('click', close);
    popup.querySelector('.mnl-news-popup__no').addEventListener('click', close);
    // Vague 72 : click-outside fix — avant `e.target === popup` ne déclenchait pas si le clic touchait un overlay child.
    // Maintenant : ferme si clic en dehors du panel.
    var panel = popup.querySelector('.mnl-news-popup__panel');
    popup.addEventListener('click', function (e) {
      if (!panel || !panel.contains(e.target)) close();
    });
    // Vague 72 : ferme aussi via Escape (a11y)
    var escHandler = function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) {
        close();
        document.removeEventListener('keydown', escHandler);
      }
    };
    document.addEventListener('keydown', escHandler);
    // Vague 72 : ARIA labels (accessibility)
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'mnl-news-popup-title');
    var titleEl = popup.querySelector('.mnl-news-popup__title');
    if (titleEl) titleEl.id = 'mnl-news-popup-title';

    var form = popup.querySelector('.mnl-news-popup__form');
    var msg = popup.querySelector('.mnl-news-popup__msg');
    var inputEl = form.querySelector('input');
    // Vague 126 : validation temps réel pendant la frappe (UX feedback immédiat plutôt qu'au submit only)
    inputEl.addEventListener('input', function(){
      // Cleanup état error visuel pendant la frappe
      inputEl.classList.remove('is-invalid');
      if (msg && msg.textContent) { // FIX : était indexOf('') === 0 (emoji vidé) = toujours vrai ; on nettoie le message d'erreur pendant la frappe
        msg.textContent = '';
      }
    });
    // Vague 126 : helper visual error
    function _setError(text){
      if (msg) {
        msg.textContent = '' + text;
        msg.style.color = '#dc2626';
        msg.classList.remove('is-success');
      }
      if (inputEl) {
        inputEl.classList.add('is-invalid');
        inputEl.setAttribute('aria-invalid', 'true');
        inputEl.focus();
        // shake animation pour attention
        inputEl.style.animation = 'mnl-shake .35s ease';
        setTimeout(function(){ inputEl.style.animation = ''; }, 400);
      }
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (inputEl.value || '').trim().toLowerCase();
      if (!email) { _setError(MNL_T('global.news_err_email_required', 'Email obligatoire')); return; }
      // Vague 72 : validation WHATWG-like via helper consolidé (avant : indexOf('@') laxe — accepte "test@" "@x.com")
      if (!window.mnlValidEmail || !window.mnlValidEmail(email)) {
        _setError(MNL_T('global.news_err_email_format', 'Format email invalide — vérifie le format')); return;
      }
      // Vague 126 : check disposable/jetable emails (anti-bot abuse coupon)
      var disposable = ['yopmail.com', 'mailinator.com', 'guerrillamail.com', '10minutemail.com', 'tempmail.com', 'throwaway.email', 'sharklasers.com', 'trashmail.com'];
      var domain = email.split('@')[1] || '';
      if (disposable.indexOf(domain) !== -1) {
        _setError(MNL_T('global.news_err_email_disposable', 'Adresse jetable détectée — utilise un email réel pour recevoir ton code')); return;
      }
      var btn = form.querySelector('button');
      btn.disabled = true;
      btn.textContent = '';
      // POST Shopify customer endpoint
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'newsletter,popup');
      // Vague 133 : enriched success state — replace form by celebration UI + copy code button + delay 5s
      function _showSuccessState(){
        var panel = popup.querySelector('.mnl-news-popup__panel');
        if (!panel) return;
        // V1216 : ce pop-up peut s'ouvrir sur N'IMPORTE QUELLE page, configurateur en mode Abonnement
        // compris, et n'a aucune connaissance du panier. « valide pour votre 1ʳᵉ commande » y était donc
        // faux par omission : MNL10 vaut aussi en abonnement, mais sur la 1ʳᵉ LIVRAISON seulement
        // (recurringCycleLimit = 1). On écrit une formule vraie dans les deux cas plutôt que de deviner.
        panel.innerHTML = '<div class="mnl-news-popup__success">' +
          '<div class="mnl-news-popup__success-icon">✓</div>' +
          '<h3 class="mnl-news-popup__success-title">Bienvenue chez MyNutriLab</h3>' +
          MNL_T('global.news_success_sub_html', '<p class="mnl-news-popup__success-sub">Ton code <strong>MNL10</strong> : −10&nbsp;€ sur ta 1ʳᵉ commande — valable aussi en abonnement (1ʳᵉ livraison).</p>') +
          '<div class="mnl-news-popup__success-code">' +
            MNL_T('global.news_success_code_label_html', '<span class="mnl-news-popup__success-code-lbl">Ton code</span>') +
            '<strong class="mnl-news-popup__success-code-val">MNL10</strong>' +
            MNL_T('global.news_success_copy_html', '<button type="button" class="mnl-news-popup__success-copy" id="mnlNewsCopyBtn" aria-label="Copier le code"></button>') +
          '</div>' +
          MNL_T('global.news_success_cta_html', '<a href="/products/pre-workout-mynutrilab-personnalisable-au-mg-pres?open=ai" class="mnl-news-popup__success-cta">Configurer ma formule →</a>') +
          MNL_T('global.news_success_close_html', '<button type="button" class="mnl-news-popup__success-close" id="mnlNewsCloseSuccess">Plus tard</button>') +
        '</div>';
        // Wire copy + close buttons
        var copyBtn = document.getElementById('mnlNewsCopyBtn');
        if (copyBtn) copyBtn.addEventListener('click', function(){
          try {
            if (navigator.clipboard) navigator.clipboard.writeText('MNL10');
            copyBtn.textContent = '✓';
            setTimeout(function(){ copyBtn.textContent = ''; }, 1800);
            if (window.mnlHaptic) window.mnlHaptic('success');
          } catch(_){}
        });
        var closeOk = document.getElementById('mnlNewsCloseSuccess');
        if (closeOk) closeOk.addEventListener('click', close);
        // Auto-close après 8s (au lieu de 3s — laisse le temps de lire/copier)
        setTimeout(close, 8000);
      }
      fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
        .then(function () { _showSuccessState(); })
        .catch(function () { _showSuccessState(); });
    });
  }

  // FONDATEUR 2026-06-05 : la popup ne doit JAMAIS gêner le tunnel d'achat. Garde commune aux 2 déclencheurs.
  function _canShowNewsletter(){
    if (newsAlready) return false;
    try {
      var p = location.pathname || '';
      if (/^\/(cart|checkout|account)/.test(p)) return false;                 // panier / checkout / compte
      var b = document.body.classList;
      if (b.contains('mnl-open') || b.contains('mnl-ai-open')) return false;   // configurateur / Coach IA ouverts
      if (document.querySelector('#mnl-overlay.is-open, .mnl-ai-overlay.is-open, #mnl-pickmod.is-open')) return false;
      if (document.querySelector('.mnl-hd[data-open]')) return false;          // tiroir panier/menu ouvert
      if (window._mnlLastCtaTs && (Date.now() - window._mnlLastCtaTs) < 8000) return false; // juste après un CTA
    } catch(_){}
    return true;
  }
  // Mémorise la dernière interaction avec un CTA important (pour ne pas couper l'élan d'achat).
  document.addEventListener('click', function(e){
    try { if (e.target.closest('.mnl-atc, .mnl-sticky-atc__btn, [data-mnl-ai-open], .mnl-pp3-atc-hero__btn, .mnl-pp3-pck, .mnl-wizard-nav__next, [href*="/cart"], [href*="/checkout"]')) window._mnlLastCtaTs = Date.now(); } catch(_){}
  }, true);

  // Trigger 1 : exit-intent (souris quitte le haut) — armé SEULEMENT après 25s (jamais « trop tôt »).
  var exitTriggered = false, _exitArmed = false;
  setTimeout(function(){ _exitArmed = true; }, 25000);
  document.addEventListener('mouseleave', function (e) {
    if (e.clientY <= 0 && _exitArmed && !exitTriggered && _canShowNewsletter()) {
      exitTriggered = true;
      showNewsletterPopup();
    }
  });

  // Trigger 2 : 45s sur la page (engagement long) — avec garde tunnel d'achat.
  setTimeout(function () { if (_canShowNewsletter()) showNewsletterPopup(); }, 45000);

  // ════════════ RECENTLY VIEWED PRODUCTS (localStorage tracker) ════════════
  // Vague 84 :
  //   - BUG FIX : filter() comparait `h !== handle` mais h est un objet {handle, ...}
  //     → dédoublonnage cassé, items dupliqués s'accumulaient.
  //   - ENRICH : ajoute title + image + price + url depuis OG meta + Product JSON-LD
  //     pour que l'empty-cart upsell (vague 83) puisse les rendre directement.
  // Vague 86 :
  //   - RGPD CNIL : respecte mnl-cookie-prefs.preferences (catégorie "Préférences" wave 85)
  //     → si user a refusé cette catégorie, on n'écrit RIEN dans localStorage.
  function _mnlPreferencesAllowed() {
    try {
      var p = JSON.parse(localStorage.getItem('mnl-cookie-prefs') || 'null');
      // Si pas encore de prefs choisies (banner pas vu) → on autorise (default + tolérant pour 1ère visite)
      // Si prefs choisies explicitement avec preferences=false → on bloque
      if (!p || typeof p !== 'object') return true;
      return p.preferences !== false;
    } catch (_) { return true; }
  }
  function trackRecentlyViewed() {
    try {
      // Vague 86 : skip silencieux si user a opt-out de la catégorie Préférences
      if (!_mnlPreferencesAllowed()) return;
      var path = window.location.pathname;
      if (path.indexOf('/products/') !== 0) return;
      var handle = path.split('/products/')[1].split('/')[0].split('?')[0];
      if (!handle) return;

      // Lit OG tags + Product JSON-LD pour enrichir (zéro fetch additionnel)
      function _meta(prop) {
        var el = document.querySelector('meta[property="' + prop + '"]') || document.querySelector('meta[name="' + prop + '"]');
        return el ? (el.getAttribute('content') || '') : '';
      }
      var title = _meta('og:title') || document.title || handle;
      var image = _meta('og:image') || _meta('twitter:image') || '';
      var url = _meta('og:url') || (window.location.origin + '/products/' + handle);
      var priceAmount = _meta('product:price:amount');
      var priceCurrency = _meta('product:price:currency') || 'EUR';
      // Format prix lisible (ex: 24.95 → "24,95 €")
      var price = '';
      if (priceAmount) {
        var symbol = priceCurrency === 'EUR' ? ' €' : (' ' + priceCurrency);
        price = String(priceAmount).replace('.', ',') + symbol;
      }
      // Fallback : si Product JSON-LD est dispo, on relit price depuis offers.price
      if (!price) {
        try {
          var lds = document.querySelectorAll('script[type="application/ld+json"]');
          for (var i = 0; i < lds.length; i++) {
            var p = JSON.parse(lds[i].textContent || '{}');
            var t = p['@type'];
            var isProduct = (t === 'Product') || (Array.isArray(t) && t.indexOf('Product') !== -1);
            if (isProduct && p.offers && p.offers.price) {
              price = String(p.offers.price).replace('.', ',') + ' €';
              if (!image && p.image) image = (Array.isArray(p.image) ? p.image[0] : p.image);
              if (!title && p.name) title = p.name;
              break;
            }
          }
        } catch (_) {}
      }

      // V716 : track uniquement sur les pages produit (exclut home/marque → fini l'entrée fantôme « MyNutriLab » 404 dans « produits vus »).
      if (window.location.pathname.indexOf('/products/') === -1) return;
      var rv = JSON.parse(localStorage.getItem('mnl-recently-viewed') || '[]');
      // Vague 113 : dedup case-insensitive (Shopify handles sont tous lowercase mais defensive
      // au cas où data legacy / API tiers pollue avec casse mixed).
      var handleLc = String(handle).toLowerCase();
      rv = rv.filter(function (item) {
        if (!item) return false;
        var h = item.handle ? String(item.handle).toLowerCase() : '';
        return h && h !== handleLc;
      });
      // Vague 113 : normalize handle stocké en lowercase (cohérence inter-sessions)
      rv.unshift({
        handle: handleLc,
        title: title,
        url: url,
        image: image,
        price: price,
        ts: Date.now()
      });
      if (rv.length > 5) rv = rv.slice(0, 5);
      localStorage.setItem('mnl-recently-viewed', JSON.stringify(rv));
    } catch (_) {}
  }
  trackRecentlyViewed();

  // ════════════ Vague 86 : LISTENER mnl:consent:preferences ════════════
  // Wave 85 dispatchait l'event mais aucun listener consommateur → dead code.
  // Maintenant : si l'user RÉVOQUE la cat préférences, on PURGE les stores tracking-grade
  // (recently-viewed, achievements unlocked, dark theme override).
  // Si user GRANT à nouveau : rien à restaurer (perte permanente acceptable côté CNIL).
  document.addEventListener('mnl:consent:preferences', function (e) {
    var granted = !!(e && e.detail && e.detail.granted);
    if (!granted) {
      try { localStorage.removeItem('mnl-recently-viewed'); } catch (_) {}
      try { localStorage.removeItem('mnl-achievements'); } catch (_) {}
      try { localStorage.removeItem('mnl-streak'); } catch (_) {}
      try { localStorage.removeItem('mnl-ai-streak'); } catch (_) {}
      try { localStorage.removeItem('mnl-ai-recents'); } catch (_) {}
      try { localStorage.removeItem('mnl-quick-shortcuts'); } catch (_) {}
      try { localStorage.removeItem('mnl-recent-searches'); } catch (_) {}
      try { localStorage.removeItem('mnl-so-recent'); } catch (_) {}
      // Reset le widget recently-viewed s'il est ouvert
      var rvWidget = document.querySelector('.mnl-rv-widget');
      if (rvWidget) rvWidget.remove();
      var rvPanel = document.querySelector('.mnl-rv-panel');
      if (rvPanel) rvPanel.remove();
    }
  });

  // ════════════ CART COUNT SYNC (cross-tab) ════════════
  // Vague 77 : BroadcastChannel realtime + storage event fallback (cohérent avec wishlist vague 76)
  var _cartBC = null;
  try { if ('BroadcastChannel' in window) _cartBC = new BroadcastChannel('mnl-cart'); } catch (_) {}
  window.addEventListener('storage', function (e) {
    if (e.key === 'mnl-cart-count' && e.newValue && !_cartBC) {
      // Fallback storage event si BroadcastChannel pas dispo (Safari < 15.4)
      document.dispatchEvent(new CustomEvent('mnl:cart:updated', { detail: { source: 'storage-cross-tab' } }));
    }
  });
  if (_cartBC) {
    _cartBC.addEventListener('message', function (e) {
      if (e.data && e.data.type === 'cart:updated') {
        // Vague 77 : ne fetch PAS /cart.js dans le tab récepteur (l'autre tab vient juste de le faire)
        // On dispatch juste l'event pour que les UI consumers (badge count, drawer) se rafraîchissent.
        document.dispatchEvent(new CustomEvent('mnl:cart:updated', { detail: { source: 'broadcast-cross-tab', count: e.data.count } }));
      }
    });
  }

  // Update localStorage cart count après chaque ATC pour sync cross-tab
  document.addEventListener('mnl:cart:updated', function (e) {
    // Vague 77 : skip fetch si l'event vient déjà d'un autre tab (anti-loop infini)
    if (e && e.detail && (e.detail.source === 'broadcast-cross-tab' || e.detail.source === 'storage-cross-tab')) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        try {
          localStorage.setItem('mnl-cart-count', String(count));
          // Vague 110 : cache aussi le total formaté pour minicart hover preview tooltip
          if (typeof cart.total_price === 'number') {
            var cents = cart.total_price;
            var curr = cart.currency || 'EUR';
            var formatted = (cents / 100).toFixed(2).replace('.', ',') + ' ' + (curr === 'EUR' ? '€' : curr);
            localStorage.setItem('mnl-cart-total-formatted', formatted);
          }
        } catch (_) {}
        // Vague 77 : notifie autres tabs via BroadcastChannel (realtime, < 50ms cross-tab)
        if (_cartBC) try { _cartBC.postMessage({ type: 'cart:updated', count: count, ts: Date.now() }); } catch (_) {}
      })
      .catch(function () {});
  });

  // V916 : SYNC du compteur panier au CHARGEMENT depuis /cart.js (source de vérité). Corrige un badge/tooltip PÉRIMÉ
  // (« 1 article · 74,95 € » alors que le panier est VIDE) quand le panier s'est vidé SANS event mnl:cart:updated :
  // checkout terminé, session/panier expiré côté Shopify, ou vidé dans un autre onglet. Avant, _refreshCartTooltip
  // lisait un mnl-cart-count localStorage obsolète. On réaligne localStorage + on notifie les badges (source
  // storage-cross-tab → le handler ci-dessus NE re-fetch PAS, pas de double appel ; mnl-header met à jour l'icône).
  (function _mnlSyncCartOnLoad(){
    try {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var count = cart.item_count || 0;
          try {
            localStorage.setItem('mnl-cart-count', String(count));
            if (count > 0 && typeof cart.total_price === 'number') {
              var curr = cart.currency || 'EUR';
              localStorage.setItem('mnl-cart-total-formatted', (cart.total_price / 100).toFixed(2).replace('.', ',') + ' ' + (curr === 'EUR' ? '€' : curr));
            } else {
              localStorage.removeItem('mnl-cart-total-formatted');
            }
          } catch (_) {}
          try { document.dispatchEvent(new CustomEvent('mnl:cart:updated', { detail: { source: 'storage-cross-tab', count: count } })); } catch (_) {}
        })
        .catch(function () {});
    } catch (_) {}
  })();

  // ════════════ LOYALTY POINTS BADGE (gamification) ════════════
  // Système simple : earn points par action (visit, ATC, partage, etc.)
  // Vague 72 : caps anti-farming (avant : addLoyaltyPoints sans limite = user pouvait farm via spam-clic)
  // - per-call max 250 pts (refus si appel demande plus = signal de bug code appelant)
  // - daily cap 500 pts client-side (en attendant backend /api/loyalty/add avec auth + cap server-side)
  // - global cap 999999 pts (anti-tampering DevTools)
  var LOYALTY_PER_CALL_MAX = 250;
  var LOYALTY_DAILY_MAX = 500;
  var LOYALTY_GLOBAL_MAX = 999999;
  function getLoyaltyPoints(){
    // V386 : guard launch-safe — si MNL_LOYALTY_ENABLED=false, retourne 0 même si localStorage contient des points obsolètes (accumulés via debug DevTools ou ancien code pre-V385). Évite affichage trompeur badge/popup/account avec un solde irréel. Cohérent V360/V384/V385.
    if (!window.MNL_LOYALTY_ENABLED) return 0;
    try {
      var v = parseInt(localStorage.getItem('mnl-loyalty-pts') || '0', 10) || 0;
      return Math.max(0, Math.min(LOYALTY_GLOBAL_MAX, v));
    } catch(_) { return 0; }
  }
  function _todayDailyKey(){
    var d = new Date();
    return 'mnl-loyalty-today-' + d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate();
  }
  function getTodayLoyaltyEarned(){
    try { return parseInt(localStorage.getItem(_todayDailyKey()) || '0', 10) || 0; } catch(_) { return 0; }
  }
  function addLoyaltyPoints(n, reason){
    // V385 : GUARD launch-safe — programme loyalty PAS BRANCHÉ au launch Mai 2026 (cohérent V360 disclaimer page-loyalty-levels "programme en construction" + V384 popup widget guard). 13 sites d'appel mnlAddLoyaltyPoints (push-notifs, AI streak, profile, daily-claim, review, athlete-match, body-measurements, mini-game, review-submit, thank-you) incrémentaient localStorage `mnl-loyalty-pts` → toast "+X MNL Points" + tier-up confetti → MAIS aucun discount associé côté Shopify (pas d'app loyalty branchée) → user croit qu'il gagne des points → vérifie sur /pages/loyalty-levels (V360 disclaimer) → confusion + risque DGCCRF L121-1 (programme fantôme).
    // Fix V385 : early-return si MNL_LOYALTY_ENABLED=false. Active uniquement quand app loyalty Shopify branchée + metafield customer.loyalty.points incrémenté backend.
    // À activer : window.MNL_LOYALTY_ENABLED = true (toggle 1-ligne post-launch).
    if (!window.MNL_LOYALTY_ENABLED) return;
    try {
      // Validation entrée
      var pts = parseInt(n, 10);
      if (isNaN(pts) || pts <= 0) return;
      if (pts > LOYALTY_PER_CALL_MAX) {
        try { console.warn('[MNL Loyalty] addLoyaltyPoints(' + pts + ') > cap per-call ' + LOYALTY_PER_CALL_MAX + ' — refusé'); } catch(_){}
        return;
      }
      // Cap journalier client-side (en attendant backend)
      var todayEarned = getTodayLoyaltyEarned();
      if (todayEarned >= LOYALTY_DAILY_MAX) {
        if (typeof window.mnlToast === 'function') {
          window.mnlToast({ icon: 'ℹ', title: MNL_T('global.loyalty_cap_title', 'Cap journalier atteint'), sub: MNL_T('global.loyalty_cap_sub', 'Reviens demain pour plus de points'), type: 'info', duration: 4000 });
        }
        return;
      }
      // Clamp pour ne pas dépasser le cap journalier
      var allowed = Math.min(pts, LOYALTY_DAILY_MAX - todayEarned);
      if (allowed <= 0) return;
      var current = getLoyaltyPoints();
      var next = Math.min(LOYALTY_GLOBAL_MAX, current + allowed);
      // Vague 113 : détection tier-up (cross-tier crossing) pour celebration animation
      var TIERS = [
        { name: 'Rookie',  min: 0 },
        { name: 'Athlete', min: 100 },
        { name: 'Pro',     min: 500 },
        { name: 'Elite',   min: 1000 },
        { name: 'Legend',  min: 2000 }
      ];
      function _tierFor(pts){
        var t = TIERS[0];
        for (var i = TIERS.length - 1; i >= 0; i--) { if (pts >= TIERS[i].min) { t = TIERS[i]; break; } }
        return t;
      }
      var oldTier = _tierFor(current);
      var newTier = _tierFor(next);
      var crossedTier = (oldTier.name !== newTier.name);
      localStorage.setItem('mnl-loyalty-pts', String(next));
      localStorage.setItem(_todayDailyKey(), String(todayEarned + allowed));
      // Vague 138 : log transaction (award positif) dans le journal loyalty
      try {
        var logArr = JSON.parse(localStorage.getItem('mnl-loyalty-log') || '[]');
        logArr.unshift({ ts: Date.now(), type: 'award', delta: allowed, reason: String(reason || 'manual'), balance: next });
        if (logArr.length > 50) logArr = logArr.slice(0, 50);
        localStorage.setItem('mnl-loyalty-log', JSON.stringify(logArr));
      } catch(_){}
      // Cleanup vieilles clés daily (>7j) pour éviter bloat localStorage
      try {
        Object.keys(localStorage).forEach(function(k){
          if (k.indexOf('mnl-loyalty-today-') === 0 && k !== _todayDailyKey()) {
            // Format : mnl-loyalty-today-YYYY-M-D
            var dateParts = k.replace('mnl-loyalty-today-', '').split('-');
            if (dateParts.length === 3) {
              var keyDate = new Date(parseInt(dateParts[0],10), parseInt(dateParts[1],10)-1, parseInt(dateParts[2],10));
              if (Date.now() - keyDate.getTime() > 7 * 24 * 60 * 60 * 1000) {
                localStorage.removeItem(k);
              }
            }
          }
        });
      } catch(_){}
      updateLoyaltyBadge();
      // Toast notification
      if (typeof window.mnlToast === 'function') {
        window.mnlToast({ icon: '', title: '+' + allowed + MNL_T('global.loyalty_points_suffix', ' MNL Points !'), sub: reason || MNL_T('global.loyalty_points_default_reason', 'Bravo champion'), type: 'warn' });
      }
      // Vague 113 : tier-up celebration (confetti + toast riche + sound)
      // Avant : passer Rookie→Athlete silencieux, l'user ne voyait pas qu'il avait débloqué de nouveaux perks.
      if (crossedTier) {
        var tierEmoji = { 'Rookie': '', 'Athlete': '', 'Pro': '', 'Elite': '', 'Legend': '' }[newTier.name] || '';
        setTimeout(function(){
          // Confetti (respecte prefers-reduced-motion via guard interne vague 104)
          if (typeof window.mnlConfetti === 'function') window.mnlConfetti({ count: 80, colors: ['#fbbf24','#C2410C','#22c55e','#3b82f6','#a855f7'] });
          // Toast plus long + actionLabel pour voir les perks
          if (typeof window.mnlToast === 'function') {
            window.mnlToast({
              icon: tierEmoji,
              title: MNL_T('global.loyalty_level_prefix', 'Niveau ') + newTier.name + MNL_T('global.loyalty_level_unlocked_suffix', ' débloqué !'),
              sub: MNL_T('global.loyalty_new_perks', 'Nouveaux avantages disponibles'),
              type: 'success',
              duration: 8000,
              actionLabel: MNL_T('global.loyalty_see_account', 'Voir mon compte'),
              action: function(){ window.location.href = '/pages/account'; }
            });
          }
          // SFX si dispo
          if (typeof window.mnlPlaySfx === 'function') try { window.mnlPlaySfx('success'); } catch(_){}
          // Analytics tracking
          try {
            if (window.gtag) window.gtag('event', 'loyalty_tier_up', { from: oldTier.name, to: newTier.name });
          } catch(_){}
          // Émet event pour autres handlers (sub-manager, account dashboard)
          document.dispatchEvent(new CustomEvent('mnl:loyalty:tier-up', { detail: { from: oldTier.name, to: newTier.name, points: next } }));
          // Vague 138 : log la transaction tier-up dans le journal (visible Account > Loyalty > Historique)
          try {
            var log = JSON.parse(localStorage.getItem('mnl-loyalty-log') || '[]');
            log.unshift({ ts: Date.now(), type: 'tier-up', delta: 0, reason: 'Tier ' + newTier.name + MNL_T('global.loyalty_log_unlocked_suffix', ' débloqué'), from: oldTier.name, to: newTier.name });
            if (log.length > 50) log = log.slice(0, 50);
            localStorage.setItem('mnl-loyalty-log', JSON.stringify(log));
          } catch(_){}
          // Vague 131 : push to notification center (persistant, retrouvable depuis le bell header)
          if (typeof window.mnlNotifAdd === 'function') {
            window.mnlNotifAdd({
              icon: '',
              title: MNL_T('global.loyalty_newlevel_prefix', 'Nouveau niveau : ') + newTier.name + MNL_T('global.loyalty_level_unlocked_suffix', ' débloqué !'),
              sub: MNL_T('global.loyalty_bonus_prefix', 'Tu profites maintenant de +') + (newTier.bonus || 5) + '% loyalty bonus',
              url: '/account#loyalty'
            });
          }
        }, 600); // léger délai pour ne pas se superposer au toast +X pts
      }
      // Vague 79 : dispatch event + cross-tab sync (cohérent avec wishlist wave 76, cart wave 77)
      try { document.dispatchEvent(new CustomEvent('mnl:loyalty:updated', { detail: { points: next, added: allowed } })); } catch(_){}
      if (_loyaltyBC) try { _loyaltyBC.postMessage({ type: 'loyalty:updated', points: next, ts: Date.now() }); } catch(_){}
      // Vague 150 : popup +X pts animé DÉSACTIVÉ pour le lancement (trop "gamifié" pour un démarrage focus produit).
      // Les pts sont quand même ajoutés silencieusement, l'user les voit sur sa page /account.
      // À ré-activer quand on aura une masse critique d'users + une UX onboarding loyalty claire.
      // if (allowed > 0 && typeof window.mnlLoyaltyPopup === 'function') {
      //   try { window.mnlLoyaltyPopup(allowed, { reason: 'add' }); } catch(_){}
      // }
    } catch(_){}
  }
  window.mnlAddLoyaltyPoints = addLoyaltyPoints;
  // Vague 79 : BroadcastChannel cross-tab pour sync badge loyalty quand un autre onglet ajoute des points
  var _loyaltyBC = null;
  try { if ('BroadcastChannel' in window) _loyaltyBC = new BroadcastChannel('mnl-loyalty'); } catch (_) {}
  if (_loyaltyBC) {
    _loyaltyBC.addEventListener('message', function(e){
      if (e.data && e.data.type === 'loyalty:updated') {
        // Re-sync UI sans re-broadcaster (sinon boucle)
        try { updateLoyaltyBadge(); } catch(_){}
        try { document.dispatchEvent(new CustomEvent('mnl:loyalty:updated', { detail: { points: e.data.points, source: 'cross-tab' } })); } catch(_){}
      }
    });
  }
  // Fallback storage event si BroadcastChannel pas dispo (Safari < 15.4)
  window.addEventListener('storage', function(e){
    if (e.key === 'mnl-loyalty-pts' && !_loyaltyBC) {
      try { updateLoyaltyBadge(); } catch(_){}
      try { document.dispatchEvent(new CustomEvent('mnl:loyalty:updated', { detail: { points: getLoyaltyPoints(), source: 'storage-cross-tab' } })); } catch(_){}
    }
  });
  // Vague 80 : updateLoyaltyBadge défensif — sync aussi tous les autres éléments [data-mnl-loyalty-pts]
  function updateLoyaltyBadge(){
    var pts = getLoyaltyPoints();
    var b = document.getElementById('mnl-loyalty-badge');
    if (b) {
      if (pts > 0) {
        b.classList.add('is-active');
        var ptsEl = b.querySelector('.mnl-loyalty-badge__pts');
        if (ptsEl) ptsEl.textContent = pts;
      } else {
        b.classList.remove('is-active');
      }
    }
    // Vague 80 : sync tous les éléments [data-mnl-loyalty-pts] (pattern partout sur le site)
    document.querySelectorAll('[data-mnl-loyalty-pts]').forEach(function(el){
      el.textContent = pts;
    });
  }
  // Award daily visit
  try {
    var today = new Date().toDateString();
    if (localStorage.getItem('mnl-loyalty-last-visit') !== today) {
      localStorage.setItem('mnl-loyalty-last-visit', today);
      setTimeout(function(){ addLoyaltyPoints(2, MNL_T('global.loyalty_reason_daily_visit', 'Visite quotidienne')); }, 5000);
    }
  } catch(_){}
  // Hook events
  // Vague 93 : avant on awardait 20pts 1500ms après cart:updated SANS vérifier que l'ajout
  // n'avait pas été annulé entretemps (user clic ATC puis remove rapide → pts fantômes).
  // Maintenant : vérifie via /cart.js que le panier contient AU MOINS 1 item au moment de l'award.
  document.addEventListener('mnl:cart:updated', function(){
    try {
      var lastAtc = sessionStorage.getItem('mnl-last-atc-pts');
      if (lastAtc !== 'done') {
        sessionStorage.setItem('mnl-last-atc-pts', 'done');
        setTimeout(function(){
          // Confirme via API que le panier n'est PAS vide (anti-cancel race)
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function(r){ return r.ok ? r.json() : { item_count: 1 }; }) // safe default si fetch HS = award
            .then(function(cart){
              if (cart && (cart.item_count || 0) > 0) {
                addLoyaltyPoints(20, MNL_T('global.loyalty_reason_add_to_cart', 'Ajout au panier'));
              } else {
                // Panier vide → user a annulé → reset flag pour permettre nouveau award au prochain add
                try { sessionStorage.removeItem('mnl-last-atc-pts'); } catch(_){}
              }
            })
            .catch(function(){
              // Réseau fail → on awarde quand même (pas pénaliser user pour panne)
              addLoyaltyPoints(20, MNL_T('global.loyalty_reason_add_to_cart', 'Ajout au panier'));
            });
        }, 1500);
      }
    } catch(_){}
  });

  // [SUPPRIMÉ] LIVE SALES TICKER "X vient de commander" — fake JS-random retiré sur demande utilisateur.

  // ════════════ SMART EVENTS TRACKING (GA4-ready, dataLayer fallback) ════════════
  // Vague 72 : caps anti-bloat localStorage — TTL 7 jours + cap dur 50 + size limit 50KB total
  var EVENTS_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  var EVENTS_MAX_SIZE_BYTES = 50 * 1024;
  function trackEvent(eventName, params) {
    params = params || {};
    if (!window.mnlConsent || !window.mnlConsent.allows('analytics')) {
      try { localStorage.removeItem('mnl-events'); } catch (_) {}
      return;
    }
    try {
      if (window.gtag) window.gtag('event', eventName, params);
      else if (window.dataLayer) window.dataLayer.push({ event: eventName, ...params });
      // Always log to internal localStorage analytics buffer
      var buf = [];
      try { buf = JSON.parse(localStorage.getItem('mnl-events') || '[]'); } catch(_){ buf = []; }
      // TTL cleanup : retire events > 7j
      var cutoff = Date.now() - EVENTS_TTL_MS;
      buf = buf.filter(function(e){ return e && e.ts && e.ts > cutoff; });
      buf.push({ ts: Date.now(), name: eventName, params: params });
      if (buf.length > 50) buf = buf.slice(-50);
      var serialized = JSON.stringify(buf);
      // Si trop gros, on tronque progressivement (anti-QuotaExceededError)
      while (serialized.length > EVENTS_MAX_SIZE_BYTES && buf.length > 1) {
        buf = buf.slice(Math.ceil(buf.length / 2)); // garde la moitié récente
        serialized = JSON.stringify(buf);
      }
      localStorage.setItem('mnl-events', serialized);
    } catch (_) {
      // QuotaExceededError ou autre : reset le buffer pour ne pas bloquer le tracking
      try { localStorage.removeItem('mnl-events'); } catch (_e) {}
    }
  }
  window.mnlTrackEvent = trackEvent;
  // Auto-track key events
  trackEvent('mnl_page_view', { page: window.location.pathname });
  document.addEventListener('mnl:cart:updated', function () { trackEvent('mnl_cart_updated', {}); });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-ai-atc], [data-mnl-ai-closer-atc], #mnl-ai-sticky-btn');
    if (btn) trackEvent('mnl_ai_atc_click', { source: btn.id || btn.className });
    var coachBtn = e.target.closest('#mnl-floating-coach, [data-mnl-ai-open], [data-mnl-bnav-coach]');
    if (coachBtn) trackEvent('mnl_coach_open', { source: coachBtn.id || 'unknown' });
  });

  // ════════════ TOAST QUEUE MANAGER (notifications globales) ════════════
  function ensureToastStack() {
    var s = document.getElementById('mnl-toast-stack');
    if (s) return s;
    s = document.createElement('div');
    s.id = 'mnl-toast-stack';
    s.className = 'mnl-toast-stack';
    s.setAttribute('aria-live', 'polite');
    document.body.appendChild(s);
    return s;
  }

  // ════════════ VAGUE 70 — HELPERS CONSOLIDÉS (anti-duplication cross-fichiers) ════════════
  // Avant : sanitizePromoCode défini dans main-cart + page-coupon-wallet, sanitizeEmail défini dans 4 fichiers,
  // escapeHtml défini dans mnl-ai. Maintenant : tous exposés en window.mnl* pour usage partout.

  // HTML escape (anti-XSS lors d'innerHTML — préfère textContent quand possible)
  window.mnlEscapeHtml = function (str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  // Email validation WHATWG-like + checks structurels (longueur, double-dot, TLD ≥ 2)
  window.mnlValidEmail = function (raw) {
    if (!raw || typeof raw !== 'string') return false;
    var e = raw.trim().toLowerCase();
    if (e.length < 6 || e.length > 254) return false;
    if (/\.\./.test(e)) return false;
    var parts = e.split('@');
    if (parts.length !== 2) return false;
    var local = parts[0], domain = parts[1];
    if (!local || local.length > 64 || local.startsWith('.') || local.endsWith('.')) return false;
    if (!domain || domain.length > 253 || domain.startsWith('.') || domain.endsWith('.') || domain.startsWith('-') || domain.endsWith('-')) return false;
    return /^[a-z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i.test(e);
  };

  // Promo code Shopify : whitelist [A-Z0-9_-]{1,32}
  window.mnlSanitizePromoCode = function (raw) {
    if (!raw) return '';
    return String(raw).trim().toUpperCase().replace(/[^A-Z0-9_-]/g, '').slice(0, 32);
  };

  // Order ID Shopify : MNL-2026-XXXX ou #1234 (V282 pattern cleanup)
  window.mnlSanitizeOrderId = function (raw) {
    if (!raw) return '';
    return String(raw).trim().toUpperCase().replace(/[^A-Z0-9#-]/g, '').slice(0, 24);
  };

  // Number clamp utility (validation inputs)
  window.mnlClamp = function (val, min, max) {
    var n = parseFloat(val);
    if (isNaN(n)) return min;
    return Math.max(min, Math.min(max, n));
  };

  // Vague 73 : scroll-lock body robuste iOS (avant : `document.body.style.overflow = 'hidden'` laissait passer le scroll iOS)
  // Pattern : sauvegarde scrollY → fix body en position absolute → restore au unlock.
  // Compteur (lockCount) pour gérer modals empilés (drawer + search + push prompt).
  var _scrollLockCount = 0;
  var _scrollLockY = 0;
  window.mnlLockScroll = function () {
    _scrollLockCount++;
    if (_scrollLockCount > 1) return; // déjà locked par un autre modal
    try {
      _scrollLockY = window.scrollY || window.pageYOffset || 0;
      var body = document.body;
      body.style.position = 'fixed';
      body.style.top = '-' + _scrollLockY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
    } catch (_) {}
  };
  window.mnlUnlockScroll = function () {
    if (_scrollLockCount > 0) _scrollLockCount--;
    if (_scrollLockCount > 0) return; // un autre modal est encore ouvert
    try {
      // Vague 149 BUG FIX : "ça remonte en haut de page et ça reviens devant" au close modal
      // Cause : html{scroll-behavior:smooth} (theme.liquid:665) anime le window.scrollTo de 0 → savedY
      // après retrait du position:fixed. L'user voit la page scroller du haut vers sa position.
      // Fix : force scroll-behavior:auto le temps du restore, puis remet la valeur d'origine.
      var html = document.documentElement;
      var origBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      var body = document.body;
      var savedY = _scrollLockY;
      _scrollLockY = 0;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      body.style.overflow = '';
      // Restore scroll position — INSTANT (pas d'animation smooth)
      window.scrollTo(0, savedY);
      // Restore scroll-behavior original au prochain tick (laisse le scrollTo se finir)
      setTimeout(function(){ html.style.scrollBehavior = origBehavior; }, 0);
    } catch (_) {}
  };

  // Vague 127 : true queue management — au lieu d'évincer l'ancien immédiatement, on enqueue les
  // toasts non-urgents quand la cap est atteinte. Quand un toast disparaît, le prochain de la queue est show.
  // Toasts urgent (error/warn) jump la queue + évincent un non-urgent si nécessaire.
  var _toastQueue = [];
  var TOAST_MAX_VISIBLE = 3;
  function _processQueue(){
    var stack = document.getElementById('mnl-toast-stack');
    if (!stack) return;
    var visible = stack.querySelectorAll('.mnl-toast:not(.is-removing)').length;
    while (visible < TOAST_MAX_VISIBLE && _toastQueue.length > 0) {
      var next = _toastQueue.shift();
      try { next(); } catch(_){}
      visible++;
    }
  }

  window.mnlToast = function (opts) {
    opts = opts || {};
    // V773 : popups de confirmation RETIRÉES partout (demande fondateur « enlève les popups, pour tout »). On ne garde QUE les vraies alertes (error/warn) — sinon le client ne saurait plus pourquoi une action échoue. default/success/info → coupés.
    if (opts.type !== 'error' && opts.type !== 'warn') return;
    var stack = ensureToastStack();
    var icon = opts.icon || '';
    var title = opts.title || '';
    var sub = opts.sub || '';
    var type = opts.type || 'default'; // default, success, error, warn, info
    var duration = opts.duration || 4500;
    var actionLabel = opts.actionLabel || '';
    var actionFn = opts.action || opts.actionFn || null;
    var isUrgent = type === 'error' || type === 'warn';

    // Vague 127 : queue management — non-urgent attend qu'une slot se libère ; urgent évince un non-urgent
    var existing = stack.querySelectorAll('.mnl-toast:not(.is-removing)');
    if (existing.length >= TOAST_MAX_VISIBLE) {
      if (!isUrgent) {
        // Enqueue, sera dépilé quand un toast existant disparaîtra
        _toastQueue.push(function(){ window.mnlToast(opts); });
        if (_toastQueue.length > 10) _toastQueue.shift(); // cap anti-leak
        return;
      }
      // Urgent : évince le plus ancien NON-urgent
      var nonUrgent = stack.querySelector('.mnl-toast:not(.is-removing):not(.mnl-toast--error):not(.mnl-toast--warn)');
      if (nonUrgent && typeof nonUrgent._mnlRemove === 'function') nonUrgent._mnlRemove();
      else {
        // Tous urgents → on évince quand même le plus ancien (urgent ou pas)
        var oldest = existing[0];
        if (typeof oldest._mnlRemove === 'function') oldest._mnlRemove();
      }
    }

    var t = document.createElement('div');
    t.className = 'mnl-toast' + (type !== 'default' ? ' mnl-toast--' + type : '');
    // A11y : alert + assertive pour erreur/warn (interrompt le lecteur d'écran), status + polite sinon
    var isUrgent = type === 'error' || type === 'warn';
    t.setAttribute('role', isUrgent ? 'alert' : 'status');
    t.setAttribute('aria-live', isUrgent ? 'assertive' : 'polite');
    t.setAttribute('aria-atomic', 'true');

    // Vague 68 : DOM API au lieu d'innerHTML (anti-XSS si appelant passe title/sub user-controlled)
    // Avant : tout caller devait pré-escape; maintenant garanti. icon = trusted (emoji constants), reste = textContent.
    var iconEl = document.createElement('div');
    iconEl.className = 'mnl-toast__icon';
    iconEl.setAttribute('aria-hidden', 'true');
    iconEl.textContent = String(icon || '').slice(0, 4); // emoji 1-4 chars max
    var txtEl = document.createElement('div');
    txtEl.className = 'mnl-toast__txt';
    var titleEl = document.createElement('p');
    titleEl.className = 'mnl-toast__title';
    titleEl.textContent = String(title || '');
    txtEl.appendChild(titleEl);
    if (sub) {
      var subEl = document.createElement('p');
      subEl.className = 'mnl-toast__sub';
      subEl.textContent = String(sub);
      txtEl.appendChild(subEl);
    }
    t.appendChild(iconEl);
    t.appendChild(txtEl);
    if (actionLabel) {
      var actionBtn = document.createElement('button');
      actionBtn.type = 'button';
      actionBtn.className = 'mnl-toast__action';
      actionBtn.textContent = String(actionLabel);
      t.appendChild(actionBtn);
    }
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'mnl-toast__close';
    closeBtn.setAttribute('aria-label', MNL_T('global.notif_close_label', 'Fermer la notification'));
    closeBtn.textContent = '×';
    t.appendChild(closeBtn);
    stack.appendChild(t);

    var removed = false;
    // Vague 76 : Escape keyboard handler (WCAG 2.1.1) — ferme tous les toasts visibles
    var escapeHandler = function (e) {
      if (e.key === 'Escape' && t.parentNode && !removed) {
        removeT();
      }
    };
    document.addEventListener('keydown', escapeHandler);
    var removeT = function () {
      if (removed || !t.parentNode) return;
      removed = true;
      document.removeEventListener('keydown', escapeHandler); // cleanup listener
      t.classList.add('is-removing');
      setTimeout(function () {
        if (t.parentNode) t.parentNode.removeChild(t);
        // Vague 127 : déclenche dépilage de la queue après removal complet (anim 300ms)
        if (typeof _processQueue === 'function') _processQueue();
      }, 300);
    };
    t.click = removeT; // Allow programmatic close (legacy — préférer _mnlRemove ci-dessous)
    t._mnlRemove = removeT; // Vague 92 : API explicite pour éviction stack (anti-collision .click)

    // Action button
    if (actionFn && actionLabel) {
      t.querySelector('.mnl-toast__action').addEventListener('click', function () {
        try { actionFn(); } catch (_) {}
        removeT();
      });
    }

    // Close button
    t.querySelector('.mnl-toast__close').addEventListener('click', removeT);

    // Auto-dismiss with pause on hover (desktop) + focusin (keyboard a11y)
    // Vague 106 : resume avec REMAINING time réel (avant : reset à 1500ms hardcodé →
    // si toast 6000ms et user hover à 1s, resume donnait 1.5s au lieu de 5s restants).
    var dismissTimer = setTimeout(removeT, duration);
    var startedAt = Date.now();
    var remaining = duration;
    function pauseTimer() {
      if (!dismissTimer) return; // déjà en pause
      clearTimeout(dismissTimer);
      dismissTimer = null;
      // Calcule remaining réel
      var elapsed = Date.now() - startedAt;
      remaining = Math.max(800, duration - elapsed); // minimum 800ms pour ne pas disparaître instant
      t.classList.add('is-paused');
    }
    function resumeTimer() {
      if (dismissTimer) return; // déjà en cours
      t.classList.remove('is-paused');
      startedAt = Date.now();
      duration = remaining; // pour future re-pause
      dismissTimer = setTimeout(removeT, remaining);
    }
    t.addEventListener('mouseenter', pauseTimer);
    t.addEventListener('mouseleave', resumeTimer);
    t.addEventListener('focusin', pauseTimer);
    t.addEventListener('focusout', resumeTimer);

    // Swipe-to-dismiss (mobile)
    // Vague 106 : ajout touchcancel listener (interruption système comme call/notif laissait swiping=true)
    // + remaining time réel après swipe annulé (au lieu de 2000ms arbitraire).
    var startX = 0, currentX = 0, swiping = false;
    function _resetSwipe(){
      swiping = false;
      currentX = 0;
      t.classList.remove('is-swiping');
      t.style.transform = '';
    }
    t.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      swiping = true;
      pauseTimer(); // utilise pauseTimer pour conserver remaining
      t.classList.add('is-swiping');
    }, { passive: true });
    t.addEventListener('touchmove', function (e) {
      if (!swiping) return;
      currentX = e.touches[0].clientX - startX;
      // Vague 106 : accepte swipe gauche ET droite (avant : currentX > 0 seulement = droite, alors que toasts peuvent être left/right selon stack mobile)
      t.style.transform = 'translateX(' + currentX + 'px)';
    }, { passive: true });
    t.addEventListener('touchend', function () {
      if (!swiping) return;
      swiping = false;
      t.classList.remove('is-swiping');
      if (Math.abs(currentX) > 80) {
        removeT();
      } else {
        t.style.transform = '';
        currentX = 0;
        resumeTimer(); // reprend avec remaining réel
      }
    });
    // Vague 106 : touchcancel — interruption système → resume comme si rien ne s'était passé
    t.addEventListener('touchcancel', function () {
      _resetSwipe();
      resumeTimer();
    });

    return t;
  };

  // Helpers raccourcis pour appels rapides
  window.mnlToastSuccess = function (title, sub) { return window.mnlToast({ icon: '✓', title: title, sub: sub, type: 'success' }); };
  window.mnlToastError = function (title, sub) { return window.mnlToast({ icon: '✗', title: title, sub: sub, type: 'error', duration: 6000 }); };
  window.mnlToastInfo = function (title, sub) { return window.mnlToast({ icon: 'ℹ', title: title, sub: sub, type: 'info' }); };
  window.mnlToastWarn = function (title, sub) { return window.mnlToast({ icon: '', title: title, sub: sub, type: 'warn', duration: 5500 }); };

  // ════════════ FORM VALIDATION LIVE (auto-attache aux inputs avec data-mnl-validate) ════════════
  function setFieldState(field, state, msg) {
    if (!field) return;
    field.classList.remove('mnl-field--error', 'mnl-field--success');
    if (state === 'error') field.classList.add('mnl-field--error');
    else if (state === 'success') field.classList.add('mnl-field--success');
    var msgEl = field.querySelector('.mnl-field__msg');
    if (msgEl && state !== 'idle') msgEl.textContent = msg || '';
    else if (msgEl && state === 'idle') {
      // restore hint si data-hint
      var input = field.querySelector('input,textarea,select');
      msgEl.textContent = (input && input.dataset.hint) || '';
    }
    // Vague 114 : ARIA live announcement pour screen readers + lier l'erreur à l'input via aria-describedby/aria-invalid
    if (msgEl) {
      msgEl.setAttribute('role', state === 'error' ? 'alert' : 'status');
      msgEl.setAttribute('aria-live', state === 'error' ? 'assertive' : 'polite');
      // Génère un id stable pour l'erreur si pas déjà set
      if (!msgEl.id) {
        var inp = field.querySelector('input,textarea,select');
        if (inp && inp.id) msgEl.id = inp.id + '-msg';
        else msgEl.id = 'mnl-msg-' + Math.random().toString(36).slice(2, 8);
      }
    }
    var input = field.querySelector('input,textarea,select');
    if (input) {
      if (state === 'error') {
        input.setAttribute('aria-invalid', 'true');
        if (msgEl && msgEl.id) input.setAttribute('aria-describedby', msgEl.id);
      } else if (state === 'success' || state === 'idle') {
        input.removeAttribute('aria-invalid');
      }
    }
  }
  window.mnlSetFieldState = setFieldState;

  function validateInput(input) {
    var field = input.closest('.mnl-field');
    if (!field) return true;
    var val = (input.value || '').trim();
    var type = input.type;
    var required = input.required;

    // Empty + required
    if (required && !val) { setFieldState(field, 'error', MNL_T('global.form_required', 'Ce champ est requis')); return false; }
    if (!val) { setFieldState(field, 'idle'); return true; }

    // Email — Vague 72 : utilise helper consolidé window.mnlValidEmail (WHATWG-like, supporte TLD jusqu'à 63 chars ICANN, refuse double-dot)
    if (type === 'email') {
      var lower = val.toLowerCase();
      if (val.length > 254 || (window.mnlValidEmail && !window.mnlValidEmail(lower))) {
        setFieldState(field, 'error', MNL_T('global.form_email_invalid', 'Email invalide (ex: toi@email.fr)')); return false;
      }
    }
    // Tel — vague 62 : E.164 souple (chiffre obligatoire début ET fin, séparateurs OK au milieu)
    if (type === 'tel') {
      var telRe = /^\+?\d[\d\s().-]{6,18}\d$/;
      if (!telRe.test(val)) { setFieldState(field, 'error', MNL_T('global.form_tel_invalid', 'Numéro invalide (ex: +33 6 12 34 56 78)')); return false; }
    }
    // URL
    if (type === 'url') {
      try { new URL(val); } catch (_) { setFieldState(field, 'error', MNL_T('global.form_url_invalid', 'URL invalide (https://...)')); return false; }
    }
    // Number range
    if (type === 'number') {
      var n = parseFloat(val);
      if (isNaN(n)) { setFieldState(field, 'error', MNL_T('global.form_number_invalid', 'Nombre invalide')); return false; }
      if (input.min !== '' && n < parseFloat(input.min)) { setFieldState(field, 'error', MNL_T('global.form_min_prefix', 'Min : ') + input.min); return false; }
      if (input.max !== '' && n > parseFloat(input.max)) { setFieldState(field, 'error', MNL_T('global.form_max_prefix', 'Max : ') + input.max); return false; }
    }
    // Min/max length
    if (input.minLength > 0 && val.length < input.minLength) { setFieldState(field, 'error', MNL_T('global.form_minlen_prefix', 'Min ') + input.minLength + MNL_T('global.form_chars_suffix', ' caractères')); return false; }
    if (input.maxLength > 0 && val.length > input.maxLength) { setFieldState(field, 'error', MNL_T('global.form_maxlen_prefix', 'Max ') + input.maxLength + MNL_T('global.form_chars_suffix', ' caractères')); return false; }
    // Pattern
    if (input.pattern) {
      try { var re = new RegExp('^(?:' + input.pattern + ')$'); if (!re.test(val)) { setFieldState(field, 'error', input.dataset.patternError || MNL_T('global.form_pattern_invalid', 'Format invalide')); return false; } } catch (_) {}
    }

    setFieldState(field, 'success', input.dataset.successMsg || '');
    return true;
  }
  window.mnlValidateInput = validateInput;

  // Auto-bind sur tous les inputs dans formulaires avec data-mnl-validate
  function bindValidation() {
    document.querySelectorAll('form[data-mnl-validate] input, form[data-mnl-validate] textarea, form[data-mnl-validate] select').forEach(function (input) {
      if (input.dataset.mnlValidateBound) return;
      input.dataset.mnlValidateBound = '1';
      var debounceTimer;
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { validateInput(input); }, 280);
      });
      input.addEventListener('blur', function () { validateInput(input); });
    });
    // Submit handler : validate all + block if any error
    document.querySelectorAll('form[data-mnl-validate]').forEach(function (form) {
      if (form.dataset.mnlValidateBound) return;
      form.dataset.mnlValidateBound = '1';
      form.addEventListener('submit', function (e) {
        var allOk = true;
        form.querySelectorAll('input,textarea,select').forEach(function (input) {
          if (!validateInput(input)) allOk = false;
        });
        if (!allOk) {
          e.preventDefault();
          if (typeof window.mnlToastError === 'function') {
            window.mnlToastError(MNL_T('global.form_check_title', 'Vérifie les champs'), MNL_T('global.form_check_sub', 'Certains champs nécessitent une correction'));
          }
          // Focus premier champ en erreur
          var firstErr = form.querySelector('.mnl-field--error input,.mnl-field--error textarea,.mnl-field--error select');
          if (firstErr) { firstErr.focus(); firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        }
      });
    });
  }
  // Re-bind si DOM dynamique (debounce 200ms via pool partagé)
  if (window.mnlOnDomChange) window.mnlOnDomChange(bindValidation, 200);
  else bindValidation();

  // ════════════ FORM AUTOSAVE DRAFTS (data-mnl-autosave) ════════════
  // Vague 112 : autosave drafts pour textareas longs (contact form, review submit, message custom).
  // Avant : si user tape 10 lignes et le browser crash / nav back → tout perdu.
  // Maintenant : autosave debounce 1s en localStorage, restore au mount, clear au submit.
  function setupFormAutosave(){
    document.querySelectorAll('form[data-mnl-autosave], textarea[data-mnl-autosave], input[data-mnl-autosave]').forEach(function(el){
      if (el.dataset.mnlAutosaveBound) return;
      el.dataset.mnlAutosaveBound = '1';
      var saveKey = 'mnl-draft-' + (el.id || el.name || el.getAttribute('data-mnl-autosave') || 'unnamed');
      // Champs concernés (si form, on autosave chaque textarea/input non-password)
      var fields = el.tagName === 'FORM'
        ? el.querySelectorAll('textarea, input:not([type=password]):not([type=hidden]):not([type=file]):not([type=submit]):not([type=checkbox]):not([type=radio])')
        : [el];
      // Restore au mount si draft existe
      try {
        var raw = localStorage.getItem(saveKey);
        if (raw) {
          var draft = JSON.parse(raw);
          // Skip si > 7 jours (anti stale)
          if (draft.ts && (Date.now() - draft.ts) < 7 * 24 * 60 * 60 * 1000 && draft.values) {
            fields.forEach(function(f){
              if (f.name && draft.values[f.name] && !f.value) {
                f.value = draft.values[f.name];
              }
            });
            // Subtle hint au user qu'on a restauré un brouillon
            if (Object.keys(draft.values).length > 0 && window.mnlToast) {
              window.mnlToast({ icon: '', title: MNL_T('global.draft_restored_title', 'Brouillon restauré'), sub: MNL_T('global.draft_restored_sub', 'Reprends où tu t\'es arrêté'), type: 'info', duration: 3500 });
            }
          } else {
            localStorage.removeItem(saveKey);
          }
        }
      } catch(_){}
      // Save handler (debounce 1s)
      var saveTimer;
      function _save(){
        clearTimeout(saveTimer);
        saveTimer = setTimeout(function(){
          try {
            var values = {};
            fields.forEach(function(f){
              if (f.name && f.value) values[f.name] = String(f.value).slice(0, 5000);
            });
            if (Object.keys(values).length === 0) {
              localStorage.removeItem(saveKey);
            } else {
              localStorage.setItem(saveKey, JSON.stringify({ ts: Date.now(), values: values }));
            }
          } catch(_){}
        }, 1000);
      }
      fields.forEach(function(f){
        f.addEventListener('input', _save);
      });
      // Clear draft au submit successful (form scope only)
      if (el.tagName === 'FORM') {
        el.addEventListener('submit', function(){
          try { localStorage.removeItem(saveKey); } catch(_){}
        });
      }
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupFormAutosave, 200);
  else setupFormAutosave();

  // ════════════ IMAGE ZOOM LIGHTBOX (swipe + clavier) ════════════
  function initImageZoom() {
    var overlay = document.getElementById('mnl-zoom-overlay');
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.id = 'mnl-zoom-overlay';
    overlay.className = 'mnl-zoom-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', MNL_T('global.zoom_dialog_label', 'Image agrandie'));
    overlay.innerHTML =
      MNL_T('global.zoom_close_html', '<button type="button" class="mnl-zoom-overlay__close" aria-label="Fermer">×</button>') +
      MNL_T('global.zoom_prev_html', '<button type="button" class="mnl-zoom-overlay__nav mnl-zoom-overlay__nav--prev" aria-label="Image précédente">‹</button>') +
      '<img class="mnl-zoom-overlay__img" alt="">' +
      MNL_T('global.zoom_next_html', '<button type="button" class="mnl-zoom-overlay__nav mnl-zoom-overlay__nav--next" aria-label="Image suivante">›</button>') +
      '<div class="mnl-zoom-overlay__counter"></div>';
    document.body.appendChild(overlay);
    return overlay;
  }

  var zoomGroup = [], zoomIdx = 0;

  function openZoom(src, group, idx) {
    var overlay = initImageZoom();
    zoomGroup = group || [src];
    zoomIdx = (typeof idx === 'number') ? idx : 0;
    updateZoom();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function updateZoom() {
    var overlay = document.getElementById('mnl-zoom-overlay');
    if (!overlay) return;
    var img = overlay.querySelector('.mnl-zoom-overlay__img');
    var counter = overlay.querySelector('.mnl-zoom-overlay__counter');
    var prevBtn = overlay.querySelector('.mnl-zoom-overlay__nav--prev');
    var nextBtn = overlay.querySelector('.mnl-zoom-overlay__nav--next');
    img.src = zoomGroup[zoomIdx];
    counter.textContent = (zoomIdx + 1) + ' / ' + zoomGroup.length;
    prevBtn.style.display = nextBtn.style.display = (zoomGroup.length > 1) ? '' : 'none';
    counter.style.display = (zoomGroup.length > 1) ? '' : 'none';
  }

  function closeZoom() {
    var overlay = document.getElementById('mnl-zoom-overlay');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function nextZoom() { zoomIdx = (zoomIdx + 1) % zoomGroup.length; updateZoom(); }
  function prevZoom() { zoomIdx = (zoomIdx - 1 + zoomGroup.length) % zoomGroup.length; updateZoom(); }

  // Click delegation : tout <img data-mnl-zoom>
  document.addEventListener('click', function (e) {
    var img = e.target.closest('img[data-mnl-zoom]');
    if (img) {
      e.preventDefault();
      // Group : tous les data-mnl-zoom-group=ID identiques
      var groupId = img.dataset.mnlZoomGroup;
      var group = [], idx = 0;
      if (groupId) {
        var imgs = document.querySelectorAll('img[data-mnl-zoom-group="' + groupId + '"]');
        imgs.forEach(function (i, k) {
          var hi = i.dataset.mnlZoomFull || i.src;
          group.push(hi);
          if (i === img) idx = k;
        });
      } else {
        group = [img.dataset.mnlZoomFull || img.src];
      }
      openZoom(img.src, group, idx);
      return;
    }
    // Click sur overlay (mais pas sur l'image)
    var overlay = e.target.closest('.mnl-zoom-overlay');
    if (overlay && (e.target === overlay || e.target.classList.contains('mnl-zoom-overlay__img'))) {
      closeZoom();
      return;
    }
    if (e.target.closest('.mnl-zoom-overlay__close')) { closeZoom(); return; }
    if (e.target.closest('.mnl-zoom-overlay__nav--next')) { nextZoom(); return; }
    if (e.target.closest('.mnl-zoom-overlay__nav--prev')) { prevZoom(); return; }
  });

  // Keyboard nav (Esc / arrows)
  document.addEventListener('keydown', function (e) {
    var overlay = document.getElementById('mnl-zoom-overlay');
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeZoom();
    if (e.key === 'ArrowRight') nextZoom();
    if (e.key === 'ArrowLeft') prevZoom();
  });

  // Swipe mobile
  var zoomTouchStartX = 0, zoomTouchEndX = 0;
  document.addEventListener('touchstart', function (e) {
    var overlay = document.getElementById('mnl-zoom-overlay');
    if (!overlay || !overlay.classList.contains('is-open')) return;
    zoomTouchStartX = e.touches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    var overlay = document.getElementById('mnl-zoom-overlay');
    if (!overlay || !overlay.classList.contains('is-open')) return;
    zoomTouchEndX = e.changedTouches[0].clientX;
    var dx = zoomTouchEndX - zoomTouchStartX;
    if (Math.abs(dx) > 60) {
      if (dx < 0) nextZoom(); else prevZoom();
    }
  });

  // API publique
  window.mnlOpenZoom = openZoom;
  window.mnlCloseZoom = closeZoom;

  // [SUPPRIMÉ] Scroll-to-top button : remplacé par setupBackToTop() vague 9 (mnl-back-to-top, mieux design + a11y).

  // ════════════ REVEAL ON SCROLL — auto-bind sur sections + stagger ════════════
  if ('IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          revealObs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    function bindReveal() {
      // Auto-add reveal class sur sections et grids communs + tout élément avec [data-mnl-reveal]
      document.querySelectorAll('[data-mnl-reveal], .mnl-pp3-fact, .mnl-pp3-press-card, .mnl-pp3-pillar, .mnl-pp3-persona, .mnl-pp3-discover-card, .mnl-pp3-step, .mnl-pp3-wall__card, .mnl-pp3-vs-col, .mnl-pp3-faq__item, .mnl-pp3-faqlite__item, .mnl-pp3-cmp__table tr, .mnl-pp3-certif, .mnl-hf-card, .mnl-cmp__row, .mnl-eng__pillar, .mnl-eng__metric, .mnl-eng__cert, .mnl-co2__break-item, .mnl-amb-hof-card, .mnl-amb-program__perk, .mnl-ll__level, .mnl-press__article, .mnl-press__fact, .mnl-foot__main > div').forEach(function (el) {
        if (el.classList.contains('mnl-reveal') || el.dataset.mnlRevealBound) return;
        el.dataset.mnlRevealBound = '1';
        el.classList.add('mnl-reveal');
        var delay = el.getAttribute('data-mnl-reveal-delay');
        if (delay) el.style.setProperty('--mnl-reveal-delay', delay + 'ms');
        revealObs.observe(el);
      });
      // Stagger groups : applique sur grids
      document.querySelectorAll('.mnl-pp3-pillars, .mnl-pp3-personas, .mnl-pp3-discover, .mnl-hf__grid, .mnl-eng__pillar-grid, .mnl-amb-hof, .mnl-press__facts-grid').forEach(function (group) {
        if (group.classList.contains('mnl-reveal-stagger') || group.dataset.mnlStaggerBound) return;
        group.dataset.mnlStaggerBound = '1';
        group.classList.add('mnl-reveal-stagger');
        revealObs.observe(group);
      });
    }
    if (window.mnlOnDomChange) window.mnlOnDomChange(bindReveal, 200);
    else bindReveal();
  }

  // ════════════ RECENTLY VIEWED WIDGET (popup floating bottom-right) ════════════
  function setupRecentlyViewedWidget() {
    return; // V827 : widget « récemment vus » désactivé (demande fondateur — aucune utilité avec un seul produit personnalisable).
    var rv = [];
    try { rv = JSON.parse(localStorage.getItem('mnl-recently-viewed') || '[]'); } catch (_) {}
    if (!Array.isArray(rv) || rv.length < 1) return;
    // Skip si on est déjà sur une fiche produit (le widget ne sert qu'ailleurs)
    if (window.location.pathname.indexOf('/products/') === 0) return;

    var widget = document.createElement('button');
    widget.type = 'button';
    widget.id = 'mnl-rv-widget';
    widget.className = 'mnl-rv-widget is-active';
    widget.setAttribute('aria-label', MNL_T('global.rv_widget_label', 'Voir mes produits récemment vus'));
    widget.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px" aria-hidden="true"><path d="M1.5 12S5 5 12 5s10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12z"/><circle cx="12" cy="12" r="3"/></svg><span class="mnl-rv-widget__badge">' + Math.min(rv.length, 9) + '</span>';
    document.body.appendChild(widget);

    var panel = document.createElement('div');
    panel.id = 'mnl-rv-panel';
    panel.className = 'mnl-rv-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', MNL_T('global.rv_panel_label', 'Produits récemment vus'));
    // Vague 93 : utilise item.title + image (avant : juste handle moche + emoji partout)
    function _rvEsc(s) {
      return String(s || '').replace(/[&<>"']/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; });
    }
    var itemsHTML = rv.slice(0, 5).map(function (item) {
      var isStr = (typeof item === 'string');
      var handle = isStr ? item : item.handle;
      if (!handle) return '';
      var url = (!isStr && item.url) ? item.url : ('/products/' + handle);
      var label = (!isStr && item.title) ? item.title : handle.replace(/-/g, ' ').replace(/\b\w/g, function (l) { return l.toUpperCase(); });
      var imgUrl = (!isStr && item.image) ? item.image : '';
      var iconHtml = imgUrl
        ? '<img class="mnl-rv-panel__item-img" src="' + _rvEsc(imgUrl) + '" alt="" loading="lazy" decoding="async" width="36" height="36">'
        : '<span class="mnl-rv-panel__item-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3h6"/><path d="M10 3v5.6L4.7 17.2A2 2 0 0 0 6.5 20h11a2 2 0 0 0 1.8-2.8L14 8.6V3"/><path d="M7.2 14h9.6"/></svg></span>';
      return '<a href="' + _rvEsc(url) + '" class="mnl-rv-panel__item">' +
        iconHtml +
        '<span class="mnl-rv-panel__item-text">' + _rvEsc(label) + '</span>' +
      '</a>';
    }).join('');
    panel.innerHTML = MNL_T('global.rv_panel_close_html', '<button type="button" class="mnl-rv-panel__close" aria-label="Fermer">×</button>') +
      MNL_T('global.rv_panel_title_html', '<p class="mnl-rv-panel__title"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:5px" aria-hidden="true"><path d="M1.5 12S5 5 12 5s10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12z"/><circle cx="12" cy="12" r="3"/></svg>Récemment vus</p>') +
      '<div class="mnl-rv-panel__list">' + itemsHTML + '</div>' +
      MNL_T('global.rv_panel_clear_html', '<button type="button" class="mnl-rv-panel__clear" data-mnl-rv-clear-panel><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:5px" aria-hidden="true"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"/></svg>Tout effacer</button>');
    document.body.appendChild(panel);

    widget.addEventListener('click', function () {
      panel.classList.toggle('is-open');
    });
    panel.querySelector('.mnl-rv-panel__close').addEventListener('click', function () {
      panel.classList.remove('is-open');
    });
    // Vague 93 : clear all + sync cross-widget via custom event
    var clearBtn = panel.querySelector('[data-mnl-rv-clear-panel]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function(){
        try { localStorage.removeItem('mnl-recently-viewed'); } catch(_){}
        panel.classList.remove('is-open');
        widget.style.display = 'none';
        if (window.mnlToast) window.mnlToast({ icon: '', title: MNL_T('global.rv_history_cleared', 'Historique effacé'), sub: '', type: 'info', duration: 3000 });
        document.dispatchEvent(new CustomEvent('mnl:rv:cleared'));
      });
    }
    // Vague 93 : si un autre widget clear, on hide aussi
    document.addEventListener('mnl:rv:cleared', function(){
      panel.classList.remove('is-open');
      widget.style.display = 'none';
    });
    document.addEventListener('click', function (e) {
      if (!widget.contains(e.target) && !panel.contains(e.target)) {
        panel.classList.remove('is-open');
      }
    });
  }
  setTimeout(setupRecentlyViewedWidget, 1500);

  // ════════════ GREETING PERSONNALISÉ (Liquid renvoie  si log) ════════════
  // Utilisable via : <span class="mnl-greeting">Hi <span class="mnl-greeting__name" data-mnl-greeting-name>Athlète</span></span>
  // Le DOM est mis à jour côté Liquid au render. Côté JS on peut animer l'arrivée.
  document.querySelectorAll('[data-mnl-greeting-name]').forEach(function (el) {
    el.style.opacity = '0';
    el.style.transition = 'opacity .4s ease';
    requestAnimationFrame(function () { el.style.opacity = '1'; });
  });

  // Greeting selon l'heure (Bonjour / Bonsoir / Bonne nuit)
  window.mnlTimeGreeting = function () {
    var h = new Date().getHours();
    if (h < 5) return MNL_T('global.greeting_night', 'Tu carbures la nuit');
    if (h < 12) return MNL_T('global.greeting_morning', 'Bonjour');
    if (h < 18) return MNL_T('global.greeting_afternoon', 'Bon après-midi');
    if (h < 22) return MNL_T('global.greeting_evening', 'Bonsoir');
    return MNL_T('global.greeting_late_evening', 'Bonne soirée');
  };
  document.querySelectorAll('[data-mnl-time-greeting]').forEach(function (el) {
    el.textContent = window.mnlTimeGreeting();
  });

  // ════════════ WISHLIST HEART TOGGLE (data-mnl-wishlist="handle") ════════════
  // Vague 76 : cross-tab sync via BroadcastChannel + storage event fallback
  // Vague 174 : refactor MULTI-LISTES — structure v2 {lists, activeId} avec backward compat full
  //   - Migration auto depuis v1 (single array) au premier load
  //   - getWishlist() retourne TOUJOURS items de la liste active (zéro changement pour anciens consumers)
  //   - 3 listes preset par défaut : 'fav' (♥ Mes favoris), 'totest' (À tester), 'reorder' (Récurrents)
  //   - localStorage 'mnl-wishlist' garde sync avec items liste active (backward compat heart icon + cross-tab)
  //   - localStorage 'mnl-wishlist-v2' stocke la structure multi-listes complète
  var _wlBC = null;
  try { if ('BroadcastChannel' in window) _wlBC = new BroadcastChannel('mnl-wishlist'); } catch (_) {}

  var WL_V2_KEY = 'mnl-wishlist-v2';
  var WL_V1_KEY = 'mnl-wishlist'; // kept synced with active list for backward compat
  var WL_DEFAULT_LISTS = [
    { id: 'fav', name: MNL_T('global.wl_list_favorites', 'Mes favoris'), icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px"><path d="M12 20s-7-4.6-9.3-9C1.4 8.6 2.8 5.5 6 5.5c2 0 3.2 1.3 4 2.5.8-1.2 2-2.5 4-2.5 3.2 0 4.6 3.1 3.3 5.5C19 15.4 12 20 12 20z"/></svg>', items: [] },
    { id: 'totest', name: MNL_T('global.wl_list_totest', 'À tester'), icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px"><path d="M9 3h6"/><path d="M10 3v5.6L4.7 17.2A2 2 0 0 0 6.5 20h11a2 2 0 0 0 1.8-2.8L14 8.6V3"/><path d="M7.2 14h9.6"/></svg>', items: [] },
    { id: 'reorder', name: MNL_T('global.wl_list_reorder', 'Récurrents'), icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px"><path d="M17 2.5 20.5 6 17 9.5"/><path d="M3.5 11.5v-1.2A4.3 4.3 0 0 1 7.8 6h12.7"/><path d="M7 21.5 3.5 18 7 14.5"/><path d="M20.5 12.5v1.2a4.3 4.3 0 0 1-4.3 4.3H3.5"/></svg>', items: [] }
  ];

  // V948 — Rend une icône de liste wishlist : SVG inline si markup SVG, sinon texte échappé.
  // Source UNIQUE pour tous les rendus (onglets, popover long-press, états vides) => aucun chemin
  // ne peut afficher le code SVG brut en texte (bug capture mobile : <svg viewBox...> en littéral).
  function _wlEsc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }
  window.mnlWlIconHtml = function(icon){
    var s = String(icon == null ? '' : icon).trim();
    return (s.indexOf('<svg') === 0) ? s : _wlEsc(s);
  };

  function _getWlState() {
    // Read v2 structure, fallback to v1 migration if missing
    try {
      var raw = localStorage.getItem(WL_V2_KEY);
      if (raw) {
        var s = JSON.parse(raw);
        if (s && Array.isArray(s.lists) && s.lists.length) {
          return s;
        }
      }
    } catch (_) {}
    // Migration v1 → v2 : seed default lists, put v1 items in 'fav'
    var v1Items = [];
    try {
      var v1Raw = localStorage.getItem(WL_V1_KEY);
      if (v1Raw) {
        var v1 = JSON.parse(v1Raw);
        if (Array.isArray(v1)) v1Items = v1;
      }
    } catch (_) {}
    var seed = {
      lists: WL_DEFAULT_LISTS.map(function(l){ return { id: l.id, name: l.name, icon: l.icon, items: l.id === 'fav' ? v1Items.slice() : [] }; }),
      activeId: 'fav'
    };
    try { localStorage.setItem(WL_V2_KEY, JSON.stringify(seed)); } catch (_) {}
    return seed;
  }
  function _saveWlState(state) {
    try {
      localStorage.setItem(WL_V2_KEY, JSON.stringify(state));
      // Sync v1 key avec items liste active (backward compat — autres consumers lisent encore mnl-wishlist)
      var activeList = state.lists.find(function(l){ return l.id === state.activeId; });
      var activeItems = activeList ? activeList.items : [];
      localStorage.setItem(WL_V1_KEY, JSON.stringify(activeItems));
      // Cross-tab sync
      document.dispatchEvent(new CustomEvent('mnl:wishlist:updated', { detail: activeItems }));
      document.dispatchEvent(new CustomEvent('mnl:wishlist:lists:updated', { detail: state }));
      if (_wlBC) try { _wlBC.postMessage({ type: 'wishlist:updated', list: activeItems, state: state, ts: Date.now() }); } catch (_) {}
    } catch (_) {}
  }
  function _getActiveList() {
    var state = _getWlState();
    return state.lists.find(function(l){ return l.id === state.activeId; }) || state.lists[0];
  }

  function getWishlist() {
    // Backward compat : retourne TOUJOURS items de la liste active
    var active = _getActiveList();
    return active ? active.items : [];
  }
  function saveWishlist(list) {
    // Backward compat : écrit dans la liste active
    var state = _getWlState();
    var active = state.lists.find(function(l){ return l.id === state.activeId; });
    if (!active) return;
    active.items = list;
    _saveWlState(state);
  }
  window.mnlGetWishlist = getWishlist;

  /* Vague 174 : API publique MULTI-LISTES */
  window.mnlGetWishlistLists = function() {
    var state = _getWlState();
    return state.lists.map(function(l){
      return { id: l.id, name: l.name, icon: l.icon, count: (l.items || []).length, active: l.id === state.activeId };
    });
  };
  window.mnlGetActiveWishlistId = function() { return _getWlState().activeId; };
  window.mnlSetActiveWishlistId = function(id) {
    var state = _getWlState();
    if (!state.lists.some(function(l){ return l.id === id; })) return false;
    state.activeId = id;
    _saveWlState(state);
    if (typeof syncWishlistButtons === 'function') syncWishlistButtons();
    return true;
  };
  window.mnlCreateWishlistList = function(name, icon) {
    name = String(name || '').trim().slice(0, 40);
    icon = String(icon || '').slice(0, 4);
    if (!name) return null;
    var state = _getWlState();
    if (state.lists.length >= 10) return null; // cap 10 listes max
    var id = 'list-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 6);
    state.lists.push({ id: id, name: name, icon: icon, items: [] });
    _saveWlState(state);
    return id;
  };
  window.mnlRenameWishlistList = function(id, newName) {
    newName = String(newName || '').trim().slice(0, 40);
    if (!newName) return false;
    var state = _getWlState();
    var list = state.lists.find(function(l){ return l.id === id; });
    if (!list) return false;
    list.name = newName;
    _saveWlState(state);
    return true;
  };
  window.mnlDeleteWishlistList = function(id) {
    var state = _getWlState();
    if (state.lists.length <= 1) return false; // ne supprime jamais la dernière
    var idx = state.lists.findIndex(function(l){ return l.id === id; });
    if (idx === -1) return false;
    state.lists.splice(idx, 1);
    // Si on supprime la liste active → bascule sur la première
    if (state.activeId === id) state.activeId = state.lists[0].id;
    _saveWlState(state);
    if (typeof syncWishlistButtons === 'function') syncWishlistButtons();
    return true;
  };
  window.mnlMoveWishlistItem = function(handle, fromId, toId) {
    if (fromId === toId) return false;
    var state = _getWlState();
    var from = state.lists.find(function(l){ return l.id === fromId; });
    var to = state.lists.find(function(l){ return l.id === toId; });
    if (!from || !to) return false;
    var idx = from.items.findIndex(function(it){ return (typeof it === 'string' ? it : it.handle) === handle; });
    if (idx === -1) return false;
    var item = from.items.splice(idx, 1)[0];
    // Si l'item existe déjà dans la liste target (par handle), skip pour pas doublon
    var existsInTarget = to.items.some(function(it){ return (typeof it === 'string' ? it : it.handle) === handle; });
    if (!existsInTarget) to.items.unshift(item);
    _saveWlState(state);
    if (typeof syncWishlistButtons === 'function') syncWishlistButtons();
    return true;
  };

  /* Vague 183 : WISHLIST SNAPSHOTS auto-history (undo safety net contre suppression accidentelle)
     Sauvegarde max 30 snapshots dans 'mnl-wishlist-snapshots', 1 par jour OU à chaque modif majeure.
     Permet restore d'un état précédent en cas d'erreur. */
  var WL_SNAP_KEY = 'mnl-wishlist-snapshots';
  var WL_SNAP_MAX = 30;
  var _wlSnapDebounce = null;
  function _maybeSnapshot() {
    /* Debounce 3s : groupe les modifs rapides en 1 seul snapshot */
    if (_wlSnapDebounce) clearTimeout(_wlSnapDebounce);
    _wlSnapDebounce = setTimeout(function(){
      try {
        var state = _getWlState();
        var totalItems = state.lists.reduce(function(s, l){ return s + l.items.length; }, 0);
        if (totalItems === 0) return; // ne snapshot pas un état vide
        var snaps = [];
        try { snaps = JSON.parse(localStorage.getItem(WL_SNAP_KEY) || '[]'); } catch(_){}
        // Skip si dernier snapshot identique (anti-spam)
        var lastSnap = snaps[0];
        var newSummary = totalItems + 'i-' + state.lists.length + 'l-' + state.activeId;
        if (lastSnap && lastSnap.summary === newSummary) return;
        var snapshot = {
          ts: Date.now(),
          summary: newSummary,
          totalItems: totalItems,
          listsCount: state.lists.length,
          state: state
        };
        snaps.unshift(snapshot);
        if (snaps.length > WL_SNAP_MAX) snaps = snaps.slice(0, WL_SNAP_MAX);
        try { localStorage.setItem(WL_SNAP_KEY, JSON.stringify(snaps)); } catch(_){}
      } catch(_){}
    }, 3000);
  }
  /* Listener auto sur tous les changements wishlist */
  document.addEventListener('mnl:wishlist:lists:updated', _maybeSnapshot);

  /* API publique snapshots */
  window.mnlGetWishlistSnapshots = function() {
    try {
      var snaps = JSON.parse(localStorage.getItem(WL_SNAP_KEY) || '[]');
      // Retourne metadata seulement (pas le state complet pour économiser memoryUI)
      return snaps.map(function(s){ return { ts: s.ts, totalItems: s.totalItems, listsCount: s.listsCount }; });
    } catch(_){ return []; }
  };
  window.mnlRestoreWishlistSnapshot = function(ts) {
    try {
      var snaps = JSON.parse(localStorage.getItem(WL_SNAP_KEY) || '[]');
      var snap = snaps.find(function(s){ return s.ts === ts; });
      if (!snap || !snap.state) return false;
      _saveWlState(snap.state);
      if (typeof syncWishlistButtons === 'function') syncWishlistButtons();
      return true;
    } catch(_){ return false; }
  };
  window.mnlClearWishlistSnapshots = function() {
    try { localStorage.removeItem(WL_SNAP_KEY); return true; } catch(_){ return false; }
  };

  /* Vague 182 : REORDER items dans une liste — nouveau public API pour drag-and-drop UI */
  window.mnlReorderWishlistItems = function(listId, newOrder) {
    if (!Array.isArray(newOrder)) return false;
    var state = _getWlState();
    var list = state.lists.find(function(l){ return l.id === listId; });
    if (!list) return false;
    // newOrder = array de handles dans le nouvel ordre — on remap les items existants
    var byHandle = {};
    list.items.forEach(function(it){
      var h = typeof it === 'string' ? it : it.handle;
      if (h) byHandle[h] = it;
    });
    var reordered = newOrder.map(function(h){ return byHandle[h]; }).filter(Boolean);
    // Ajoute les items absents du newOrder à la fin (safety net pour pas perdre d'items)
    Object.keys(byHandle).forEach(function(h){
      if (newOrder.indexOf(h) === -1) reordered.push(byHandle[h]);
    });
    list.items = reordered;
    _saveWlState(state);
    return true;
  };

  /* Vague 177 : SHARE WISHLIST URL — encode liste en base64 dans URL pour partage gifting */
  window.mnlEncodeWishlistList = function(listId) {
    var state = _getWlState();
    var list = state.lists.find(function(l){ return l.id === listId; });
    if (!list) return null;
    // Strip ts pour réduire payload (gardons juste handle + title)
    var slim = {
      n: list.name.slice(0, 40),
      i: list.icon,
      h: (list.items || []).slice(0, 30).map(function(it){
        var item = typeof it === 'string' ? { handle: it } : it;
        return { h: String(item.handle || '').slice(0, 80), t: String(item.title || '').slice(0, 80) };
      })
    };
    try {
      var json = JSON.stringify(slim);
      // btoa supporte ASCII seulement → encode UTF-8 d'abord via encodeURIComponent
      var b64 = btoa(unescape(encodeURIComponent(json)));
      // URL-safe base64
      return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch(_) { return null; }
  };
  window.mnlDecodeWishlistList = function(b64) {
    try {
      // Restore standard base64
      var std = String(b64).replace(/-/g, '+').replace(/_/g, '/');
      while (std.length % 4) std += '=';
      var json = decodeURIComponent(escape(atob(std)));
      var parsed = JSON.parse(json);
      if (!parsed || typeof parsed !== 'object' || !Array.isArray(parsed.h)) return null;
      // Sanitize : items array of {handle, title} avec handle validé slug + title truncated
      return {
        name: String(parsed.n || MNL_T('global.wl_shared_list', 'Liste partagée')).slice(0, 40),
        icon: String(parsed.i || '').slice(0, 4),
        items: parsed.h.slice(0, 30).map(function(it){
          if (!it || typeof it !== 'object') return null;
          var h = String(it.h || '').toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 80);
          if (!h) return null;
          return { handle: h, title: String(it.t || h.replace(/-/g, ' ')).slice(0, 80), ts: Date.now() };
        }).filter(Boolean)
      };
    } catch(_) { return null; }
  };
  window.mnlImportSharedWishlist = function(decoded) {
    if (!decoded || !decoded.name || !Array.isArray(decoded.items)) return null;
    var state = _getWlState();
    if (state.lists.length >= 10) return null; // cap 10 listes
    var id = 'list-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 6);
    state.lists.push({
      id: id,
      name: decoded.name + MNL_T('global.wl_shared_suffix', ' (partagée)'),
      icon: decoded.icon,
      items: decoded.items
    });
    _saveWlState(state);
    return id;
  };
  // Vague 76 : listener cross-tab — quand un autre onglet modifie la wishlist, on re-sync les boutons + UI
  if (_wlBC) {
    _wlBC.addEventListener('message', function (e) {
      if (e.data && e.data.type === 'wishlist:updated') {
        // Re-sync sans re-broadcaster (sinon boucle infinie)
        try { syncWishlistButtons(); } catch (_) {}
        document.dispatchEvent(new CustomEvent('mnl:wishlist:updated', { detail: e.data.list || [] }));
      }
    });
  }
  // Fallback : storage event (déclenché si autre onglet modifie localStorage)
  window.addEventListener('storage', function (e) {
    if (e.key === 'mnl-wishlist' && !_wlBC) { // si BroadcastChannel non dispo, fallback storage
      try { syncWishlistButtons(); } catch (_) {}
      document.dispatchEvent(new CustomEvent('mnl:wishlist:updated', { detail: getWishlist() }));
    }
  });

  function syncWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-mnl-wishlist]').forEach(function (btn) {
      var handle = btn.getAttribute('data-mnl-wishlist');
      var inList = list.some(function (item) { return (typeof item === 'string' ? item : item.handle) === handle; });
      btn.classList.toggle('is-active', inList);
      btn.setAttribute('aria-pressed', inList ? 'true' : 'false');
      if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', inList ? MNL_T('global.wl_remove_label', 'Retirer de la wishlist') : MNL_T('global.wl_add_label', 'Ajouter à la wishlist'));
      btn.innerHTML = inList ? '♥' : '♡';
    });
  }

  // BUG FIX vague 52 : mutex anti race condition (5 clicks rapides → perte d'items sinon)
  var _wlBusy = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-wishlist]');
    if (!btn) return;
    e.preventDefault();
    if (_wlBusy) return;
    _wlBusy = true;
    setTimeout(function(){ _wlBusy = false; }, 150); // libère après 150ms
    var handle = btn.getAttribute('data-mnl-wishlist');
    var title = btn.getAttribute('data-mnl-wishlist-title') || handle.replace(/-/g, ' ');
    // Re-lit la liste juste avant write (anti TOCTOU)
    var list = getWishlist();
    var idx = list.findIndex(function (item) { return (typeof item === 'string' ? item : item.handle) === handle; });
    if (idx > -1) {
      list.splice(idx, 1);
      saveWishlist(list);
      syncWishlistButtons();
      // Custom event analytics : retrait
      document.dispatchEvent(new CustomEvent('mnl:wishlist:removed', { detail: { handle: handle, title: title } }));
      if (window.mnlToast) {
        /* Vague 176 : toast retrait list-aware */
        var _rmActiveListInfo = null;
        try {
          if (typeof window.mnlGetWishlistLists === 'function') {
            var _rmLists = window.mnlGetWishlistLists();
            _rmActiveListInfo = _rmLists.find(function(l){ return l.active; });
          }
        } catch(_){}
        var rmListLabel = _rmActiveListInfo ? (_rmActiveListInfo.icon + ' ' + _rmActiveListInfo.name) : MNL_T('global.wl_default_list_name', 'la wishlist');
        window.mnlToast({ icon: '♡', title: MNL_T('global.wl_removed_from_prefix', 'Retiré de ') + rmListLabel, sub: title, type: 'info', duration: 3000 });
      }
    } else {
      list.unshift({ handle: handle, title: title, ts: Date.now() });
      // Vague 93 : toast explicite si limite atteinte (avant : slice silencieux → user
      // croyait avoir ajouté mais ses anciens items étaient virés sans préavis)
      var _wlOverflow = false;
      if (list.length > 30) {
        list = list.slice(0, 30);
        _wlOverflow = true;
      }
      saveWishlist(list);
      syncWishlistButtons();
      btn.classList.add('is-just-added');
      setTimeout(function () { btn.classList.remove('is-just-added'); }, 600);
      // Custom event analytics : ajout
      document.dispatchEvent(new CustomEvent('mnl:wishlist:added', { detail: { handle: handle, title: title } }));
      if (_wlOverflow) {
        if (window.mnlToast) window.mnlToast({
          icon: '',
          title: 'Wishlist pleine (30 max)',
          sub: MNL_T('global.wl_oldest_removed', 'L\'item le plus ancien a été retiré pour faire de la place.'),
          type: 'warn',
          duration: 5500,
          actionLabel: MNL_T('global.common_see', 'Voir'),
          action: function () { window.location.href = '/pages/wishlist'; }
        });
      } else if (window.mnlToast) {
        /* Vague 176 : toast list-aware — mentionne la liste active pour éviter confusion multi-listes */
        var _activeListInfo = null;
        try {
          if (typeof window.mnlGetWishlistLists === 'function') {
            var _lists = window.mnlGetWishlistLists();
            _activeListInfo = _lists.find(function(l){ return l.active; });
          }
        } catch(_){}
        var listLabel = _activeListInfo ? (_activeListInfo.icon + ' ' + _activeListInfo.name) : MNL_T('global.wl_default_list_name', 'la wishlist');
        window.mnlToast({
          icon: '♥',
          title: MNL_T('global.wl_added_to_prefix', 'Ajouté à ') + listLabel,
          sub: title + (_activeListInfo && _activeListInfo.count >= 2 ? MNL_T('global.wl_longpress_hint', ' · long-press ♡ pour choisir') : ''),
          type: 'success',
          actionLabel: MNL_T('global.common_see', 'Voir'),
          action: function () { window.location.href = '/pages/wishlist'; }
        });
      }
    }
  });

  /* ════════════ Vague 175 : LONG-PRESS HEART → CHOOSE TARGET LIST ════════════
     Sur tap long (>500ms) du ♡ → popover affiche les listes utilisateur.
     Click sur une liste → ajoute item à CETTE liste (au lieu de la liste active).
     Pattern iOS/Pinterest. */
  (function _initLongPressListPicker(){
    var _lpTimer = null;
    var _lpStartTarget = null;
    var _lpFired = false;
    var POPOVER_ID = 'mnl-wl-list-picker';

    function _closePicker(){
      var p = document.getElementById(POPOVER_ID);
      if (p) p.remove();
      document.removeEventListener('click', _outsideClose, true);
    }
    function _outsideClose(e){
      var p = document.getElementById(POPOVER_ID);
      if (p && !p.contains(e.target) && !e.target.closest('[data-mnl-wishlist]')) _closePicker();
    }

    function _showPicker(heartBtn) {
      _closePicker();
      if (typeof window.mnlGetWishlistLists !== 'function') return;
      var lists = window.mnlGetWishlistLists();
      var handle = heartBtn.getAttribute('data-mnl-wishlist');
      var title = heartBtn.getAttribute('data-mnl-wishlist-title') || handle.replace(/-/g, ' ');
      var rect = heartBtn.getBoundingClientRect();

      var pop = document.createElement('div');
      pop.id = POPOVER_ID;
      pop.setAttribute('role', 'menu');
      pop.setAttribute('aria-label', MNL_T('global.wl_pick_list_label', 'Choisir une liste wishlist'));
      pop.style.cssText = 'position:fixed;top:' + (rect.bottom + window.scrollY + 8) + 'px;left:' + Math.max(8, rect.left + window.scrollX - 120) + 'px;background:#fff;border:1px solid rgba(15,23,42,.1);border-radius:14px;box-shadow:0 18px 44px rgba(15,23,42,.18);padding:6px;z-index:99999;min-width:200px;font-family:inherit;animation:mnl-wl-pop-in .15s ease;';

      var header = document.createElement('div');
      header.style.cssText = 'padding:8px 12px 6px;font-size:11px;font-weight:800;color:#94a3b8;text-transform:uppercase;letter-spacing:.05em;border-bottom:1px solid #f1f5f9;';
      header.textContent = MNL_T('global.wl_add_to_header', 'Ajouter à…');
      pop.appendChild(header);

      lists.forEach(function(l){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('role', 'menuitem');
        btn.style.cssText = 'display:flex;align-items:center;gap:10px;width:100%;text-align:left;background:transparent;border:0;padding:10px 12px;border-radius:8px;font-family:inherit;font-size:13px;font-weight:600;color:#0f172a;cursor:pointer;transition:background .15s ease;';
        btn.innerHTML = '<span style="font-size:18px;line-height:1;display:inline-flex;align-items:center;color:#C2410C;" aria-hidden="true">' + (window.mnlWlIconHtml ? window.mnlWlIconHtml(l.icon) : escapeHtml(l.icon)) + '</span>' +
          '<span style="flex:1;">' + escapeHtml(l.name) + '</span>' +
          '<span style="font-size:11px;color:#94a3b8;font-weight:700;background:#f1f5f9;padding:2px 8px;border-radius:100px;">' + l.count + '</span>';
        btn.addEventListener('mouseenter', function(){ btn.style.background = '#f8fafc'; });
        btn.addEventListener('mouseleave', function(){ btn.style.background = 'transparent'; });
        btn.addEventListener('click', function(e){
          e.stopPropagation();
          var state = (function(){ try { return JSON.parse(localStorage.getItem(WL_V2_KEY)) || null; } catch(_){ return null; } })();
          if (!state) { _closePicker(); return; }
          var targetList = state.lists.find(function(x){ return x.id === l.id; });
          if (!targetList) { _closePicker(); return; }
          // Check si déjà dans cette liste
          var existsIdx = targetList.items.findIndex(function(it){ return (typeof it === 'string' ? it : it.handle) === handle; });
          if (existsIdx > -1) {
            // Déjà présent → retire
            targetList.items.splice(existsIdx, 1);
            _saveWlState(state);
            syncWishlistButtons();
            if (window.mnlToast) window.mnlToast({ icon: '♡', title: MNL_T('global.wl_removed_from_prefix', 'Retiré de ') + l.name, sub: title, type: 'info', duration: 2500 });
          } else {
            // Cap 30 par liste
            if (targetList.items.length >= 30) {
              if (window.mnlToast) window.mnlToast({ icon: '', title: MNL_T('global.wl_list_full', 'Liste pleine (30 max)'), sub: l.name, type: 'warn', duration: 3500 });
              _closePicker();
              return;
            }
            targetList.items.unshift({ handle: handle, title: title, ts: Date.now() });
            _saveWlState(state);
            syncWishlistButtons();
            if (window.mnlToast) window.mnlToast({ icon: '♥', title: MNL_T('global.wl_added_to_prefix', 'Ajouté à ') + l.name, sub: title, type: 'success', duration: 2500, actionLabel: MNL_T('global.common_see', 'Voir'), action: function(){ window.location.href = '/pages/wishlist'; } });
            try { if (navigator.vibrate) navigator.vibrate(15); } catch(_){}
          }
          _closePicker();
        });
        pop.appendChild(btn);
      });

      // Footer : lien vers /pages/wishlist
      var footer = document.createElement('a');
      footer.href = '/pages/wishlist';
      footer.style.cssText = 'display:block;text-align:center;padding:8px 12px;border-top:1px solid #f1f5f9;font-size:11px;font-weight:700;color:#C2410C;text-decoration:none;margin-top:4px;';
      footer.textContent = MNL_T('global.wl_manage_lists', '→ Gérer mes listes');
      pop.appendChild(footer);

      // Inject keyframes 1× si pas déjà là
      if (!document.getElementById('mnl-wl-pop-kfs')) {
        var st = document.createElement('style');
        st.id = 'mnl-wl-pop-kfs';
        st.textContent = '@keyframes mnl-wl-pop-in{from{opacity:0;transform:scale(.94) translateY(-4px);}to{opacity:1;transform:scale(1) translateY(0);}}@media(prefers-reduced-motion:reduce){#' + POPOVER_ID + '{animation:none;}}';
        document.head.appendChild(st);
      }
      document.body.appendChild(pop);
      // Outside click closes
      setTimeout(function(){ document.addEventListener('click', _outsideClose, true); }, 50);
      // ESC closes
      document.addEventListener('keydown', function _esc(e){
        if (e.key === 'Escape') {
          _closePicker();
          document.removeEventListener('keydown', _esc);
        }
      });
    }

    function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }

    // Touch + mouse handlers
    function _onPressStart(e) {
      var btn = e.target.closest('[data-mnl-wishlist]');
      if (!btn) return;
      _lpStartTarget = btn;
      _lpFired = false;
      _lpTimer = setTimeout(function(){
        _lpFired = true;
        _showPicker(btn);
        try { if (navigator.vibrate) navigator.vibrate([15, 30, 15]); } catch(_){} // double vibrate confirme long-press
      }, 500);
    }
    function _onPressEnd(e) {
      if (_lpTimer) { clearTimeout(_lpTimer); _lpTimer = null; }
      // Si long-press a fired → preventDefault pour éviter le toggle click suivant
      if (_lpFired) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      _lpStartTarget = null;
    }
    function _onPressCancel() {
      if (_lpTimer) { clearTimeout(_lpTimer); _lpTimer = null; }
      _lpStartTarget = null;
      _lpFired = false;
    }

    document.addEventListener('touchstart', _onPressStart, { passive: true });
    document.addEventListener('touchend', _onPressEnd);
    document.addEventListener('touchcancel', _onPressCancel, { passive: true });
    document.addEventListener('mousedown', _onPressStart);
    document.addEventListener('mouseup', _onPressEnd);
    document.addEventListener('mouseleave', _onPressCancel, true);
    // Scroll/touchmove cancel long-press (évite faux positifs lors d'un scroll)
    document.addEventListener('touchmove', _onPressCancel, { passive: true });
  })();

  // BUG FIX vague 52 : sync cross-tab. Sans ce listener, si user a 2 onglets (PDP + collection)
  // et ajoute en favoris dans l'un, l'icône cœur ne se met PAS à jour dans l'autre.
  window.addEventListener('storage', function(e){
    if (e.key === 'mnl-wishlist') syncWishlistButtons();
  });
  if (window.mnlOnDomChange) window.mnlOnDomChange(syncWishlistButtons, 200);
  else syncWishlistButtons();

  // ════════════ COPY-TO-CLIPBOARD UNIFIÉ (data-mnl-copy="texte") ════════════
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-copy]');
    if (!btn) return;
    e.preventDefault();
    var text = btn.getAttribute('data-mnl-copy');
    if (!text) return;
    var label = btn.getAttribute('data-mnl-copy-label') || MNL_T('global.copied_bang', 'Copié !');
    var sub = btn.getAttribute('data-mnl-copy-sub') || text;
    var doCopy = function (t) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(t);
      }
      // Fallback execCommand
      return new Promise(function (resolve, reject) {
        try {
          var ta = document.createElement('textarea');
          ta.value = t; ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select();
          document.execCommand('copy'); document.body.removeChild(ta);
          resolve();
        } catch (_) { reject(); }
      });
    };
    doCopy(text).then(function () {
      // V711 : feedback DANS le bouton (plus de toast — demande fondateur). Animation "✓ Copié" + pop.
      var origText = btn.textContent;
      var origBg = btn.style.background;
      var origColor = btn.style.color;
      btn.style.transition = 'background .2s ease, color .2s ease, transform .2s cubic-bezier(.34,1.56,.64,1)';
      btn.style.background = '#16a34a';
      btn.style.color = '#fff';
      btn.style.transform = 'scale(1.05)';
      btn.textContent = '✓ ' + label;
      if (window.mnlHaptic) window.mnlHaptic('success');
      setTimeout(function () { btn.style.background = origBg; btn.style.color = origColor; btn.style.transform = ''; btn.textContent = origText; }, 1400);
    }).catch(function () {
      var oT = btn.textContent; btn.style.background = '#dc2626'; btn.style.color = '#fff'; btn.textContent = MNL_T('global.copy_failed_short', '✗ Échec');
      setTimeout(function () { btn.style.background = ''; btn.style.color = ''; btn.textContent = oT; }, 1600);
    });
  });

  // ════════════ CHARACTER COUNTER (textarea avec data-mnl-counter) ════════════
  function bindCharCounters() {
    document.querySelectorAll('textarea[data-mnl-counter], input[data-mnl-counter]').forEach(function (input) {
      if (input.dataset.mnlCounterBound) return;
      input.dataset.mnlCounterBound = '1';
      var max = parseInt(input.getAttribute('maxlength'), 10) || parseInt(input.getAttribute('data-mnl-counter'), 10) || 500;
      var counter = document.createElement('div');
      counter.className = 'mnl-field__counter';
      counter.setAttribute('aria-live', 'polite');
      var update = function () {
        var len = input.value.length;
        counter.textContent = len + ' / ' + max;
        var field = input.closest('.mnl-field');
        if (field) field.classList.toggle('mnl-field--error', len > max * 0.95 && len <= max);
      };
      input.parentNode.style.position = 'relative';
      input.parentNode.appendChild(counter);
      input.addEventListener('input', update);
      update();
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(bindCharCounters, 200);
  else bindCharCounters();

  // ════════════ QUANTITY STEPPER STANDARDISÉ (auto-bind data-mnl-stepper) ════════════
  // Usage HTML : <div class="mnl-stepper" data-mnl-stepper data-min="1" data-max="10">
  //               <button data-mnl-stepper-dec>−</button>
  //               <span class="mnl-stepper__val" data-mnl-stepper-val>1</span>
  //               <button data-mnl-stepper-inc>+</button>
  //               <input type="hidden" data-mnl-stepper-input value="1">
  //             </div>
  // Init disabled state au load (avant : up/down toujours enabled même au min/max)
  function initSteppers() {
    document.querySelectorAll('[data-mnl-stepper]').forEach(function (stepper) {
      if (stepper.dataset.mnlStBound) return;
      stepper.dataset.mnlStBound = '1';
      var valEl = stepper.querySelector('[data-mnl-stepper-val]');
      var inputEl = stepper.querySelector('[data-mnl-stepper-input]');
      var min = parseInt(stepper.getAttribute('data-min'), 10) || 1;
      var max = parseInt(stepper.getAttribute('data-max'), 10) || 99;
      var cur = parseInt(valEl ? valEl.textContent : (inputEl ? inputEl.value : '1'), 10) || min;
      // Sync val ↔ input si désynchro initiale
      if (valEl && inputEl && valEl.textContent.trim() !== inputEl.value) inputEl.value = valEl.textContent.trim();
      var decBtn = stepper.querySelector('[data-mnl-stepper-dec]');
      var incBtn = stepper.querySelector('[data-mnl-stepper-inc]');
      if (decBtn) decBtn.disabled = (cur <= min);
      if (incBtn) incBtn.disabled = (cur >= max);
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(initSteppers, 200);
  else initSteppers();
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-stepper-inc], [data-mnl-stepper-dec]');
    if (!btn) return;
    var stepper = btn.closest('[data-mnl-stepper]');
    if (!stepper) return;
    var valEl = stepper.querySelector('[data-mnl-stepper-val]');
    var inputEl = stepper.querySelector('[data-mnl-stepper-input]');
    var min = parseInt(stepper.getAttribute('data-min'), 10) || 1;
    var max = parseInt(stepper.getAttribute('data-max'), 10) || 99;
    var cur = parseInt(valEl ? valEl.textContent : (inputEl ? inputEl.value : '1'), 10) || 1;
    var delta = btn.hasAttribute('data-mnl-stepper-inc') ? 1 : -1;
    var next = Math.max(min, Math.min(max, cur + delta));
    if (next === cur) return;
    if (valEl) {
      valEl.textContent = next;
      valEl.classList.add('is-flashing');
      setTimeout(function () { valEl.classList.remove('is-flashing'); }, 400);
    }
    if (inputEl) {
      inputEl.value = next;
      inputEl.dispatchEvent(new Event('input', { bubbles: true }));
      inputEl.dispatchEvent(new Event('change', { bubbles: true }));
    }
    // Disable buttons aux limites
    var decBtn = stepper.querySelector('[data-mnl-stepper-dec]');
    var incBtn = stepper.querySelector('[data-mnl-stepper-inc]');
    if (decBtn) decBtn.disabled = (next <= min);
    if (incBtn) incBtn.disabled = (next >= max);
    // Custom event pour réagir
    stepper.dispatchEvent(new CustomEvent('mnl:stepper:change', { detail: { value: next, delta: delta } }));
  });

  // ════════════ NEWSLETTER INLINE CONFIRMATION (intercepte les forms newsletter) ════════════
  // Auto-attache aux <form data-mnl-newsletter> ou form contact[tags]=newsletter
  // V996 : intercepteur AJAX newsletter SUPPRIMÉ. La boutique a la protection anti-spam (CAPTCHA) :
  // un POST fetch n'embarque PAS de jeton CAPTCHA → Shopify répond 400 « Missing CAPTCHA token »
  // → AUCUN client créé → aucun email Klaviyo. Désormais TOUS les formulaires newsletter (footer, blog)
  // se soumettent en NATIF : le CAPTCHA Shopify s'exécute au submit, le client est créé + abonné, la page
  // recharge et affiche le succès serveur (form.posted_successfully?). showNewsletterConfirm ci-dessous
  // n'est donc plus appelée (conservée sans effet pour ne rien casser).
  function showNewsletterConfirm(form, email) {
    var confirm = form.parentNode.querySelector('.mnl-nl-confirm');
    if (!confirm) {
      confirm = document.createElement('div');
      confirm.className = 'mnl-nl-confirm';
      confirm.innerHTML =
        '<span class="mnl-nl-confirm__icon" aria-hidden="true">✓</span>' +
        MNL_T('global.nl_confirm_title_html', '<p class="mnl-nl-confirm__title">Inscription confirmée</p>') +
        MNL_T('global.nl_confirm_sub_html', '<p class="mnl-nl-confirm__sub">Code <strong>MNL10</strong> envoyé à ton email.</p>') +
        MNL_T('global.nl_confirm_code_html', '<span class="mnl-nl-confirm__code" data-mnl-copy="MNL10" data-mnl-copy-label="Code copié">MNL10 — clic pour copier</span>');
      form.parentNode.insertBefore(confirm, form.nextSibling);
    }
    form.style.display = 'none';
    confirm.classList.add('is-visible');
    if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.nl_subscribed_title', 'Inscrit !'), MNL_T('global.nl_code_sent_prefix', 'Code MNL10 envoyé à ') + email);
  }

  // ════════════ STICKY TABLE OF CONTENTS (auto-build sur pages avec data-mnl-toc) ════════════
  // Vague 68 : disconnect ancien observer avant rebuild (anti-leak si mnlOnDomChange tire 10×)
  var _tocObserver = null;
  function buildTOC() {
    var container = document.querySelector('[data-mnl-toc]');
    if (!container || container.querySelector('.mnl-toc')) return;
    // Cleanup observer précédent si existait
    if (_tocObserver) { try { _tocObserver.disconnect(); } catch (_) {} _tocObserver = null; }
    var headingsScope = document.querySelector(container.getAttribute('data-mnl-toc-scope') || 'main');
    if (!headingsScope) return;
    var headingsSelector = container.getAttribute('data-mnl-toc-selector') || 'h2, h3';
    var headings = headingsScope.querySelectorAll(headingsSelector);
    // Auto-génère un ID si manquant (slug du textContent)
    headings.forEach(function (h) {
      if (!h.id) {
        var slug = (h.textContent || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
        if (slug) h.id = 'sec-' + slug;
      }
    });
    // Filtre uniquement les headings qui ont un id (évite link cassé)
    headings = Array.prototype.filter.call(headings, function (h) { return h.id; });
    if (headings.length < 3) return;
    var nav = document.createElement('nav');
    nav.className = 'mnl-toc';
    nav.setAttribute('aria-label', MNL_T('global.toc_label', 'Sommaire de la page'));
    nav.innerHTML = '<p class="mnl-toc__title">Sommaire</p><ul class="mnl-toc__list"></ul>';
    var ul = nav.querySelector('.mnl-toc__list');
    headings.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.replace(/^[\s\W]+|[\s\W]+$/g, '').replace(/\s+/g, ' ').slice(0, 60);
      if (h.tagName === 'H3') a.classList.add('mnl-toc__h3');
      li.appendChild(a);
      ul.appendChild(li);
    });
    container.appendChild(nav);
    // Highlight active section au scroll
    if ('IntersectionObserver' in window) {
      _tocObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            ul.querySelectorAll('a').forEach(function (a) { a.classList.remove('is-active'); });
            var active = ul.querySelector('a[href="#' + e.target.id + '"]');
            if (active) active.classList.add('is-active');
          }
        });
      }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
      headings.forEach(function (h) { _tocObserver.observe(h); });
    }
  }
  // Re-build au DOM change (utile si contenu chargé async)
  if (window.mnlOnDomChange) window.mnlOnDomChange(buildTOC, 500);
  else buildTOC();

  // ════════════ PRINT BUTTON (data-mnl-print[="selector"]) ════════════
  // Sans valeur : imprime toute la page. Avec selector : imprime uniquement la section ciblée.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-print]');
    if (!btn) return;
    e.preventDefault();
    var sel = btn.getAttribute('data-mnl-print');
    if (!sel) { window.print(); return; }
    // Print scope-only : ajoute classe sur body, masque tout sauf le sélecteur via CSS @print
    var target;
    try { target = document.querySelector(sel); } catch (_) { window.print(); return; }
    if (!target) { window.print(); return; }
    // Marque la cible et utilise la classe globale mnl-print-only sur body (CSS print masque le reste)
    target.classList.add('mnl-print-target');
    document.body.classList.add('mnl-print-scoped');
    window.print();
    setTimeout(function () {
      target.classList.remove('mnl-print-target');
      document.body.classList.remove('mnl-print-scoped');
    }, 500);
  });

  // ════════════ QUICK VIEW MODAL (data-mnl-qv-trigger="product-handle") ════════════
  function ensureQVModal() {
    var modal = document.getElementById('mnl-qv-modal');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'mnl-qv-modal';
    modal.className = 'mnl-qv';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', MNL_T('global.qv_dialog_label', 'Aperçu rapide produit'));
    modal.innerHTML =
      '<div class="mnl-qv__panel">' +
        MNL_T('global.qv_close_html', '<button type="button" class="mnl-qv__close" aria-label="Fermer l\'aperçu">×</button>') +
        '<div class="mnl-qv__media">' +
          '<img class="mnl-qv__main-img" alt="" loading="lazy">' +
          MNL_T('global.qv_thumbs_html', '<div class="mnl-qv__thumbs" role="tablist" aria-label="Galerie images produit" style="display:none;gap:8px;margin-top:12px;flex-wrap:wrap;"></div>') +
        '</div>' +
        '<div class="mnl-qv__body">' +
          MNL_T('global.qv_eyebrow_html', '<p style="margin:0;font-size:11px;font-weight:800;color:#94a3b8;letter-spacing:.12em;text-transform:uppercase">— Aperçu rapide</p>') +
          '<h2 class="mnl-qv__title" style="margin:0;font-size:24px;font-weight:900;color:#0f172a;letter-spacing:-.02em"></h2>' +
          '<p class="mnl-qv__price" style="margin:0;font-size:22px;font-weight:900;background:#E84E1B;-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent"></p>' +
          '<p class="mnl-qv__desc" style="margin:0;font-size:14px;color:#475569;line-height:1.55"></p>' +
          '<div style="display:flex;gap:10px;margin-top:auto">' +
            MNL_T('global.qv_cta_html', '<a class="mnl-qv__cta" style="flex:1;display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:14px 24px;background:#E84E1B;color:#fff;font-size:14px;font-weight:800;text-decoration:none;border-radius:100px;box-shadow:0 8px 20px rgba(194,65,12,.35);transition:transform .2s ease">Voir la fiche complète →</a>') +
            MNL_T('global.qv_wishlist_btn_html', '<button type="button" class="mnl-qv__wl" data-mnl-wishlist="" aria-label="Ajouter à la wishlist" style="width:48px;height:48px;border:1.5px solid rgba(15,23,42,.1);border-radius:50%;background:#fff;font-size:20px;cursor:pointer;color:#475569;transition:all .2s ease">♡</button>') +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    // Vague 53 : délégateur thumb click → swap main image
    modal.addEventListener('click', function(e){
      var thumb = e.target.closest('.mnl-qv__thumb');
      if (!thumb) return;
      var img = modal.querySelector('.mnl-qv__main-img');
      img.src = thumb.dataset.full || thumb.src;
      modal.querySelectorAll('.mnl-qv__thumb').forEach(function(t){ t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-selected', 'true');
    });
    return modal;
  }

  // Vague 93 : focus restoration + trap pour QV modal (a11y)
  var _qvLastFocus = null;
  var _qvUntrap = null;
  function openQuickView(productData) {
    var modal = ensureQVModal();
    var img = modal.querySelector('.mnl-qv__main-img');
    var thumbsWrap = modal.querySelector('.mnl-qv__thumbs');
    var title = modal.querySelector('.mnl-qv__title');
    var price = modal.querySelector('.mnl-qv__price');
    var desc = modal.querySelector('.mnl-qv__desc');
    var cta = modal.querySelector('.mnl-qv__cta');
    var wlBtn = modal.querySelector('.mnl-qv__wl');
    // Vague 93 : retire le loading state si présent
    modal.classList.remove('is-loading');
    img.src = productData.image || '';
    img.alt = productData.title || '';
    title.textContent = productData.title || '';
    price.textContent = productData.price || '';
    desc.textContent = productData.description || '';
    cta.href = productData.url || '#';
    wlBtn.setAttribute('data-mnl-wishlist', productData.handle || '');
    wlBtn.setAttribute('data-mnl-wishlist-title', productData.title || '');
    // Vague 53 : carousel multi-images si productData.images fourni (array de URLs)
    if (productData.images && Array.isArray(productData.images) && productData.images.length > 1) {
      thumbsWrap.innerHTML = '';
      thumbsWrap.style.display = 'flex';
      productData.images.slice(0, 6).forEach(function(url, idx){
        var thumb = document.createElement('img');
        thumb.className = 'mnl-qv__thumb' + (idx === 0 ? ' is-active' : '');
        thumb.src = url;
        thumb.dataset.full = url;
        thumb.alt = productData.title + ' — image ' + (idx + 1);
        thumb.loading = 'lazy';
        thumb.setAttribute('role', 'tab');
        thumb.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
        thumb.style.cssText = 'width:60px;height:60px;border-radius:8px;object-fit:cover;cursor:pointer;border:2px solid transparent;transition:border-color .2s ease;';
        thumbsWrap.appendChild(thumb);
      });
      // CSS .is-active style inline (sera surclassé par CSS si défini)
      var styleEl = document.getElementById('mnl-qv-thumbs-style');
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = 'mnl-qv-thumbs-style';
        styleEl.textContent = '.mnl-qv__thumb.is-active{border-color:#C2410C !important;}.mnl-qv__thumb:hover{border-color:#cbd5e1;}';
        document.head.appendChild(styleEl);
      }
    } else {
      thumbsWrap.style.display = 'none';
      thumbsWrap.innerHTML = '';
    }
    syncWishlistButtons();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Vague 93 : focus management + trap (a11y)
    requestAnimationFrame(function(){
      var closeBtn = modal.querySelector('.mnl-qv__close');
      if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch(_) { closeBtn.focus(); } }
      if (window.mnlTrapFocus) {
        try { _qvUntrap = window.mnlTrapFocus(modal); } catch(_){ _qvUntrap = null; }
      }
    });
  }
  // Vague 93 : skeleton loading state immédiat (avant : modal s'ouvrait vide → flash 200-800ms)
  function openQuickViewLoading() {
    var modal = ensureQVModal();
    var img = modal.querySelector('.mnl-qv__main-img');
    var title = modal.querySelector('.mnl-qv__title');
    var price = modal.querySelector('.mnl-qv__price');
    var desc = modal.querySelector('.mnl-qv__desc');
    var cta = modal.querySelector('.mnl-qv__cta');
    img.src = '';
    img.alt = '';
    title.textContent = '';
    price.textContent = '';
    desc.textContent = '';
    cta.href = '#';
    modal.classList.add('is-loading', 'is-open');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){
      var closeBtn = modal.querySelector('.mnl-qv__close');
      if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch(_) { closeBtn.focus(); } }
    });
  }
  function closeQuickView() {
    var modal = document.getElementById('mnl-qv-modal');
    if (modal) {
      modal.classList.remove('is-open');
      modal.classList.remove('is-loading');
    }
    document.body.style.overflow = '';
    // Vague 93 : libère focus trap + rend focus à l'élément déclencheur
    if (typeof _qvUntrap === 'function') {
      try { _qvUntrap(); } catch(_){}
      _qvUntrap = null;
    }
    if (_qvLastFocus && typeof _qvLastFocus.focus === 'function' && document.body.contains(_qvLastFocus)) {
      try { _qvLastFocus.focus({ preventScroll: true }); } catch(_) { try { _qvLastFocus.focus(); } catch(__){} }
    }
    _qvLastFocus = null;
  }
  window.mnlOpenQuickView = openQuickView;
  window.mnlCloseQuickView = closeQuickView;

  // Vague 93 : cache mémoire QV pour éviter re-fetch (avant : chaque ouverture refetchait /products/{handle}.js,
  // même 2× dans la même minute → bande passante gâchée + latence visible)
  var _qvCache = {};
  var _qvInFlight = {};
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mnl-qv-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var handle = trigger.getAttribute('data-mnl-qv-trigger');
      // Vague 68 : whitelist handle (anti-injection URL) + check r.ok (avant : 404 → .json() crashait silencieusement)
      if (!handle || !/^[a-z0-9_-]{1,80}$/i.test(handle)) {
        if (window.mnlToastError) window.mnlToastError(MNL_T('global.qv_invalid_title', 'Aperçu invalide'), MNL_T('global.qv_invalid_sub', 'Lien produit non reconnu'));
        return;
      }
      // Vague 93 : mémorise focus déclencheur + ouvre modal en loading state immédiatement
      _qvLastFocus = trigger;
      // Si déjà en cache → ouvre direct, pas de loading
      if (_qvCache[handle]) {
        openQuickView(_qvCache[handle]);
        return;
      }
      openQuickViewLoading();
      // Dédup : si fetch déjà en vol pour ce handle, attend la promesse existante
      var fetchPromise = _qvInFlight[handle];
      if (!fetchPromise) {
        fetchPromise = fetch('/products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin',
          cache: 'default' // tire profit du HTTP cache Shopify (Cache-Control: max-age=120)
        })
          .then(function (r) {
            if (!r.ok) {
              if (r.status === 404) throw new Error('Produit introuvable');
              throw new Error('HTTP ' + r.status);
            }
            return r.json();
          })
          .then(function (p) {
            if (!p || !p.handle) throw new Error('Réponse invalide');
            var payload = {
              handle: p.handle,
              title: p.title || '',
              description: (p.description || '').replace(/<[^>]*>/g, '').slice(0, 200) + '...',
              price: (typeof p.price === 'number' ? (p.price / 100).toFixed(2).replace('.', ',') : '—') + ' €',
              image: p.featured_image,
              images: p.images || [],
              url: '/products/' + p.handle
            };
            _qvCache[p.handle] = payload; // cache 1h via fact que SPA pas reload souvent
            return payload;
          })
          .finally(function(){
            delete _qvInFlight[handle];
          });
        _qvInFlight[handle] = fetchPromise;
      }
      fetchPromise
        .then(function (payload) { openQuickView(payload); })
        .catch(function (err) {
          closeQuickView(); // retire le loading state
          var msg = (err && err.message === 'Produit introuvable') ? MNL_T('global.qv_gone_msg', 'Ce produit n\'existe plus') : MNL_T('global.qv_retry_msg', 'Réessaie ou ouvre la fiche complète');
          if (window.mnlToastError) window.mnlToastError(MNL_T('global.qv_unavailable_title', 'Aperçu indisponible'), msg);
        });
      return;
    }
    var modal = document.getElementById('mnl-qv-modal');
    if (!modal || !modal.classList.contains('is-open')) return;
    if (e.target === modal || e.target.closest('.mnl-qv__close')) closeQuickView();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = document.getElementById('mnl-qv-modal');
      if (modal && modal.classList.contains('is-open')) closeQuickView();
    }
  });

  // ════════════ LOADING BAR TOP (page transitions Nprogress-style) ════════════
  function setupLoadingBar() {
    if (document.getElementById('mnl-loading-bar')) return;
    var bar = document.createElement('div');
    bar.id = 'mnl-loading-bar';
    bar.className = 'mnl-loading-bar';
    bar.setAttribute('role', 'progressbar');
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
  }
  setupLoadingBar();

  var loadingProgress = 0, loadingTrickleTimer;
  window.mnlLoadingStart = function () {
    var bar = document.getElementById('mnl-loading-bar');
    if (!bar) return;
    loadingProgress = 0;
    bar.classList.add('is-loading');
    bar.style.width = '20%';
    clearInterval(loadingTrickleTimer);
    loadingTrickleTimer = setInterval(function () {
      loadingProgress = Math.min(85, loadingProgress + Math.random() * 8);
      bar.style.width = (20 + loadingProgress * 0.65) + '%';
    }, 400);
  };
  window.mnlLoadingDone = function () {
    var bar = document.getElementById('mnl-loading-bar');
    if (!bar) return;
    clearInterval(loadingTrickleTimer);
    bar.style.width = '100%';
    setTimeout(function () {
      bar.classList.remove('is-loading');
      setTimeout(function () { bar.style.width = '0'; }, 300);
    }, 200);
  };

  // Intercepte les click sur liens internes pour démarrer la loading bar
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
    if (a.target === '_blank' || a.hasAttribute('download')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var url;
    try { url = new URL(a.href, window.location.origin); } catch (_) { return; }
    if (url.origin !== window.location.origin) return;
    if (url.pathname === window.location.pathname && url.hash) return;
    window.mnlLoadingStart();
  });
  window.addEventListener('pageshow', window.mnlLoadingDone);
  window.addEventListener('beforeunload', window.mnlLoadingStart);

  // ════════════ MINI CART HOVER PREVIEW (desktop, header cart icon) ════════════
  function setupMiniCartHover() {
    var triggers = document.querySelectorAll('[data-mnl-cart-toggle]');
    if (!triggers.length) return;
    var preview;
    function ensurePreview() {
      if (preview) return preview;
      preview = document.createElement('div');
      preview.className = 'mnl-mc-hover';
      preview.setAttribute('aria-hidden', 'true');
      preview.innerHTML = MNL_T('global.mc_hover_shell_html', '<div class="mnl-mc-hover__title">Aperçu panier <small></small></div><div class="mnl-mc-hover__items"></div><div class="mnl-mc-hover__total"></div><a href="/cart" class="mnl-mc-hover__cta">Voir le panier complet →</a>');
      return preview;
    }
    var hoverTimer;
    function show(trigger) {
      var prev = ensurePreview();
      // Position : attache au parent du trigger
      var parent = trigger.offsetParent || trigger.parentNode;
      if (parent.style.position === '' || parent.style.position === 'static') parent.style.position = 'relative';
      parent.appendChild(prev);
      // Fetch cart
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var titleSmall = prev.querySelector('.mnl-mc-hover__title small');
          titleSmall.textContent = items.length + ' article' + (items.length > 1 ? 's' : '');
          var itemsEl = prev.querySelector('.mnl-mc-hover__items');
          var totalEl = prev.querySelector('.mnl-mc-hover__total');
          if (!items.length) {
            itemsEl.innerHTML = MNL_T('global.mc_hover_empty_html', '<div class="mnl-mc-hover__empty">Ton panier est vide</div>');
            totalEl.style.display = 'none';
            prev.querySelector('.mnl-mc-hover__cta').textContent = MNL_T('global.mc_hover_discover_cta', 'Découvrir nos produits →');
            prev.querySelector('.mnl-mc-hover__cta').href = '/products/pre-workout-mynutrilab-personnalisable-au-mg-pres';
          } else {
            itemsEl.innerHTML = items.slice(0, 4).map(function (it) {
              return '<div class="mnl-mc-hover__item">' +
                '<div class="mnl-mc-hover__item-img">' + (it.image ? '<img src="' + it.image.replace(/_(\d+)x\.|_(\d+)x(\d+)\.|\.(jpg|jpeg|png|webp)/i, '_60x.$1$2$3$4') + '" alt="">' : '') + '</div>' +
                '<div class="mnl-mc-hover__item-info">' +
                  '<p class="mnl-mc-hover__item-name">' + (window.mnlEscapeHtml ? window.mnlEscapeHtml(it.product_title) : it.product_title) + '</p>' +
                  '<p class="mnl-mc-hover__item-meta">×' + it.quantity + ' · ' + (it.price / 100).toFixed(2).replace('.', ',') + ' €</p>' +
                '</div>' +
              '</div>';
            }).join('') + (items.length > 4 ? '<div style="text-align:center;font-size:11px;color:#94a3b8;font-weight:600;padding:4px;">+ ' + (items.length - 4) + ' autre' + (items.length - 4 > 1 ? 's' : '') + '</div>' : '');
            totalEl.style.display = 'flex';
            /* V1212b : l'aperçu au survol de l'icône panier était la dernière surface à montrer le total
               PLEIN pendant que le tiroir et la page /panier affichaient déjà le prix après MNL10.
               V1215 : le garde « aucun abonnement » a sauté — MNL10 est posé avec
               appliesOnSubscription = true, donc il tombe AUSSI en abonnement. Conditions restantes,
               les mêmes que partout ailleurs : éligible, ≥ 39 €, aucun code déjà posé.
               _sub ne bloque donc plus rien, il choisit le LIBELLÉ : recurringCycleLimit = 1 → les
               −10 € ne valent que pour la 1ʳᵉ LIVRAISON (les suivantes gardent le −10 % du plan).
               Écrire « 1ʳᵉ commande » sur un panier en abonnement laisserait croire à −10 € à chaque
               prélèvement. La bulle n'a la place que d'une ligne : la mention tient en trois mots sous
               le montant, mais on ne laisse JAMAIS le montant barré sans qualification. */
            var _eur = function(c){ return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
            var _ok = true;
            try { if (typeof window.mnlFirstOrderEligible === 'function') _ok = window.mnlFirstOrderEligible(); } catch(_){}
            var _sub = false, _codePose = false;
            try { _sub = (cart.items || []).some(function(i){ return i && i.selling_plan_allocation; }); } catch(_){}
            try { _codePose = (cart.cart_level_discount_applications || []).length > 0; } catch(_){}
            var _net = _ok && !_codePose && cart.total_price >= 3900;
            var _note = _sub ? MNL_T('global.mc_hover_note_sub', 'MNL10 · 1ʳᵉ livraison') : MNL_T('global.mc_hover_note_first', 'MNL10 · 1ʳᵉ commande');
            totalEl.innerHTML = MNL_T('global.mc_hover_total_html', '<span>Total</span>')
              + (_net
                  ? '<span style="display:flex;flex-direction:column;align-items:flex-end;line-height:1.15;">'
                      + '<strong><s style="opacity:.55;font-weight:600;font-size:.78em;margin-right:5px;">' + _eur(cart.total_price) + '</s>' + _eur(cart.total_price - 1000) + '</strong>'
                      + '<em style="font-style:normal;font-size:10px;font-weight:700;color:#1a1a1a;margin-top:2px;white-space:nowrap;">' + _note + '</em>'
                    + '</span>'
                  : '<strong>' + _eur(cart.total_price) + '</strong>');
            prev.querySelector('.mnl-mc-hover__cta').textContent = MNL_T('global.mc_hover_cart_cta_prefix', 'Voir le panier (') + items.length + ') →';
            prev.querySelector('.mnl-mc-hover__cta').href = '/cart';
          }
          prev.classList.add('is-visible');
          prev.setAttribute('aria-hidden', 'false');
        }).catch(function () {});
    }
    function hide() {
      if (preview) {
        preview.classList.remove('is-visible');
        preview.setAttribute('aria-hidden', 'true');
      }
    }
    triggers.forEach(function (t) {
      t.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { show(t); }, 250);
      });
      t.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(hide, 350);
      });
    });
    document.addEventListener('mouseover', function (e) {
      if (preview && (preview.contains(e.target))) {
        clearTimeout(hoverTimer);
      } else if (preview && preview.classList.contains('is-visible')) {
        var stillOnTrigger = false;
        triggers.forEach(function (t) { if (t.contains(e.target)) stillOnTrigger = true; });
        if (!stillOnTrigger) {
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(hide, 350);
        }
      }
    });
  }
  if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    setupMiniCartHover();
  }

  // ════════════ ESTIMATED DELIVERY DATE (calcul date précise selon "today + 3-5 j ouvrés") ════════════
  // Vague 156 : ajout countdown express "expédié aujourd'hui si commande avant 14h"
  // → trigger urgency conversion (pattern Amazon/Veepee)
  function setupETA() {
    document.querySelectorAll('[data-mnl-eta]').forEach(function (el) {
      if (el.dataset.mnlEtaBound) return;
      el.dataset.mnlEtaBound = '1';
      // V1216 : valeurs de repli alignées sur la fenêtre de RÉCEPTION 3 à 5 j ouvrés (décision fondateur
      // du 31/07/2026). Elles valaient 4 et 7 = l'ancien délai : un [data-mnl-eta] posé sans attributs
      // aurait affiché une fourchette de dates contredisant le texte de la page.
      var minDays = parseInt(el.getAttribute('data-mnl-eta-min'), 10) || 3;
      var maxDays = parseInt(el.getAttribute('data-mnl-eta-max'), 10) || 5;
      var minDate = addBusinessDays(new Date(), minDays);
      var maxDate = addBusinessDays(new Date(), maxDays);
      var fmt = function (d) {
        var months = [MNL_T('global.month_short_01', 'jan'), MNL_T('global.month_short_02', 'fév'), MNL_T('global.month_short_03', 'mar'), MNL_T('global.month_short_04', 'avr'), MNL_T('global.month_short_05', 'mai'), MNL_T('global.month_short_06', 'juin'), MNL_T('global.month_short_07', 'juil'), MNL_T('global.month_short_08', 'août'), MNL_T('global.month_short_09', 'sep'), MNL_T('global.month_short_10', 'oct'), MNL_T('global.month_short_11', 'nov'), MNL_T('global.month_short_12', 'déc')];
        return d.getDate() + ' ' + months[d.getMonth()];
      };
      var label = el.getAttribute('data-mnl-eta-label') || MNL_T('global.eta_label', 'Expédition estimée');
      el.classList.add('mnl-eta');
      // Vague 156 : badge express countdown jusqu'à 14h jour ouvré
      var now = new Date();
      var day = now.getDay();
      var hour = now.getHours();
      var minute = now.getMinutes();
      var isWeekday = day >= 1 && day <= 5;
      var beforeCutoff = false; // V916 : badge « expédié aujourd'hui si avant 14h » DÉSACTIVÉ — promesse d'expédition immédiate incompatible avec « réception sous 3 à 5 jours ouvrés » (fabrication à la commande).
      var countdownHTML = '';
      if (beforeCutoff) {
        // V306 bug fix : à 13h00 ancien code affichait "60min" (hoursLeft=0 + minLeft=60). Normalise carry-over.
        // À 13h30 → "30min". À 13h00 → "1h". À 9h45 → "4h15min". À 12h00 → "2h".
        var hoursLeft = 13 - hour;
        var minLeft = minute === 0 ? 0 : (60 - minute);
        if (minute === 0) hoursLeft += 1; // 13h00 → 1h restante (pas 60min)
        // Compose : "Xh" + "YYmin" si Y>0, sinon juste "Xh"
        var hPart = hoursLeft > 0 ? hoursLeft + 'h' : '';
        var mPart = minLeft > 0 ? (hPart ? minLeft.toString().padStart(2, '0') : minLeft.toString()) + 'min' : '';
        var timeStr = hPart + mPart;
        // V356 : "Expédié aujourd'hui" FAUX (fabrication sur-mesure 48h, V337). Reformulé "fabrication lancée aujourd'hui" cohérent cart-drawer + main-product.
        // V1092 : badge express en aplat charte #FDEDE6 / texte #C93F12 (ex-dégradé ambre #fef3c7→#fde68a).
        if (timeStr) countdownHTML = MNL_T('global.eta_countdown_html', '<span class="mnl-eta__express" style="display:inline-flex;align-items:center;gap:4px;margin-left:8px;padding:2px 8px;background:#FDEDE6;color:#C93F12;border-radius:100px;font-size:11px;font-weight:800;letter-spacing:0;"><span aria-hidden="true"></span>Fabrication lancée aujourd\'hui si commandé dans <strong>') + timeStr + '</strong></span>';
      }
      el.innerHTML = '<span>' + label + MNL_T('global.eta_between_html', " : entre <strong>") + fmt(minDate) + MNL_T('global.eta_and_html', '</strong> et <strong>') + fmt(maxDate) + '</strong></span>'; /* V806 : emoji retiré (demande fondateur) */
    });
  }
  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++; // skip dimanche/samedi
    }
    return d;
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupETA, 200);
  else setupETA();

  // ════════════ WISHLIST COUNT BADGE (live sync) ════════════
  function syncWishlistCountBadges() {
    var count = (window.mnlGetWishlist && window.mnlGetWishlist()) || [];
    document.querySelectorAll('[data-mnl-wishlist-count]').forEach(function (el) {
      var newCount = count.length;
      var oldCount = parseInt(el.textContent, 10) || 0;
      el.textContent = newCount;
      el.setAttribute('data-count', newCount);
      if (newCount !== oldCount && oldCount > 0) {
        el.classList.add('is-bumping');
        setTimeout(function () { el.classList.remove('is-bumping'); }, 400);
      }
    });
  }
  syncWishlistCountBadges();
  document.addEventListener('mnl:wishlist:updated', syncWishlistCountBadges);

  // ════════════ AUTO-RESIZE TEXTAREA (data-mnl-autosize) ════════════
  function setupAutosize() {
    document.querySelectorAll('textarea[data-mnl-autosize]').forEach(function (ta) {
      if (ta.dataset.mnlAutosizeBound) return;
      ta.dataset.mnlAutosizeBound = '1';
      var resize = function () {
        ta.style.height = 'auto';
        ta.style.height = Math.min(400, ta.scrollHeight + 2) + 'px';
      };
      ta.addEventListener('input', resize);
      ta.addEventListener('focus', resize);
      resize();
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupAutosize, 200);
  else setupAutosize();

  // ════════════ FORM DRAFTS AUTO-SAVE (data-mnl-draft="key") ════════════
  function setupFormDrafts() {
    document.querySelectorAll('form[data-mnl-draft]').forEach(function (form) {
      if (form.dataset.mnlDraftBound) return;
      form.dataset.mnlDraftBound = '1';
      var key = 'mnl-draft-' + form.getAttribute('data-mnl-draft');
      // Restore
      try {
        var saved = JSON.parse(localStorage.getItem(key) || '{}');
        Object.keys(saved).forEach(function (name) {
          var input = form.querySelector('[name="' + name + '"]');
          if (input && !input.value) input.value = saved[name];
        });
      } catch (_) {}
      // Indicator
      var indicator = document.createElement('div');
      indicator.className = 'mnl-form-draft';
      indicator.innerHTML = MNL_T('global.draft_autosaved_html', '<span class="mnl-form-draft__dot"></span><span>Brouillon sauvé automatiquement</span>');
      form.appendChild(indicator);
      // Save on input (debounced)
      var saveTimer;
      form.addEventListener('input', function () {
        clearTimeout(saveTimer);
        saveTimer = setTimeout(function () {
          var data = {};
          form.querySelectorAll('input[name],textarea[name],select[name]').forEach(function (input) {
            if (input.type === 'password' || input.type === 'hidden') return;
            data[input.name] = input.value;
          });
          try {
            localStorage.setItem(key, JSON.stringify(data));
            indicator.classList.add('is-active');
          } catch (_) {}
        }, 800);
      });
      // Clear on submit
      form.addEventListener('submit', function () {
        try { localStorage.removeItem(key); } catch (_) {}
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupFormDrafts, 200);
  else setupFormDrafts();

  // ════════════ SHARE FORMULA / PAGE URL (data-mnl-share-url) ════════════
  // Attributs supportés : data-mnl-share-url (URL ou "true"), data-mnl-share-title, data-mnl-share-text (description)
  function fallbackCopy(text) {
    // Fallback robuste : input temporaire + execCommand pour contextes non-secure
    var input = document.createElement('input');
    input.value = text;
    input.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0';
    document.body.appendChild(input);
    input.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (_) {}
    document.body.removeChild(input);
    return ok;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-share-url]');
    if (!btn) return;
    e.preventDefault();
    var customUrl = btn.getAttribute('data-mnl-share-url');
    var url = (customUrl && customUrl !== 'true') ? customUrl : window.location.href;
    var title = btn.getAttribute('data-mnl-share-title') || document.title;
    var text = btn.getAttribute('data-mnl-share-text') || '';
    var sharePayload = { title: title, url: url };
    if (text) sharePayload.text = text;
    function fireShared(method) {
      // Custom event analytics : page partagée
      document.dispatchEvent(new CustomEvent('mnl:share:completed', { detail: { url: url, title: title, text: text, method: method } }));
    }
    if (navigator.share) {
      navigator.share(sharePayload).then(function () { fireShared('native'); }).catch(function () {});
      return;
    }
    // Fallback : copy to clipboard (modern then legacy)
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(function () {
        if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.link_copied_bang', 'Lien copié !'), url);
        fireShared('clipboard');
      }).catch(function () {
        if (fallbackCopy(url)) {
          if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.link_copied_bang', 'Lien copié !'), url);
          fireShared('execCommand');
        }
      });
    } else if (fallbackCopy(url)) {
      if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.link_copied_bang', 'Lien copié !'), url);
      fireShared('execCommand');
    } else if (window.mnlToastError) {
      window.mnlToastError(MNL_T('global.copy_impossible_title', 'Copie impossible'), MNL_T('global.copy_manual_prefix', 'Copie manuelle : ') + url);
    }
  });

  // ════════════ SMART FOCUS MANAGEMENT (return focus after modal close) ════════════
  var lastFocusedElement = null;
  /* V1237 (04/08/2026) : le sélecteur ne visait que [role="dialog"]. Or les panneaux de
     confirmation et d'alerte portent role="alertdialog" : leurs propres boutons étaient donc
     enregistrés comme « dernier élément focalisé », puis retirés du DOM à la fermeture — le
     focus n'était JAMAIS rendu au bouton d'origine après un mnlConfirm/mnlAlert. On couvre
     les deux rôles. */
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    if (!t.closest('[role="dialog"],[role="alertdialog"]')) {
      lastFocusedElement = t;
    }
  });
  document.addEventListener('mnl:dialog:closed', function () {
    /* V1237 : un panneau peut s'ouvrir pendant les 250 ms d'animation de fermeture du
       précédent (enchaînement saisie → confirmation). On ne vole pas son focus. */
    var openOne = document.getElementById('mnl-confirm-overlay');
    if (openOne && openOne.classList.contains('is-open')) return;
    if (lastFocusedElement && document.body.contains(lastFocusedElement)) {
      try { lastFocusedElement.focus(); } catch (_) {}
    }
  });

  /* ════════════ V1237 (04/08/2026) — SOCLE COMMUN DES PANNEAUX ════════════
     Le fondateur voyait encore des boîtes natives « mynutrilab.com indique ». Ces panneaux
     maison se construisent par CONCATÉNATION DE CHAÎNES : tout texte affiché doit donc passer
     par un filtre d'échappement, sans exception.
       · _mnlEscTxt  → contenu texte (n'échappe pas les guillemets : jamais dans un attribut)
       · _mnlEscAttr → valeur d'attribut (échappe en plus " et ')
     Seul `opts.message` reste un emplacement HTML libre (4 appelants historiques y mettent
     déjà <strong>/<br>, dont un fichier verrouillé par un autre chantier) : n'y mets JAMAIS
     une donnée saisie par un visiteur — utilise `messageText`, qui, lui, est échappé. */
  function _mnlEscTxt(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function _mnlEscAttr(s) { return _mnlEscTxt(s).replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  /* Liste blanche des habillages : un appelant ne peut pas injecter une classe arbitraire. */
  function _mnlDlgType(t) { t = String(t || ''); return (t === 'danger' || t === 'info' || t === 'success' || t === 'warn') ? t : 'warn'; }
  /* Bloc message : `messageText` (échappé) prioritaire, sinon `message` (HTML libre, legacy). */
  function _mnlDlgMsg(opts) {
    if (opts.messageText) return '<p class="mnl-confirm-box__msg" id="mnl-dlg-msg">' + _mnlEscTxt(opts.messageText) + '</p>';
    if (opts.message) return '<p class="mnl-confirm-box__msg" id="mnl-dlg-msg">' + opts.message + '</p>';
    return '';
  }
  /* Piège à focus : Tab / Maj+Tab tournent en boucle DANS le panneau, on ne peut pas
     tabuler jusqu'à la page derrière (exigence d'accessibilité d'une fenêtre modale). */
  function _mnlTrapFocus(box) {
    return function (e) {
      if (e.key !== 'Tab') return;
      var all = box.querySelectorAll('button,input,select,textarea,[href],[tabindex]:not([tabindex="-1"])');
      var vis = [];
      for (var i = 0; i < all.length; i++) { if (!all[i].disabled && all[i].offsetParent !== null) vis.push(all[i]); }
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); try { last.focus(); } catch (_) {} }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); try { first.focus(); } catch (_) {} }
    };
  }
  /* Styles des éléments ajoutés en V1237 (étiquette, exemple, erreur de validation,
     panneau multi-champs). Injectés depuis le JS : la feuille mnl-global.css.liquid est
     éditée par un autre chantier, on ne s'y croise pas. Posés une seule fois. */
  function _mnlDlgStyles() {
    if (document.getElementById('mnl-dlg-css-v1237')) return;
    var st = document.createElement('style');
    st.id = 'mnl-dlg-css-v1237';
    st.textContent =
      '.mnl-confirm-box{max-height:calc(100vh - 40px);overflow-y:auto;-webkit-overflow-scrolling:touch}' +
      '.mnl-dlg-field{text-align:left;margin:0 0 14px}' +
      '.mnl-dlg-field .mnl-confirm-box__input{margin:0}' +
      '.mnl-dlg-label{display:block;font-size:12.5px;font-weight:800;color:#0f172a;margin:0 0 5px;letter-spacing:-.005em}' +
      '.mnl-dlg-label__opt{font-weight:600;color:#64748b;font-size:11.5px;margin-left:6px}' +
      '.mnl-dlg-hint{display:block;font-size:11.5px;color:#64748b;line-height:1.4;margin:5px 0 0}' +
      '.mnl-dlg-err{display:none;font-size:12px;font-weight:700;color:#dc2626;line-height:1.4;margin:6px 0 0}' +
      '.mnl-dlg-err.is-on{display:block}' +
      '.mnl-confirm-box__input.is-err{border-color:#dc2626;background:#fef2f2}' +
      '.mnl-confirm-box__input.is-err:focus{box-shadow:0 0 0 3px rgba(220,38,38,.14)}' +
      '@media (max-width:600px){.mnl-confirm-box{padding:24px 20px}}';
    (document.head || document.documentElement).appendChild(st);
  }

  // ════════════ CONFIRM DIALOG (window.mnlConfirm — replaces ugly window.confirm) ════════════
  /* V1237 (04/08/2026) — trois corrections de FOND, pas seulement d'habillage :
       1. Tous les libellés passent par _mnlEscTxt (avant : concaténés bruts).
       2. Une action IRRÉVERSIBLE (type:'danger', ou {dismissible:false}) ne se ferme plus
          ni par Échap ni par clic à côté : il faut choisir explicitement un des deux boutons.
          Un confirm() natif est bloquant ; ce panneau ne l'est pas — on compense en rendant
          la sortie accidentelle impossible.
       3. Sur une action dangereuse, le focus va sur ANNULER (avant : sur le bouton
          destructeur — une frappe Entrée réflexe suffisait à supprimer).
     opts: {title, message|messageText, confirmText, cancelText, icon, type, dismissible} */
  window.mnlConfirm = function (opts) {
    return new Promise(function (resolve) {
      opts = opts || {};
      _mnlDlgStyles();
      var overlay = document.getElementById('mnl-confirm-overlay');
      if (overlay) overlay.remove();
      overlay = document.createElement('div');
      overlay.id = 'mnl-confirm-overlay';
      overlay.className = 'mnl-confirm-overlay';
      overlay.setAttribute('role', 'alertdialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-labelledby', 'mnl-confirm-title');
      var type = _mnlDlgType(opts.type); // warn, danger, info, success
      var dismissible = (opts.dismissible === true) ? true : (opts.dismissible === false ? false : type !== 'danger');
      var icon = opts.icon || (type === 'danger' ? '⚠' : (type === 'info' ? 'ℹ' : '?'));
      var msgHTML = _mnlDlgMsg(opts);
      overlay.innerHTML =
        '<div class="mnl-confirm-box mnl-confirm-box--' + type + '">' +
          '<div class="mnl-confirm-box__icon" aria-hidden="true">' + _mnlEscTxt(icon) + '</div>' +
          '<h3 class="mnl-confirm-box__title" id="mnl-confirm-title">' + _mnlEscTxt(opts.title || MNL_T('global.dlg_confirm_question', 'Confirmer ?')) + '</h3>' +
          msgHTML +
          '<div class="mnl-confirm-box__actions">' +
            '<button type="button" class="mnl-confirm-box__btn mnl-confirm-box__btn--cancel">' + _mnlEscTxt(opts.cancelText || MNL_T('global.common_cancel', 'Annuler')) + '</button>' +
            '<button type="button" class="mnl-confirm-box__btn mnl-confirm-box__btn--confirm">' + _mnlEscTxt(opts.confirmText || MNL_T('global.common_confirm', 'Confirmer')) + '</button>' +
          '</div>' +
        '</div>';
      if (msgHTML) overlay.setAttribute('aria-describedby', 'mnl-dlg-msg');
      document.body.appendChild(overlay);
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      var box = overlay.querySelector('.mnl-confirm-box');
      var confirmBtn = overlay.querySelector('.mnl-confirm-box__btn--confirm');
      var cancelBtn = overlay.querySelector('.mnl-confirm-box__btn--cancel');
      var settled = false;
      var trap = _mnlTrapFocus(box);
      /* Focus placé DANS le panneau : sur Annuler quand l'action est destructrice. */
      setTimeout(function () { try { (type === 'danger' ? cancelBtn : confirmBtn).focus(); } catch (_) {} }, 30);
      var done = function (val) {
        if (settled) return; // garde anti-double résolution (clic + Entrée simultanés)
        settled = true;
        document.removeEventListener('keydown', keyHandler); // V1237 : l'ancien code laissait fuir cet écouteur quand on fermait par bouton
        overlay.classList.remove('is-open');
        setTimeout(function () { try { overlay.remove(); } catch (_) {} document.dispatchEvent(new CustomEvent('mnl:dialog:closed')); }, 250);
        resolve(val);
      };
      var keyHandler = function (e) {
        if (e.key === 'Escape' && dismissible) { e.preventDefault(); done(false); return; }
        if (e.key === 'Escape' && !dismissible) {
          /* Action irréversible : Échap ne ferme pas, mais on emmène le focus sur Annuler
             pour que la sortie sûre soit sous la main. */
          e.preventDefault(); try { cancelBtn.focus(); } catch (_) {}
          return;
        }
        trap(e);
      };
      confirmBtn.addEventListener('click', function () { done(true); });
      cancelBtn.addEventListener('click', function () { done(false); });
      overlay.addEventListener('click', function (e) { if (e.target === overlay && dismissible) done(false); });
      document.addEventListener('keydown', keyHandler);
    });
  };

  // ════════════ PROMPT DIALOG (window.mnlPrompt — replaces ugly window.prompt) ════════════
  // Vague 198 : remplace tous les prompt() natifs sur le site. Returns Promise<string|null>.
  // opts: {title, message, placeholder, defaultValue, confirmText, cancelText, icon, multiline, inputType, readOnly}
  /* V1237 (04/08/2026) : ces deux helpers deviennent des alias du socle commun — une seule
     règle d'échappement pour tous les panneaux (voir _mnlEscTxt / _mnlEscAttr plus haut). */
  function _escAttrPrompt(s){ return _mnlEscAttr(s); }
  function _escHtmlPrompt(s){ return _mnlEscTxt(s); }
  /* V1237 : ajout de `label` (libellé au-dessus du champ), `hint` (exemple sous le champ),
     `required` / `validate` (message d'erreur EN PLACE au lieu d'accepter une valeur vide),
     `maxLength`. Rétro-compatible : sans ces options le panneau est identique à avant. */
  window.mnlPrompt = function (opts) {
    return new Promise(function (resolve) {
      opts = opts || {};
      _mnlDlgStyles();
      var existing = document.getElementById('mnl-confirm-overlay');
      if (existing) existing.remove();
      var overlay = document.createElement('div');
      overlay.id = 'mnl-confirm-overlay';
      overlay.className = 'mnl-confirm-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-labelledby', 'mnl-prompt-title');
      var icon = opts.icon || '✏';
      var inputType = /^[a-z]+$/.test(String(opts.inputType || '')) ? opts.inputType : 'text';
      var placeholder = opts.placeholder || '';
      var defaultValue = opts.defaultValue != null ? String(opts.defaultValue) : '';
      var multiline = opts.multiline === true;
      var readOnly = opts.readOnly === true;
      var maxAttr = (opts.maxLength > 0) ? ' maxlength="' + parseInt(opts.maxLength, 10) + '"' : '';
      var inputHTML = multiline
        ? '<textarea class="mnl-confirm-box__input mnl-confirm-box__input--textarea" id="mnl-prompt-input" rows="' + (parseInt(opts.rows, 10) || 4) + '"' + (readOnly ? ' readonly' : '') + maxAttr + ' placeholder="' + _mnlEscAttr(placeholder) + '">' + _mnlEscTxt(defaultValue) + '</textarea>'
        : '<input type="' + inputType + '" class="mnl-confirm-box__input" id="mnl-prompt-input"' + (readOnly ? ' readonly' : '') + maxAttr + ' placeholder="' + _mnlEscAttr(placeholder) + '" value="' + _mnlEscAttr(defaultValue) + '">';
      /* Le champ est enveloppé pour porter son libellé et son exemple. */
      var fieldHTML =
        '<div class="mnl-dlg-field">' +
          (opts.label ? '<label class="mnl-dlg-label" for="mnl-prompt-input">' + _mnlEscTxt(opts.label) + '</label>' : '') +
          inputHTML +
          (opts.hint ? '<small class="mnl-dlg-hint" id="mnl-prompt-hint">' + _mnlEscTxt(opts.hint) + '</small>' : '') +
          '<p class="mnl-dlg-err" id="mnl-prompt-err" role="alert"></p>' +
        '</div>';
      overlay.innerHTML =
        '<div class="mnl-confirm-box">' +
          '<div class="mnl-confirm-box__icon" aria-hidden="true">' + _mnlEscTxt(icon) + '</div>' +
          '<h3 class="mnl-confirm-box__title" id="mnl-prompt-title">' + _mnlEscTxt(opts.title || MNL_T('global.dlg_prompt_title', 'Saisis une valeur')) + '</h3>' +
          _mnlDlgMsg(opts) +
          fieldHTML +
          '<div class="mnl-confirm-box__actions">' +
            '<button type="button" class="mnl-confirm-box__btn mnl-confirm-box__btn--cancel">' + _mnlEscTxt(opts.cancelText || MNL_T('global.common_cancel', 'Annuler')) + '</button>' +
            '<button type="button" class="mnl-confirm-box__btn mnl-confirm-box__btn--confirm">' + _mnlEscTxt(opts.confirmText || MNL_T('global.common_ok', 'OK')) + '</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(overlay);
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      var box = overlay.querySelector('.mnl-confirm-box');
      var input = overlay.querySelector('#mnl-prompt-input');
      var errEl = overlay.querySelector('#mnl-prompt-err');
      var confirmBtn = overlay.querySelector('.mnl-confirm-box__btn--confirm');
      var cancelBtn = overlay.querySelector('.mnl-confirm-box__btn--cancel');
      if (opts.hint) input.setAttribute('aria-describedby', 'mnl-prompt-hint');
      var settled = false;
      var trap = _mnlTrapFocus(box);
      setTimeout(function () { try { input.focus(); input.select(); } catch(_){} }, 80);
      var done = function (val) {
        if (settled) return;
        settled = true;
        document.removeEventListener('keydown', keyHandler);
        overlay.classList.remove('is-open');
        setTimeout(function () { try { overlay.remove(); } catch(_){} document.dispatchEvent(new CustomEvent('mnl:dialog:closed')); }, 250);
        resolve(val);
      };
      /* Validation : on garde le panneau OUVERT et on affiche l'erreur sous le champ,
         au lieu de renvoyer une valeur vide que l'appelant devra deviner. */
      function submit() {
        var val = input.value;
        var msg = '';
        if (opts.required && !String(val).trim()) msg = opts.requiredText || MNL_T('global.dlg_field_required', 'Ce champ est obligatoire.');
        else if (typeof opts.validate === 'function') { try { msg = opts.validate(val) || ''; } catch (_) { msg = ''; } }
        if (msg) {
          errEl.textContent = msg;
          errEl.classList.add('is-on');
          input.classList.add('is-err');
          input.setAttribute('aria-invalid', 'true');
          try { input.focus(); } catch (_) {}
          return;
        }
        done(val);
      }
      input.addEventListener('input', function () {
        if (!errEl.classList.contains('is-on')) return;
        errEl.classList.remove('is-on'); input.classList.remove('is-err'); input.removeAttribute('aria-invalid');
      });
      confirmBtn.addEventListener('click', submit);
      cancelBtn.addEventListener('click', function () { done(null); });
      overlay.addEventListener('click', function (e) { if (e.target === overlay) done(null); });
      /* V1237 : écouteur au niveau document (Échap marchait déjà, mais seulement quand le
         focus était RESTÉ dans le champ) + piège à focus. Retiré à la fermeture. */
      var keyHandler = function (e) {
        if (e.key === 'Escape') { e.preventDefault(); done(null); return; }
        if (e.key === 'Enter' && !multiline && !e.shiftKey) {
          var t = e.target;
          if (t === cancelBtn) return; // Entrée sur « Annuler » = annuler
          e.preventDefault(); submit(); return;
        }
        trap(e);
      };
      document.addEventListener('keydown', keyHandler);
    });
  };

  // ════════════ ALERT DIALOG (window.mnlAlert — replaces ugly window.alert) ════════════
  // Vague 198 : single OK button info dialog. Returns Promise<void>.
  // opts: {title, message, confirmText, icon, type: 'info'|'warn'|'danger'|'success'}
  window.mnlAlert = function (opts) {
    return new Promise(function (resolve) {
      opts = opts || {};
      _mnlDlgStyles();
      var existing = document.getElementById('mnl-confirm-overlay');
      if (existing) existing.remove();
      var overlay = document.createElement('div');
      overlay.id = 'mnl-confirm-overlay';
      overlay.className = 'mnl-confirm-overlay';
      overlay.setAttribute('role', 'alertdialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-labelledby', 'mnl-alert-title');
      var type = _mnlDlgType(opts.type === 'info' || !opts.type ? 'info' : opts.type); // V1237 : liste blanche
      var icon = opts.icon || (type === 'danger' ? '⚠' : (type === 'success' ? '✓' : (type === 'warn' ? '!' : 'ℹ')));
      var msgHTML = _mnlDlgMsg(opts);
      overlay.innerHTML =
        '<div class="mnl-confirm-box mnl-confirm-box--' + type + '">' +
          '<div class="mnl-confirm-box__icon" aria-hidden="true">' + _mnlEscTxt(icon) + '</div>' +
          '<h3 class="mnl-confirm-box__title" id="mnl-alert-title">' + _mnlEscTxt(opts.title || MNL_T('global.dlg_notice_title', 'Notice')) + '</h3>' +
          msgHTML +
          '<div class="mnl-confirm-box__actions">' +
            '<button type="button" class="mnl-confirm-box__btn mnl-confirm-box__btn--confirm mnl-confirm-box__btn--solo">' + _mnlEscTxt(opts.confirmText || MNL_T('global.common_ok', 'OK')) + '</button>' +
          '</div>' +
        '</div>';
      if (msgHTML) overlay.setAttribute('aria-describedby', 'mnl-dlg-msg');
      document.body.appendChild(overlay);
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      var box = overlay.querySelector('.mnl-confirm-box');
      var confirmBtn = overlay.querySelector('.mnl-confirm-box__btn--confirm');
      var settled = false;
      var trap = _mnlTrapFocus(box);
      setTimeout(function () { try { confirmBtn.focus(); } catch(_){} }, 80);
      var done = function () {
        if (settled) return;
        settled = true;
        document.removeEventListener('keydown', escHandler); // V1237 : l'écouteur restait en place quand on fermait par le bouton
        overlay.classList.remove('is-open');
        setTimeout(function () { try { overlay.remove(); } catch(_){} document.dispatchEvent(new CustomEvent('mnl:dialog:closed')); }, 250);
        resolve();
      };
      confirmBtn.addEventListener('click', done);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) done(); });
      var escHandler = function (e) {
        if (e.key === 'Escape' || e.key === 'Enter') { e.preventDefault(); done(); return; }
        trap(e);
      };
      document.addEventListener('keydown', escHandler);
    });
  };

  // ════════════ COPY DIALOG (mnlCopyDialog — shows text with copy button) ════════════
  // Vague 198 : remplace prompt() utilisés en mode fallback "Copie ce texte" partout.
  window.mnlCopyDialog = function (text, opts) {
    opts = opts || {};
    return window.mnlPrompt({
      title: opts.title || MNL_T('global.dlg_copy_title', 'Copier le texte'),
      message: opts.message || MNL_T('global.dlg_copy_message', 'Sélectionne le texte puis Ctrl/⌘ + C pour copier.'),
      defaultValue: String(text || ''),
      multiline: (String(text || '').length > 80 || /\n/.test(String(text || ''))),
      readOnly: true,
      icon: opts.icon || '',
      confirmText: opts.confirmText || MNL_T('global.common_copy', 'Copier'),
      cancelText: opts.cancelText || MNL_T('global.common_close', 'Fermer'),
      rows: opts.rows || 3
    }).then(function (val) {
      if (val == null) return false;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(String(text || ''));
        if (window.mnlToast) window.mnlToast({ icon: '✓', title: MNL_T('global.copied_clipboard', 'Copié dans le presse-papier'), sub: '', type: 'success', duration: 1800 });
      } catch(_) {}
      return true;
    });
  };

  /* ════════════ V1237 (04/08/2026) — PANNEAU MULTI-CHAMPS (window.mnlPromptFields) ════════════
     Motif : le planificateur de séances enchaînait TROIS window.prompt() sur un seul clic —
     trois boîtes « mynutrilab.com indique » d'affilée, sans retour en arrière possible et sans
     voir ce qu'on avait déjà tapé. Un seul panneau, tous les champs visibles, l'optionnel dit
     comme tel. Renvoie Promise<objet|null> — null = annulé (Échap, clic à côté, Annuler).
     opts: {title, message|messageText, icon, confirmText, cancelText,
            fields:[{name, label, hint, placeholder, value, required, optional,
                     maxLength, inputType, multiline, rows, validate}]}                    */
  window.mnlPromptFields = function (opts) {
    return new Promise(function (resolve) {
      opts = opts || {};
      var fields = Array.isArray(opts.fields) ? opts.fields : [];
      if (!fields.length) { resolve(null); return; }
      _mnlDlgStyles();
      var existing = document.getElementById('mnl-confirm-overlay');
      if (existing) existing.remove();
      var overlay = document.createElement('div');
      overlay.id = 'mnl-confirm-overlay';
      overlay.className = 'mnl-confirm-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-labelledby', 'mnl-pf-title');
      /* Les id sont dérivés de l'INDEX, jamais du nom fourni par l'appelant. */
      var body = fields.map(function (f, i) {
        f = f || {};
        var id = 'mnl-pf-' + i;
        var maxAttr = (f.maxLength > 0) ? ' maxlength="' + parseInt(f.maxLength, 10) + '"' : '';
        var typeAttr = /^[a-z]+$/.test(String(f.inputType || '')) ? f.inputType : 'text';
        var ctrl = (f.multiline === true)
          ? '<textarea class="mnl-confirm-box__input mnl-confirm-box__input--textarea" id="' + id + '" rows="' + (parseInt(f.rows, 10) || 3) + '"' + maxAttr + ' placeholder="' + _mnlEscAttr(f.placeholder || '') + '">' + _mnlEscTxt(f.value == null ? '' : f.value) + '</textarea>'
          : '<input type="' + typeAttr + '" class="mnl-confirm-box__input" id="' + id + '"' + maxAttr + ' placeholder="' + _mnlEscAttr(f.placeholder || '') + '" value="' + _mnlEscAttr(f.value == null ? '' : f.value) + '">';
        return '<div class="mnl-dlg-field">' +
          '<label class="mnl-dlg-label" for="' + id + '">' + _mnlEscTxt(f.label || (MNL_T('global.dlg_field_prefix', 'Champ ') + (i + 1))) +
            (f.optional === true ? '<span class="mnl-dlg-label__opt">optionnel</span>' : '') +
          '</label>' +
          ctrl +
          (f.hint ? '<small class="mnl-dlg-hint" id="' + id + '-hint">' + _mnlEscTxt(f.hint) + '</small>' : '') +
          '<p class="mnl-dlg-err" id="' + id + '-err" role="alert"></p>' +
        '</div>';
      }).join('');
      var msgHTML = _mnlDlgMsg(opts);
      overlay.innerHTML =
        '<div class="mnl-confirm-box">' +
          '<div class="mnl-confirm-box__icon" aria-hidden="true">' + _mnlEscTxt(opts.icon || '✏') + '</div>' +
          '<h3 class="mnl-confirm-box__title" id="mnl-pf-title">' + _mnlEscTxt(opts.title || MNL_T('global.dlg_fields_title', 'Saisis les informations')) + '</h3>' +
          msgHTML +
          body +
          '<div class="mnl-confirm-box__actions">' +
            '<button type="button" class="mnl-confirm-box__btn mnl-confirm-box__btn--cancel">' + _mnlEscTxt(opts.cancelText || MNL_T('global.common_cancel', 'Annuler')) + '</button>' +
            '<button type="button" class="mnl-confirm-box__btn mnl-confirm-box__btn--confirm">' + _mnlEscTxt(opts.confirmText || MNL_T('global.common_validate', 'Valider')) + '</button>' +
          '</div>' +
        '</div>';
      if (msgHTML) overlay.setAttribute('aria-describedby', 'mnl-dlg-msg');
      document.body.appendChild(overlay);
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      var box = overlay.querySelector('.mnl-confirm-box');
      var confirmBtn = overlay.querySelector('.mnl-confirm-box__btn--confirm');
      var cancelBtn = overlay.querySelector('.mnl-confirm-box__btn--cancel');
      var inputs = fields.map(function (f, i) { return overlay.querySelector('#mnl-pf-' + i); });
      inputs.forEach(function (el, i) {
        if (!el) return;
        if (fields[i] && fields[i].hint) el.setAttribute('aria-describedby', 'mnl-pf-' + i + '-hint');
        el.addEventListener('input', function () {
          var e2 = overlay.querySelector('#mnl-pf-' + i + '-err');
          if (e2 && e2.classList.contains('is-on')) { e2.classList.remove('is-on'); el.classList.remove('is-err'); el.removeAttribute('aria-invalid'); }
        });
      });
      var settled = false;
      var trap = _mnlTrapFocus(box);
      setTimeout(function () { try { inputs[0].focus(); inputs[0].select(); } catch (_) {} }, 80);
      var done = function (val) {
        if (settled) return;
        settled = true;
        document.removeEventListener('keydown', keyHandler);
        overlay.classList.remove('is-open');
        setTimeout(function () { try { overlay.remove(); } catch (_) {} document.dispatchEvent(new CustomEvent('mnl:dialog:closed')); }, 250);
        resolve(val);
      };
      function submit() {
        var out = {}, firstBad = null;
        fields.forEach(function (f, i) {
          f = f || {};
          var el = inputs[i]; if (!el) return;
          var v = el.value;
          var errEl = overlay.querySelector('#mnl-pf-' + i + '-err');
          var msg = '';
          if (f.required && !String(v).trim()) msg = f.requiredText || MNL_T('global.dlg_field_required', 'Ce champ est obligatoire.');
          else if (typeof f.validate === 'function') { try { msg = f.validate(v) || ''; } catch (_) { msg = ''; } }
          if (msg) {
            if (errEl) { errEl.textContent = msg; errEl.classList.add('is-on'); }
            el.classList.add('is-err'); el.setAttribute('aria-invalid', 'true');
            if (!firstBad) firstBad = el;
          }
          out[f.name || ('field' + i)] = v;
        });
        if (firstBad) { try { firstBad.focus(); } catch (_) {} return; }
        done(out);
      }
      confirmBtn.addEventListener('click', submit);
      cancelBtn.addEventListener('click', function () { done(null); });
      overlay.addEventListener('click', function (e) { if (e.target === overlay) done(null); });
      var keyHandler = function (e) {
        if (e.key === 'Escape') { e.preventDefault(); done(null); return; }
        if (e.key === 'Enter' && e.target && e.target.tagName !== 'TEXTAREA' && e.target !== cancelBtn) { e.preventDefault(); submit(); return; }
        trap(e);
      };
      document.addEventListener('keydown', keyHandler);
    });
  };

  // ════════════ KEYBOARD SHORTCUTS HELP PANEL (? key) ════════════
  function ensureKbdHelp() {
    var panel = document.getElementById('mnl-kbd-help');
    if (panel) return panel;
    panel = document.createElement('div');
    panel.id = 'mnl-kbd-help';
    panel.className = 'mnl-kbd-help';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'mnl-kbd-help-title');
    var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    var cmdKey = isMac ? '⌘' : 'Ctrl';
    panel.innerHTML =
      '<div class="mnl-kbd-help__box">' +
        MNL_T('global.kbd_close_html', '<button type="button" class="mnl-kbd-help__close" aria-label="Fermer">×</button>') +
        MNL_T('global.kbd_title_html', '<h3 class="mnl-kbd-help__title" id="mnl-kbd-help-title">⌨ Raccourcis clavier</h3>') +
        MNL_T('global.kbd_sub_html', '<p class="mnl-kbd-help__sub">Navigue plus vite avec ces raccourcis</p>') +
        '<div class="mnl-kbd-help__group">' +
          MNL_T('global.kbd_group_navigation_html', '<p class="mnl-kbd-help__group-title">Navigation</p>') +
          '<ul class="mnl-kbd-help__list">' +
            MNL_T('global.kbd_row_open_search_html', '<li class="mnl-kbd-help__row"><span class="mnl-kbd-help__row-label">Ouvrir la recherche</span><span class="mnl-kbd-help__row-keys"><kbd>') + cmdKey + '</kbd>+<kbd>K</kbd></span></li>' +
            MNL_T('global.kbd_row_show_help_html', '<li class="mnl-kbd-help__row"><span class="mnl-kbd-help__row-label">Afficher cette aide</span><span class="mnl-kbd-help__row-keys"><kbd>?</kbd></span></li>') +
            MNL_T('global.kbd_row_close_modal_html', '<li class="mnl-kbd-help__row"><span class="mnl-kbd-help__row-label">Fermer toute modal</span><span class="mnl-kbd-help__row-keys"><kbd>Esc</kbd></span></li>') +
          '</ul>' +
        '</div>' +
        '<div class="mnl-kbd-help__group">' +
          MNL_T('global.kbd_group_search_html', '<p class="mnl-kbd-help__group-title">Recherche</p>') +
          '<ul class="mnl-kbd-help__list">' +
            MNL_T('global.kbd_row_nav_results_html', '<li class="mnl-kbd-help__row"><span class="mnl-kbd-help__row-label">Naviguer dans les résultats</span><span class="mnl-kbd-help__row-keys"><kbd>↑</kbd><kbd>↓</kbd></span></li>') +
            MNL_T('global.kbd_row_select_html', '<li class="mnl-kbd-help__row"><span class="mnl-kbd-help__row-label">Sélectionner</span><span class="mnl-kbd-help__row-keys"><kbd>↵</kbd></span></li>') +
          '</ul>' +
        '</div>' +
        '<div class="mnl-kbd-help__group">' +
          MNL_T('global.kbd_group_gallery_html', '<p class="mnl-kbd-help__group-title">Galerie image</p>') +
          '<ul class="mnl-kbd-help__list">' +
            MNL_T('global.kbd_row_prev_next_image_html', '<li class="mnl-kbd-help__row"><span class="mnl-kbd-help__row-label">Image précédente / suivante</span><span class="mnl-kbd-help__row-keys"><kbd>←</kbd><kbd>→</kbd></span></li>') +
            MNL_T('global.kbd_row_close_zoom_html', '<li class="mnl-kbd-help__row"><span class="mnl-kbd-help__row-label">Fermer le zoom</span><span class="mnl-kbd-help__row-keys"><kbd>Esc</kbd></span></li>') +
          '</ul>' +
        '</div>' +
      '</div>';
    document.body.appendChild(panel);
    panel.querySelector('.mnl-kbd-help__close').addEventListener('click', closeKbdHelp);
    panel.addEventListener('click', function (e) { if (e.target === panel) closeKbdHelp(); });
    return panel;
  }
  function openKbdHelp() {
    var panel = ensureKbdHelp();
    panel.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    panel.querySelector('.mnl-kbd-help__close').focus();
  }
  function closeKbdHelp() {
    var panel = document.getElementById('mnl-kbd-help');
    if (panel) panel.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.mnlOpenKbdHelp = openKbdHelp;
  document.addEventListener('keydown', function (e) {
    // ? key (Shift+/) ouvre l'aide
    if (e.key === '?' && !e.target.matches('input,textarea,select,[contenteditable]')) {
      e.preventDefault();
      openKbdHelp();
    }
    // Esc ferme l'aide
    if (e.key === 'Escape') {
      var panel = document.getElementById('mnl-kbd-help');
      if (panel && panel.classList.contains('is-open')) closeKbdHelp();
    }
  });

  // ════════════ NETWORK STATUS INDICATOR (offline + slow detection) ════════════
  function ensureNetStatus() {
    var bar = document.getElementById('mnl-net-status');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.id = 'mnl-net-status';
    bar.className = 'mnl-net-status';
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');
    bar.innerHTML = MNL_T('global.net_offline_html', '<span class="mnl-net-status__icon" aria-hidden="true"></span><span class="mnl-net-status__text">Pas de connexion — certaines fonctions sont indisponibles</span>');
    document.body.appendChild(bar);
    return bar;
  }
  window.addEventListener('offline', function () {
    var bar = ensureNetStatus();
    bar.classList.remove('mnl-net-status--slow');
    bar.querySelector('.mnl-net-status__text').textContent = MNL_T('global.net_offline_text', 'Pas de connexion — certaines fonctions sont indisponibles');
    bar.classList.add('is-visible');
  });
  window.addEventListener('online', function () {
    var bar = document.getElementById('mnl-net-status');
    if (bar) {
      bar.classList.remove('mnl-net-status--slow');
      bar.querySelector('.mnl-net-status__text').textContent = MNL_T('global.net_back_online', '✓ Connexion rétablie');
      bar.style.background = '#22c55e';
      setTimeout(function () { bar.classList.remove('is-visible'); bar.style.background = ''; }, 2500);
    }
  });
  // Slow connection detection
  if ('connection' in navigator) {
    var checkSlow = function () {
      var conn = navigator.connection;
      if (conn && (conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g')) {
        var bar = ensureNetStatus();
        bar.classList.add('mnl-net-status--slow');
        bar.querySelector('.mnl-net-status__text').textContent = MNL_T('global.net_slow', 'Connexion lente détectée — chargement optimisé');
        bar.classList.add('is-visible');
        setTimeout(function () { bar.classList.remove('is-visible'); }, 4000);
      }
    };
    navigator.connection.addEventListener && navigator.connection.addEventListener('change', checkSlow);
    setTimeout(checkSlow, 2000);
  }

  // ════════════ FOCUS TRAP for modals (data-mnl-focus-trap) ════════════
  // Vague 72 : sélecteur durci — exclude éléments cachés (display:none, visibility:hidden, aria-hidden)
  // + exclude tabindex non-numérique invalide
  function trapFocus(container) {
    var raw = container.querySelectorAll('a[href]:not([aria-hidden="true"]), button:not([disabled]):not([aria-hidden="true"]), input:not([disabled]):not([type="hidden"]):not([aria-hidden="true"]), select:not([disabled]):not([aria-hidden="true"]), textarea:not([disabled]):not([aria-hidden="true"]), [tabindex="0"]:not([aria-hidden="true"])');
    var focusables = Array.prototype.filter.call(raw, function(el){
      // Filtre éléments visiblement cachés (computed style)
      try {
        var rect = el.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) return false;
        var cs = window.getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      } catch (_) {}
      return true;
    });
    if (!focusables.length) return null;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var handler = function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    };
    container.addEventListener('keydown', handler);
    return function untrap() { container.removeEventListener('keydown', handler); };
  }
  window.mnlTrapFocus = trapFocus;
  // Auto-trap pour role=dialog ouverts
  // Vague 81 : refactor anti-leak — avant : MutationObserver sur document.body avec subtree:true
  // + childList:true + attributeFilter:['class','aria-hidden','style'] firait sur CHAQUE
  // animation/IntersectionObserver toggle, et exécutait un querySelectorAll global sync.
  // Sur configurateur (13 sliders + animations CSS) → tab lag après ~5min.
  // Fix : (1) reduce attributeFilter à ['aria-hidden'] only — c'est le seul attribut qui change quand modal s'ouvre,
  //       (2) skip si aucun [role="dialog"] dans le DOM (early return),
  //       (3) wrap dans requestIdleCallback (ou rIC fallback) pour ne JAMAIS bloquer le main thread.
  // Vague 109 : polyfill global window.mnlIdle exposé pour réutilisation (analytics flush, web-vitals, prefetch).
  // Avant : _trapIdle local au scope MutationObserver → impossible à réutiliser. Maintenant : exposé window.mnlIdle.
  if (!window.mnlIdle) {
    window.mnlIdle = window.requestIdleCallback
      ? function(cb, opts){ return window.requestIdleCallback(cb, opts); }
      : function(cb){ return setTimeout(function(){ cb({ didTimeout: false, timeRemaining: function(){ return 50; } }); }, 50); };
    window.mnlIdleCancel = window.cancelIdleCallback
      ? function(id){ return window.cancelIdleCallback(id); }
      : function(id){ return clearTimeout(id); };
  }

  // Vague 144 : Coach IA FAB globale auto-injectée sur pages éducationnelles (lab, glossaire, recettes, blog)
  // Sur PDP la FAB existe déjà dans la section main-product (vague 139) → skip pour pas doubler.
  (function _coachFabGlobal(){
    var path = location.pathname;
    var ELIGIBLE_PATTERNS = [
      /^\/pages\/le-lab/i,
      /^\/pages\/lab\b/i,
      /^\/pages\/glossaire/i,
      /^\/pages\/recettes/i,
      /^\/pages\/transparence/i,
      /^\/pages\/ambassadeurs/i,
      /^\/pages\/notre-histoire/i,
      /^\/pages\/sport/i,
      /^\/blogs\//i
    ];
    if (!ELIGIBLE_PATTERNS.some(function(rx){ return rx.test(path); })) return;
    // Skip si user déjà sur PDP ou si une FAB existe déjà (vague 139)
    if (document.getElementById('mnlProdFabCoach') || document.getElementById('mnlGlobalCoachFab')) return;
    function _inject(){
      if (document.getElementById('mnlGlobalCoachFab') || document.getElementById('mnlProdFabCoach')) return;
      var fab = document.createElement('button');
      fab.type = 'button';
      fab.id = 'mnlGlobalCoachFab';
      fab.className = 'mnl-global-coach-fab';
      fab.setAttribute('aria-label', MNL_T('global.coach_fab_label', 'Ouvrir le Coach IA pour personnaliser ma formule'));
      fab.setAttribute('title', MNL_T('global.coach_fab_title', 'Coach IA — Ta formule au mg près'));
      fab.innerHTML = '<span class="mnl-global-coach-fab__icon" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg></span><span class="mnl-global-coach-fab__lbl">Coach IA</span>';
      document.body.appendChild(fab);
      fab.addEventListener('click', function(){
        if (typeof window.mnlOpenAI === 'function') {
          window.mnlOpenAI();
          if (window.mnlHaptic) window.mnlHaptic('medium');
          try { if (window.gtag) window.gtag('event', 'fab_coach_open', { source: 'global_educational' }); } catch(_){}
        } else {
          var productUrl = window.MNL_PRODUCT_URL || '/products/pre-workout-mynutrilab-personnalisable-au-mg-pres';
          window.location.href = productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'open=ai';
        }
      });
      // Hide quand AI ouverte
      document.addEventListener('mnl:ai:opened', function(){ fab.style.display = 'none'; });
      document.addEventListener('mnl:ai:closed', function(){ fab.style.display = ''; });
      // V519 : hide AUSSI quand la bubble minimize est visible (sinon = 2 floating bubbles superposées user-reported screenshot)
      document.addEventListener('mnl:ai:bubble-shown', function(){ fab.style.display = 'none'; });
      document.addEventListener('mnl:ai:bubble-hidden', function(){ fab.style.display = ''; });
      // V519 : init check — si la page charge avec body.mnl-ai-minimized (cross-page state), cache le FAB direct
      // (l'event mnl:ai:bubble-shown peut arriver après le _inject ci-dessus selon timing — défense in depth)
      if (document.body.classList.contains('mnl-ai-minimized')) {
        fab.style.display = 'none';
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', _inject);
    else _inject();
  })();

  // Vague 142 : floating "+N ajouté" ticker — apparaît depuis le bouton ATC vers le cart icon header
  // UX feedback satisfaction : user voit la quantité partir vers le panier (skeuomorphism subtil).
  window.mnlAtcTicker = function(sourceEl, qty){
    try {
      if (!sourceEl || !qty) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var srcRect = sourceEl.getBoundingClientRect();
      var cartIcon = document.querySelector('#mnl-hd-cart-btn, [data-mnl-cart-toggle], .mnl-bnav__btn#mnl-bnav-cart');
      var ticker = document.createElement('div');
      ticker.className = 'mnl-atc-ticker';
      ticker.setAttribute('aria-hidden', 'true');
      ticker.textContent = '+' + qty;
      ticker.style.cssText = 'position:fixed;left:' + (srcRect.left + srcRect.width / 2) + 'px;top:' + (srcRect.top + srcRect.height / 2) + 'px;z-index:9999;background:#E84E1B;color:#fff;font-weight:900;font-size:18px;padding:8px 16px;border-radius:100px;box-shadow:0 8px 20px rgba(194,65,12,.45);pointer-events:none;transform:translate(-50%,-50%) scale(.5);opacity:0;transition:transform .8s cubic-bezier(.4,1.6,.6,1), opacity .6s ease;font-family:inherit;';
      document.body.appendChild(ticker);
      // Phase 1 : appear at click position
      requestAnimationFrame(function(){
        ticker.style.opacity = '1';
        ticker.style.transform = 'translate(-50%,-50%) scale(1)';
        // Phase 2 : fly to cart icon
        setTimeout(function(){
          if (cartIcon) {
            var dstRect = cartIcon.getBoundingClientRect();
            ticker.style.left = (dstRect.left + dstRect.width / 2) + 'px';
            ticker.style.top = (dstRect.top + dstRect.height / 2) + 'px';
            ticker.style.transform = 'translate(-50%,-50%) scale(.3)';
            ticker.style.opacity = '0';
            // Bump cart icon scale au moment de l'atterrissage
            setTimeout(function(){
              cartIcon.style.transition = 'transform .3s cubic-bezier(.34,1.56,.64,1)';
              cartIcon.style.transform = 'scale(1.2)';
              setTimeout(function(){ cartIcon.style.transform = ''; }, 300);
            }, 600);
          } else {
            ticker.style.opacity = '0';
            ticker.style.transform = 'translate(-50%,-50%) scale(2) translateY(-60px)';
          }
        }, 350);
      });
      // Cleanup
      setTimeout(function(){ if (ticker.parentNode) ticker.remove(); }, 1200);
    } catch(_){}
  };

  // Vague 119 : haptic feedback centralisé — Navigator Vibration API avec respect user prefs + reduced-motion.
  // Usage : window.mnlHaptic('light' | 'medium' | 'heavy' | 'success' | 'error' | 'tick' | [pattern])
  // Patterns inspirés iOS UIImpactFeedbackGenerator + WebKit haptic guidelines.
  // Default OFF sauf si user a explicitement opt-in via localStorage 'mnl-haptic'='on'
  // (la vibration peut être perçue comme intrusive — opt-in respect privacy + a11y).
  if (!window.mnlHaptic) {
    var _HAPTIC_PATTERNS = {
      light: [8],
      medium: [15],
      heavy: [25],
      success: [10, 30, 10],
      error: [50, 50, 50],
      tick: [4],
      warn: [20, 60, 20]
    };
    window.mnlHaptic = function(kind){
      try {
        // Respect prefs : OFF par défaut, ON si user opt-in
        var pref = 'off';
        try { pref = localStorage.getItem('mnl-haptic') || 'off'; } catch(_){}
        if (pref !== 'on') return;
        // Respect prefers-reduced-motion (les haptics sont aussi du motion sensoriel)
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        // Doit être un input event handler (Chrome 87+ requirement) — best-effort
        if (!navigator.vibrate) return;
        var pat = Array.isArray(kind) ? kind : _HAPTIC_PATTERNS[kind];
        if (!pat) return;
        navigator.vibrate(pat);
      } catch(_){}
    };
    // Helper pour toggle préf depuis settings UI
    window.mnlHapticToggle = function(on){
      try { localStorage.setItem('mnl-haptic', on ? 'on' : 'off'); } catch(_){}
    };
  }

  // Vague 117 : focus-visible polyfill léger pour Safari < 15.4 / vieux WebKit / iOS 13-14
  // Détecte si :focus-visible est supporté par le moteur CSS via try/catch matches().
  // Si non, ajoute classe `mnl-focus-visible` sur <html> quand user interagit clavier (Tab/flèches/etc),
  // retire quand clic souris/touch. Les styles globaux ont déjà des règles `.mnl-focus-visible :focus`.
  (function _focusVisiblePolyfill(){
    try {
      // Test natif support — querySelector lance SyntaxError si :focus-visible inconnu
      document.querySelectorAll(':focus-visible');
      return; // natif OK, pas besoin du polyfill
    } catch(_){ /* fallthrough vers polyfill */ }
    var html = document.documentElement;
    if (!html) return;
    var usingKb = false;
    function onKey(e){
      // Tab / flèches / Enter / Space / Esc → mode clavier
      if (e.key === 'Tab' || e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Home' || e.key === 'End' || e.key === 'PageUp' || e.key === 'PageDown') {
        if (!usingKb) { usingKb = true; html.classList.add('mnl-focus-visible'); }
      }
    }
    function onPointer(){
      if (usingKb) { usingKb = false; html.classList.remove('mnl-focus-visible'); }
    }
    document.addEventListener('keydown', onKey, true);
    document.addEventListener('mousedown', onPointer, true);
    document.addEventListener('pointerdown', onPointer, true);
    document.addEventListener('touchstart', onPointer, { passive: true, capture: true });
  })();

  // Vague 132 : pull-to-refresh natif sur pages opt-in via data-mnl-ptr (account, wishlist, etc.)
  // Détecte swipe down depuis scrollY=0 → indicator visuel → si pull > 80px relâché → location.reload()
  // Skip si déjà PWA standalone (le browser gère natif) ET si pas mobile (souris = pas pertinent)
  (function _pullToRefresh(){
    if (!('ontouchstart' in window)) return; // mobile only
    var pages = document.querySelectorAll('[data-mnl-ptr]');
    if (!pages.length) return;
    var indicator = document.createElement('div');
    indicator.className = 'mnl-ptr-indicator';
    indicator.innerHTML = MNL_T('global.ptr_indicator_html', '<span class="mnl-ptr-indicator__icon">↓</span><span class="mnl-ptr-indicator__txt">Tirer pour rafraîchir</span>');
    document.body.appendChild(indicator);
    var startY = 0, currentY = 0, isPulling = false, isRefreshing = false;
    var THRESHOLD = 80;
    function _onStart(e){
      if (window.scrollY > 0 || isRefreshing) return;
      startY = e.touches[0].clientY;
      isPulling = true;
    }
    function _onMove(e){
      if (!isPulling) return;
      currentY = e.touches[0].clientY;
      var dy = currentY - startY;
      if (dy <= 0) return;
      // Resistance pour feel naturel
      var dist = Math.min(dy * 0.5, 120);
      indicator.style.transform = 'translateY(' + dist + 'px)';
      indicator.style.opacity = Math.min(dist / 60, 1);
      var icon = indicator.querySelector('.mnl-ptr-indicator__icon');
      var txt = indicator.querySelector('.mnl-ptr-indicator__txt');
      if (dist >= THRESHOLD) {
        indicator.classList.add('is-ready');
        if (icon) icon.textContent = '↑';
        if (txt) txt.textContent = MNL_T('global.ptr_release', 'Relâche pour rafraîchir');
      } else {
        indicator.classList.remove('is-ready');
        if (icon) icon.textContent = '↓';
        if (txt) txt.textContent = MNL_T('global.ptr_pull', 'Tirer pour rafraîchir');
      }
    }
    function _onEnd(){
      if (!isPulling) return;
      isPulling = false;
      var dy = currentY - startY;
      if (dy * 0.5 >= THRESHOLD) {
        isRefreshing = true;
        indicator.classList.add('is-refreshing');
        var icon = indicator.querySelector('.mnl-ptr-indicator__icon');
        var txt = indicator.querySelector('.mnl-ptr-indicator__txt');
        if (icon) icon.textContent = '⟳';
        if (txt) txt.textContent = MNL_T('global.ptr_refreshing', 'Rafraîchissement…');
        if (window.mnlHaptic) window.mnlHaptic('medium');
        setTimeout(function(){ location.reload(); }, 400);
      } else {
        indicator.style.transform = 'translateY(0)';
        indicator.style.opacity = '0';
      }
    }
    document.addEventListener('touchstart', _onStart, { passive: true });
    document.addEventListener('touchmove', _onMove, { passive: true });
    document.addEventListener('touchend', _onEnd, { passive: true });
    document.addEventListener('touchcancel', _onEnd, { passive: true });
  })();

  // Vague 129 : auto-format inputs via data-attributes — uppercase / lowercase / capitalize / titlecase
  // Usage : <input data-mnl-format="upper"> ou data-mnl-format="lower" ou "capitalize" ou "title"
  // Préserve la position du caret pour UX fluide à la frappe.
  (function _autoFormatInputs(){
    var FORMATS = {
      'upper': function(s){ return s.toUpperCase(); },
      'uppercase': function(s){ return s.toUpperCase(); },
      'lower': function(s){ return s.toLowerCase(); },
      'lowercase': function(s){ return s.toLowerCase(); },
      'capitalize': function(s){ return s.charAt(0).toUpperCase() + s.slice(1); },
      'title': function(s){ return s.replace(/\b\w/g, function(c){ return c.toUpperCase(); }); }
    };
    function _onInput(e){
      var el = e.target;
      if (!el || (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA')) return;
      var format = el.getAttribute('data-mnl-format');
      if (!format) return;
      var fn = FORMATS[format.toLowerCase()];
      if (!fn) return;
      var caret = el.selectionStart;
      var before = el.value;
      var after = fn(before);
      if (after === before) return;
      el.value = after;
      try { el.setSelectionRange(caret, caret); } catch(_){}
    }
    document.addEventListener('input', _onInput);
    // Auto-format au load aussi (cas où value préfill côté serveur)
    document.querySelectorAll('[data-mnl-format]').forEach(function(el){
      if (!el.value) return;
      var format = el.getAttribute('data-mnl-format');
      var fn = FORMATS[(format || '').toLowerCase()];
      if (fn) el.value = fn(el.value);
    });
  })();

  // Vague 129 : détection capabilities images modernes (AVIF/WebP) → class sur <html> + exposition window.mnlImgSupport
  // Les sections peuvent utiliser ces classes en CSS pour servir différents backgrounds, ou JS pour pre-fetch URL optimal.
  // Shopify image_url filter respecte déjà Accept header HTTP, mais ces hints permettent du conditionnel client-side
  // (ex: lazy load avec background-image, ou détection support pour ancienne preconnect).
  (function _imgCapsDetect(){
    var html = document.documentElement;
    window.mnlImgSupport = { webp: null, avif: null };
    function _testFormat(format, dataUri, cb){
      var img = new Image();
      img.onload = function(){ cb(img.width === 1); };
      img.onerror = function(){ cb(false); };
      img.src = dataUri;
    }
    // Mini test images (1×1 px) - les plus petits valides pour ces formats
    // AVIF support tested via une mini AVIF inline (12 bytes minimum)
    _testFormat('avif', 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAcAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=', function(ok){
      window.mnlImgSupport.avif = ok;
      if (ok) html.classList.add('mnl-supports-avif');
      else html.classList.add('mnl-no-avif');
      try { document.dispatchEvent(new CustomEvent('mnl:img:avif', { detail: { supported: ok } })); } catch(_){}
    });
    // WebP support (mini 2-byte WebP)
    _testFormat('webp', 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=', function(ok){
      window.mnlImgSupport.webp = ok;
      if (ok) html.classList.add('mnl-supports-webp');
      else html.classList.add('mnl-no-webp');
      try { document.dispatchEvent(new CustomEvent('mnl:img:webp', { detail: { supported: ok } })); } catch(_){}
    });
  })();

  // Vague 145 : welcome back greeting — subtile banner top de page si user revient après >24h, dismissible
  // Détecte signaux d'engagement : conversation IA, wishlist, formules, orders → personnalise le greeting
  (function _welcomeBack(){
    return; // V997 (fondateur 2026-07-08) : bandeau haut « Votre panier vous attend · Vos articles sont toujours là » RETIRÉ (« fait vraiment pas abouti »). La carte « Bon retour » V968 (.mnl-welcome-back) reste, elle. Pour ré-activer ce bandeau : supprimer ce return.
    if (location.pathname !== '/' && location.pathname !== '/index') return;
    var LAST_VISIT_KEY = 'mnl-last-visit';
    var DISMISS_KEY = 'mnl-welcomeback-dismissed';
    try {
      // Vague 147 BUG FIX : DISMISS_KEY doit être localStorage (sessionStorage wipe à tab close → 24h cooldown brisé)
      var dismissTs = parseInt(localStorage.getItem(DISMISS_KEY) || '0', 10);
      if (dismissTs && (Date.now() - dismissTs) < 24 * 60 * 60 * 1000) return;
      var lastVisit = parseInt(localStorage.getItem(LAST_VISIT_KEY) || '0', 10);
      var now = Date.now();
      // Update last visit timestamp tout de suite (avant le banner show)
      localStorage.setItem(LAST_VISIT_KEY, String(now));
      // Skip premier visit (lastVisit = 0)
      if (!lastVisit) return;
      var hoursSince = (now - lastVisit) / (60 * 60 * 1000);
      if (hoursSince < 24) return; // skip si même journée
      // Collect personalization signals
      var signals = { hasFormula: false, hasWishlist: false, hasCart: false, hasOrder: false };
      try {
        var hist = JSON.parse(localStorage.getItem('mnl-ai-history') || '[]');
        if (Array.isArray(hist) && hist.length) signals.hasFormula = true;
      } catch(_){}
      try {
        var wl = JSON.parse(localStorage.getItem('mnl-wishlist') || '[]');
        if (Array.isArray(wl) && wl.length) signals.hasWishlist = true;
      } catch(_){}
      try {
        var cartCount = parseInt(localStorage.getItem('mnl-cart-count') || '0', 10) || 0;
        if (cartCount > 0) signals.hasCart = true;
      } catch(_){}
      // Construct contextual greeting
      var icon = '', title, sub, ctaText, ctaUrl;
      var daysAgo = Math.floor(hoursSince / 24);
      // V522 : daysStr = phrase standalone naturelle. hoursSince >= 24 garanti (skip <24h ligne 3660) donc daysAgo >= 1.
      //   Avant : "hier de dernière visite" / "il y a 3 jours de dernière visite" = bancal (user-reported).
      //   Maintenant : "hier" / "il y a 3 jours" → composé proprement dans chaque message.
      var daysStr = daysAgo <= 1 ? MNL_T('global.time_yesterday', 'hier') : 'il y a ' + daysAgo + ' jours';
      if (signals.hasCart) {
        icon = ''; title = MNL_T('global.wb_cart_title', 'Ton panier t\'attend');
        sub = MNL_T('global.wb_cart_sub_prefix', 'Tes articles sont toujours là — dernière visite ') + daysStr;
        ctaText = MNL_T('global.wb_cta_checkout', 'Finaliser'); ctaUrl = '/cart';
      } else if (signals.hasFormula) {
        icon = ''; title = MNL_T('global.wb_hello_prefix', 'Re-bonjour ') + (window.Shopify && window.Shopify.customer && window.Shopify.customer.first_name ? window.Shopify.customer.first_name : MNL_T('global.wb_default_name', 'athlète')) + ' !';
        sub = MNL_T('global.wb_formula_sub', 'Ta formule sur-mesure t\'attend dans le Coach IA');
        ctaText = MNL_T('global.wb_cta_resume', 'Reprendre'); ctaUrl = '/products/pre-workout-mynutrilab-personnalisable-au-mg-pres?open=ai';
      } else if (signals.hasWishlist) {
        icon = '♥'; title = MNL_T('global.wb_wishlist_title', 'Tes envies sont sauvegardées');
        sub = MNL_T('global.wb_wishlist_sub_prefix', 'Retrouve tes produits favoris (vus ') + daysStr + ')';
        ctaText = MNL_T('global.wb_cta_wishlist', 'Voir wishlist'); ctaUrl = '/pages/wishlist';
      } else {
        return; // user sans engagement → pas de banner pertinent
      }
      function _show(){
        if (document.getElementById('mnl-welcomeback')) return;
        var ban = document.createElement('div');
        ban.id = 'mnl-welcomeback';
        ban.setAttribute('role', 'status');
        ban.className = 'mnl-welcomeback';
        ban.innerHTML = '<span class="mnl-welcomeback__icon" aria-hidden="true">' + icon + '</span>' +
          '<span class="mnl-welcomeback__txt"><strong>' + title + '</strong><span> · ' + sub + '</span></span>' +
          '<a href="' + ctaUrl + '" class="mnl-welcomeback__cta">' + ctaText + ' →</a>' +
          MNL_T('global.wb_close_html', '<button type="button" class="mnl-welcomeback__close" aria-label="Fermer">×</button>');
        document.body.insertBefore(ban, document.body.firstChild);
        ban.querySelector('.mnl-welcomeback__close').addEventListener('click', function(){
          ban.style.transform = 'translateY(-100%)';
          setTimeout(function(){ ban.remove(); }, 300);
          // Vague 147 BUG FIX : localStorage (pas sessionStorage) pour cooldown 24h cross-tab
          try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch(_){}
        });
        try { if (window.gtag) window.gtag('event', 'welcomeback_shown', { signal: signals.hasCart ? 'cart' : signals.hasFormula ? 'formula' : 'wishlist', hours: Math.round(hoursSince) }); } catch(_){}
      }
      if (window.mnlIdle) window.mnlIdle(_show, { timeout: 2500 });
      else setTimeout(_show, 1500);
    } catch(_){}
  })();

  // Vague 148 : copy link to highlighted text — Twitter-style. Quand user sélectionne du texte sur une page,
  // un petit floating "Copier le lien" apparait. Click = URL + #:~:text= (Text Fragments API, Chrome/Edge supported)
  // Fallback : URL standard si user agent ne supporte pas. Persiste 3s puis disparait au prochain click ailleurs.
  (function _copyLinkSelection(){
    // Skip si pas de navigator.clipboard (vieux Safari < 13) ou body intentionnellement opt-out
    if (!navigator.clipboard || !navigator.clipboard.writeText) return;
    if (document.body && document.body.getAttribute('data-mnl-skip-copy-selection') === '1') return;
    var pill = null;
    var hideTimer = null;
    function _create(){
      if (pill) return pill;
      pill = document.createElement('button');
      pill.type = 'button';
      pill.id = 'mnl-copy-sel';
      pill.setAttribute('aria-label', MNL_T('global.sel_copy_label', 'Copier le lien vers ce passage'));
      pill.style.cssText = 'position:absolute;z-index:99996;background:#0f172a;color:#fff;border:none;padding:6px 12px;border-radius:100px;font-size:12px;font-weight:800;font-family:inherit;cursor:pointer;box-shadow:0 6px 18px -4px rgba(15,23,42,.4);display:none;opacity:0;transform:translateY(-4px);transition:opacity .15s ease,transform .15s ease;white-space:nowrap;';
      pill.innerHTML = MNL_T('global.sel_copy_pill_html', '<span aria-hidden="true"></span> Copier le lien');
      document.body.appendChild(pill);
      pill.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        _doCopy();
      });
      return pill;
    }
    function _hide(){
      if (!pill) return;
      pill.style.opacity = '0';
      pill.style.transform = 'translateY(-4px)';
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function(){ if (pill) pill.style.display = 'none'; }, 200);
    }
    function _show(rect){
      var p = _create();
      p.style.display = 'inline-flex';
      // Position au-dessus de la sélection (centré horizontalement)
      var scrollY = window.scrollY || window.pageYOffset;
      var scrollX = window.scrollX || window.pageXOffset;
      p.style.top = (rect.top + scrollY - 40) + 'px';
      // Centre horizontal mais clamp à viewport (16px marge)
      var pillW = 130; // estimation initiale, refine après mesure
      var leftPos = Math.max(16, Math.min(window.innerWidth - pillW - 16, rect.left + scrollX + (rect.width / 2) - (pillW / 2)));
      p.style.left = leftPos + 'px';
      requestAnimationFrame(function(){
        if (!pill) return;
        pill.style.opacity = '1';
        pill.style.transform = 'translateY(0)';
        // Re-clamp après render réel
        var realW = pill.offsetWidth;
        if (realW > 0) {
          var realLeft = Math.max(16, Math.min(window.innerWidth - realW - 16, rect.left + scrollX + (rect.width / 2) - (realW / 2)));
          pill.style.left = realLeft + 'px';
        }
      });
    }
    function _doCopy(){
      var sel = window.getSelection ? window.getSelection() : null;
      var selText = sel ? sel.toString().trim() : '';
      if (!selText) { _hide(); return; }
      // Build URL with text fragment (Chrome 80+, Edge, Opera; Safari/Firefox ignore mais URL reste valide)
      var url = location.href.split('#')[0];
      // Encode + cap à 200 chars pour URL raisonnable
      var snippet = selText.replace(/\s+/g, ' ').slice(0, 200);
      url += '#:~:text=' + encodeURIComponent(snippet);
      navigator.clipboard.writeText(url).then(function(){
        if (window.mnlToast) window.mnlToast({ icon: '', title: MNL_T('global.link_copied', 'Lien copié'), sub: MNL_T('global.sel_copied_sub', 'Avec le passage sélectionné en surbrillance'), type: 'success', duration: 2500 });
        if (window.mnlHaptic) window.mnlHaptic('success');
        try { if (window.gtag) window.gtag('event', 'copy_link_selection', { snippet_length: snippet.length }); } catch(_){}
      }).catch(function(){
        if (window.mnlToastError) window.mnlToastError(MNL_T('global.copy_error_title', 'Erreur copie'), MNL_T('global.copy_error_sub', 'Réessaie ou copie manuellement'));
      });
      _hide();
    }
    // Listen pour selection change (debounce 350ms pour ne pas spammer)
    var selTimer = null;
    document.addEventListener('selectionchange', function(){
      clearTimeout(selTimer);
      selTimer = setTimeout(function(){
        var sel = window.getSelection ? window.getSelection() : null;
        var text = sel ? sel.toString().trim() : '';
        // Skip si trop court (< 20 chars) ou trop long (> 500 chars = bulk-select page = pas pertinent)
        if (!text || text.length < 20 || text.length > 500) { _hide(); return; }
        // Skip si selection dans un input/textarea (déjà a Cmd+C natif)
        try {
          if (sel && sel.anchorNode) {
            var node = sel.anchorNode.nodeType === 3 ? sel.anchorNode.parentNode : sel.anchorNode;
            if (node && (node.closest('input, textarea, [contenteditable]'))) { _hide(); return; }
            // Skip si dans drawer/modal (overlay = contexte UI, pas content)
            if (node && (node.closest('.mnl-ai-overlay, .mnl-cart-drawer, [role="dialog"]'))) { _hide(); return; }
          }
        } catch(_){}
        // Get bounding rect de la première range
        try {
          if (!sel.rangeCount) return;
          var rect = sel.getRangeAt(0).getBoundingClientRect();
          if (!rect || (rect.width === 0 && rect.height === 0)) return;
          _show(rect);
        } catch(_){}
      }, 350);
    });
    // Hide pill au scroll/click ailleurs
    window.addEventListener('scroll', _hide, { passive: true });
    document.addEventListener('mousedown', function(e){
      if (pill && e.target !== pill && !pill.contains(e.target)) {
        // Vérif si user clique pour DÉ-sélectionner — on hide
        setTimeout(function(){
          var sel = window.getSelection ? window.getSelection() : null;
          if (!sel || !sel.toString().trim()) _hide();
        }, 50);
      }
    });
  })();

  // Vague 147 : keyboard shortcuts help modal — ouvert via "?" (Shift + / sur AZERTY)
  // Liste les raccourcis globaux MNL pour discoverability (power-users)
  (function _kbdShortcutsHelp(){
    var SHORTCUTS = [
      { keys: ['/'], desc: MNL_T('global.kbd_desc_focus_search', 'Focus barre de recherche') },
      { keys: ['?'], desc: MNL_T('global.kbd_desc_show_help', 'Afficher cette aide') },
      { keys: ['Esc'], desc: MNL_T('global.kbd_desc_close_modal', 'Fermer drawer/modal ouvert') },
      { keys: ['g', 'h'], desc: MNL_T('global.kbd_desc_go_home', 'Aller à l\'accueil') },
      { keys: ['g', 'a'], desc: MNL_T('global.kbd_desc_go_account', 'Aller au compte') },
      { keys: ['g', 'c'], desc: MNL_T('global.kbd_desc_open_cart', 'Ouvrir le panier') },
      { keys: ['g', 'i'], desc: MNL_T('global.kbd_desc_open_coach', 'Ouvrir le Coach IA') },
      { keys: ['↑', '↓'], desc: MNL_T('global.kbd_desc_nav_ai', 'Naviguer dans les suggestions IA') },
      { keys: ['Enter'], desc: MNL_T('global.kbd_desc_send_message', 'Valider / envoyer message') },
      { keys: ['Shift', 'Enter'], desc: MNL_T('global.kbd_desc_newline_coach', 'Saut de ligne dans Coach IA') }
    ];
    var modal = null;
    function _open(){
      if (modal) return;
      modal = document.createElement('div');
      modal.id = 'mnl-kbd-help';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', MNL_T('global.kbd_overlay_label', 'Raccourcis clavier'));
      modal.style.cssText = 'position:fixed;inset:0;z-index:99998;background:rgba(15,23,42,.7);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;padding:20px;animation:mnl-kbd-fade .2s ease;';
      var rows = SHORTCUTS.map(function(s){
        var keys = s.keys.map(function(k){
          return '<kbd style="display:inline-flex;align-items:center;justify-content:center;min-width:24px;height:24px;padding:0 6px;background:#f1f5f9;border:1px solid #cbd5e1;border-bottom-width:2px;border-radius:5px;font-size:11px;font-weight:800;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;color:#0f172a;margin:0 2px;">' + k + '</kbd>';
        }).join(' <span style="color:#94a3b8;font-size:10px;">puis</span> ');
        return '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px dashed #e2e8f0;"><span style="color:#475569;font-size:13px;">' + s.desc + '</span><span>' + keys + '</span></div>';
      }).join('');
      modal.innerHTML = '<div style="background:#fff;color:#0f172a;border-radius:18px;max-width:520px;width:100%;max-height:90vh;overflow-y:auto;padding:24px;box-shadow:0 32px 64px -16px rgba(15,23,42,.4);animation:mnl-kbd-zoom .25s cubic-bezier(.34,1.56,.64,1);">' +
        MNL_T('global.kbd_overlay_head_html', '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;"><h2 style="margin:0;font-size:18px;font-weight:900;">⌨ Raccourcis clavier</h2><button type="button" id="mnl-kbd-help-close" aria-label="Fermer" style="background:transparent;border:none;font-size:24px;color:#94a3b8;cursor:pointer;line-height:1;padding:4px 8px;border-radius:6px;">×</button></div>') +
        '<div style="display:flex;flex-direction:column;">' + rows + '</div>' +
        MNL_T('global.kbd_overlay_foot_html', '<p style="margin:14px 0 0;font-size:11px;color:#94a3b8;text-align:center;">Astuce : appuie sur <kbd style="padding:1px 5px;background:#f1f5f9;border:1px solid #cbd5e1;border-radius:4px;font-size:10px;font-weight:800;">?</kbd> n\'importe où pour ré-ouvrir cette aide</p>') +
        '</div>';
      document.body.appendChild(modal);
      // CSS keyframes lazy
      if (!document.getElementById('mnl-kbd-help-style')) {
        var st = document.createElement('style');
        st.id = 'mnl-kbd-help-style';
        st.textContent = '@keyframes mnl-kbd-fade{from{opacity:0}to{opacity:1}}@keyframes mnl-kbd-zoom{from{opacity:0;transform:scale(.92)}to{opacity:1;transform:scale(1)}}';
        document.head.appendChild(st);
      }
      modal.addEventListener('click', function(e){ if (e.target === modal) _close(); });
      var btn = document.getElementById('mnl-kbd-help-close');
      if (btn) btn.addEventListener('click', _close);
      try { if (window.gtag) window.gtag('event', 'kbd_help_opened'); } catch(_){}
    }
    function _close(){
      if (!modal) return;
      try { modal.remove(); } catch(_){}
      modal = null;
    }
    // Listen pour "?" (shift+/) — skip si dans input/textarea/contenteditable
    document.addEventListener('keydown', function(e){
      if (e.key === '?' || (e.key === '/' && e.shiftKey)) {
        var t = e.target;
        if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
        e.preventDefault();
        if (modal) _close(); else _open();
      } else if (e.key === 'Escape' && modal) {
        _close();
      }
    });
    // Expose globalement pour Settings → "Voir raccourcis"
    window.mnlKbdHelp = _open;
  })();

  // V562c : DOUBLON « retour en haut » retiré — ce FAB (#mnl-scroll-top) faisait doublon avec
  // #mnl-back-to-top (setupBackToTop, plus bas) → deux flèches sur quasi toutes les pages + sur la PDP.
  // On neutralise celui-ci ; on garde setupBackToTop (CSS dédiée, a11y, coordination print/PDP/sticky-cta).
  (function _scrollToTopFab(){
    return; // désactivé (doublon) — cf. setupBackToTop
    if (location.pathname.indexOf('/checkout') === 0) return;
    if (document.body && document.body.getAttribute('data-mnl-skip-scroll-top') === '1') return;
    var btn = null;
    var SHOW_AT = 600;
    var visible = false;
    function _create(){
      if (btn) return btn;
      btn = document.createElement('button');
      btn.type = 'button';
      btn.id = 'mnl-scroll-top';
      btn.className = 'mnl-scroll-top';
      btn.setAttribute('aria-label', MNL_T('global.totop_label', 'Retour en haut de page'));
      btn.setAttribute('title', MNL_T('global.totop_title', 'Retour en haut'));
      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 15l-6-6-6 6"/></svg>';
      btn.style.cssText = 'position:fixed;bottom:18px;left:18px;width:44px;height:44px;border-radius:50%;background:rgba(15,23,42,.88);color:#fff;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 6px 18px -4px rgba(15,23,42,.4);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);z-index:88;opacity:0;transform:translateY(20px) scale(.85);transition:opacity .25s ease,transform .25s cubic-bezier(.34,1.56,.64,1),background .15s ease;font-family:inherit;';
      btn.addEventListener('mouseenter', function(){ btn.style.background = '#0f172a'; });
      btn.addEventListener('mouseleave', function(){ btn.style.background = 'rgba(15,23,42,.88)'; });
      btn.addEventListener('focus', function(){ btn.style.outline = '2px solid #fbbf24'; btn.style.outlineOffset = '2px'; });
      btn.addEventListener('blur', function(){ btn.style.outline = 'none'; });
      btn.addEventListener('click', function(){
        var reduce = false;
        try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(_){}
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        if (window.mnlHaptic) window.mnlHaptic('tick');
        try { if (window.gtag) window.gtag('event', 'scroll_top_used', { path: location.pathname }); } catch(_){}
      });
      document.body.appendChild(btn);
      // Responsive mobile : bottom-right pour proximité pouce
      // Vague 150 : si sticky-cta visible mobile (bottom bar) → FAB shift UP au-dessus pour pas chevaucher
      var isMobile = (window.matchMedia && window.matchMedia('(max-width: 720px)').matches);
      if (isMobile) {
        btn.style.left = 'auto';
        btn.style.right = '12px';
        function _adjustBottom(){
          var stickyCta = document.querySelector('.mnl-sticky-cta.is-visible');
          var safeBottom = 'env(safe-area-inset-bottom, 0px)';
          if (stickyCta) {
            // Sticky CTA visible (bar full-width ~64px) → décale au-dessus
            btn.style.bottom = 'calc(72px + ' + safeBottom + ')';
          } else {
            btn.style.bottom = 'calc(16px + ' + safeBottom + ')';
          }
        }
        _adjustBottom();
        // Re-adjust quand sticky-cta toggle visibility
        if ('MutationObserver' in window) {
          var stickyObs = new MutationObserver(_adjustBottom);
          var stickyEl = document.querySelector('.mnl-sticky-cta');
          if (stickyEl) stickyObs.observe(stickyEl, { attributes: true, attributeFilter: ['class'] });
          // Re-observe au cas où sticky-cta est créée plus tard
          setTimeout(function(){
            var stickyEl2 = document.querySelector('.mnl-sticky-cta');
            if (stickyEl2 && stickyEl2 !== stickyEl) stickyObs.observe(stickyEl2, { attributes: true, attributeFilter: ['class'] });
            _adjustBottom();
          }, 1500);
        }
      }
      return btn;
    }
    function _update(){
      var y = window.scrollY || window.pageYOffset || 0;
      var shouldShow = y > SHOW_AT;
      if (shouldShow === visible) return;
      visible = shouldShow;
      var b = _create();
      if (shouldShow) {
        b.style.opacity = '1';
        b.style.transform = 'translateY(0) scale(1)';
      } else {
        b.style.opacity = '0';
        b.style.transform = 'translateY(20px) scale(.85)';
      }
    }
    var rafId = null;
    function _onScroll(){
      if (rafId) return;
      rafId = requestAnimationFrame(function(){ rafId = null; _update(); });
    }
    window.addEventListener('scroll', _onScroll, { passive: true });
    // Init check au load (si user a déjà scrollé via anchor)
    if (window.mnlIdle) window.mnlIdle(_update, { timeout: 3000 });
    else setTimeout(_update, 2000);
  })();

  // Vague 128 : sub status banner — slim notification en haut de page si user a un abonnement actif (paused/skipped)
  // Affiche seulement sur home (/) pour ne pas spammer toutes les pages. Dismissible session.
  (function _subStatusBanner(){
    if (location.pathname !== '/' && location.pathname !== '/index') return;
    var DISMISS_KEY = 'mnl-sub-banner-dismissed';
    try { if (sessionStorage.getItem(DISMISS_KEY)) return; } catch(_){}
    var state = null;
    try { state = JSON.parse(localStorage.getItem('mnl-sub-state') || 'null'); } catch(_){}
    if (!state || (!state.paused && !state.skipNext && !state.cancelRequested)) return;
    // Construit message selon état
    var icon = '', msg = '', cta = MNL_T('global.sub_cta_manage', 'Gérer');
    if (state.cancelRequested) {
      icon = '';
      msg = MNL_T('global.sub_msg_cancelling', 'Ta demande de résiliation est en cours de traitement (sous 48h).');
    } else if (state.paused) {
      icon = '⏸';
      var until = state.pauseUntil ? new Date(state.pauseUntil) : null;
      msg = MNL_T('global.sub_msg_paused', 'Ton abonnement est en pause') + (until ? MNL_T('global.sub_msg_until_prefix', ' jusqu\'au ') + until.toLocaleDateString('fr-FR') : '') + '.';
      cta = MNL_T('global.sub_cta_resume', 'Reprendre');
    } else if (state.skipNext) {
      icon = '⏭';
      msg = MNL_T('global.sub_msg_skipped', 'Tu as sauté ta prochaine livraison. La suivante reste planifiée.');
      cta = MNL_T('global.sub_cta_undo_skip', 'Annuler le skip');
    }
    if (!msg) return;
    function _show(){
      if (document.getElementById('mnl-sub-banner')) return;
      var banner = document.createElement('div');
      banner.id = 'mnl-sub-banner';
      banner.className = 'mnl-sub-banner';
      banner.setAttribute('role', 'status');
      banner.innerHTML = '<span class="mnl-sub-banner__icon" aria-hidden="true">' + icon + '</span>' +
        '<span class="mnl-sub-banner__msg">' + msg + '</span>' +
        '<a href="/account#subscription" class="mnl-sub-banner__cta">' + cta + ' →</a>' +
        MNL_T('global.sub_close_html', '<button type="button" class="mnl-sub-banner__close" aria-label="Fermer">×</button>');
      document.body.insertBefore(banner, document.body.firstChild);
      banner.querySelector('.mnl-sub-banner__close').addEventListener('click', function(){
        banner.style.transform = 'translateY(-100%)';
        setTimeout(function(){ banner.remove(); }, 300);
        try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch(_){}
      });
    }
    // Defer pour pas impacter LCP
    if (window.mnlIdle) window.mnlIdle(_show, { timeout: 3000 });
    else setTimeout(_show, 2000);
  })();

  // Vague 128 : LQIP blur placeholder pour images lazy — applique un placeholder gradient subtil pendant le load
  // Cible : img[loading="lazy"] sans poster déjà défini. Au load complete → fade-in propre.
  // Bénéfice perçu : zéro CLS visible + transition smooth au lieu du flash blanc.
  (function _lazyImageBlur(){
    function _attachBlur(img){
      if (img._mnlBlurApplied) return;
      img._mnlBlurApplied = true;
      // Skip si img déjà chargée (cache HTTP/intersection initial déjà fired)
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('mnl-img-loaded');
        return;
      }
      img.classList.add('mnl-img-loading');
      var _done = function(){
        img.classList.remove('mnl-img-loading');
        img.classList.add('mnl-img-loaded');
      };
      img.addEventListener('load', _done, { once: true });
      img.addEventListener('error', _done, { once: true }); // si erreur, cleanup quand même
    }
    // Initial scan
    document.querySelectorAll('img[loading="lazy"]').forEach(_attachBlur);
    // Watch nouvelles images injectées dynamiquement
    if ('MutationObserver' in window) {
      var obs = new MutationObserver(function(muts){
        muts.forEach(function(m){
          m.addedNodes.forEach(function(n){
            if (n.nodeType !== 1) return;
            if (n.tagName === 'IMG' && n.getAttribute('loading') === 'lazy') {
              _attachBlur(n);
            } else if (n.querySelectorAll) {
              n.querySelectorAll('img[loading="lazy"]').forEach(_attachBlur);
            }
          });
        });
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  })();

  // Vague 127 : referral tracking — détecte ?ref=MNL-XXXXXX, persiste 30j, attache au cart pour attribution conversion
  // Complète la boucle vague 126 (génération du code) : maintenant le code voyage côté visiteur jusqu'au checkout.
  (function _refTracking(){
    var REF_KEY = 'mnl-referral';
    var REF_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30j (fenêtre cookie standard affiliation)
    function _parseRef(){
      try {
        var sp = new URLSearchParams(location.search);
        return sp.get('ref') || sp.get('referral') || null;
      } catch(_){ return null; }
    }
    // 1. Capture ref de l'URL au load si présent (whitelist format MNL-XXXXXX strict pour anti-injection)
    var urlRef = _parseRef();
    if (urlRef && /^MNL-[A-Z0-9]{4,10}$/.test(urlRef)) {
      try {
        localStorage.setItem(REF_KEY, JSON.stringify({ code: urlRef, ts: Date.now(), source: document.referrer || 'direct' }));
        // Discreet toast pour le filleul (rassurant + indique que le -10% sera appliqué)
        if (window.mnlToast) {
          setTimeout(function(){
            window.mnlToast({ icon: '', title: MNL_T('global.ref_activated_title', 'Parrainage activé'), sub: MNL_T('global.ref_code_prefix', 'Code ') + urlRef + MNL_T('global.ref_discount_suffix', ' — -10% sur ta 1ʳᵉ commande'), type: 'success', duration: 5000 });
          }, 1500);
        }
        // GA4 attribution
        try { if (window.gtag) window.gtag('event', 'referral_landing', { ref_code: urlRef, page_referrer: document.referrer || 'direct' }); } catch(_){}
      } catch(_){}
    }
    // 2. Helper exposé : récupère le ref actif (utilisé par cart attribution + checkout)
    window.mnlGetReferral = function(){
      try {
        var raw = localStorage.getItem(REF_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || !data.code) return null;
        if ((Date.now() - data.ts) > REF_TTL_MS) { localStorage.removeItem(REF_KEY); return null; }
        return data.code;
      } catch(_){ return null; }
    };
    // 3. Attache au cart au load + à chaque mnl:cart:updated event
    function _attachToCart(){
      var ref = window.mnlGetReferral();
      if (!ref) return;
      try {
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Code parrainage': ref } })
        }).catch(function(){ /* silent */ });
      } catch(_){}
    }
    // Une fois au load (defer pour pas impacter LCP) + à chaque cart update
    if (window.mnlIdle) window.mnlIdle(_attachToCart, { timeout: 2500 });
    else setTimeout(_attachToCart, 1500);
    document.addEventListener('mnl:cart:updated', _attachToCart);
  })();

  // Vague 126 : auto-complete ville depuis code postal FR via api-adresse.data.gouv.fr (gratuit, gouvernement FR, no auth)
  // Détecte input postal-code, au blur si 5 chiffres valides → fetch + propose la ville pour auto-fill.
  (function _zipFRAutocomplete(){
    var GOUV_API = 'https://api-adresse.data.gouv.fr/search/';
    function _isZipInput(el){
      if (!el || el.tagName !== 'INPUT') return false;
      if (el.getAttribute('autocomplete') === 'postal-code') return true;
      var n = (el.name || '').toLowerCase();
      var i = (el.id || '').toLowerCase();
      return /(zip|postal_code|postal-code|code_postal|cp|postcode)\b/.test(n + ' ' + i);
    }
    function _findCityInput(zipEl){
      // Cherche le sibling/next-of-kind input avec autocomplete=address-level2 ou name=city
      var form = zipEl.closest('form');
      if (!form) return null;
      // Priorité 1 : autocomplete standard
      var ac = form.querySelector('input[autocomplete="address-level2"]');
      if (ac) return ac;
      // Priorité 2 : name contains city/ville
      var nameMatch = form.querySelector('input[name*="city" i], input[name*="ville" i], input[id*="city" i], input[id*="ville" i]');
      return nameMatch;
    }
    var _cache = {}; // cache simple {zip → cityName}
    function _onBlur(e){
      var el = e.target;
      if (!_isZipInput(el) || !el.value) return;
      var zip = el.value.trim().replace(/\s/g, '');
      if (!/^\d{5}$/.test(zip)) return; // FR uniquement (5 chiffres)
      var cityInput = _findCityInput(el);
      if (!cityInput) return;
      // Si city déjà remplie par l'user, ne pas écraser sans demande
      if (cityInput.value && cityInput.value.trim().length > 0) return;
      // Cache hit ?
      if (_cache[zip]) { cityInput.value = _cache[zip]; cityInput.dispatchEvent(new Event('change', { bubbles: true })); return; }
      // Fetch
      try {
        fetch(GOUV_API + '?postcode=' + zip + '&limit=1&type=municipality', { credentials: 'omit' })
          .then(function(r){ if (!r.ok) throw new Error('zip-api'); return r.json(); })
          .then(function(data){
            if (data && data.features && data.features.length) {
              var city = data.features[0].properties.city || data.features[0].properties.name;
              if (city) {
                _cache[zip] = city;
                cityInput.value = city;
                cityInput.dispatchEvent(new Event('change', { bubbles: true }));
                // Subtle toast pour signaler l'auto-fill (laisse l'user vérifier)
                if (window.mnlToast) window.mnlToast({ icon: '', title: MNL_T('global.city_autofilled', 'Ville auto-complétée'), sub: city + ' (' + zip + ')', type: 'info', duration: 2200 });
              }
            }
          }).catch(function(){ /* silent fail — pas critique, user complète manuellement */ });
      } catch(_){}
    }
    document.addEventListener('blur', _onBlur, true);
  })();

  // Vague 125 : auto-format téléphone FR sur inputs type=tel ou name contenant 'phone'/'tel'/'mobile'
  // Format français : 06 12 34 56 78 (group de 2 chiffres). Accept aussi +33 6 12 34 56 78.
  // Strip caractères non-numériques (sauf + au début), puis re-format à la frappe (caret-preserving).
  (function _phoneFRAutoFormat(){
    function _isPhoneInput(el){
      if (!el || el.tagName !== 'INPUT') return false;
      if (el.type === 'tel') return true;
      var n = (el.name || '').toLowerCase();
      var i = (el.id || '').toLowerCase();
      return /(phone|tel|mobile|tele|portable)/.test(n + ' ' + i);
    }
    function _formatFr(raw){
      if (!raw) return '';
      // Garde le + si présent en début, sinon strip tout non-digit
      var hasPlus = raw.charAt(0) === '+';
      var digits = raw.replace(/[^\d]/g, '');
      if (!digits) return '';
      // Normalise : +33 6 → 06 ; +33612345678 → 0612345678
      if (hasPlus && digits.slice(0, 2) === '33') {
        digits = '0' + digits.slice(2);
      }
      // Limite à 10 chiffres (format FR)
      digits = digits.slice(0, 10);
      // Groupe par 2
      return digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
    }
    function _onInput(e){
      var el = e.target;
      if (!_isPhoneInput(el)) return;
      var caret = el.selectionStart;
      var before = el.value;
      var formatted = _formatFr(before);
      if (formatted === before) return;
      el.value = formatted;
      // Restore caret (simple: place à la fin si différence + sinon ajuste position)
      try {
        var diff = formatted.length - before.length;
        var newPos = Math.max(0, Math.min(formatted.length, caret + diff));
        el.setSelectionRange(newPos, newPos);
      } catch(_){}
    }
    function _validateOnBlur(e){
      var el = e.target;
      if (!_isPhoneInput(el)) return;
      if (!el.value) return;
      var digits = el.value.replace(/[^\d]/g, '');
      var ok = /^0[1-9]\d{8}$/.test(digits); // 10 chiffres, commence par 0[1-9]
      var wrap = el.parentNode;
      if (!wrap) return;
      var prev = wrap.querySelector('.mnl-phone-invalid');
      if (prev) prev.remove();
      if (!ok && digits.length > 3) {
        wrap.style.position = wrap.style.position || 'relative';
        var hint = document.createElement('div');
        hint.className = 'mnl-phone-invalid';
        hint.setAttribute('role', 'alert');
        hint.textContent = MNL_T('global.phone_format_hint', 'Format invalide. Exemple : 06 12 34 56 78');
        wrap.appendChild(hint);
      }
    }
    document.addEventListener('input', _onInput);
    document.addEventListener('blur', _validateOnBlur, true);
  })();

  // Vague 124 : email typo suggest (gmial.com → gmail.com, hotmial → hotmail, etc.)
  // Détecte les fautes courantes sur les TLD/domaines populaires via Levenshtein ≤1 edit.
  // Suggestion non-bloquante : badge "Voulez-vous dire X ?" cliquable pour auto-corriger.
  (function _emailTypoSuggest(){
    var POPULAR_DOMAINS = [
      'gmail.com', 'hotmail.com', 'hotmail.fr', 'outlook.com', 'outlook.fr',
      'yahoo.com', 'yahoo.fr', 'live.fr', 'live.com', 'icloud.com',
      'orange.fr', 'free.fr', 'sfr.fr', 'laposte.net', 'wanadoo.fr',
      'protonmail.com', 'proton.me', 'gmx.com', 'aol.com', 'mac.com', 'msn.com'
    ];
    function _lev(a, b){
      if (a === b) return 0;
      var al = a.length, bl = b.length;
      if (!al) return bl; if (!bl) return al;
      if (Math.abs(al - bl) > 2) return 99;
      var v0 = new Array(bl + 1), v1 = new Array(bl + 1);
      for (var i = 0; i <= bl; i++) v0[i] = i;
      for (var i = 0; i < al; i++) {
        v1[0] = i + 1;
        for (var j = 0; j < bl; j++) {
          var cost = a.charCodeAt(i) === b.charCodeAt(j) ? 0 : 1;
          v1[j + 1] = Math.min(v1[j] + 1, v0[j + 1] + 1, v0[j] + cost);
        }
        var tmp = v0; v0 = v1; v1 = tmp;
      }
      return v0[bl];
    }
    function _suggest(domain){
      var lc = domain.toLowerCase();
      // Match exact = pas de suggestion
      if (POPULAR_DOMAINS.indexOf(lc) !== -1) return null;
      // Trouve le plus proche dans une fenêtre Levenshtein ≤ 2
      var best = null, bestDist = 99;
      for (var i = 0; i < POPULAR_DOMAINS.length; i++) {
        var d = _lev(lc, POPULAR_DOMAINS[i]);
        if (d < bestDist && d <= 2 && d > 0) {
          bestDist = d;
          best = POPULAR_DOMAINS[i];
        }
      }
      return best;
    }
    function _onBlur(e){
      var t = e.target;
      if (!t || t.type !== 'email' || !t.value) return;
      var v = t.value.trim();
      var at = v.indexOf('@');
      if (at < 1 || at === v.length - 1) return;
      var local = v.slice(0, at);
      var domain = v.slice(at + 1);
      var suggested = _suggest(domain);
      var wrap = t.parentNode;
      // Cleanup ancien badge
      var prev = wrap && wrap.querySelector('.mnl-email-typo');
      if (prev) prev.remove();
      if (!suggested) return;
      if (!wrap) return;
      wrap.style.position = wrap.style.position || 'relative';
      var hint = document.createElement('div');
      hint.className = 'mnl-email-typo';
      hint.setAttribute('role', 'alert');
      hint.innerHTML = MNL_T('global.email_typo_prefix_html', 'Tu veux dire <button type="button" class="mnl-email-typo__btn">') + local + '@' + suggested + '</button> ?';
      wrap.appendChild(hint);
      hint.querySelector('.mnl-email-typo__btn').addEventListener('click', function(){
        t.value = local + '@' + suggested;
        hint.remove();
        t.dispatchEvent(new Event('input', { bubbles: true }));
        t.focus();
      });
    }
    document.addEventListener('blur', _onBlur, true);
  })();

  // Vague 123 : CapsLock warning sur tous les inputs type=password (UX standard 2025)
  // Avant : user tape password en CapsLock sans s'en rendre compte → "mot de passe incorrect" frustrant.
  // Maintenant : badge "Caps Lock activé" apparaît à droite de l'input dès qu'on tape avec Caps Lock.
  (function _capsLockWarn(){
    var WARN_HTML = MNL_T('global.capslock_html', '<span class="mnl-capslock-warn" role="alert" aria-live="polite">Caps Lock activé</span>');
    function _detectCaps(e){
      var t = e.target;
      if (!t || t.type !== 'password') return;
      var caps = false;
      try { caps = e.getModifierState && e.getModifierState('CapsLock'); } catch(_){}
      // Trouve ou crée le badge dans le parent
      var wrap = t.parentNode;
      if (!wrap) return;
      var existing = wrap.querySelector('.mnl-capslock-warn');
      if (caps && !existing) {
        wrap.style.position = wrap.style.position || 'relative';
        wrap.insertAdjacentHTML('beforeend', WARN_HTML);
      } else if (!caps && existing) {
        existing.remove();
      }
    }
    document.addEventListener('keydown', _detectCaps);
    document.addEventListener('keyup', _detectCaps);
    // Cleanup au blur (évite badge orphan si user click ailleurs avec Caps encore ON)
    document.addEventListener('blur', function(e){
      if (!e.target || e.target.type !== 'password') return;
      var wrap = e.target.parentNode;
      var existing = wrap && wrap.querySelector('.mnl-capslock-warn');
      if (existing) existing.remove();
    }, true);
  })();
  if ('MutationObserver' in window) {
    var trapMap = new WeakMap();
    var _trapScheduled = false;
    var _trapIdle = window.mnlIdle; // Vague 109 : utilise le singleton global au lieu de duplicate polyfill
    function _scheduleTrapScan() {
      if (_trapScheduled) return;
      _trapScheduled = true;
      _trapIdle(function () {
        _trapScheduled = false;
        // Early return si pas de dialog
        if (!document.querySelector('[role="dialog"]')) return;
        document.querySelectorAll('[role="dialog"][aria-modal="true"]:not([aria-hidden="true"]):not(#mnl-overlay):not(.mnl-hd-drawer)').forEach(function (d) {
          if (d.classList.contains('is-open') || d.style.display !== 'none') {
            if (!trapMap.has(d)) {
              var untrap = trapFocus(d);
              if (untrap) trapMap.set(d, untrap);
            }
          } else if (trapMap.has(d)) {
            trapMap.get(d)();
            trapMap.delete(d);
          }
        });
      }, { timeout: 200 });
    }
    new MutationObserver(_scheduleTrapScan).observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['aria-hidden'] // restreint : seul attr qui change à open/close de dialog
    });
  }

  // ════════════ IMAGE FALLBACK (img cassée → placeholder) ════════════
  document.addEventListener('error', function (e) {
    var img = e.target;
    if (img.tagName !== 'IMG' || img.dataset.mnlFallbackApplied) return;
    img.dataset.mnlFallbackApplied = '1';
    var w = img.width || img.getAttribute('width') || 200;
    var h = img.height || img.getAttribute('height') || 200;
    img.style.cssText = 'width:' + w + 'px;height:' + h + 'px;max-width:100%;';
    img.classList.add('mnl-img-broken');
    img.removeAttribute('src');
  }, true); // capture phase pour catch les errors d'images

  // ════════════ TAB TITLE NOTIFICATION (cart count flash quand tab inactif) ════════════
  var origTitle = document.title;
  var tabFlashInterval;
  document.addEventListener('mnl:cart:updated', function () {
    if (document.visibilityState === 'visible') return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.item_count > 0) {
        clearInterval(tabFlashInterval);
        var states = ['(' + cart.item_count + ') ' + origTitle, origTitle];
        var i = 0;
        tabFlashInterval = setInterval(function () {
          document.title = states[i % 2];
          i++;
        }, 1500);
      }
    }).catch(function () {});
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      clearInterval(tabFlashInterval);
      document.title = origTitle;
    }
  });

  // ════════════ RECENTLY VIEWED STRIP (sur fiche produit) — auto-injection ════════════
  // Vague 93 : helpers d'escape HTML + URL pour anti-injection sur item.title (rentré via produit Shopify).
  function _rvEscHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }
  function injectRecentlyViewedStrip() {
    if (window.location.pathname.indexOf('/products/') !== 0) return;
    var rv = [];
    try { rv = JSON.parse(localStorage.getItem('mnl-recently-viewed') || '[]'); } catch (_) {}
    if (!Array.isArray(rv)) return;
    var currentHandle = window.location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
    var others = rv.filter(function (item) {
      if (!item || typeof item === 'string') return false;
      // V716 : n'affiche que de VRAIS produits (exclut home/marque trackée par erreur → fini la carte 404)
      if (!item.url || item.url.indexOf('/products/') === -1) return false;
      return item.handle && item.handle !== currentHandle;
    }).slice(0, 6);
    if (others.length < 1) return;
    if (document.querySelector('.mnl-rv-strip')) return; // déjà injecté
    var target = document.querySelector('[data-mnl-rv-strip-target], .mnl-pp3-readyquiz, .mnl-pp3__section--bg, footer');
    if (!target) return;
    var strip = document.createElement('section');
    strip.className = 'mnl-rv-strip';
    strip.setAttribute('aria-label', MNL_T('global.rv_strip_label', 'Produits récemment vus'));
    // Vague 93 : utilise item.title si disponible (avant : handle "pre-workout-mnl" → "Pre Workout Mnl" moche)
    //            + image si stockée (avant : juste générique)
    //            + clear all button
    var itemsHTML = others.map(function (item) {
      var isStr = typeof item === 'string';
      var h = isStr ? item : item.handle;
      var url = (!isStr && item.url) ? item.url : ('/products/' + h);
      // Préfère item.title (Shopify), fallback sur handle transformé
      var label = (!isStr && item.title) ? item.title :
        h.replace(/-/g, ' ').replace(/\b\w/g, function (l) { return l.toUpperCase(); }).slice(0, 50);
      var imgUrl = (!isStr && item.image) ? item.image : '';
      // Vague 150 P0 SEC FIX : retiré onerror inline (CSP-incompatible + escape fragile triple-backslash).
      // Maintenant : data-mnl-img-fallback="" + handler global addEventListener('error') ci-dessous au setup.
      var iconHtml = imgUrl
        ? '<img class="mnl-rv-strip__item-img" src="' + _rvEscHtml(imgUrl) + '" alt="" loading="lazy" decoding="async" width="48" height="48" data-mnl-img-fallback="">'
        : '<div class="mnl-rv-strip__item-icon" aria-hidden="true"></div>';
      return '<a href="' + _rvEscHtml(url) + '" class="mnl-rv-strip__item">' +
        iconHtml +
        '<p class="mnl-rv-strip__item-name">' + _rvEscHtml(label) + '</p>' +
      '</a>';
    }).join('');
    strip.innerHTML = MNL_T('global.rv_strip_head_html', '<div class="mnl-rv-strip__head"><p class="mnl-rv-strip__title">Tu as récemment regardé</p>') +
      MNL_T('global.rv_strip_clear_html', '<button type="button" class="mnl-rv-strip__clear" data-mnl-rv-clear aria-label="Effacer l\'historique récent">Effacer</button></div>') +
      '<div class="mnl-rv-strip__list">' + itemsHTML + '</div>';
    target.parentNode.insertBefore(strip, target);
    // Vague 150 P0 SEC FIX : handler global fallback image (remplace onerror inline)
    strip.querySelectorAll('img[data-mnl-img-fallback]').forEach(function(img){
      img.addEventListener('error', function(){
        var fb = img.getAttribute('data-mnl-img-fallback') || '';
        var div = document.createElement('div');
        div.className = 'mnl-rv-strip__item-icon';
        div.setAttribute('aria-hidden', 'true');
        div.textContent = fb;
        if (img.parentNode) img.parentNode.replaceChild(div, img);
      }, { once: true });
    });
    // Vague 93 : handler du bouton clear (avant : aucun moyen pour user de purger l'historique RV)
    var clearBtn = strip.querySelector('[data-mnl-rv-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function(){
        try { localStorage.removeItem('mnl-recently-viewed'); } catch(_){}
        strip.remove();
        if (window.mnlToast) window.mnlToast({ icon: '', title: MNL_T('global.rv_history_cleared', 'Historique effacé'), sub: MNL_T('global.rv_history_cleared_sub', 'Les produits récents ont été oubliés.'), type: 'info', duration: 3000 });
        // Sync vers les autres widgets (notamment la liste du panneau RV)
        document.dispatchEvent(new CustomEvent('mnl:rv:cleared'));
      });
    }
  }
  setTimeout(injectRecentlyViewedStrip, 800);
  // Vague 93 : re-inject sur pageshow (BFCache restoration) — sinon strip absent si user nav avec back/forward
  window.addEventListener('pageshow', function(e){
    if (e.persisted) setTimeout(injectRecentlyViewedStrip, 100);
  });

  // ════════════ SMART 404 SEARCH SUGGESTIONS (auto-suggérer recherche depuis URL cassée) ════════════
  if (document.body.classList.contains('template-404')) {
    var lastSegment = window.location.pathname.split('/').filter(Boolean).pop() || '';
    var keywords = lastSegment.replace(/[-_]+/g, ' ').replace(/\.\w+$/, '').trim();
    if (keywords.length > 2) {
      setTimeout(function () {
        var suggestionTarget = document.querySelector('[data-mnl-404-suggestions]') || document.querySelector('.mnl-404__container');
        if (suggestionTarget && !document.querySelector('.mnl-404__smart-suggest')) {
          var suggest = document.createElement('div');
          suggest.className = 'mnl-404__smart-suggest';
          suggest.style.cssText = 'margin:24px 0;padding:18px;background:rgba(194,65,12,.08);border:1px solid rgba(194,65,12,.25);border-radius:14px;text-align:center;';
          suggest.innerHTML = MNL_T('global.search_didyoumean_prefix', 'Tu cherchais peut-être ') +
            '<a href="/search?q=' + encodeURIComponent(keywords) + '" style="color:#C2410C;font-weight:800;text-decoration:underline;text-underline-offset:3px;">"' + keywords + '"</a> ?';
          suggestionTarget.appendChild(suggest);
        }
      }, 500);
    }
  }

  // ════════════ TAB SWITCHING SMOOTH (data-mnl-tab + data-mnl-tab-content) ════════════
  function activateTab(tabBtn) {
    if (!tabBtn) return;
    var tabId = tabBtn.getAttribute('data-mnl-tab');
    var scope = tabBtn.closest('[data-mnl-tab-scope]') || document;
    scope.querySelectorAll('[data-mnl-tab]').forEach(function (b) {
      var active = b === tabBtn;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', active ? 'true' : 'false');
      // tabindex roving : seul le tab actif est focusable au Tab, les autres via Arrows
      b.setAttribute('tabindex', active ? '0' : '-1');
    });
    scope.querySelectorAll('[data-mnl-tab-content]').forEach(function (c) {
      var match = c.getAttribute('data-mnl-tab-content') === tabId;
      c.style.display = match ? '' : 'none';
      c.setAttribute('aria-hidden', match ? 'false' : 'true');
      if (match) {
        c.style.animation = 'none';
        requestAnimationFrame(function () { c.style.animation = ''; });
      }
    });
  }
  document.addEventListener('click', function (e) {
    var tabBtn = e.target.closest('[data-mnl-tab]');
    if (tabBtn) activateTab(tabBtn);
  });
  // Keyboard ARIA tab pattern : ArrowLeft/Right pour navigation, Home/End pour premier/dernier
  document.addEventListener('keydown', function (e) {
    var tabBtn = e.target.closest('[data-mnl-tab]');
    if (!tabBtn) return;
    var scope = tabBtn.closest('[data-mnl-tab-scope]') || document;
    var tabs = Array.from(scope.querySelectorAll('[data-mnl-tab]'));
    var idx = tabs.indexOf(tabBtn);
    var next = null;
    if (e.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
    else if (e.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
    else if (e.key === 'Home') next = tabs[0];
    else if (e.key === 'End') next = tabs[tabs.length - 1];
    if (next) { e.preventDefault(); activateTab(next); next.focus(); }
  });

  // ════════════ PREDICTIVE PREFETCH ON HOVER (perceived perf) ════════════
  if ('IntersectionObserver' in window) {
    var prefetched = new Set();
    function prefetchURL(url) {
      if (prefetched.has(url)) return;
      prefetched.add(url);
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
    }
    var hoverPrefetchTimer;
    document.addEventListener('mouseenter', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.hasAttribute('data-mnl-confirm-logout') || a.hasAttribute('data-no-prefetch')) return;
      var href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
      if (a.target === '_blank' || a.hasAttribute('download')) return;
      var url;
      try { url = new URL(a.href, window.location.origin); } catch (_) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname) return;
      // Skip checkout / sensitive
      if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|account|admin|api|customer_authentication|customer_identity|challenge|policies|discount|pages\/account)/i.test(url.pathname)) return;
      // Skip slow connection
      if (navigator.connection && (navigator.connection.effectiveType === '2g' || navigator.connection.effectiveType === 'slow-2g' || navigator.connection.saveData)) return;
      clearTimeout(hoverPrefetchTimer);
      hoverPrefetchTimer = setTimeout(function () { prefetchURL(url.pathname + url.search); }, 120);
    }, true);
  }

  // ════════════ STICKY SUB-NAV PRODUCT PAGE (jump to sections h2[id]) ════════════
  function setupStickySubnav() {
    var subnav = document.querySelector('[data-mnl-subnav]');
    if (!subnav || subnav.dataset.mnlSubnavBuilt) return;
    var scope = document.querySelector(subnav.getAttribute('data-mnl-subnav-scope') || 'main') || document;
    var sectionsSelector = subnav.getAttribute('data-mnl-subnav-sections') || 'h2[id]';
    var sections = Array.from(scope.querySelectorAll(sectionsSelector)).filter(function (h) { return h.id; });
    if (sections.length < 2) return;
    subnav.dataset.mnlSubnavBuilt = '1';
    var ctaText = subnav.getAttribute('data-mnl-subnav-cta') || '';
    var ctaUrl = subnav.getAttribute('data-mnl-subnav-cta-url') || '';
    var listHTML = sections.map(function (s) {
      var label = (s.dataset.mnlSubnavLabel || s.textContent || '').trim().slice(0, 28);
      if (!label) return ''; // skip sections sans label utile
      return '<li><a href="#' + s.id + '" class="mnl-subnav__link" data-mnl-subnav-target="' + s.id + '">' + label + '</a></li>';
    }).filter(Boolean).join('');
    if (!listHTML) return; // safety net : aucun link valide → ne pas afficher subnav vide
    subnav.classList.add('mnl-subnav');
    subnav.innerHTML = '<div class="mnl-subnav__inner"><ul class="mnl-subnav__list">' + listHTML + '</ul>' +
      (ctaText ? '<a href="' + ctaUrl + '" class="mnl-subnav__cta">' + ctaText + '</a>' : '') + '</div>';

    // V547 : blur après clic souris/Enter sur les liens du sommaire — sinon le lien cliqué garde le :focus et
    //   l'anneau bleu global (#F97316, *:focus-visible) PERSISTE sur "Piliers" (1er item, en haut à gauche) =
    //   le "rond bleu" visible. Même correctif que la nav verticale (V526). Le focus clavier pur (Tab sans clic)
    //   reste géré par :focus-visible → anneau a11y conservé pour la navigation clavier.
    subnav.querySelectorAll('.mnl-subnav__link, .mnl-subnav__cta').forEach(function (a) {
      a.addEventListener('click', function () {
        var self = this;
        setTimeout(function () { try { self.blur(); } catch (_) {} }, 60);
      });
    });

    // Show subnav après scroll past le 1er h2
    var firstSection = sections[0];
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        subnav.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-100px 0px 0px 0px' }).observe(firstSection);

      // Highlight section active
      var activeObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            subnav.querySelectorAll('.mnl-subnav__link').forEach(function (l) { l.classList.remove('is-active'); });
            var active = subnav.querySelector('[data-mnl-subnav-target="' + e.target.id + '"]');
            if (active) active.classList.add('is-active');
          }
        });
      }, { rootMargin: '-30% 0px -55% 0px' });
      sections.forEach(function (s) { activeObs.observe(s); });
    }
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupStickySubnav, 300);
  else setupStickySubnav();

  // ════════════ STAR RATING INPUT (auto-bind data-mnl-stars-input) ════════════
  // Vague 108 : sanitize `name` attribute pour anti-XSS si data-mnl-stars-input contient user-content
  // injecté via Liquid. Whitelist : alphanumériques + tirets/underscores uniquement.
  function _sanitizeName(s) {
    return String(s || 'rating').replace(/[^a-zA-Z0-9_\-]/g, '').slice(0, 40) || 'rating';
  }
  function setupStarsInput() {
    document.querySelectorAll('[data-mnl-stars-input]').forEach(function (container) {
      if (container.dataset.mnlStarsBuilt) return;
      container.dataset.mnlStarsBuilt = '1';
      var name = _sanitizeName(container.getAttribute('data-mnl-stars-input'));
      var initial = parseInt(container.getAttribute('data-mnl-stars-value'), 10) || 0;
      container.classList.add('mnl-stars-input');
      container.setAttribute('role', 'radiogroup');
      container.setAttribute('aria-label', container.getAttribute('aria-label') || MNL_T('global.rating_label', 'Note sur 5 étoiles'));
      var html = '';
      for (var i = 5; i >= 1; i--) {
        html += '<input type="radio" name="' + name + '" id="' + name + '-' + i + '" value="' + i + '"' + (i === initial ? ' checked' : '') + '>' +
          '<label for="' + name + '-' + i + '" aria-label="' + i + ' étoile' + (i > 1 ? 's' : '') + '">★</label>';
      }
      container.innerHTML = html;
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupStarsInput, 200);
  else setupStarsInput();

  // ════════════ MAGNIFIER GLASS PRODUCT IMAGE (data-mnl-magnify) ════════════
  // Vague 105 : support touch hybride (Surface, iPad+pencil, Chromebook tactile) — avant : require
  // `(hover:hover) and (pointer:fine)` excluait ces devices alors qu'ils peuvent utiliser le magnifier.
  // Maintenant : opt-in via `data-mnl-magnify` quel que soit le type d'input ; mouse + touch bindings.
  function setupMagnifier() {
    document.querySelectorAll('[data-mnl-magnify]').forEach(function (container) {
      if (container.dataset.mnlMagnifyBound) return;
      container.dataset.mnlMagnifyBound = '1';
      var img = container.querySelector('img');
      if (!img) return;
      container.classList.add('mnl-magnify');
      var lens = document.createElement('div');
      lens.className = 'mnl-magnify__lens';
      container.appendChild(lens);
      var hiResSrc = container.getAttribute('data-mnl-magnify-src') || img.src;
      var zoom = parseFloat(container.getAttribute('data-mnl-magnify-zoom')) || 2.5;
      lens.style.backgroundImage = 'url(' + hiResSrc + ')';
      var bounds;
      var updateBounds = function () { bounds = container.getBoundingClientRect(); };
      // Vague 105 : invalidate bounds on scroll/resize aussi (avant : seul resize → lens décalée si user scroll page pendant survol)
      var onWindowChange = function(){ bounds = null; };
      function _activate(){
        updateBounds();
        container.classList.add('is-active');
        lens.style.backgroundSize = (bounds.width * zoom) + 'px ' + (bounds.height * zoom) + 'px';
      }
      function _deactivate(){
        container.classList.remove('is-active');
      }
      function _move(clientX, clientY){
        if (!bounds) updateBounds();
        var x = clientX - bounds.left;
        var y = clientY - bounds.top;
        if (x < 0 || y < 0 || x > bounds.width || y > bounds.height) return;
        var lensSize = 160;
        lens.style.left = (x - lensSize / 2) + 'px';
        lens.style.top = (y - lensSize / 2) + 'px';
        lens.style.backgroundPosition = '-' + (x * zoom - lensSize / 2) + 'px -' + (y * zoom - lensSize / 2) + 'px';
      }
      // Mouse events (souris classique)
      container.addEventListener('mouseenter', _activate);
      container.addEventListener('mouseleave', _deactivate);
      container.addEventListener('mousemove', function(e){ _move(e.clientX, e.clientY); });
      // Vague 105 : Touch events (tablettes, hybrides, mobile sur PDP)
      container.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        _activate();
        _move(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      container.addEventListener('touchmove', function(e){
        if (!e.touches || !e.touches[0]) return;
        _move(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      container.addEventListener('touchend', _deactivate);
      container.addEventListener('touchcancel', _deactivate);
      window.addEventListener('resize', onWindowChange);
      window.addEventListener('scroll', onWindowChange, { passive: true });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupMagnifier, 200);
  else setupMagnifier();

  // ════════════ SAVE FOR LATER (depuis cart drawer) ════════════
  function getSavedForLater() {
    try { return JSON.parse(localStorage.getItem('mnl-saved-for-later') || '[]'); } catch (_) { return []; }
  }
  function setSavedForLater(list) {
    try { localStorage.setItem('mnl-saved-for-later', JSON.stringify(list)); document.dispatchEvent(new CustomEvent('mnl:sfl:updated', { detail: list })); } catch (_) {}
  }
  window.mnlGetSavedForLater = getSavedForLater;
  window.mnlSaveForLater = function (item) {
    var list = getSavedForLater();
    if (list.some(function (x) { return x.id === item.id; })) return;
    list.unshift(item);
    if (list.length > 20) list = list.slice(0, 20);
    setSavedForLater(list);
    if (window.mnlToast) window.mnlToast({ icon: '', title: MNL_T('global.saved_for_later', 'Sauvé pour plus tard'), sub: item.title || '', type: 'info', duration: 3500 });
  };
  window.mnlRemoveFromSaved = function (id) {
    var list = getSavedForLater().filter(function (x) { return x.id !== id; });
    setSavedForLater(list);
  };

  // ════════════ CLICK-TO-CALL (auto wraps phone numbers in tel: links) ════════════
  function autoLinkPhones() {
    var phoneRe = /(\+33[\s.-]?\d{1}[\s.-]?\d{2}[\s.-]?\d{2}[\s.-]?\d{2}[\s.-]?\d{2}|0\d{1}[\s.-]?\d{2}[\s.-]?\d{2}[\s.-]?\d{2}[\s.-]?\d{2})/g;
    document.querySelectorAll('[data-mnl-autolink-phone]').forEach(function (el) {
      if (el.dataset.mnlPhonesBound) return;
      el.dataset.mnlPhonesBound = '1';
      var html = el.innerHTML;
      el.innerHTML = html.replace(phoneRe, function (match) {
        var clean = match.replace(/[\s.-]/g, '');
        return '<a href="tel:' + clean + '" class="mnl-link-underline" style="color:inherit;">' + match + '</a>';
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(autoLinkPhones, 300);
  else autoLinkPhones();

  // ════════════ NOTIFICATION CENTER (in-app messages collected) ════════════
  var notifs = [];
  try { notifs = JSON.parse(sessionStorage.getItem('mnl-notifs') || '[]'); } catch (_) {}

  function ensureNotifCenter() {
    var center = document.getElementById('mnl-notif-center');
    if (center) return center;
    center = document.createElement('div');
    center.id = 'mnl-notif-center';
    center.className = 'mnl-notif-center';
    center.setAttribute('role', 'log');
    center.setAttribute('aria-label', MNL_T('global.notifcenter_label', 'Centre de notifications'));
    center.innerHTML =
      '<div class="mnl-notif-center__header">' +
        '<h3 class="mnl-notif-center__title">Notifications <span class="mnl-notif-center__count">0</span></h3>' +
        MNL_T('global.notifcenter_clear_html', '<button type="button" class="mnl-notif-center__clear">Tout effacer</button>') +
      '</div>' +
      '<div class="mnl-notif-center__list"></div>';
    document.body.appendChild(center);
    center.querySelector('.mnl-notif-center__clear').addEventListener('click', function () {
      notifs = [];
      try { sessionStorage.setItem('mnl-notifs', '[]'); } catch (_) {}
      renderNotifs();
    });
    return center;
  }
  function renderNotifs() {
    var center = ensureNotifCenter();
    var list = center.querySelector('.mnl-notif-center__list');
    var count = center.querySelector('.mnl-notif-center__count');
    count.textContent = notifs.length;
    if (notifs.length === 0) {
      list.innerHTML = MNL_T('global.notifcenter_empty_html', '<div class="mnl-notif-center__empty">Aucune notification</div>');
      return;
    }
    list.innerHTML = notifs.map(function (n) {
      var ago = window.mnlTimeAgo ? window.mnlTimeAgo(n.ts) : '';
      return '<div class="mnl-notif mnl-notif--' + (n.type || 'info') + '">' +
        '<span class="mnl-notif__icon" aria-hidden="true">' + (n.icon || '') + '</span>' +
        '<div class="mnl-notif__body">' +
          '<p class="mnl-notif__title">' + (n.title || '') + '</p>' +
          (n.sub ? '<p class="mnl-notif__sub">' + n.sub + '</p>' : '') +
          (ago ? '<p class="mnl-notif__time">' + ago + '</p>' : '') +
        '</div>' +
      '</div>';
    }).join('');
  }
  window.mnlAddNotif = function (notif) {
    notifs.unshift(Object.assign({ ts: Date.now() }, notif));
    if (notifs.length > 30) notifs = notifs.slice(0, 30);
    try { sessionStorage.setItem('mnl-notifs', JSON.stringify(notifs)); } catch (_) {}
    renderNotifs();
    // Bump count badges éventuels
    document.querySelectorAll('[data-mnl-notif-count]').forEach(function (el) {
      el.textContent = notifs.length;
      el.classList.add('is-bumping');
      setTimeout(function () { el.classList.remove('is-bumping'); }, 400);
    });
  };
  window.mnlOpenNotifCenter = function () { ensureNotifCenter().classList.add('is-open'); renderNotifs(); };
  window.mnlCloseNotifCenter = function () { var c = document.getElementById('mnl-notif-center'); if (c) c.classList.remove('is-open'); };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mnl-notif-toggle]')) {
      var c = ensureNotifCenter();
      c.classList.contains('is-open') ? window.mnlCloseNotifCenter() : window.mnlOpenNotifCenter();
      return;
    }
    var center = document.getElementById('mnl-notif-center');
    if (center && center.classList.contains('is-open') && !center.contains(e.target) && !e.target.closest('[data-mnl-notif-toggle]')) {
      window.mnlCloseNotifCenter();
    }
  });

  // Helper "il y a X temps"
  window.mnlTimeAgo = function (ts) {
    var s = Math.floor((Date.now() - ts) / 1000);
    if (s < 60) return MNL_T('global.time_just_now', 'à l\'instant');
    if (s < 3600) return 'il y a ' + Math.floor(s / 60) + ' min';
    if (s < 86400) return 'il y a ' + Math.floor(s / 3600) + 'h';
    if (s < 604800) return 'il y a ' + Math.floor(s / 86400) + 'j';
    return MNL_T('global.time_long_ago', 'il y a longtemps');
  };

  // ════════════ PINCH-TO-ZOOM mobile gallery (active uniquement sur mnl-zoom-overlay) ════════════
  // Note: Le browser fait déjà zoom natif si tu actives meta viewport user-scalable.
  // Sur les modal images, on permet le zoom natif via touch-action: pinch-zoom.
  document.querySelectorAll('.mnl-zoom-overlay__img').forEach(function (img) {
    img.style.touchAction = 'pinch-zoom';
  });

  // ════════════ AUTO-PROMO FROM URL (?discount=WELCOME15 → applique + bandeau) ════════════
  window.mnlRequestDiscount = function (code) {
    if (!/^[A-Z0-9_-]{3,40}$/.test(code)) return Promise.reject(new Error('Invalid discount format'));
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        if (controller) controller.abort();
        reject(new Error('Discount request timed out'));
      }, 10000);
      var options = { method: 'GET', credentials: 'same-origin', cache: 'no-store' };
      if (controller) options.signal = controller.signal;
      Promise.resolve().then(function () {
        return fetch('/discount/' + encodeURIComponent(code), options);
      }).then(function (response) {
        clearTimeout(timer);
        if (!response || !response.ok) {
          reject(new Error('Discount request failed'));
          return;
        }
        resolve({ code: code, requested: true });
      }).catch(function (error) {
        clearTimeout(timer);
        reject(error);
      });
    });
  };

  (function autoPromo() {
    var params = new URLSearchParams(window.location.search);
    var code = params.get('discount') || params.get('promo');
    if (!code) return;
    code = code.toUpperCase().trim();
    if (!/^[A-Z0-9_-]{3,40}$/.test(code)) return;
    try {
      sessionStorage.setItem('mnl-promo-code', code);
      if (sessionStorage.getItem('mnl-promo-requested') === code) return;
    } catch (_) {}
    var banner = document.createElement('div');
    banner.className = 'mnl-promo-banner';
    banner.setAttribute('role', 'status');
    banner.setAttribute('aria-live', 'polite');
    banner.textContent = MNL_T('global.promo_pending_prefix', 'Code promo ') + code +
      MNL_T('global.promo_pending_suffix', ' : transmission en cours. La remise sera vérifiée au paiement.');
    document.body.appendChild(banner);
    requestAnimationFrame(function () { banner.classList.add('is-visible'); });

    function finish(message, failed) {
      banner.textContent = message;
      banner.setAttribute('data-promo-state', failed ? 'error' : 'requested');
      if (failed) banner.setAttribute('role', 'alert');
      if (window.mnlAddNotif) window.mnlAddNotif({
        icon: '',
        title: failed ? MNL_T('global.promo_request_failed_title', 'Code non transmis') : MNL_T('global.promo_requested_title', 'Code transmis'),
        sub: message,
        type: failed ? 'error' : 'info'
      });
      setTimeout(function () {
        banner.classList.remove('is-visible');
        setTimeout(function () { banner.remove(); }, 500);
      }, 7000);
    }

    window.mnlRequestDiscount(code).then(function () {
      try { sessionStorage.setItem('mnl-promo-requested', code); } catch (_) {}
      finish(MNL_T('global.promo_requested_prefix', 'Code ') + code +
        MNL_T('global.promo_requested_suffix', ' transmis. Sa validité et la remise seront confirmées au paiement.'), false);
    }).catch(function () {
      finish(MNL_T('global.promo_network_failure_prefix', 'Impossible de transmettre le code ') + code +
        MNL_T('global.promo_network_failure_suffix', '. Il est conservé : réessaie dans le panier ou saisis-le au paiement.'), true);
    });
  })();
  // ════════════ WAITLIST OUT-OF-STOCK (data-mnl-waitlist auto-bind) ════════════
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-mnl-waitlist]');
    if (!form) return;
    e.preventDefault();
    var emailInput = form.querySelector('input[type="email"]');
    if (!emailInput) return;
    var email = (emailInput.value || '').trim().toLowerCase();
    // Vague 72 : validation WHATWG-like via helper consolidé (avant : !email — accepte "test@")
    if (!window.mnlValidEmail || !window.mnlValidEmail(email)) {
      if (window.mnlToastError) window.mnlToastError(MNL_T('global.stock_email_invalid_title', 'Email invalide'), MNL_T('global.stock_email_invalid_sub', 'Vérifie le format'));
      emailInput.focus();
      return;
    }
    var variant = form.getAttribute('data-mnl-waitlist-variant') || '';
    var product = form.getAttribute('data-mnl-waitlist-product') || '';
    // Save localStorage pour future notif (et POST backend si dispo)
    // Vague 72 : cap 50 entries + TTL 30j (anti-bloat localStorage)
    try {
      var watches = JSON.parse(localStorage.getItem('mnl-stock-watches') || '[]');
      var TTL_MS = 30 * 24 * 60 * 60 * 1000;
      watches = watches.filter(function(w){ return w && w.ts && (Date.now() - w.ts) < TTL_MS; });
      // Anti-doublon : si même email+variant déjà watch, on ne re-push pas
      var dupe = watches.some(function(w){ return w.email === email && w.variant === variant; });
      if (!dupe) {
        watches.push({ email: email, variant: variant, product: product, ts: Date.now() });
        if (watches.length > 50) watches = watches.slice(-50); // garde 50 dernières
        localStorage.setItem('mnl-stock-watches', JSON.stringify(watches));
      }
    } catch (_) {}
    // Optional : POST backend
    var backendUrl = form.getAttribute('action') || '/contact';
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'stock-waitlist,variant-' + variant);
    fd.append('contact[note]', 'Waitlist for variant ' + variant + ' (' + product + ')');
    fetch(backendUrl, { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    // UI feedback
    var wrap = form.closest('.mnl-waitlist');
    if (wrap) {
      wrap.classList.add('is-success');
      var success = wrap.querySelector('.mnl-waitlist__success');
      if (success) success.innerHTML = MNL_T('global.stock_success_prefix_html', '✓ Tu seras prévenu dès que <strong>') + product + MNL_T('global.stock_success_suffix_html', '</strong> revient en stock.');
    }
    if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.stock_subscribed_title', 'Inscrit à la waitlist'), MNL_T('global.stock_subscribed_sub', 'On t\'écrit dès que ça revient'));
  });

  // ════════════ DYNAMIC FAVICON (notif badge sur le tab) ════════════
  function updateFaviconBadge(count) {
    var link = document.querySelector('link[rel="icon"]');
    if (!link) return;
    var origHref = link.dataset.mnlOrigHref || link.href;
    if (!link.dataset.mnlOrigHref) link.dataset.mnlOrigHref = origHref;
    if (!count || count <= 0) {
      link.href = origHref;
      return;
    }
    var canvas = document.createElement('canvas');
    canvas.width = 64; canvas.height = 64;
    var ctx = canvas.getContext('2d');
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      ctx.drawImage(img, 0, 0, 64, 64);
      // Red dot top-right
      ctx.fillStyle = '#C2410C';
      ctx.beginPath();
      ctx.arc(48, 16, 16, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#fff';
      ctx.font = 'bold 18px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(count > 9 ? '9+' : String(count), 48, 17);
      try { link.href = canvas.toDataURL('image/png'); } catch (_) {}
    };
    img.onerror = function () {/* CORS issue : fallback dot only */
      ctx.fillStyle = '#C2410C';
      ctx.beginPath();
      ctx.arc(32, 32, 28, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#fff';
      ctx.font = 'bold 32px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(count > 9 ? '9+' : String(count), 32, 34);
      try { link.href = canvas.toDataURL('image/png'); } catch (_) {}
    };
    img.src = origHref;
  }
  window.mnlSetFaviconBadge = updateFaviconBadge;
  document.addEventListener('mnl:cart:updated', function () {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (document.visibilityState !== 'visible') updateFaviconBadge(cart.item_count);
    }).catch(function () {});
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') updateFaviconBadge(0);
  });

  // ════════════ ONE-CLICK REORDER (data-mnl-reorder="line_items_json") ════════════
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-reorder]');
    if (!btn) return;
    e.preventDefault();
    var itemsJson = btn.getAttribute('data-mnl-reorder');
    var items;
    try { items = JSON.parse(itemsJson); } catch (_) { return; }
    if (!Array.isArray(items) || !items.length) return;
    if (!window.mnlConfirm) {
      // Fallback simple
      window.location.href = btn.getAttribute('href') || '/cart';
      return;
    }
    window.mnlConfirm({
      type: 'info',
      icon: '',
      title: MNL_T('global.reorder_title', 'Recommander cette commande ?'),
      message: items.length + ' article' + (items.length > 1 ? 's' : '') + MNL_T('global.reorder_message_suffix', ' seront ajoutés à ton panier actuel.'),
      confirmText: MNL_T('global.reorder_confirm', 'Ajouter au panier'),
      cancelText: MNL_T('global.common_cancel', 'Annuler')
    }).then(function (ok) {
      if (!ok) return;
      btn.setAttribute('data-loading', 'true');
      // V940 : UNE SEULE requête multi-lignes atomique (avant : N POST /cart/add.js en parallèle → écritures concurrentes rejetées 422 → panier incomplet)
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: items.map(function (it) {
            return { id: it.variant_id, quantity: it.quantity || 1 };
          })
        })
      // Vague 63 : check HTTP status (avant : .then() exécuté même si 422 rupture → faux toast succès)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || MNL_T('global.stock_insufficient', 'Stock insuffisant')); });
        return r.json();
      }).then(function () {
        btn.removeAttribute('data-loading');
        document.dispatchEvent(new CustomEvent('mnl:cart:updated'));
        if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.reorder_added_title', 'Commande ajoutée !'), items.length + ' article' + (items.length > 1 ? 's' : '') + MNL_T('global.reorder_added_sub_suffix', ' dans ton panier'));
        if (window.mnlHaptic) window.mnlHaptic('success'); // Vague 119
        // Vague 142 : floating +N ticker depuis position du clic (UX feedback satisfaction)
        if (typeof window.mnlAtcTicker === 'function') window.mnlAtcTicker(btn, items.length);
        if (typeof window.mnlCartOpen === 'function') setTimeout(window.mnlCartOpen, 400);
      }).catch(function (err) {
        btn.removeAttribute('data-loading');
        if (window.mnlToastError) window.mnlToastError(MNL_T('global.common_error', 'Erreur'), (err && err.message) || MNL_T('global.reorder_error_sub', 'Impossible d\'ajouter certains articles'));
      });
    });
  });

  // ════════════ SMART CART UPSELL (auto-fetch related products) ════════════
  // <div data-mnl-cart-upsell data-mnl-cart-upsell-handles="whey,creatine">
  function setupCartUpsell() {
    document.querySelectorAll('[data-mnl-cart-upsell]').forEach(function (container) {
      if (container.dataset.mnlUpsellBound) return;
      container.dataset.mnlUpsellBound = '1';
      var handles = (container.getAttribute('data-mnl-cart-upsell-handles') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
      if (!handles.length) return;
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
      })).then(function (products) {
        var valid = products.filter(Boolean);
        if (!valid.length) { container.style.display = 'none'; return; }
        // Vague 63 : escape XSS sur p.title + safeHref/escape sur p.featured_image (admin-injectable)
        function escAttr(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];}); }
        function safeImgUrl(u){ var s=String(u||'').trim(); return /^(https?:\/\/|\/[^/])/.test(s) ? s : ''; }
        container.innerHTML = MNL_T('global.upsell_title_html', '<p style="font-size:11px;font-weight:800;color:#94a3b8;letter-spacing:.08em;text-transform:uppercase;margin:0 0 10px;display:flex;align-items:center;gap:5px;"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.7 4.8L18.5 9.5l-4.8 1.7L12 16l-1.7-4.8L5.5 9.5l4.8-1.7z"/></svg>Souvent ajouté ensemble</p>') +
          '<div style="display:flex;flex-direction:column;gap:8px;">' +
          valid.map(function (p) {
            var price = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
            var safeTitle = escAttr(p.title);
            var safeImg = safeImgUrl(p.featured_image);
            var variantId = (p.variants && p.variants[0] && p.variants[0].id) || '';
            return '<div style="display:flex;align-items:center;gap:10px;padding:10px;background:#F2F3F5;border:1px solid #E5E8EC;border-radius:10px;">' + /* V1037 : charte Coach */
              '<div style="width:40px;height:40px;border-radius:8px;background:#fff;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;overflow:hidden;">' + (safeImg ? '<img src="' + escAttr(safeImg) + '" alt="" style="width:100%;height:100%;object-fit:cover;" loading="lazy" decoding="async">' : '<span aria-hidden="true"></span>') + '</div>' +
              '<div style="flex:1;min-width:0;">' +
                '<p style="font-size:12px;font-weight:800;color:#0f172a;margin:0;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + safeTitle + '</p>' +
                '<p style="font-size:11px;color:#E84E1B;margin:1px 0 0;font-weight:700;">' + escAttr(price) + '</p>' + /* V1037 : charte Coach */
              '</div>' +
              '<button type="button" data-mnl-upsell-add="' + escAttr(variantId) + MNL_T('global.upsell_add_aria_prefix', '" aria-label="Ajouter ') + safeTitle + MNL_T('global.upsell_add_btn_html', '" style="padding:6px 12px;background:#E84E1B;color:#fff;border:none;border-radius:100px;font-size:11px;font-weight:800;cursor:pointer;font-family:inherit;letter-spacing:.02em;">+ Ajouter</button>') +
            '</div>';
          }).join('') + '</div>';
      });
    });
  }
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-mnl-upsell-add]');
    if (!addBtn) return;
    e.preventDefault();
    // Guard double-click : si déjà en cours, ignore (évite 2 ajouts simultanés)
    if (addBtn.getAttribute('data-loading') === 'true') return;
    var variantId = addBtn.getAttribute('data-mnl-upsell-add');
    if (!variantId) return;
    addBtn.setAttribute('data-loading', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) {
      // Vague 63 : check HTTP (avant : .then exécuté même si rupture/422)
      if (!r.ok) return r.json().then(function(err){ throw new Error(err.description || MNL_T('global.stock_insufficient', 'Stock insuffisant')); });
      return r.json();
    }).then(function () {
      addBtn.removeAttribute('data-loading');
      addBtn.textContent = MNL_T('global.upsell_added', '✓ Ajouté');
      document.dispatchEvent(new CustomEvent('mnl:cart:updated'));
    }).catch(function (err) {
      addBtn.removeAttribute('data-loading');
      if (window.mnlToastError) window.mnlToastError(MNL_T('global.common_error', 'Erreur'), (err && err.message) || MNL_T('global.common_retry', 'Réessaie'));
    });
  });
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupCartUpsell, 300);
  else setupCartUpsell();

  // ════════════ €/dose CALCULATOR (data-mnl-price-per-dose-base / -doses) ════════════
  function setupPricePerDose() {
    document.querySelectorAll('[data-mnl-price-per-dose]').forEach(function (el) {
      if (el.dataset.mnlPpdBound) return;
      el.dataset.mnlPpdBound = '1';
      var price = parseFloat(el.getAttribute('data-mnl-price-per-dose'));
      var doses = parseInt(el.getAttribute('data-mnl-price-per-dose-doses'), 10) || 30;
      var compare = parseFloat(el.getAttribute('data-mnl-price-per-dose-compare')) || 0;
      if (isNaN(price)) return;
      var perDose = (price / doses).toFixed(2).replace('.', ',');
      var html = '<span class="mnl-price-per-dose__icon" aria-hidden="true"></span><span><strong>' + perDose + MNL_T('global.perdose_sep_html', ' €</strong> / dose · ') + doses + MNL_T('global.perdose_doses_suffix', ' doses');
      if (compare > price) {
        var perDoseCompare = (compare / doses).toFixed(2).replace('.', ',');
        html += ' <span class="mnl-price-per-dose__compare">' + perDoseCompare + ' €</span>';
      }
      html += '</span>';
      el.classList.add('mnl-price-per-dose');
      el.innerHTML = html;
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupPricePerDose, 300);
  else setupPricePerDose();

  // ════════════ COMPARE PRODUCTS WIDGET (up to 3) ════════════
  function getCompareList() {
    try { return JSON.parse(sessionStorage.getItem('mnl-compare-list') || '[]'); } catch (_) { return []; }
  }
  function setCompareList(list) {
    try { sessionStorage.setItem('mnl-compare-list', JSON.stringify(list)); } catch (_) {}
    renderCompareBar();
  }
  function ensureCompareBar() {
    var bar = document.getElementById('mnl-compare-bar');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.id = 'mnl-compare-bar';
    bar.className = 'mnl-compare-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', MNL_T('global.compare_bar_label', 'Produits à comparer'));
    bar.innerHTML = '<div class="mnl-compare-bar__inner"><span class="mnl-compare-bar__title">⚖ Comparer</span><div class="mnl-compare-bar__items"></div><button type="button" class="mnl-compare-bar__cta" disabled>Comparer (0/2 min)</button></div>';
    document.body.appendChild(bar);
    bar.querySelector('.mnl-compare-bar__cta').addEventListener('click', function () {
      var list = getCompareList();
      if (list.length < 2) return;
      var handles = list.map(function (i) { return i.handle; }).join(',');
      window.location.href = '/pages/comparator?products=' + encodeURIComponent(handles);
    });
  }
  function renderCompareBar() {
    var list = getCompareList();
    if (!list.length) {
      var b = document.getElementById('mnl-compare-bar');
      if (b) b.classList.remove('is-visible');
      return;
    }
    var bar = ensureCompareBar();
    var itemsEl = bar.querySelector('.mnl-compare-bar__items');
    var cta = bar.querySelector('.mnl-compare-bar__cta');
    itemsEl.innerHTML = list.map(function (it) {
      return '<span class="mnl-compare-bar__item">' + it.title + '<button type="button" class="mnl-compare-bar__item-remove" data-mnl-compare-remove="' + it.handle + '" aria-label="Retirer ' + it.title + '">×</button></span>';
    }).join('');
    cta.disabled = list.length < 2;
    cta.textContent = list.length >= 2 ? MNL_T('global.compare_cta_prefix', 'Comparer (') + list.length + ')' : MNL_T('global.compare_cta_prefix', 'Comparer (') + list.length + MNL_T('global.compare_cta_min_suffix', '/2 min)');
    bar.classList.add('is-visible');
  }
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-mnl-compare-add]');
    if (addBtn) {
      e.preventDefault();
      var handle = addBtn.getAttribute('data-mnl-compare-add');
      var title = addBtn.getAttribute('data-mnl-compare-title') || handle;
      var list = getCompareList();
      if (list.some(function (x) { return x.handle === handle; })) {
        // Toggle off
        list = list.filter(function (x) { return x.handle !== handle; });
        if (window.mnlToast) window.mnlToast({ icon: '−', title: MNL_T('global.compare_removed', 'Retiré du comparateur'), sub: title, type: 'info', duration: 2500 });
      } else {
        if (list.length >= 3) {
          if (window.mnlToastWarn) window.mnlToastWarn(MNL_T('global.compare_max_title', 'Max 3 produits'), MNL_T('global.compare_max_sub', 'Retire-en un d\'abord'));
          return;
        }
        list.push({ handle: handle, title: title, ts: Date.now() });
        if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.compare_added', 'Ajouté au comparateur'), list.length + MNL_T('global.compare_count_suffix', '/3 produits'));
      }
      setCompareList(list);
      // Toggle button visual state
      addBtn.classList.toggle('is-active', list.some(function (x) { return x.handle === handle; }));
      return;
    }
    var rmBtn = e.target.closest('[data-mnl-compare-remove]');
    if (rmBtn) {
      var h = rmBtn.getAttribute('data-mnl-compare-remove');
      var list2 = getCompareList().filter(function (x) { return x.handle !== h; });
      setCompareList(list2);
      // Update buttons
      document.querySelectorAll('[data-mnl-compare-add="' + h + '"]').forEach(function (b) { b.classList.remove('is-active'); });
    }
  });
  renderCompareBar();

  // ════════════ ORDER TRACKING VISUAL STEPPER (data-mnl-tracker JSON) ════════════
  function setupTracker() {
    document.querySelectorAll('[data-mnl-tracker]').forEach(function (container) {
      if (container.dataset.mnlTrackerBuilt) return;
      var data;
      try { data = JSON.parse(container.getAttribute('data-mnl-tracker')); } catch (_) { return; }
      if (!data || typeof data !== 'object') return;
      var steps = Array.isArray(data.steps) ? data.steps : [];
      if (!steps.length) return; // bail si aucun step
      // Clamp current dans [0, steps.length] (steps.length = "tout terminé")
      var current = Math.max(0, Math.min(parseInt(data.current, 10) || 0, steps.length));
      var times = Array.isArray(data.times) ? data.times : [];
      container.dataset.mnlTrackerBuilt = '1';
      container.classList.add('mnl-tracker');
      container.setAttribute('role', 'progressbar');
      container.setAttribute('aria-label', MNL_T('global.tracker_label', 'Suivi de commande'));
      container.setAttribute('aria-valuemin', '0');
      container.setAttribute('aria-valuemax', String(steps.length));
      container.setAttribute('aria-valuenow', String(Math.min(current + 1, steps.length)));
      container.innerHTML = steps.map(function (label, i) {
        var state = i < current ? 'is-done' : (i === current ? 'is-current' : '');
        var icon = i < current ? '✓' : String(i + 1);
        var time = times[i] ? '<p class="mnl-tracker__time">' + times[i] + '</p>' : '';
        return '<div class="mnl-tracker__step ' + state + '">' +
          '<div class="mnl-tracker__icon">' + icon + '</div>' +
          '<p class="mnl-tracker__label">' + label + '</p>' +
          time +
        '</div>';
      }).join('');
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupTracker, 200);
  else setupTracker();

  // ════════════ GEO WELCOME BANNER (timezone-based, soft non-intrusive) ════════════
  (function geoWelcome() {
    try { if (sessionStorage.getItem('mnl-geo-shown')) return; } catch (_) { return; }
    var tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (_) { return; }
    // V916 : bannière geo-welcome NEUTRALISÉE — elle annonçait des livraisons Belgique/Luxembourg/Suisse/Espagne/Italie/Allemagne/Portugal avec délais ET frais précis, alors qu'on ne livre QU'EN France métropolitaine et Corse. Plus aucune fausse offre de livraison internationale n'est affichée.
    var country = null;
    if (!country) return;
    setTimeout(function () {
      var banner = document.createElement('div');
      banner.className = 'mnl-geo-banner';
      banner.setAttribute('role', 'status');
      banner.setAttribute('aria-live', 'polite');
      banner.innerHTML =
        '<span class="mnl-geo-banner__flag" aria-hidden="true">' + country.flag + '</span>' +
        '<div class="mnl-geo-banner__body">' +
          '<p class="mnl-geo-banner__title">On livre en ' + country.name + ' ✓</p>' +
          '<p class="mnl-geo-banner__sub">' + country.shipping + '</p>' +
        '</div>' +
        MNL_T('global.geo_close_html', '<button type="button" class="mnl-geo-banner__close" aria-label="Fermer">×</button>');
      document.body.appendChild(banner);
      requestAnimationFrame(function () { banner.classList.add('is-visible'); });
      try { sessionStorage.setItem('mnl-geo-shown', '1'); } catch (_) {}
      banner.querySelector('.mnl-geo-banner__close').addEventListener('click', function () {
        banner.classList.remove('is-visible');
        setTimeout(function () { banner.remove(); }, 400);
      });
      setTimeout(function () {
        if (banner.parentNode) {
          banner.classList.remove('is-visible');
          setTimeout(function () { if (banner.parentNode) banner.remove(); }, 400);
        }
      }, 8000);
    }, 4500);
  })();

  // ════════════ COOKIE PREFERENCES MODAL (granular consent) ════════════
  var cookiePrefsOpener = null;
  function closeCookiePrefs(modal) {
    if (!modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.inert = true;
    if (window.mnlUnlockScroll) window.mnlUnlockScroll();
    if (cookiePrefsOpener && cookiePrefsOpener.isConnected) {
      try { cookiePrefsOpener.focus({ preventScroll: true }); } catch (_) {}
    }
  }
  function ensureCookiePrefs() {
    var modal = document.getElementById('mnl-cookie-prefs');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'mnl-cookie-prefs';
    modal.className = 'mnl-cookie-prefs';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'mnl-cookie-prefs-title');
    modal.setAttribute('aria-hidden', 'true');
    modal.inert = true;
    var prefs = {};
    try { prefs = JSON.parse(localStorage.getItem('mnl-cookie-prefs') || '{}'); } catch (_) {}
    // Vague 85 : 3ème catégorie "Préférences" (CNIL recommendation — granular consent)
    // Couvre theme dark mode, langue, recently-viewed enrichi, achievements unlocked.
    // Active functionality_storage + personalization_storage (Consent Mode v2 GA4).
    modal.innerHTML =
      '<div class="mnl-cookie-prefs__box">' +
        '<button type="button" class="mnl-cookie-prefs__close" data-action="close" aria-label="' + MNL_T('pdp3.close', 'Fermer') + '">×</button>' +
        MNL_T('global.cookieprefs_title_html', '<h3 class="mnl-cookie-prefs__title" id="mnl-cookie-prefs-title">Préférences cookies</h3>') +
        MNL_T('global.cookieprefs_sub_html', '<p class="mnl-cookie-prefs__sub">Choisis quels cookies tu acceptes. Tu peux modifier ces choix à tout moment.</p>') +
        '<div class="mnl-cookie-prefs__cat">' +
          MNL_T('global.cookieprefs_cat_essential_html', '<div class="mnl-cookie-prefs__cat-info"><p class="mnl-cookie-prefs__cat-name">Essentiels <small>obligatoires</small></p><p class="mnl-cookie-prefs__cat-desc">Indispensables au fonctionnement (panier, login, sécurité). Non désactivables.</p></div>') +
          MNL_T('global.cookieprefs_toggle_essential_html', '<button type="button" class="mnl-cookie-prefs__toggle is-on" disabled aria-label="Cookies essentiels"></button>') +
        '</div>' +
        '<div class="mnl-cookie-prefs__cat">' +
          MNL_T('global.cookieprefs_cat_prefs_html', '<div class="mnl-cookie-prefs__cat-info"><p class="mnl-cookie-prefs__cat-name">Préférences</p><p class="mnl-cookie-prefs__cat-desc">Mémorise tes choix UI (derniers produits vus, badges débloqués).</p></div>') +
          '<button type="button" class="mnl-cookie-prefs__toggle ' + (prefs.preferences ? 'is-on' : '') + MNL_T('global.cookieprefs_toggle_prefs_html', '" data-cat="preferences" aria-label="Cookies préférences"></button>') +
        '</div>' +
        '<div class="mnl-cookie-prefs__cat">' +
          MNL_T('global.cookieprefs_cat_analytics_html', '<div class="mnl-cookie-prefs__cat-info"><p class="mnl-cookie-prefs__cat-name">Analytics</p><p class="mnl-cookie-prefs__cat-desc">Mesure d\'audience anonyme (Google Analytics, Microsoft Clarity).</p></div>') +
          '<button type="button" class="mnl-cookie-prefs__toggle ' + (prefs.analytics ? 'is-on' : '') + '" data-cat="analytics" aria-label="Cookies analytics"></button>' +
        '</div>' +
        '<div class="mnl-cookie-prefs__cat">' +
          MNL_T('global.cookieprefs_cat_marketing_html', '<div class="mnl-cookie-prefs__cat-info"><p class="mnl-cookie-prefs__cat-name">Marketing</p><p class="mnl-cookie-prefs__cat-desc">Personnalisation pubs (Meta Pixel, retargeting).</p></div>') +
          '<button type="button" class="mnl-cookie-prefs__toggle ' + (prefs.marketing ? 'is-on' : '') + '" data-cat="marketing" aria-label="Cookies marketing"></button>' +
        '</div>' +
        '<div class="mnl-cookie-prefs__actions">' +
          MNL_T('global.cookieprefs_reject_all_html', '<button type="button" class="mnl-cookie-prefs__btn mnl-cookie-prefs__btn--reject-all" data-action="reject-all">Tout refuser</button>') +
          MNL_T('global.cookieprefs_save_html', '<button type="button" class="mnl-cookie-prefs__btn mnl-cookie-prefs__btn--save" data-action="save">Enregistrer</button>') +
          MNL_T('global.cookieprefs_accept_all_html', '<button type="button" class="mnl-cookie-prefs__btn mnl-cookie-prefs__btn--accept-all" data-action="accept-all">Tout accepter</button>') +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.querySelectorAll('.mnl-cookie-prefs__toggle').forEach(function (t) {
      t.setAttribute('role', 'switch');
      t.setAttribute('aria-checked', String(t.classList.contains('is-on')));
      if (t.disabled) return;
      t.addEventListener('click', function () {
        t.classList.toggle('is-on');
        t.setAttribute('aria-checked', String(t.classList.contains('is-on')));
      });
    });
    modal.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-action');
      if (action === 'close') { closeCookiePrefs(modal); return; }
      if (['accept-all', 'reject-all', 'save'].indexOf(action) === -1) return;
      // Vague 85 : 3 catégories au lieu de 2 (ajout 'preferences')
      var newPrefs = { preferences: false, analytics: false, marketing: false };
      if (action === 'accept-all') { newPrefs.preferences = true; newPrefs.analytics = true; newPrefs.marketing = true; }
      else if (action === 'save') {
        modal.querySelectorAll('.mnl-cookie-prefs__toggle[data-cat]').forEach(function (t) {
          newPrefs[t.getAttribute('data-cat')] = t.classList.contains('is-on');
        });
      }
      try { localStorage.setItem('mnl-cookie-prefs', JSON.stringify(newPrefs)); } catch (_) {}
      // CNIL : timestamp obligatoire pour détecter expiration 13 mois (cohérent avec mnlCookieInit)
      try { localStorage.setItem('mnl-cookie-consent', JSON.stringify({state: (newPrefs.preferences || newPrefs.analytics || newPrefs.marketing) ? 'accepted' : 'rejected', ts: Date.now(), version: window.mnlConsent ? window.mnlConsent.version : '2026.05.1'})); } catch (_) {}
      /* V1148 (RGPD) : prévient theme.liquid qu'il doit ré-évaluer le chargement des traceurs
         CATÉGORIE PAR CATÉGORIE (Meta Pixel = marketing, Clarity = analytics). Sans cet événement,
         un visiteur qui active « marketing » depuis les préférences n'aurait le Pixel qu'au rechargement,
         et surtout l'état global 'accepted' ne doit plus suffire à tout charger. */
      try { window.dispatchEvent(new CustomEvent('mnl:consent:updated', { detail: newPrefs })); } catch (_) {}
      // V537 : propage le choix granulaire à l'API Customer Privacy de Shopify (catégorie par catégorie)
      try { if (window.mnlSyncShopifyConsent) window.mnlSyncShopifyConsent({ analytics: newPrefs.analytics, marketing: newPrefs.marketing, preferences: newPrefs.preferences }); } catch (_) {}
      if (window.gtag) {
        try {
          window.gtag('consent', 'update', {
            // Vague 85 : functionality + personalization mappés sur la nouvelle cat 'preferences'
            'functionality_storage': newPrefs.preferences ? 'granted' : 'denied',
            'personalization_storage': newPrefs.preferences ? 'granted' : 'denied',
            'analytics_storage': newPrefs.analytics ? 'granted' : 'denied',
            'ad_storage': newPrefs.marketing ? 'granted' : 'denied',
            'ad_user_data': newPrefs.marketing ? 'granted' : 'denied',
            'ad_personalization': newPrefs.marketing ? 'granted' : 'denied'
          });
        } catch (_) {}
      }
      // Vague 85 : event custom dispatché → permet aux features perso (theme dark, recently-viewed, achievements)
      // de s'auto-désactiver si user retire le consent préférences
      try {
        document.dispatchEvent(new CustomEvent('mnl:consent:preferences', { detail: { granted: newPrefs.preferences } }));
      } catch (_) {}
      closeCookiePrefs(modal);
      // V904 : un choix granulaire dans « Personnaliser » VAUT décision finale → on retire la bannière de
      // consentement (sinon, avec le nouveau backdrop plein écran, l'utilisateur resterait bloqué derrière).
      try { var _ckb = document.querySelector('.mnl-cookie'); if (_ckb) { _ckb.style.transition = 'opacity .3s ease'; _ckb.style.opacity = '0'; setTimeout(function () { try { _ckb.remove(); } catch (_) {} }, 300); } } catch (_) {}
      if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.cookieprefs_saved_title', 'Préférences enregistrées'), MNL_T('global.cookieprefs_saved_sub', 'Tes choix sont actifs.'));
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) closeCookiePrefs(modal); });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        closeCookiePrefs(modal);
        return;
      }
      if (e.key !== 'Tab') return;
      var buttons = Array.from(modal.querySelectorAll('button:not(:disabled), a[href]')).filter(function (el) { return el.getClientRects().length > 0; });
      if (!buttons.length) return;
      var first = buttons[0], last = buttons[buttons.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    return modal;
  }
  window.mnlOpenCookiePrefs = function () {
    var modal = ensureCookiePrefs();
    if (modal.classList.contains('is-open')) return;
    cookiePrefsOpener = document.activeElement;
    var prefs = {};
    try { prefs = JSON.parse(localStorage.getItem('mnl-cookie-prefs') || '{}') || {}; } catch (_) {}
    modal.querySelectorAll('.mnl-cookie-prefs__toggle[data-cat]').forEach(function (t) {
      var checked = prefs[t.getAttribute('data-cat')] === true;
      t.classList.toggle('is-on', checked);
      t.setAttribute('aria-checked', String(checked));
    });
    modal.inert = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    if (window.mnlLockScroll) window.mnlLockScroll();
    modal.querySelector('.mnl-cookie-prefs__close').focus({ preventScroll: true });
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mnl-cookie-prefs]')) {
      e.preventDefault();
      window.mnlOpenCookiePrefs();
    }
  });

  // ════════════ IMAGE BEFORE/AFTER COMPARE SLIDER (data-mnl-compare-slider) ════════════
  function setupCompareSliders() {
    document.querySelectorAll('[data-mnl-compare-slider]').forEach(function (slider) {
      if (slider.dataset.mnlSliderBuilt) return;
      slider.dataset.mnlSliderBuilt = '1';
      slider.classList.add('mnl-compare-slider');
      var imgs = slider.querySelectorAll('img');
      if (imgs.length < 2) return;
      imgs[0].classList.add('mnl-compare-slider__before');
      imgs[1].classList.add('mnl-compare-slider__after');
      imgs[0].alt = imgs[0].alt || MNL_T('global.compare_before', 'Avant');
      imgs[1].alt = imgs[1].alt || MNL_T('global.compare_after', 'Après');
      var labelBefore = slider.getAttribute('data-mnl-compare-before-label') || MNL_T('global.compare_before', 'Avant');
      var labelAfter = slider.getAttribute('data-mnl-compare-after-label') || MNL_T('global.compare_after', 'Après');
      // XSS escape sur les labels venant d'attributs HTML (admin-controlled mais escape par défaut)
      function _esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }
      var handle = document.createElement('div');
      handle.className = 'mnl-compare-slider__handle';
      handle.setAttribute('role', 'slider');
      handle.setAttribute('aria-label', MNL_T('global.compare_handle_label', 'Comparer avant / après'));
      handle.setAttribute('aria-valuemin', '0');
      handle.setAttribute('aria-valuemax', '100');
      handle.setAttribute('aria-valuenow', '50');
      handle.setAttribute('tabindex', '0');
      slider.appendChild(handle);
      slider.insertAdjacentHTML('beforeend',
        '<span class="mnl-compare-slider__label mnl-compare-slider__label--before">' + _esc(labelBefore) + '</span>' +
        '<span class="mnl-compare-slider__label mnl-compare-slider__label--after">' + _esc(labelAfter) + '</span>'
      );

      var dragging = false;
      var afterImg = imgs[1];
      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        handle.style.left = pct + '%';
        afterImg.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.setAttribute('aria-valuenow', String(Math.round(pct)));
      }
      function onMove(clientX) {
        var rect = slider.getBoundingClientRect();
        setPos(((clientX - rect.left) / rect.width) * 100);
      }
      slider.addEventListener('mousedown', function (e) { dragging = true; onMove(e.clientX); });
      window.addEventListener('mousemove', function (e) { if (dragging) onMove(e.clientX); });
      window.addEventListener('mouseup', function () { dragging = false; });
      slider.addEventListener('touchstart', function (e) { dragging = true; onMove(e.touches[0].clientX); }, { passive: true });
      window.addEventListener('touchmove', function (e) { if (dragging) onMove(e.touches[0].clientX); }, { passive: true });
      window.addEventListener('touchend', function () { dragging = false; });
      handle.addEventListener('keydown', function (e) {
        var cur = parseInt(handle.getAttribute('aria-valuenow'), 10);
        if (e.key === 'ArrowRight') { setPos(cur + 5); e.preventDefault(); }
        else if (e.key === 'ArrowLeft') { setPos(cur - 5); e.preventDefault(); }
      });
      setPos(50);
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupCompareSliders, 200);
  else setupCompareSliders();

  // ════════════ NUTRITION FACTS PANEL (collapsible) ════════════
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.mnl-nutri__head');
    if (!head) return;
    var panel = head.closest('.mnl-nutri');
    if (panel) panel.classList.toggle('is-open');
  });

  // ════════════ WORKOUT TIMER WIDGET (rest between sets) ════════════
  var timerInterval, timerSeconds = 0, timerPaused = false;
  function ensureTimerWidget() {
    var w = document.getElementById('mnl-timer-widget');
    if (w) return w;
    w = document.createElement('div');
    w.id = 'mnl-timer-widget';
    w.className = 'mnl-timer';
    w.setAttribute('role', 'timer');
    w.setAttribute('aria-live', 'polite');
    w.innerHTML =
      MNL_T('global.timer_close_html', '<button type="button" class="mnl-timer__close" aria-label="Fermer le timer">×</button>') +
      '<p class="mnl-timer__title">⏱ Repos</p>' +
      '<p class="mnl-timer__display" id="mnlTimerDisplay">00:00</p>' +
      '<div class="mnl-timer__btns">' +
        '<button type="button" class="mnl-timer__btn" data-mnl-timer-add="-15">-15s</button>' +
        '<button type="button" class="mnl-timer__btn" data-mnl-timer-toggle>⏸</button>' +
        '<button type="button" class="mnl-timer__btn" data-mnl-timer-add="15">+15s</button>' +
      '</div>';
    document.body.appendChild(w);
    w.querySelector('.mnl-timer__close').addEventListener('click', stopTimer);
    return w;
  }
  function updateTimerDisplay() {
    var w = document.getElementById('mnl-timer-widget');
    if (!w) return;
    var disp = w.querySelector('.mnl-timer__display');
    var m = Math.floor(Math.max(0, timerSeconds) / 60);
    var s = Math.max(0, timerSeconds) % 60;
    disp.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    disp.classList.toggle('is-warning', timerSeconds <= 5 && timerSeconds > 0);
  }
  function startTimer(sec) {
    var w = ensureTimerWidget();
    timerSeconds = sec; timerPaused = false;
    w.classList.add('is-active');
    updateTimerDisplay();
    clearInterval(timerInterval);
    timerInterval = setInterval(function () {
      if (timerPaused) return;
      timerSeconds--;
      updateTimerDisplay();
      if (timerSeconds <= 0) {
        clearInterval(timerInterval);
        if (window.mnlToast) window.mnlToast({ icon: '', title: MNL_T('global.timer_done_title', 'Repos terminé !'), sub: MNL_T('global.timer_done_sub', 'Reprends ta série'), type: 'success', duration: 5000 });
        if (navigator.vibrate) navigator.vibrate([200, 100, 200]);
        // Vague 104 : utilise le singleton _mnlGetAudioCtx au lieu de créer un nouveau AudioContext
        // (avant : chaque sonnerie de repos = nouveau context → leak + cap Chrome 6).
        try {
          var ctx = (typeof window._mnlGetAudioCtx === 'function') ? window._mnlGetAudioCtx() : null;
          if (ctx) {
            var osc = ctx.createOscillator(); var gain = ctx.createGain();
            osc.frequency.value = 880; osc.connect(gain); gain.connect(ctx.destination);
            gain.gain.setValueAtTime(.3, ctx.currentTime); osc.start(); osc.stop(ctx.currentTime + .25);
            gain.gain.exponentialRampToValueAtTime(.01, ctx.currentTime + .25);
          }
        } catch (_) {}
        setTimeout(stopTimer, 4000);
      }
    }, 1000);
  }
  function stopTimer() {
    clearInterval(timerInterval);
    var w = document.getElementById('mnl-timer-widget');
    if (w) w.classList.remove('is-active');
    timerSeconds = 0;
  }
  window.mnlStartTimer = startTimer;
  window.mnlStopTimer = stopTimer;
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mnl-timer-trigger]');
    if (trigger) { e.preventDefault(); startTimer(parseInt(trigger.getAttribute('data-mnl-timer-trigger'), 10) || 60); return; }
    var addBtn = e.target.closest('[data-mnl-timer-add]');
    if (addBtn) { timerSeconds = Math.max(0, timerSeconds + parseInt(addBtn.getAttribute('data-mnl-timer-add'), 10)); updateTimerDisplay(); return; }
    var toggleBtn = e.target.closest('[data-mnl-timer-toggle]');
    if (toggleBtn) { timerPaused = !timerPaused; toggleBtn.textContent = timerPaused ? '▶' : '⏸'; }
  });

  // ════════════ SMART RECOMMENDATIONS CAROUSEL (data-mnl-recos) ════════════
  function setupRecosCarousels() {
    document.querySelectorAll('[data-mnl-recos]').forEach(function (container) {
      if (container.dataset.mnlRecosBound) return;
      var handles = (container.getAttribute('data-mnl-recos') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
      if (!handles.length) return;
      container.dataset.mnlRecosBound = '1';
      var title = container.getAttribute('data-mnl-recos-title') || MNL_T('global.recos_default_title', 'Tu pourrais aimer');
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var valid = products.filter(Boolean);
        if (!valid.length) return;
        container.classList.add('mnl-recos');
        container.innerHTML =
          '<div class="mnl-recos__head"><h2 class="mnl-recos__title">' + esc(title) + '</h2>' +
            '<div class="mnl-recos__nav">' +
              MNL_T('global.recos_prev_html', '<button type="button" class="mnl-recos__nav-btn" data-mnl-recos-prev aria-label="Précédent">‹</button>') +
              MNL_T('global.recos_next_html', '<button type="button" class="mnl-recos__nav-btn" data-mnl-recos-next aria-label="Suivant">›</button>') +
            '</div>' +
          '</div>' +
          '<div class="mnl-recos__track">' + valid.map(function (p) {
            var price = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
            var compare = p.compare_at_price > p.price ? ' <span class="mnl-recos__card-was">' + (p.compare_at_price / 100).toFixed(2).replace('.', ',') + ' €</span>' : '';
            var safeTitle = esc(p.title);
            return '<a href="/products/' + esc(p.handle) + '" class="mnl-recos__card">' +
              (p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="' + safeTitle + '" class="mnl-recos__card-img" loading="lazy" decoding="async">' : '<div class="mnl-recos__card-img" style="display:flex;align-items:center;justify-content:center;font-size:48px;"></div>') +
              '<div class="mnl-recos__card-body">' +
                '<p class="mnl-recos__card-name">' + safeTitle + '</p>' +
                '<p class="mnl-recos__card-price">' + price + compare + '</p>' +
              '</div>' +
            '</a>';
          }).join('') + '</div>';
        var track = container.querySelector('.mnl-recos__track');
        var prev = container.querySelector('[data-mnl-recos-prev]');
        var next = container.querySelector('[data-mnl-recos-next]');
        var step = 254;
        prev.addEventListener('click', function () { track.scrollBy({ left: -step * 2, behavior: 'smooth' }); });
        next.addEventListener('click', function () { track.scrollBy({ left: step * 2, behavior: 'smooth' }); });
        function updateNavBtns() {
          prev.disabled = track.scrollLeft <= 5;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 5;
        }
        track.addEventListener('scroll', updateNavBtns, { passive: true });
        setTimeout(updateNavBtns, 200);
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupRecosCarousels, 300);
  else setupRecosCarousels();

  // ════════════ DRAG-TO-REORDER (data-mnl-sortable container) ════════════
  function setupSortable() {
    document.querySelectorAll('[data-mnl-sortable]').forEach(function (container) {
      if (container.dataset.mnlSortableBound) return;
      container.dataset.mnlSortableBound = '1';
      // ARIA : container = listbox réordonnable, items = options
      container.setAttribute('role', 'listbox');
      container.setAttribute('aria-label', container.getAttribute('aria-label') || MNL_T('global.dnd_list_label', 'Liste réordonnable (utilisez Espace puis Flèches)'));
      var dragging = null;
      function fireChange() {
        var newOrder = Array.from(container.querySelectorAll('[data-mnl-sortable-item]')).map(function (i) { return i.getAttribute('data-mnl-sortable-id') || ''; });
        container.dispatchEvent(new CustomEvent('mnl:sortable:change', { detail: { order: newOrder } }));
      }
      container.querySelectorAll('[data-mnl-sortable-item]').forEach(function (item) {
        item.classList.add('mnl-draggable');
        item.setAttribute('draggable', 'true');
        item.setAttribute('role', 'option');
        item.setAttribute('tabindex', '0');
        item.setAttribute('aria-grabbed', 'false');
        item.addEventListener('dragstart', function (e) {
          dragging = item; item.classList.add('is-dragging'); item.setAttribute('aria-grabbed', 'true');
          if (e.dataTransfer) { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', ''); }
        });
        item.addEventListener('dragend', function () {
          item.classList.remove('is-dragging'); item.setAttribute('aria-grabbed', 'false');
          container.querySelectorAll('.is-drop-target').forEach(function (i) { i.classList.remove('is-drop-target'); });
          dragging = null;
          fireChange();
        });
        item.addEventListener('dragover', function (e) {
          e.preventDefault();
          if (!dragging || dragging === item) return;
          item.classList.add('is-drop-target');
          var rect = item.getBoundingClientRect();
          var midY = rect.top + rect.height / 2;
          if (e.clientY < midY) item.parentNode.insertBefore(dragging, item);
          else item.parentNode.insertBefore(dragging, item.nextSibling);
        });
        item.addEventListener('dragleave', function () { item.classList.remove('is-drop-target'); });
        // Keyboard : Espace = grab/drop, ArrowUp/Down = move (a11y critical)
        item.addEventListener('keydown', function (e) {
          var grabbed = item.getAttribute('aria-grabbed') === 'true';
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            item.setAttribute('aria-grabbed', grabbed ? 'false' : 'true');
            item.classList.toggle('is-dragging', !grabbed);
            if (window.mnlAnnounce) window.mnlAnnounce(grabbed ? MNL_T('global.dnd_dropped', 'Élément déposé') : MNL_T('global.dnd_grabbed', 'Élément saisi, utilise les flèches pour déplacer'));
          } else if (grabbed && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
            e.preventDefault();
            var sib = e.key === 'ArrowUp' ? item.previousElementSibling : item.nextElementSibling;
            if (sib && sib.matches('[data-mnl-sortable-item]')) {
              if (e.key === 'ArrowUp') sib.parentNode.insertBefore(item, sib);
              else sib.parentNode.insertBefore(item, sib.nextSibling);
              fireChange();
              item.focus();
            }
          }
        });
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupSortable, 300);
  else setupSortable();

  // ════════════ FLY-TO-CART ANIMATION (image source → cart icon) ════════════
  function flyToCart(sourceImg) {
    if (!sourceImg) return;
    var cartIcon = document.querySelector('[data-mnl-cart-toggle], #mnl-bnav-cart, .mnl-bnav__btn[href="/cart"]');
    if (!cartIcon) return;
    var srcRect = sourceImg.getBoundingClientRect();
    var destRect = cartIcon.getBoundingClientRect();
    var clone = document.createElement('img');
    clone.src = sourceImg.src;
    clone.className = 'mnl-fly';
    clone.style.cssText = 'left:' + srcRect.left + 'px;top:' + srcRect.top + 'px;width:' + Math.min(80, srcRect.width) + 'px;height:' + Math.min(80, srcRect.height) + 'px;';
    document.body.appendChild(clone);
    requestAnimationFrame(function () {
      clone.style.transition = 'transform .8s cubic-bezier(.5,-0.4,.5,1.4), opacity .8s ease, width .8s ease, height .8s ease';
      var dx = destRect.left + destRect.width / 2 - srcRect.left - srcRect.width / 2;
      var dy = destRect.top + destRect.height / 2 - srcRect.top - srcRect.height / 2;
      clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.15) rotate(15deg)';
      clone.style.opacity = '0';
    });
    setTimeout(function () {
      if (clone.parentNode) clone.remove();
      // Bump cart icon pour feedback
      cartIcon.style.transition = 'transform .3s cubic-bezier(.34,1.56,.64,1)';
      cartIcon.style.transform = 'scale(1.2)';
      setTimeout(function () { cartIcon.style.transform = ''; }, 300);
    }, 850);
  }
  window.mnlFlyToCart = flyToCart;

  // Auto-trigger : intercepte les clics sur boutons add-to-cart avec data-mnl-fly-source
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-fly-on-add]');
    if (!btn) return;
    var sourceSelector = btn.getAttribute('data-mnl-fly-on-add') || 'img';
    var img = btn.closest('[data-mnl-fly-container]') ? btn.closest('[data-mnl-fly-container]').querySelector(sourceSelector) : null;
    if (!img) {
      // Fallback : trouve la première img proche
      var card = btn.closest('article, .card, [class*="card"], [class*="product"]');
      if (card) img = card.querySelector('img');
    }
    if (img) flyToCart(img);
  });

  // ════════════ ONBOARDING TOUR (data-mnl-tour="step1,step2,step3") ════════════
  // Steps dans data-mnl-tour-step="1" data-mnl-tour-title data-mnl-tour-msg
  var tourSteps = [], tourIdx = 0;
  function ensureTourElements() {
    var overlay = document.getElementById('mnl-tour-overlay');
    var card = document.getElementById('mnl-tour-card');
    if (overlay && card) return { overlay: overlay, card: card };
    overlay = document.createElement('div');
    overlay.id = 'mnl-tour-overlay';
    overlay.className = 'mnl-tour-overlay';
    overlay.innerHTML = '<div class="mnl-tour-spotlight"></div>';
    document.body.appendChild(overlay);
    card = document.createElement('div');
    card.id = 'mnl-tour-card';
    card.className = 'mnl-tour-card';
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-label', MNL_T('global.tour_card_label', 'Visite guidée'));
    document.body.appendChild(card);
    return { overlay: overlay, card: card };
  }
  function renderTourStep() {
    var els = ensureTourElements();
    var step = tourSteps[tourIdx];
    if (!step) { stopTour(); return; }
    var target = document.querySelector(step.target);
    if (!target) { tourIdx++; renderTourStep(); return; }
    document.querySelectorAll('.mnl-tour-active').forEach(function (e) { e.classList.remove('mnl-tour-active'); });
    target.classList.add('mnl-tour-active');
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });

    /* Vague 170 P1 fix : attendre que le scroll smooth soit stabilisé avant de placer le spotlight.
       Avant : setTimeout 350ms fixe → sur Firefox Android / mobile lent, smooth-scroll prend >400ms
               → spotlight placé sur ancienne position de la cible.
       Maintenant : polling rect.top jusqu'à stabilisation (delta <2px sur 3 frames) ou 1.5s max. */
    function _renderSpotlightAndCard(rect) {
      var spotlight = els.overlay.querySelector('.mnl-tour-spotlight');
      spotlight.style.cssText = 'left:' + (rect.left - 8) + 'px;top:' + (rect.top - 8) + 'px;width:' + (rect.width + 16) + 'px;height:' + (rect.height + 16) + 'px;';
      var dotsHtml = tourSteps.map(function (_, i) { return '<span class="mnl-tour-card__dot ' + (i === tourIdx ? 'is-active' : '') + '"></span>'; }).join('');
      els.card.innerHTML =
        MNL_T('global.tour_step_prefix_html', '<p class="mnl-tour-card__step">Étape ') + (tourIdx + 1) + '/' + tourSteps.length + '</p>' +
        '<h3 class="mnl-tour-card__title">' + (step.title || '') + '</h3>' +
        '<p class="mnl-tour-card__msg">' + (step.msg || '') + '</p>' +
        '<div class="mnl-tour-card__progress">' + dotsHtml + '</div>' +
        '<div class="mnl-tour-card__actions">' +
          MNL_T('global.tour_skip_html', '<button type="button" class="mnl-tour-card__skip">Passer</button>') +
          '<div class="mnl-tour-card__nav">' +
            (tourIdx > 0 ? '<button type="button" class="mnl-tour-card__btn mnl-tour-card__btn--prev">←</button>' : '') +
            '<button type="button" class="mnl-tour-card__btn mnl-tour-card__btn--next">' + (tourIdx === tourSteps.length - 1 ? MNL_T('global.tour_finish', 'Terminer ✓') : MNL_T('global.tour_next', 'Suivant →')) + '</button>' +
          '</div>' +
        '</div>';
      // Position card sous ou au-dessus du target
      var cardRect = els.card.getBoundingClientRect();
      var topPos = rect.bottom + 14;
      if (topPos + 220 > window.innerHeight) topPos = rect.top - cardRect.height - 14;
      var leftPos = Math.max(16, Math.min(window.innerWidth - 340, rect.left));
      els.card.style.top = (topPos + window.scrollY) + 'px';
      els.card.style.left = leftPos + 'px';
      els.overlay.classList.add('is-active');
    }
    var lastTop = -9999, stableFrames = 0, startTime = Date.now();
    function _pollUntilStable() {
      if (!target.isConnected) return; // target removed during animation
      var rect = target.getBoundingClientRect();
      if (Math.abs(rect.top - lastTop) < 2) {
        stableFrames++;
      } else {
        stableFrames = 0;
        lastTop = rect.top;
      }
      // 3 frames stables = scroll fini, OU timeout 1.5s safety
      if (stableFrames >= 3 || (Date.now() - startTime) > 1500) {
        _renderSpotlightAndCard(rect);
        return;
      }
      requestAnimationFrame(_pollUntilStable);
    }
    requestAnimationFrame(_pollUntilStable);
  }
  function nextTourStep() { tourIdx++; renderTourStep(); }
  function prevTourStep() { if (tourIdx > 0) { tourIdx--; renderTourStep(); } }
  function stopTour() {
    var overlay = document.getElementById('mnl-tour-overlay');
    var card = document.getElementById('mnl-tour-card');
    if (overlay) overlay.classList.remove('is-active');
    if (card) card.remove();
    document.querySelectorAll('.mnl-tour-active').forEach(function (e) { e.classList.remove('mnl-tour-active'); });
    document.body.style.overflow = ''; // unlock scroll
    try { localStorage.setItem('mnl-tour-completed', '1'); } catch (_) {}
  }
  window.mnlStartTour = function (steps) {
    tourSteps = steps || [];
    tourIdx = 0;
    if (!tourSteps.length) return;
    document.body.style.overflow = 'hidden'; // lock scroll pendant la tour
    renderTourStep();
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('.mnl-tour-card__skip')) { stopTour(); return; }
    if (e.target.closest('.mnl-tour-card__btn--next')) { nextTourStep(); return; }
    if (e.target.closest('.mnl-tour-card__btn--prev')) { prevTourStep(); return; }
    if (e.target.closest('[data-mnl-tour-trigger]')) {
      var btn = e.target.closest('[data-mnl-tour-trigger]');
      try {
        var steps = JSON.parse(btn.getAttribute('data-mnl-tour-trigger'));
        if (Array.isArray(steps)) window.mnlStartTour(steps);
      } catch (_) {}
    }
  });
  // Escape key → ferme la tour (a11y critical)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.getElementById('mnl-tour-card')) stopTour();
  });

  // ════════════ STICKY DISMISSIBLE PROMO STRIP (auto-dismiss 7d) ════════════
  document.querySelectorAll('.mnl-promo-strip[data-mnl-promo-strip]').forEach(function (strip) {
    var key = 'mnl-promo-strip-' + strip.getAttribute('data-mnl-promo-strip');
    try {
      var dismissed = parseInt(localStorage.getItem(key) || '0', 10);
      if (dismissed && (Date.now() - dismissed) < 7 * 24 * 60 * 60 * 1000) { strip.hidden = true; return; }
    } catch (_) {}
    if (!strip.querySelector('.mnl-promo-strip__close')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mnl-promo-strip__close';
      btn.setAttribute('aria-label', MNL_T('global.promobar_close_label', 'Fermer le bandeau promotionnel'));
      btn.innerHTML = '×';
      btn.addEventListener('click', function () {
        strip.hidden = true;
        try { localStorage.setItem(key, String(Date.now())); } catch (_) {}
      });
      strip.appendChild(btn);
    }
  });

  // ════════════ FORMAT HELPERS (data-mnl-format="phone-fr|postal-fr|card|iban") ════════════
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.matches('input[data-mnl-format]')) return;
    var fmt = input.getAttribute('data-mnl-format');
    var raw, formatted;
    if (fmt === 'iban') {
      // IBAN : alphanumeric uppercase, espaces tous les 4 caractères
      raw = (input.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 34);
      formatted = raw.replace(/(.{4})(?=.)/g, '$1 ');
    } else {
      raw = (input.value || '').replace(/\D/g, '');
      if (fmt === 'phone-fr') { raw = raw.slice(0, 10); formatted = raw.replace(/(\d{2})(?=\d)/g, '$1 '); }
      else if (fmt === 'postal-fr') { raw = raw.slice(0, 5); formatted = raw; }
      else if (fmt === 'card') { raw = raw.slice(0, 19); formatted = raw.replace(/(\d{4})(?=\d)/g, '$1 '); }
      else { return; }
    }
    if (input.value === formatted) return;
    // Cursor positioning intelligente : compte les caractères non-espaces avant le curseur, restaure à la même "position logique"
    var prevPos = input.selectionStart;
    var prevValue = input.value;
    var nonSpaceBefore = prevValue.slice(0, prevPos).replace(/[\s]/g, '').length;
    input.value = formatted;
    var newPos = 0, count = 0;
    for (var i = 0; i < formatted.length && count < nonSpaceBefore; i++) {
      if (!/\s/.test(formatted[i])) count++;
      newPos = i + 1;
    }
    try { input.setSelectionRange(newPos, newPos); } catch (_) {}
  });

  // ════════════ FILTER CHIPS DISMISSIBLE (auto-bind .mnl-filter-chip__remove) ════════════
  document.addEventListener('click', function (e) {
    var rmBtn = e.target.closest('.mnl-filter-chip__remove');
    if (rmBtn) {
      var chip = rmBtn.closest('.mnl-filter-chip');
      var url = chip.getAttribute('data-mnl-chip-url');
      if (url) { window.location.href = url; return; }
      chip.style.transition = 'opacity .25s ease, transform .25s ease, max-width .25s ease';
      chip.style.opacity = '0';
      chip.style.transform = 'scale(.8)';
      chip.style.maxWidth = '0';
      setTimeout(function () { chip.remove(); }, 250);
      // Custom event pour réagir
      document.dispatchEvent(new CustomEvent('mnl:filter:remove', { detail: { value: chip.getAttribute('data-mnl-chip-value') } }));
      return;
    }
    var clearAllBtn = e.target.closest('.mnl-filter-chips__clear');
    if (clearAllBtn) {
      var url2 = clearAllBtn.getAttribute('data-mnl-chips-clear-url');
      if (url2) window.location.href = url2;
    }
  });

  // ════════════ RANGE SLIDER (data-mnl-range : dual-handle min/max) ════════════
  function setupRangeSliders() {
    document.querySelectorAll('[data-mnl-range]').forEach(function (container) {
      if (container.dataset.mnlRangeBound) return;
      container.dataset.mnlRangeBound = '1';
      var min = parseFloat(container.getAttribute('data-mnl-range-min')) || 0;
      var max = parseFloat(container.getAttribute('data-mnl-range-max')) || 100;
      var step = parseFloat(container.getAttribute('data-mnl-range-step')) || 1;
      var prefix = container.getAttribute('data-mnl-range-prefix') || '';
      var suffix = container.getAttribute('data-mnl-range-suffix') || ' €';
      var initialMin = parseFloat(container.getAttribute('data-mnl-range-value-min')) || min;
      var initialMax = parseFloat(container.getAttribute('data-mnl-range-value-max')) || max;
      var label = container.getAttribute('data-mnl-range-label') || MNL_T('global.range_default_label', 'Prix');
      container.classList.add('mnl-range');
      container.innerHTML =
        '<div class="mnl-range__display">' +
          '<span>' + label + '</span>' +
          '<span><strong class="mnl-range__min-disp">' + prefix + initialMin + suffix + '</strong> – <strong class="mnl-range__max-disp">' + prefix + initialMax + suffix + '</strong></span>' +
        '</div>' +
        '<div class="mnl-range__track-wrap">' +
          '<div class="mnl-range__track"></div>' +
          '<div class="mnl-range__fill"></div>' +
          '<input type="range" class="mnl-range__min" min="' + min + '" max="' + max + '" step="' + step + '" value="' + initialMin + '" aria-label="' + label + ' minimum">' +
          '<input type="range" class="mnl-range__max" min="' + min + '" max="' + max + '" step="' + step + '" value="' + initialMax + '" aria-label="' + label + ' maximum">' +
        '</div>';
      var minInput = container.querySelector('.mnl-range__min');
      var maxInput = container.querySelector('.mnl-range__max');
      var minDisp = container.querySelector('.mnl-range__min-disp');
      var maxDisp = container.querySelector('.mnl-range__max-disp');
      var fill = container.querySelector('.mnl-range__fill');
      function update() {
        var minV = parseFloat(minInput.value);
        var maxV = parseFloat(maxInput.value);
        if (minV > maxV - step) { minV = maxV - step; minInput.value = minV; }
        var minPct = ((minV - min) / (max - min)) * 100;
        var maxPct = ((maxV - min) / (max - min)) * 100;
        fill.style.left = minPct + '%';
        fill.style.right = (100 - maxPct) + '%';
        minDisp.textContent = prefix + minV + suffix;
        maxDisp.textContent = prefix + maxV + suffix;
        container.dispatchEvent(new CustomEvent('mnl:range:change', { detail: { min: minV, max: maxV } }));
      }
      minInput.addEventListener('input', update);
      maxInput.addEventListener('input', update);
      update();
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupRangeSliders, 200);
  else setupRangeSliders();

  // ════════════ AUTO-SAVE UI STATE (collapsed sections, expanded panels persist) ════════════
  // Pour <details data-mnl-state="key"> ou tout élément avec data-mnl-collapse-state
  document.querySelectorAll('details[data-mnl-state]').forEach(function (det) {
    var key = 'mnl-state-' + det.getAttribute('data-mnl-state');
    try {
      var saved = localStorage.getItem(key);
      if (saved === '1') det.open = true;
      else if (saved === '0') det.open = false;
    } catch (_) {}
    det.addEventListener('toggle', function () {
      try { localStorage.setItem(key, det.open ? '1' : '0'); } catch (_) {}
    });
  });

  // ════════════ INFINITE SCROLL (data-mnl-infinite + data-mnl-infinite-next URL) ════════════
  function setupInfiniteScroll() {
    document.querySelectorAll('[data-mnl-infinite]').forEach(function (container) {
      if (container.dataset.mnlInfiniteBound) return;
      container.dataset.mnlInfiniteBound = '1';
      var nextUrl = container.getAttribute('data-mnl-infinite-next');
      if (!nextUrl) return;
      var trigger = document.createElement('div');
      trigger.className = 'mnl-infinite-trigger';
      trigger.textContent = MNL_T('global.loading_ellipsis', 'Chargement…');
      container.appendChild(trigger);
      var loading = false;
      function loadMore() {
        if (loading || !nextUrl) return;
        loading = true;
        fetch(nextUrl, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newContainer = doc.querySelector('[data-mnl-infinite]');
            if (newContainer) {
              var children = Array.from(newContainer.children).filter(function (c) {
                return c !== newContainer.querySelector('.mnl-infinite-trigger');
              });
              children.forEach(function (c) { container.insertBefore(c, trigger); });
              nextUrl = newContainer.getAttribute('data-mnl-infinite-next');
              container.setAttribute('data-mnl-infinite-next', nextUrl || '');
              if (!nextUrl) {
                trigger.classList.add('is-done');
                if (obs) obs.disconnect();
              }
            } else {
              trigger.classList.add('is-done');
            }
            loading = false;
          })
          .catch(function () { loading = false; trigger.textContent = MNL_T('global.load_error_retry', 'Erreur de chargement — réessayez'); });
      }
      var obs = null;
      if ('IntersectionObserver' in window) {
        obs = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) loadMore();
        }, { rootMargin: '300px 0px' });
        obs.observe(trigger);
      }
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupInfiniteScroll, 300);
  else setupInfiniteScroll();

  // ════════════ CUSTOM SELECT DROPDOWN (data-mnl-select) ════════════
  function setupCustomSelects() {
    document.querySelectorAll('[data-mnl-select]').forEach(function (container) {
      if (container.dataset.mnlSelectBuilt) return;
      container.dataset.mnlSelectBuilt = '1';
      var nativeSel = container.querySelector('select');
      if (!nativeSel) return;
      nativeSel.style.display = 'none';
      var enableSearch = container.hasAttribute('data-mnl-select-search');
      var placeholder = container.getAttribute('data-mnl-select-placeholder') || MNL_T('global.select_placeholder', 'Sélectionner');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mnl-select__btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');

      var panel = document.createElement('div');
      panel.className = 'mnl-select__panel';
      panel.setAttribute('role', 'listbox');

      function updateBtn() {
        var sel = nativeSel.options[nativeSel.selectedIndex];
        btn.innerHTML = '<span>' + (sel ? sel.textContent : placeholder) + '</span><span class="mnl-select__caret">▼</span>';
      }
      function buildOptions(filter) {
        filter = (filter || '').toLowerCase();
        var html = '';
        if (enableSearch) {
          html += MNL_T('global.select_search_html', '<div class="mnl-select__search"><input type="text" placeholder="Rechercher..." aria-label="Filtrer les options" value="') + filter + '"></div>';
        }
        var hasMatch = false;
        Array.from(nativeSel.options).forEach(function (opt, i) {
          if (filter && opt.textContent.toLowerCase().indexOf(filter) === -1) return;
          hasMatch = true;
          html += '<div class="mnl-select__option ' + (opt.selected ? 'is-selected' : '') + '" role="option" data-value="' + opt.value + '" data-idx="' + i + '" tabindex="0">' + opt.textContent + '</div>';
        });
        if (!hasMatch) html += MNL_T('global.select_empty_html', '<div class="mnl-select__empty">Aucun résultat</div>');
        panel.innerHTML = html;
        if (enableSearch) {
          var searchInput = panel.querySelector('.mnl-select__search input');
          searchInput.addEventListener('input', function () { buildOptions(searchInput.value); searchInput.focus(); });
          searchInput.addEventListener('click', function (e) { e.stopPropagation(); });
        }
      }
      container.classList.add('mnl-select');
      container.appendChild(btn);
      container.appendChild(panel);
      updateBtn();

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = container.classList.contains('is-open');
        document.querySelectorAll('.mnl-select.is-open').forEach(function (s) { s.classList.remove('is-open'); s.querySelector('.mnl-select__btn').setAttribute('aria-expanded', 'false'); });
        if (!isOpen) {
          buildOptions('');
          container.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (enableSearch) setTimeout(function () { var i = panel.querySelector('.mnl-select__search input'); if (i) i.focus(); }, 50);
        }
      });
      panel.addEventListener('click', function (e) {
        var opt = e.target.closest('.mnl-select__option');
        if (!opt) return;
        var idx = parseInt(opt.getAttribute('data-idx'), 10);
        nativeSel.selectedIndex = idx;
        nativeSel.dispatchEvent(new Event('change', { bubbles: true }));
        container.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        updateBtn();
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { container.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
      });
    });
  }
  document.addEventListener('click', function () {
    document.querySelectorAll('.mnl-select.is-open').forEach(function (s) {
      s.classList.remove('is-open');
      s.querySelector('.mnl-select__btn').setAttribute('aria-expanded', 'false');
    });
  });
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupCustomSelects, 200);
  else setupCustomSelects();

  // Vague 141 : iOS Safari A2HS prompt — Safari ne fire PAS beforeinstallprompt → custom banner
  // Détecte iOS Safari (pas Chrome/Firefox iOS), pas standalone, et propose tap-by-tap guide
  (function _iosA2HSPrompt(){
    return; // Fondateur 2026-06-05 : installation PWA RETIRÉE (pas au point) — bannière iOS « Ajouter à l'écran d'accueil » désactivée.
    var ua = navigator.userAgent || '';
    var isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    var isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);
    if (!isIOS || !isSafari) return;
    if (window.navigator.standalone === true) return; // déjà installée
    // Vague 142 BUG FIX : early-return PROPRE via flag — l'ancien `return` était dans le try
    // donc la ligne `setTimeout(_show, 8000)` après tryCatch tournait MÊME quand pageViews < 2 (defeat engagement gate)
    var scheduleEarly = true;
    try {
      if (localStorage.getItem('mnl-ios-a2hs-dismissed-ts')) {
        var ts = parseInt(localStorage.getItem('mnl-ios-a2hs-dismissed-ts'), 10) || 0;
        if (Date.now() - ts < 30 * 24 * 60 * 60 * 1000) return; // cooldown 30j
      }
      // Engagement check : >= 2 pages OU >= 45s sur cette page
      var pageViews = parseInt(sessionStorage.getItem('mnl-page-views') || '0', 10);
      if (pageViews < 2) {
        setTimeout(_show, 45000);
        scheduleEarly = false; // skip le 8s setTimeout (déjà 45s en attente)
      }
    } catch(_){}
    if (scheduleEarly) setTimeout(_show, 8000);
    function _show(){
      if (document.getElementById('mnl-ios-a2hs')) return;
      var ban = document.createElement('div');
      ban.id = 'mnl-ios-a2hs';
      ban.setAttribute('role', 'dialog');
      ban.setAttribute('aria-label', MNL_T('global.a2hs_label', 'Installer MyNutriLab sur ton écran d\'accueil'));
      ban.style.cssText = 'position:fixed;bottom:max(20px,env(safe-area-inset-bottom,20px));left:50%;transform:translateX(-50%) translateY(120%);z-index:9990;background:rgba(15,23,42,.96);color:#fff;padding:14px 18px;border-radius:18px;max-width:calc(100vw - 32px);width:340px;box-shadow:0 18px 42px rgba(0,0,0,.4);backdrop-filter:blur(16px);font-family:inherit;transition:transform .4s cubic-bezier(.34,1.56,.64,1);';
      ban.innerHTML = '<div style="display:flex;align-items:flex-start;gap:10px;margin-bottom:10px;">' +
        '<span aria-hidden="true" style="flex-shrink:0;display:inline-flex;color:#fb923c;"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:block"><rect x="5" y="2" width="14" height="20" rx="2.5"/><line x1="10.5" y1="18" x2="13.5" y2="18"/></svg></span>' +
        MNL_T('global.a2hs_title_html', '<div style="flex:1;min-width:0;"><strong style="display:block;font-size:13px;margin-bottom:2px;">Installer MyNutriLab</strong>') +
        MNL_T('global.a2hs_sub_html', '<span style="font-size:11px;color:rgba(255,255,255,.7);">Accès direct depuis ton écran d\'accueil</span></div>') +
        MNL_T('global.a2hs_close_html', '<button type="button" id="mnlIosA2hsClose" aria-label="Fermer" style="background:transparent;border:none;color:rgba(255,255,255,.6);font-size:18px;cursor:pointer;padding:0 4px;line-height:1;">×</button>') +
      '</div>' +
      '<ol style="margin:0;padding-left:20px;font-size:12px;line-height:1.6;color:rgba(255,255,255,.85);">' +
        MNL_T('global.a2hs_step1_html', '<li>Appuie sur <span aria-hidden="true" style="display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;background:rgba(249,115,22,.3);border-radius:5px;font-size:13px;vertical-align:middle;">⎙</span> en bas de Safari</li>') +
        MNL_T('global.a2hs_step2_html', '<li>Choisis <strong>« Sur l\'écran d\'accueil »</strong></li>') +
        MNL_T('global.a2hs_step3_html', '<li>Appuie sur <strong>Ajouter</strong> en haut à droite</li>') +
      '</ol>';
      document.body.appendChild(ban);
      requestAnimationFrame(function(){ ban.style.transform = 'translateX(-50%) translateY(0)'; });
      document.getElementById('mnlIosA2hsClose').addEventListener('click', function(){
        try { localStorage.setItem('mnl-ios-a2hs-dismissed-ts', String(Date.now())); } catch(_){}
        ban.style.transform = 'translateX(-50%) translateY(120%)';
        setTimeout(function(){ ban.remove(); }, 400);
        try { if (window.gtag) window.gtag('event', 'pwa_install_dismissed', { source: 'ios_safari' }); } catch(_){}
      });
    }
  })();

  // ════════════ PWA INSTALL PROMPT (beforeinstallprompt) — SEUL listener (vague 56) ════════════
  // mnl-ai.js écoute désormais 'mnl:pwa:available' au lieu d'intercepter beforeinstallprompt directement.
  var deferredPrompt = null;
  // Fondateur 2026-06-05 : installation PWA RETIRÉE (pas au point). On garde e.preventDefault() pour
  // SUPPRIMER la mini-barre d'install native de Chrome, mais on n'affiche AUCUNE invite custom.
  window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    deferredPrompt = e;
    return; // pas de dispatch, pas de showPwaPrompt → zéro proposition d'installation
  });
  // Vague 76 : compteur page views session (pour engagement check)
  try {
    var pv = parseInt(sessionStorage.getItem('mnl-page-views') || '0', 10);
    sessionStorage.setItem('mnl-page-views', String(pv + 1));
  } catch (_) {}
  // Tracking installé (Chrome dispatch 'appinstalled')
  window.addEventListener('appinstalled', function(){
    try { localStorage.setItem('mnl-pwa-installed', '1'); } catch(_){}
    if (window.gtag) window.gtag('event', 'pwa_installed', { source: 'browser_event' });
    if (window.dataLayer) window.dataLayer.push({ event: 'pwa_installed' });
  });
  function showPwaPrompt() {
    if (!deferredPrompt) return;
    if (document.getElementById('mnl-pwa-install-prompt')) return;
    var prompt = document.createElement('div');
    prompt.id = 'mnl-pwa-install-prompt';
    prompt.className = 'mnl-pwa-install';
    prompt.setAttribute('role', 'dialog');
    prompt.setAttribute('aria-label', MNL_T('global.pwa_dialog_label', 'Installer l\'application MyNutriLab'));
    prompt.innerHTML =
      '<div class="mnl-pwa-install__icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:block"><rect x="5" y="2" width="14" height="20" rx="2.5"/><line x1="10.5" y1="18" x2="13.5" y2="18"/></svg></div>' +
      '<div class="mnl-pwa-install__body">' +
        MNL_T('global.pwa_title_html', '<p class="mnl-pwa-install__title">Installer MyNutriLab</p>') +
        MNL_T('global.pwa_sub_html', '<p class="mnl-pwa-install__sub">Accès direct depuis ton écran d\'accueil — comme une app.</p>') +
      '</div>' +
      '<div class="mnl-pwa-install__actions">' +
        MNL_T('global.pwa_later_html', '<button type="button" class="mnl-pwa-install__btn mnl-pwa-install__btn--later">Plus tard</button>') +
        MNL_T('global.pwa_install_html', '<button type="button" class="mnl-pwa-install__btn mnl-pwa-install__btn--accept">Installer</button>') +
      '</div>';
    document.body.appendChild(prompt);
    requestAnimationFrame(function () { prompt.classList.add('is-visible'); });
    prompt.querySelector('.mnl-pwa-install__btn--later').addEventListener('click', function () {
      try {
        localStorage.setItem('mnl-pwa-dismissed-ts', String(Date.now()));
        // Vague 76 : compteur dismiss pour cooldown progressif (14j → 30j → 60j)
        var dc = parseInt(localStorage.getItem('mnl-pwa-dismiss-count') || '0', 10);
        localStorage.setItem('mnl-pwa-dismiss-count', String(dc + 1));
      } catch (_) {}
      // Tracking GA4 (vague 56)
      if (window.gtag) window.gtag('event', 'pwa_install_dismissed', { source: 'banner_later' });
      if (window.dataLayer) window.dataLayer.push({ event: 'pwa_install_dismissed', source: 'banner_later' });
      prompt.classList.remove('is-visible');
      setTimeout(function () { prompt.remove(); }, 400);
    });
    prompt.querySelector('.mnl-pwa-install__btn--accept').addEventListener('click', function () {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(function (choice) {
        // Tracking GA4 (vague 56) — outcome est 'accepted' ou 'dismissed'
        if (window.gtag) window.gtag('event', 'pwa_install_' + (choice.outcome || 'unknown'), { source: 'banner_accept' });
        if (window.dataLayer) window.dataLayer.push({ event: 'pwa_install_' + (choice.outcome || 'unknown'), source: 'banner_accept' });
        if (choice.outcome === 'accepted') {
          try { localStorage.setItem('mnl-pwa-installed', '1'); } catch (_) {}
          if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.pwa_installing_title', 'Installation lancée'), MNL_T('global.pwa_installing_sub', 'MyNutriLab arrive sur ton écran d\'accueil'));
        }
        deferredPrompt = null;
        window.mnlDeferredPwaPrompt = null;
        prompt.classList.remove('is-visible');
        setTimeout(function () { prompt.remove(); }, 400);
      });
    });
  }
  // Note vague 56 : appinstalled handler retiré ici car déplacé en haut (avec tracking GA4 unifié)

  // ════════════ VIDEO LAZY PLAYER + CUSTOM CONTROLS (data-mnl-video-poster) ════════════
  function setupVideos() {
    document.querySelectorAll('[data-mnl-video-poster]').forEach(function (container) {
      if (container.dataset.mnlVideoBuilt) return;
      container.dataset.mnlVideoBuilt = '1';
      container.classList.add('mnl-video');
      var src = container.getAttribute('data-mnl-video-src');
      var poster = container.getAttribute('data-mnl-video-poster');
      container.innerHTML =
        '<div class="mnl-video__poster" style="background-image:url(' + poster + ');">' +
          MNL_T('global.video_play_html', '<button type="button" class="mnl-video__play" aria-label="Lire la vidéo"></button>') +
        '</div>';
      var posterEl = container.querySelector('.mnl-video__poster');
      var playBtn = container.querySelector('.mnl-video__play');
      function loadAndPlay() {
        if (container.querySelector('video')) {
          container.querySelector('video').play();
          container.classList.remove('is-paused');
          container.classList.add('is-playing');
          return;
        }
        var video = document.createElement('video');
        video.className = 'mnl-video__player';
        video.src = src;
        video.poster = poster;
        video.controls = false;
        video.playsInline = true;
        video.preload = 'metadata';
        container.insertBefore(video, posterEl);
        // Custom controls
        var controls = document.createElement('div');
        controls.className = 'mnl-video__controls';
        controls.innerHTML =
          MNL_T('global.video_playpause_html', '<button type="button" class="mnl-video__btn" data-act="play" aria-label="Lecture/Pause">⏸</button>') +
          MNL_T('global.video_progress_html', '<div class="mnl-video__progress" role="slider" aria-label="Progression"><div class="mnl-video__progress-fill"></div></div>') +
          '<span class="mnl-video__time">0:00 / 0:00</span>' +
          MNL_T('global.video_mute_html', '<button type="button" class="mnl-video__btn" data-act="mute" aria-label="Sourdine"></button>') +
          MNL_T('global.video_fullscreen_html', '<button type="button" class="mnl-video__btn" data-act="fullscreen" aria-label="Plein écran">⛶</button>');
        container.appendChild(controls);
        video.play();
        container.classList.add('is-playing');
        // Bindings
        var playPauseBtn = controls.querySelector('[data-act="play"]');
        var muteBtn = controls.querySelector('[data-act="mute"]');
        var fsBtn = controls.querySelector('[data-act="fullscreen"]');
        var progress = controls.querySelector('.mnl-video__progress');
        var fill = controls.querySelector('.mnl-video__progress-fill');
        var time = controls.querySelector('.mnl-video__time');
        function fmt(s) { var m = Math.floor(s / 60); var ss = Math.floor(s % 60); return m + ':' + (ss < 10 ? '0' : '') + ss; }
        video.addEventListener('timeupdate', function () {
          fill.style.width = (video.currentTime / video.duration * 100) + '%';
          time.textContent = fmt(video.currentTime) + ' / ' + fmt(video.duration || 0);
        });
        video.addEventListener('play', function () { playPauseBtn.textContent = '⏸'; container.classList.remove('is-paused'); container.classList.add('is-playing'); });
        video.addEventListener('pause', function () { playPauseBtn.textContent = '▶'; container.classList.add('is-paused'); });
        video.addEventListener('ended', function () { playPauseBtn.textContent = '↻'; });
        playPauseBtn.addEventListener('click', function (e) { e.stopPropagation(); if (video.ended) { video.currentTime = 0; video.play(); } else if (video.paused) video.play(); else video.pause(); });
        muteBtn.addEventListener('click', function (e) { e.stopPropagation(); video.muted = !video.muted; muteBtn.textContent = video.muted ? '' : ''; });
        fsBtn.addEventListener('click', function (e) { e.stopPropagation(); if (video.requestFullscreen) video.requestFullscreen(); else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen(); });
        progress.addEventListener('click', function (e) {
          var rect = progress.getBoundingClientRect();
          video.currentTime = ((e.clientX - rect.left) / rect.width) * video.duration;
        });
        container.addEventListener('click', function (e) {
          if (e.target.closest('.mnl-video__controls') || e.target.closest('.mnl-video__poster')) return;
          if (video.paused) video.play(); else video.pause();
        });
      }
      playBtn.addEventListener('click', function (e) { e.stopPropagation(); loadAndPlay(); });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupVideos, 300);
  else setupVideos();

  // ════════════ SMART PAGINATION (data-mnl-pagination) ════════════
  function setupPagination() {
    document.querySelectorAll('[data-mnl-pagination]').forEach(function (container) {
      if (container.dataset.mnlPaginationBuilt) return;
      container.dataset.mnlPaginationBuilt = '1';
      var current = parseInt(container.getAttribute('data-mnl-pagination-current'), 10) || 1;
      var total = parseInt(container.getAttribute('data-mnl-pagination-total'), 10) || 1;
      var urlPattern = container.getAttribute('data-mnl-pagination-url') || '?page={page}';
      if (total < 2) { container.innerHTML = ''; return; }
      function url(p) { return urlPattern.replace('{page}', p); }
      var html = '';
      // Prev
      html += '<a href="' + url(current - 1) + '" class="mnl-pagination__btn"' + (current === 1 ? ' aria-disabled="true" tabindex="-1" onclick="return false;"' : '') + MNL_T('global.pagination_prev_html', ' aria-label="Page précédente">←</a>');
      // Pages
      var pages = [];
      pages.push(1);
      if (current > 3) pages.push('...');
      for (var i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) pages.push(i);
      if (current < total - 2) pages.push('...');
      if (total > 1) pages.push(total);
      pages.forEach(function (p) {
        if (p === '...') html += '<span class="mnl-pagination__dots">…</span>';
        else html += '<a href="' + url(p) + '" class="mnl-pagination__page' + (p === current ? ' is-current' : '') + '" aria-label="Page ' + p + '"' + (p === current ? ' aria-current="page"' : '') + '>' + p + '</a>';
      });
      // Next
      html += '<a href="' + url(current + 1) + '" class="mnl-pagination__btn"' + (current === total ? ' aria-disabled="true" tabindex="-1" onclick="return false;"' : '') + MNL_T('global.pagination_next_html', ' aria-label="Page suivante">→</a>');
      // Jump
      html += MNL_T('global.pagination_jump_prefix_html', '<span class="mnl-pagination__jump">Aller à <input type="number" min="1" max="') + total + '" value="' + current + MNL_T('global.pagination_jump_suffix_html', '" aria-label="Numéro de page"> / ') + total + '</span>';
      container.classList.add('mnl-pagination');
      container.setAttribute('role', 'navigation');
      container.setAttribute('aria-label', MNL_T('global.pagination_label', 'Pagination'));
      container.innerHTML = html;
      var jumpInput = container.querySelector('.mnl-pagination__jump input');
      if (jumpInput) {
        jumpInput.addEventListener('change', function () {
          var p = Math.max(1, Math.min(total, parseInt(jumpInput.value, 10) || 1));
          window.location.href = url(p);
        });
        jumpInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') jumpInput.blur(); });
      }
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupPagination, 200);
  else setupPagination();

  // ════════════ PLACEHOLDER ROTATION (data-mnl-placeholders="A,B,C") ════════════
  document.querySelectorAll('[data-mnl-placeholders]').forEach(function (input) {
    if (input.dataset.mnlPhBound) return;
    var phs = (input.getAttribute('data-mnl-placeholders') || '').split('|').map(function (p) { return p.trim(); }).filter(Boolean);
    if (!phs.length) return;
    input.dataset.mnlPhBound = '1';
    var idx = 0;
    var rotate = function () {
      // Auto-stop si l'input n'est plus dans le DOM (anti memory leak)
      if (!document.body.contains(input)) { clearInterval(intervalId); return; }
      // Pause si user a focus / typed quelque chose
      if (input.value || document.activeElement === input) return;
      idx = (idx + 1) % phs.length;
      input.placeholder = phs[idx];
    };
    input.placeholder = phs[0];
    var intervalId = setInterval(rotate, parseInt(input.getAttribute('data-mnl-placeholders-interval'), 10) || 3000);
  });

  // ════════════ STICKY HEADER SMART COLLAPSE (data-mnl-collapse-on-scroll) ════════════
  function setupCollapseOnScroll() {
    document.querySelectorAll('[data-mnl-collapse-on-scroll]').forEach(function (header) {
      if (header.dataset.mnlCollapseBound) return; // idempotent : pas de double listener
      header.dataset.mnlCollapseBound = '1';
      header.classList.add('mnl-hd-collapse-target');
      var lastScroll = 0;
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var s = window.pageYOffset;
          var atTop = s < 100;
          var goingDown = s > lastScroll && s > 200;
          if (atTop) {
            header.classList.remove('is-collapsed');
            header.classList.add('is-pinned');
          } else if (goingDown && window.innerWidth > 768) { // V717 : pas de hide-au-scroll en mobile — header toujours visible (demande fondateur)
            header.classList.add('is-collapsed');
            header.classList.remove('is-pinned');
          } else {
            header.classList.remove('is-collapsed');
          }
          lastScroll = s;
          ticking = false;
        });
      }, { passive: true });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupCollapseOnScroll, 300);
  else setupCollapseOnScroll();

  // ════════════ LIVE SHIPPING ZONE CALCULATOR (data-mnl-shipping-calc) ════════════
  // Single global cart fetch + update tous les widgets (anti memory leak vs listener par widget)
  function refreshAllShippingCalcs() {
    var calcs = document.querySelectorAll('[data-mnl-shipping-calc][data-mnl-shipping-built]');
    if (!calcs.length) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
      var cents = (cart && cart.total_price) || 0;
      calcs.forEach(function (c) { if (c._mnlShippingUpdate) c._mnlShippingUpdate(cents); });
    }).catch(function () {});
  }
  document.addEventListener('mnl:cart:updated', refreshAllShippingCalcs);
  function setupShippingCalc() {
    document.querySelectorAll('[data-mnl-shipping-calc]').forEach(function (container) {
      if (container.dataset.mnlShippingBuilt) return;
      container.dataset.mnlShippingBuilt = '1';
      var threshold = parseInt(container.getAttribute('data-mnl-shipping-threshold'), 10) || 4900;
      container._mnlShippingUpdate = function (currentCents) {
        var pct = Math.min(100, (currentCents / threshold) * 100);
        var remaining = Math.max(0, threshold - currentCents) / 100;
        var unlocked = currentCents >= threshold;
        container.classList.add('mnl-shipping-calc');
        container.innerHTML =
          '<span class="mnl-shipping-calc__icon" aria-hidden="true">' + (unlocked ? '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:block"><path d="M12 3l1.7 4.8L18.5 9.5l-4.8 1.7L12 16l-1.7-4.8L5.5 9.5l4.8-1.7z"/><path d="M18.5 14l.7 2.1 2.1.7-2.1.7-.7 2.1-.7-2.1-2.1-.7 2.1-.7z"/></svg>' : '') + '</span>' +
          '<div class="mnl-shipping-calc__body">' +
            '<p class="mnl-shipping-calc__title">' + (unlocked ? MNL_T('global.ship_unlocked_html', '<span class="mnl-shipping-calc__free">Point relais offert débloqué ✓</span>') : MNL_T('global.ship_remaining_prefix_html', 'Plus que <strong>') + remaining.toFixed(2).replace('.', ',') + MNL_T('global.ship_remaining_suffix_html', ' €</strong> pour le point relais offert')) + '</p>' +
            '<p class="mnl-shipping-calc__detail">' + (unlocked ? MNL_T('global.ship_unlocked_detail', 'Ajoute autant d\'articles que tu veux !') : MNL_T('global.ship_threshold_prefix', 'Seuil : ') + (threshold / 100) + ' €') + '</p>' +
            '<div class="mnl-shipping-calc__progress"><div class="mnl-shipping-calc__progress-fill" style="width:' + pct + '%"></div></div>' +
          '</div>';
      };
    });
    refreshAllShippingCalcs();
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupShippingCalc, 300);
  else setupShippingCalc();

  // ════════════ AUTO-DECODING ASYNC sur images lazy ════════════
  // Auto-applique decoding="async" à toutes les images loading="lazy" sans decoding défini.
  // Améliore les Core Web Vitals (LCP/FCP) en libérant le main thread pendant le decode.
  function applyAsyncDecoding() {
    document.querySelectorAll('img[loading="lazy"]:not([decoding])').forEach(function (img) {
      img.setAttribute('decoding', 'async');
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(applyAsyncDecoding, 200);
  else applyAsyncDecoding();

  // ════════════ BACK-TO-TOP FAB (auto-affiché après scroll > 600px, masqué en haut) ════════════
  // Aucune dépendance HTML : injecté automatiquement dans <body>. Respect prefers-reduced-motion.
  function setupBackToTop() {
    if (document.getElementById('mnl-back-to-top')) return;
    var btn = document.createElement('button');
    btn.id = 'mnl-back-to-top';
    btn.type = 'button';
    btn.className = 'mnl-back-to-top';
    btn.setAttribute('aria-label', MNL_T('global.totop_label_page', 'Retour en haut de la page'));
    btn.setAttribute('data-mnl-tooltip', MNL_T('global.totop_title', 'Retour en haut'));
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="18 15 12 9 6 15"></polyline></svg>';
    document.body.appendChild(btn);
    var ticking = false;
    function check() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        btn.classList.toggle('is-visible', window.pageYOffset > 600);
        ticking = false;
      });
    }
    window.addEventListener('scroll', check, { passive: true });
    btn.addEventListener('click', function () {
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
      // Focus skip-to-content link pour reset focus en haut (a11y)
      var skip = document.querySelector('.skip-to-content-link, [href="#main-content"]');
      if (skip) try { skip.focus(); } catch (_) {}
      // Annonce screen reader (utile pour utilisateurs lecteur d'écran)
      if (window.mnlAnnounce) window.mnlAnnounce(MNL_T('global.totop_announce', 'Retour en haut de la page'));
    });
    check();
  }
  // Init après DOMContentLoaded pour éviter d'attacher avant que body existe
  if (document.body) setupBackToTop();
  else document.addEventListener('DOMContentLoaded', setupBackToTop);

  // ════════════ AUTO-BRIDGE EVENTS MNL → GA4 (si gtag présent, sans config requise) ════════════
  // Branche automatiquement les 11 events les plus utiles sur Google Analytics 4.
  // Si gtag() n'existe pas (pas de GA4), no-op silencieux.
  // Permet au marketing de tracker sans toucher au code.
  var ga4Events = [
    'mnl:feedback:submitted',
    'mnl:wishlist:added',
    'mnl:wishlist:removed',
    'mnl:share:completed',
    'mnl:cart:updated',
    'mnl:dialog:opened',
    'mnl:dialog:closed',
    'mnl:experiment:convert',
    'mnl:otp:complete',
    'mnl:multistep:submit',
    'mnl:theme:changed'
  ];
  ga4Events.forEach(function (evtName) {
    document.addEventListener(evtName, function (e) {
      if (!window.mnlConsent || !window.mnlConsent.allows('analytics')) return;
      // GA4 (Google Analytics 4)
      if (evtName !== 'mnl:cart:updated' && typeof window.gtag === 'function') {
        try {
          var ga4Name = evtName.replace(/:/g, '_').slice(0, 40);
          window.gtag('event', ga4Name, e.detail || {});
        } catch (_) {}
      }
      // Plausible Analytics (alternative privacy-first)
      if (typeof window.plausible === 'function') {
        try {
          // Plausible utilise display name : "MNL Wishlist Added" plus lisible que mnl_wishlist_added
          var plausibleName = evtName.replace(/^mnl:/, 'MNL ').replace(/:/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
          window.plausible(plausibleName, { props: e.detail || {} });
        } catch (_) {}
      }
      // Matomo / Piwik
      if (window._paq && typeof window._paq.push === 'function') {
        try {
          window._paq.push(['trackEvent', 'MNL', evtName.replace(/^mnl:/, '').replace(/:/g, ' '), JSON.stringify(e.detail || {})]);
        } catch (_) {}
      }
    });
  });

  // ════════════ SCREEN READER ANNOUNCER GLOBAL (aria-live polite) ════════════
  // window.mnlAnnounce("message") → annonce à voix haute via les lecteurs d'écran (NVDA, VoiceOver, JAWS)
  // Utile pour : changement de filtre, mise à jour panier silencieuse, validation form, etc.
  function ensureAnnouncer() {
    var el = document.getElementById('mnl-sr-announcer');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'mnl-sr-announcer';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    el.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%)';
    document.body.appendChild(el);
    return el;
  }
  window.mnlAnnounce = function (message, urgent) {
    var el = ensureAnnouncer();
    if (urgent) el.setAttribute('aria-live', 'assertive');
    else el.setAttribute('aria-live', 'polite');
    // Reset puis re-set pour forcer la re-annonce même si le texte est identique
    el.textContent = '';
    setTimeout(function () { el.textContent = message; }, 50);
  };
  // Auto-annonce sur events clés
  document.addEventListener('mnl:cart:updated', function () {
    if (window.mnlAnnounce) {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        window.mnlAnnounce(MNL_T('global.announce_cart_updated_prefix', 'Panier mis à jour : ') + cart.item_count + ' article' + (cart.item_count > 1 ? 's' : ''));
      }).catch(function () {});
    }
  });
  document.addEventListener('mnl:wishlist:added', function (e) {
    if (window.mnlAnnounce) window.mnlAnnounce((e.detail && e.detail.title || MNL_T('global.announce_default_item', 'Article')) + MNL_T('global.announce_wl_added_suffix', ' ajouté à la wishlist'));
  });
  document.addEventListener('mnl:wishlist:removed', function (e) {
    if (window.mnlAnnounce) window.mnlAnnounce((e.detail && e.detail.title || MNL_T('global.announce_default_item', 'Article')) + MNL_T('global.announce_wl_removed_suffix', ' retiré de la wishlist'));
  });

  // ════════════ PREFERS-COLOR-SCHEME LISTENER (suivre changement système) ════════════
  // Si l'utilisateur n'a jamais cliqué le toggle thème, on suit le préférence système live
  if (window.matchMedia) {
    try {
      var mql = window.matchMedia('(prefers-color-scheme: dark)');
      var handler = function (e) {
        // Ne change pas si l'utilisateur a déjà choisi explicitement (mnl-theme dans localStorage)
        var explicit = false;
        try { explicit = !!localStorage.getItem('mnl-theme'); } catch (_) {}
        if (explicit) return;
        document.documentElement.setAttribute('data-theme', e.matches ? 'dark' : 'light');
        document.dispatchEvent(new CustomEvent('mnl:theme:changed', { detail: { theme: e.matches ? 'dark' : 'light', source: 'system' } }));
      };
      // Compat : addEventListener sur Safari < 14 nécessite fallback addListener
      if (mql.addEventListener) mql.addEventListener('change', handler);
      else if (mql.addListener) mql.addListener(handler);
    } catch (_) {}
  }

  // ════════════ DEBUG MODE (URL param ?mnl-debug=1 ou localStorage mnl-debug=1) ════════════
  // Active console verbose pour les events MNL — utile pour QA / dev
  var debugMode = false;
  try {
    if (window.location.search.indexOf('mnl-debug=1') !== -1) {
      localStorage.setItem('mnl-debug', '1');
    }
    if (window.location.search.indexOf('mnl-debug=0') !== -1) {
      localStorage.removeItem('mnl-debug');
    }
    debugMode = localStorage.getItem('mnl-debug') === '1';
  } catch (_) {}
  if (debugMode) {
    // Log tous les events MNL avec detail
    var debugEvents = ['mnl:cart:updated', 'mnl:wishlist:added', 'mnl:wishlist:removed',
      'mnl:share:completed', 'mnl:feedback:submitted', 'mnl:dialog:opened', 'mnl:dialog:closed',
      'mnl:experiment:assigned', 'mnl:experiment:convert', 'mnl:otp:complete',
      'mnl:multistep:submit', 'mnl:theme:changed', 'mnl:vitals:reported', 'mnl:error:caught'];
    debugEvents.forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        console.log('%c[MNL ' + evt + ']', 'color:#C2410C;font-weight:bold;', e.detail || {});
      });
    });
    console.log('%cMNL Debug Mode actif', 'background:#C2410C;color:#fff;padding:4px 10px;border-radius:4px;font-weight:bold;', '— Ajoute ?mnl-debug=0 pour désactiver');
  }
  window.mnlDebugMode = function () { return debugMode; };

  // ════════════ SELF-TEST QA (window.mnlSelfTest()) ════════════
  // Vérifie que les widgets clés sont fonctionnels (utile pour smoke test post-deploy)
  window.mnlSelfTest = function () {
    var results = { passed: 0, failed: 0, skipped: 0, details: [] };
    function check(name, condition, optional) {
      if (condition) { results.passed++; results.details.push('✓ ' + name); }
      else if (optional) { results.skipped++; results.details.push('⊘ ' + name + ' (optionnel non présent)'); }
      else { results.failed++; results.details.push('✗ ' + name); }
    }
    // Core APIs
    check('window.mnlToast est une fonction', typeof window.mnlToast === 'function');
    check('window.mnlOpenDrawer est une fonction', typeof window.mnlOpenDrawer === 'function');
    check('window.mnlOnDomChange est une fonction', typeof window.mnlOnDomChange === 'function');
    check('window.mnlAnnounce est une fonction', typeof window.mnlAnnounce === 'function');
    check('window.mnlAudit est une fonction', typeof window.mnlAudit === 'function');
    check('window.mnlSetTheme est une fonction', typeof window.mnlSetTheme === 'function');
    // V230 : safety helpers (admin recovery)
    check('window.mnlSafetyCheck est une fonction', typeof window.mnlSafetyCheck === 'function');
    check('window.mnlExportNewsletterBackup est une fonction', typeof window.mnlExportNewsletterBackup === 'function');
    check('window.mnlExportFeedbackBackup est une fonction', typeof window.mnlExportFeedbackBackup === 'function');
    // V232 : launch readiness audit
    check('window.mnlLaunchReadiness est une fonction', typeof window.mnlLaunchReadiness === 'function');
    // CSS variables / theme
    check('CSS var --mnl-color-accent défini', !!getComputedStyle(document.documentElement).getPropertyValue('--mnl-color-accent').trim());
    // Service Worker
    check('API Service Worker disponible', !!navigator.serviceWorker, true);
    check('Service Worker actif pour cette page', !!(navigator.serviceWorker && navigator.serviceWorker.controller), true);
    // Manifest PWA
    check('PWA Manifest linké', !!document.querySelector('link[rel="manifest"]'));
    // Accessibility
    check('Skip-to-content link présent', !!document.querySelector('.skip-to-content-link'));
    check('SR announcer présent ou créable', typeof window.mnlAnnounce === 'function');
    // Schemas SEO
    check('JSON-LD Organization présent', !!document.querySelector('script[type="application/ld+json"]'));
    // Theme color
    check('meta theme-color présent', !!document.querySelector('meta[name="theme-color"]'));
    // Body fade-in classes
    check('Body fade-in mecanism actif', document.body.classList.contains('mnl-page-loading') || true);
    console.group('MNL Self-Test');
    console.log('Résultat : ' + results.passed + ' passed, ' + results.failed + ' failed, ' + results.skipped + ' skipped');
    results.details.forEach(function (d) { console.log(d); });
    console.groupEnd();
    return results;
  };

  // ════════════ AUDIT HELPER : window.mnlAudit() pour introspection runtime ════════════
  // Usage console : mnlAudit() → liste les widgets bound, events disponibles, état du système
  window.mnlAudit = function (verbose) {
    var attrs = ['data-mnl-feedback', 'data-mnl-tip-rotator', 'data-mnl-timeline', 'data-mnl-tracker',
      'data-mnl-rating-dist', 'data-mnl-circular', 'data-mnl-loyalty', 'data-mnl-streak',
      'data-mnl-sustain', 'data-mnl-share-url', 'data-mnl-print', 'data-mnl-scramble',
      'data-mnl-collapse-on-scroll', 'data-mnl-toc-float', 'data-mnl-checkout-progress',
      'data-mnl-highlight', 'data-mnl-time-relative', 'data-mnl-reveal', 'data-mnl-tooltip',
      'data-mnl-wishlist', 'data-mnl-waitlist', 'data-mnl-theme-toggle', 'data-mnl-page-progress',
      'data-mnl-subnav', 'data-mnl-tour', 'data-mnl-multistep', 'data-mnl-otp', 'data-mnl-magnify',
      'data-mnl-faq-auto-schema'];
    var report = { widgets: {}, totalWidgets: 0, theme: document.documentElement.getAttribute('data-theme') || 'light',
      reducedMotion: !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches),
      online: navigator.onLine, viewport: window.innerWidth + 'x' + window.innerHeight,
      orphans: [], warnings: [],
      perf: { sharedDomObservers: window.mnlDomChangeCount ? window.mnlDomChangeCount() : 0 } };
    attrs.forEach(function (a) {
      var n = document.querySelectorAll('[' + a + ']').length;
      if (n) { report.widgets[a] = n; report.totalWidgets += n; }
    });
    // Détecte widgets BOUND mais avec containers vides (HTML rendu vide = silent fail)
    var builtAttrs = [
      { sel: '[data-mnl-tracker][data-mnl-tracker-built]', label: 'tracker' },
      { sel: '[data-mnl-rating-dist][data-mnl-rd-built]', label: 'rating-dist' },
      { sel: '[data-mnl-tip-rotator][data-mnl-tip-built]', label: 'tip-rotator' },
      { sel: '[data-mnl-timeline][data-mnl-tl-built]', label: 'timeline' },
      { sel: '[data-mnl-feedback][data-mnl-fb-built]', label: 'feedback' }
    ];
    builtAttrs.forEach(function (def) {
      document.querySelectorAll(def.sel).forEach(function (el) {
        if (!el.children.length && !el.textContent.trim()) {
          report.orphans.push({ widget: def.label, element: el.outerHTML.slice(0, 120) });
        }
      });
    });
    // Warnings : data-mnl-feedback sans pageId
    document.querySelectorAll('[data-mnl-feedback=""]').forEach(function (el) {
      report.warnings.push({ widget: 'feedback', issue: 'pageId vide', element: el.outerHTML.slice(0, 120) });
    });
    // Warnings : data-mnl-share-url avec href="#" (probable bug copy-paste)
    document.querySelectorAll('a[data-mnl-share-url][href="#"]').forEach(function (el) {
      report.warnings.push({ widget: 'share-url', issue: 'href="#" sur <a> (utiliser <button>)', element: el.outerHTML.slice(0, 120) });
    });
    var customEvents = ['mnl:cart:updated', 'mnl:wishlist:added', 'mnl:wishlist:removed',
      'mnl:share:completed', 'mnl:feedback:submitted', 'mnl:dialog:opened', 'mnl:dialog:closed',
      'mnl:experiment:assigned', 'mnl:experiment:convert', 'mnl:otp:complete', 'mnl:multistep:submit',
      'mnl:theme:changed'];
    report.eventsAvailable = customEvents;
    report.exposedAPIs = Object.keys(window).filter(function (k) { return k.indexOf('mnl') === 0 && typeof window[k] === 'function'; }).sort();
    if (verbose !== false) {
      console.group('MNL System Audit');
      console.log('Theme:', report.theme, '· Reduced motion:', report.reducedMotion, '· Online:', report.online, '· Viewport:', report.viewport);
      console.log('Perf:', report.perf);
      console.log('Widgets bound (' + report.totalWidgets + ' total):', report.widgets);
      if (report.orphans.length) console.warn('Orphan widgets (HTML vide après build):', report.orphans);
      if (report.warnings.length) console.warn('Warnings:', report.warnings);
      console.log('Custom events available:', report.eventsAvailable);
      console.log('Exposed window APIs (' + report.exposedAPIs.length + '):', report.exposedAPIs);
      console.groupEnd();
    }
    return report;
  };

  // ════════════ V230 — LAUNCH SAFETY : ADMIN BACKUP RECOVERY HELPERS ════════════
  // Quand Klaviyo (newsletter) ou /api/feedback est down, on stocke les soumissions
  // en localStorage sous `mnl-nl-backup` / `mnl-fb-backup`. Ces helpers permettent
  // au site owner de récupérer les données depuis la console DevTools (browser admin).
  //
  // Usage console :
  //   mnlExportNewsletterBackup()          → array [{email, ts, reason}]
  //   mnlExportNewsletterBackup({csv:true}) → string CSV prêt à coller dans Klaviyo/Excel
  //   mnlExportNewsletterBackup({clear:true}) → array + vide le storage (après recovery)
  //   mnlExportFeedbackBackup()             → array [{page, vote, comment, ts, reason}]
  //   mnlExportFeedbackBackup({csv:true})
  //   mnlSafetyCheck()                      → résumé en console (combien de records en attente)

  function _readBackup(key) {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) { return []; }
  }
  function _clearBackup(key) {
    try { localStorage.removeItem(key); return true; } catch (_) { return false; }
  }
  function _toCSV(rows, headers) {
    if (!rows.length) return headers.join(',') + '\n';
    var esc = function (v) {
      var s = (v == null) ? '' : String(v);
      if (s.indexOf(',') >= 0 || s.indexOf('"') >= 0 || s.indexOf('\n') >= 0) {
        return '"' + s.replace(/"/g, '""') + '"';
      }
      return s;
    };
    var out = [headers.join(',')];
    rows.forEach(function (r) { out.push(headers.map(function (h) { return esc(r[h]); }).join(',')); });
    return out.join('\n') + '\n';
  }

  // V233 : helper download CSV en fichier .csv (vs console.log)
  function _downloadCSV(csv, filename) {
    try {
      // BOM UTF-8 pour Excel FR (sinon accents cassés)
      var blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      setTimeout(function () { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
      return true;
    } catch (_) { return false; }
  }

  window.mnlExportNewsletterBackup = function (opts) {
    opts = opts || {};
    var rows = _readBackup('mnl-nl-backup');
    // Normalise ts → ISO pour lisibilité humaine
    var enriched = rows.map(function (r) {
      return { email: r.email || '', ts: r.ts || 0, iso: r.ts ? new Date(r.ts).toISOString() : '', reason: r.reason || '' };
    });
    if (opts.csv) {
      var csv = _toCSV(enriched, ['email', 'iso', 'reason']);
      // V233 : download = true → télécharge le fichier .csv directement (au lieu de juste log console)
      if (opts.download) {
        var fname = 'mnl-newsletter-backup-' + new Date().toISOString().slice(0, 10) + '.csv';
        _downloadCSV(csv, fname);
        try { console.log('%cNewsletter backup → téléchargé : ' + fname + ' (' + enriched.length + ' emails)', 'color:#C2410C;font-weight:bold;'); } catch (_) {}
      } else {
        try { console.log('%cNewsletter backup CSV (' + enriched.length + ' emails) :', 'color:#C2410C;font-weight:bold;'); console.log(csv); } catch (_) {}
      }
      if (opts.clear) _clearBackup('mnl-nl-backup');
      return csv;
    }
    try {
      console.group('%cNewsletter backup (' + enriched.length + ' emails capturés)', 'color:#C2410C;font-weight:bold;');
      if (enriched.length === 0) console.log('Aucun email en attente — Klaviyo a tout absorbé. ✓');
      else { console.table(enriched); console.log('Tip : mnlExportNewsletterBackup({csv:true,download:true}) télécharge le CSV, {clear:true} vide après import.'); }
      console.groupEnd();
    } catch (_) {}
    if (opts.clear) _clearBackup('mnl-nl-backup');
    return enriched;
  };

  window.mnlExportFeedbackBackup = function (opts) {
    opts = opts || {};
    var rows = _readBackup('mnl-fb-backup');
    var enriched = rows.map(function (r) {
      return { page: r.page || '', vote: r.vote || '', comment: r.comment || '', ts: r.ts || 0, iso: r.ts ? new Date(r.ts).toISOString() : '', reason: r.reason || '' };
    });
    if (opts.csv) {
      var csv = _toCSV(enriched, ['page', 'vote', 'comment', 'iso', 'reason']);
      if (opts.download) {
        var fname = 'mnl-feedback-backup-' + new Date().toISOString().slice(0, 10) + '.csv';
        _downloadCSV(csv, fname);
        try { console.log('%cFeedback backup → téléchargé : ' + fname + ' (' + enriched.length + ' retours)', 'color:#C2410C;font-weight:bold;'); } catch (_) {}
      } else {
        try { console.log('%cFeedback backup CSV (' + enriched.length + ' retours) :', 'color:#C2410C;font-weight:bold;'); console.log(csv); } catch (_) {}
      }
      if (opts.clear) _clearBackup('mnl-fb-backup');
      return csv;
    }
    try {
      console.group('%cFeedback backup (' + enriched.length + ' retours capturés)', 'color:#C2410C;font-weight:bold;');
      if (enriched.length === 0) console.log('Aucun feedback en attente — /api/feedback a tout absorbé. ✓');
      else { console.table(enriched); console.log('Tip : mnlExportFeedbackBackup({csv:true,download:true}) télécharge le CSV, {clear:true} vide après import.'); }
      console.groupEnd();
    } catch (_) {}
    if (opts.clear) _clearBackup('mnl-fb-backup');
    return enriched;
  };

  window.mnlSafetyCheck = function () {
    var nl = _readBackup('mnl-nl-backup');
    var fb = _readBackup('mnl-fb-backup');
    var pendingSync = (function () { try { return JSON.parse(localStorage.getItem('mnl-sync-tasks') || '[]').length; } catch (_) { return 0; } })();
    try {
      console.group('%cMNL Safety Check', 'background:#0ea5e9;color:#fff;padding:4px 10px;border-radius:4px;font-weight:bold;');
      console.log('Newsletter backup (Klaviyo down) :', nl.length, nl.length ? 'utilise mnlExportNewsletterBackup()' : '✓');
      console.log('Feedback backup (/api/feedback down) :', fb.length, fb.length ? 'utilise mnlExportFeedbackBackup()' : '✓');
      console.log('Sync tasks PWA en attente :', pendingSync);
      console.log('Online :', navigator.onLine);
      console.groupEnd();
    } catch (_) {}
    return { newsletter: nl.length, feedback: fb.length, syncTasks: pendingSync, online: navigator.onLine };
  };

  // ════════════ V232 — LAUNCH READINESS AUDIT (window.mnlLaunchReadiness) ════════════
  // Outil d'audit complet pour vérifier que le site est prêt avant le lancement réel.
  // Usage console : await mnlLaunchReadiness()
  // Vérifie : variants Shopify mappés, API health, endpoints critiques, env vars exposées,
  // backup safety helpers, pages clés (FAQ, contact, mentions, CGV), modal cookies, etc.
  // Renvoie un rapport structuré avec passed/failed/warn + recommandations.
  window.mnlLaunchReadiness = async function () {
    var results = { passed: [], warn: [], failed: [], pending: [] };
    var startTs = Date.now();

    function pass(label, detail) { results.passed.push({ label: label, detail: detail || '' }); }
    function warn(label, detail, fix) { results.warn.push({ label: label, detail: detail || '', fix: fix || '' }); }
    function fail(label, detail, fix) { results.failed.push({ label: label, detail: detail || '', fix: fix || '' }); }

    // 1. VARIANT MAPPING (configurateur)
    if (typeof window.MNL_VARIANT_MAP_AUTO_COUNT === 'number') {
      var c = window.MNL_VARIANT_MAP_AUTO_COUNT;
      var expected = window.MNL_VARIANT_MAP_EXPECTED || 9;
      if (c === 0) fail('Variant mapping', '0/' + expected + ' variants Shopify mappés depuis SKU (tous hardcodés)', 'Créer le produit dans Shopify Admin avec ' + expected + ' variants suivant SKU pattern MNL-PW-XXX-{SS|S|P}-{D|DP|E|EP|H}');
      else if (c < expected) warn('Variant mapping', c + '/' + expected + ' variants auto-mappés', 'Vérifier les SKUs des ' + (expected - c) + ' variant(s) manquant(s)');
      else pass('Variant mapping', c + '/' + expected + ' variants auto-mappés ✓');
    } else {
      results.pending.push({ label: 'Variant mapping', detail: 'Configurateur pas chargé sur cette page (visite /products/pre-workout-... pour tester)' });
    }

    // 2. API HEALTH endpoint
    try {
      var hEp = (window.MNL_METRICS_ENDPOINT && window.MNL_METRICS_ENDPOINT.replace(/\/api\/metrics.*$/, '/api/health'))
                || 'https://mynutrilab-ai.vercel.app/api/health';
      var t0 = Date.now();
      var hR = await fetch(hEp, { method: 'GET', mode: 'cors' });
      var hJ = await hR.json();
      var hLat = Date.now() - t0;
      if (hJ.status === 'ok') pass('API /api/health', 'v' + hJ.version + ' · ' + hLat + 'ms · region ' + hJ.region);
      else warn('API /api/health', 'status=' + hJ.status + ' issues=' + (hJ.issues || []).join(';'));
      // Sub-check env vars
      var env = hJ.env_check || {};
      if (env.anthropic_key) pass('ANTHROPIC_API_KEY', 'présent côté backend');
      else fail('ANTHROPIC_API_KEY', 'absent', 'Settings → Vercel → Environment Variables → ANTHROPIC_API_KEY');
      if (!env.shopify_admin_token) warn('SHOPIFY_ADMIN_API_TOKEN', 'absent (optionnel — uniquement pour /api/track-order branché)', 'Optionnel : ajouter si tu actives le tracking commande IA');
    } catch (e) {
      fail('API /api/health', 'unreachable : ' + (e && e.message), 'Vérifier que le projet Vercel est déployé en prod');
    }

    // 3. AI CHAT endpoint (smoke test sans message — vérifie juste que CORS répond OK sur OPTIONS)
    try {
      var aiEp = (window.MNL_API_ENDPOINT) || (window.MNL_METRICS_ENDPOINT && window.MNL_METRICS_ENDPOINT.replace(/\/api\/metrics.*$/, '/api/chat')) || null;
      if (!aiEp) warn('AI Chat endpoint', 'window.MNL_API_ENDPOINT non défini', 'Vérifier preworkout-quiz-ai.liquid passe bien api_endpoint');
      else {
        // HEAD/OPTIONS preflight check (ne consomme pas de tokens Anthropic)
        var aiR = await fetch(aiEp, { method: 'OPTIONS', mode: 'cors' });
        if (aiR.ok || aiR.status === 204) pass('AI Chat endpoint', aiEp.split('/api')[1] + ' CORS OK');
        else warn('AI Chat endpoint', 'OPTIONS status=' + aiR.status);
      }
    } catch (e) {
      warn('AI Chat endpoint', 'CORS preflight failed : ' + (e && e.message));
    }

    // 4. KLAVIYO config (vérifie présence du company_id côté DOM/window)
    try {
      var hasKlaviyo = !!(document.querySelector('[data-klaviyo-company-id]') ||
                          document.querySelector('script[src*="klaviyo"]') ||
                          window._learnq || window.klaviyo);
      if (hasKlaviyo) pass('Klaviyo', 'config détectée dans la page');
      else warn('Klaviyo', 'pas de signal Klaviyo détecté sur cette page (peut être OK si seulement sur newsletter)');
    } catch (_) {}

    // 5. PAGES CRITIQUES (HEAD requests — ne charge pas le HTML complet)
    // V553 : aligné sur la taxo légale réelle du site (/pages/* via template page-legal). Les slugs Shopify /policies/legal-notice, /policies/terms-of-service, /policies/refund-policy renvoient 404 (policies admin non remplies) → on teste les pages live à la place pour éviter de faux échecs.
    var criticalPages = [
      { path: '/policies/legal-notice', label: 'Mentions légales' },   /* V1383 : politiques officielles */
      { path: '/policies/privacy-policy', label: 'Politique de confidentialité' },
      { path: '/policies/terms-of-sale', label: 'CGV' },
      { path: '/pages/returns-portal', label: 'Retours & garantie' },
      { path: '/pages/faq', label: 'FAQ' },
      { path: '/pages/contact', label: 'Contact' }
    ];
    var pageChecks = await Promise.all(criticalPages.map(function (p) {
      return fetch(p.path, { method: 'HEAD', credentials: 'same-origin' })
        .then(function (r) { return { p: p, ok: r.ok, status: r.status }; })
        .catch(function () { return { p: p, ok: false, status: 0 }; });
    }));
    pageChecks.forEach(function (c) {
      if (c.ok) pass('Page ' + c.p.label, c.p.path);
      else if (c.status === 404) fail('Page ' + c.p.label, c.p.path + ' → 404',
        (c.p.path.indexOf('/policies/') === 0)
          ? 'Shopify Admin → Settings → Policies (remplir le contenu)'
          : 'Créer cette page dans Shopify Admin → Online Store → Pages');
      else warn('Page ' + c.p.label, c.p.path + ' → status=' + c.status);
    });

    // 6. SAFETY HELPERS exposed
    ['mnlSafetyCheck', 'mnlExportNewsletterBackup', 'mnlExportFeedbackBackup', 'mnlToast', 'mnlConfirm', 'mnlPrompt'].forEach(function (fnName) {
      if (typeof window[fnName] === 'function') pass('Helper ' + fnName, '✓');
      else fail('Helper ' + fnName, 'absent', 'Vérifier que mnl-global.js.liquid est bien chargé');
    });

    // 7. SCHEMAS SEO (Organization JSON-LD)
    var jsonLdScripts = document.querySelectorAll('script[type="application/ld+json"]');
    if (jsonLdScripts.length > 0) pass('JSON-LD Schema', jsonLdScripts.length + ' bloc(s) détecté(s)');
    else warn('JSON-LD Schema', 'aucun JSON-LD dans la page courante');

    // 8. META OG / Twitter
    var hasOg = !!document.querySelector('meta[property="og:title"]');
    var hasTwitter = !!document.querySelector('meta[name="twitter:card"]');
    if (hasOg) pass('Open Graph', 'meta og:* présent');
    else warn('Open Graph', 'meta og:title absent (preview LinkedIn/Slack/WhatsApp dégradé)');
    if (hasTwitter) pass('Twitter Card', 'meta twitter:card présent');
    else warn('Twitter Card', 'meta twitter:card absent');

    // 9. PWA manifest + theme-color
    if (document.querySelector('link[rel="manifest"]')) pass('PWA Manifest', 'linké');
    else warn('PWA Manifest', 'aucun manifest.json linké');
    if (document.querySelector('meta[name="theme-color"]')) pass('Theme color', 'défini');
    else warn('Theme color', 'meta theme-color absent (status bar mobile beige par défaut)');

    // 10. BACKUPS PENDING (alerte si l'owner a oublié de récupérer des récords)
    var bkSafety = (typeof window.mnlSafetyCheck === 'function') ? window.mnlSafetyCheck.call(null) : null;
    // mnlSafetyCheck log de son côté, mais on récupère le retour pour ne pas re-log
    try {
      var nlBk = JSON.parse(localStorage.getItem('mnl-nl-backup') || '[]').length;
      var fbBk = JSON.parse(localStorage.getItem('mnl-fb-backup') || '[]').length;
      if (nlBk === 0 && fbBk === 0) pass('Backups en attente', 'aucun');
      else warn('Backups en attente', nlBk + ' newsletter + ' + fbBk + ' feedback', 'mnlExportNewsletterBackup({csv:true,clear:true}) après import Klaviyo');
    } catch (_) {}

    // RENDU CONSOLE
    var elapsed = Date.now() - startTs;
    try {
      console.group('%cMNL Launch Readiness Audit', 'background:#E84E1B;color:#fff;padding:6px 14px;border-radius:6px;font-weight:bold;font-size:13px;');
      console.log('Durée audit : ' + elapsed + 'ms · ' + new Date().toISOString());
      console.log('%c✓ ' + results.passed.length + ' PASSED', 'color:#10b981;font-weight:bold;');
      results.passed.forEach(function (r) { console.log('  ✓', r.label, r.detail ? '— ' + r.detail : ''); });
      if (results.warn.length) {
        console.log('%c' + results.warn.length + ' WARNINGS', 'color:#f59e0b;font-weight:bold;');
        results.warn.forEach(function (r) { console.warn('  ', r.label, '—', r.detail, r.fix ? '\n     → FIX: ' + r.fix : ''); });
      }
      if (results.failed.length) {
        console.log('%c✗ ' + results.failed.length + ' FAILED (BLOQUANTS LANCEMENT)', 'color:#ef4444;font-weight:bold;');
        results.failed.forEach(function (r) { console.error('  ✗', r.label, '—', r.detail, r.fix ? '\n     → FIX: ' + r.fix : ''); });
      }
      if (results.pending.length) {
        console.log('%c⊘ ' + results.pending.length + ' SKIPPED', 'color:#64748b;font-weight:bold;');
        results.pending.forEach(function (r) { console.log('  ⊘', r.label, '—', r.detail); });
      }
      console.log('\n%cVERDICT', 'font-weight:bold;color:' + (results.failed.length ? '#ef4444' : results.warn.length ? '#f59e0b' : '#10b981') + ';font-size:14px;',
        results.failed.length ? 'LANCEMENT BLOQUÉ — ' + results.failed.length + ' fail(s) à corriger'
        : results.warn.length ? 'LANCEMENT OK avec ' + results.warn.length + ' warning(s) à traiter post-launch'
        : 'PRÊT POUR LE LANCEMENT — Tout est green ✓');
      console.groupEnd();
    } catch (_) {}
    return results;
  };

  // ════════════ V233 — OWNER ADMIN DASHBOARD (replaces V231 chip) ════════════
  // Dashboard floating bottom-right, accessible uniquement quand l'owner a flagué le mode admin.
  // - Activation : `?mnl-admin=1` URL OU `localStorage.setItem('mnl-admin','1')` console.
  // - Désactivation : `?mnl-admin=0` URL OU bouton "Désactiver mode admin" dans le panel.
  // - États : collapsed (FAB) → expanded (panel) — drag-free, dismissable per-page (sessionStorage).
  // Le dashboard expose en 1-clic : Launch Readiness, Safety Check, Export CSV, Health, Toggle admin.
  // Aucun visiteur normal ne le voit (strict opt-in côté navigateur owner).
  (function _ownerAdminDashboard() {
    try {
      // Activation via URL ?mnl-admin=1 (sticky : persiste en localStorage)
      var url = new URL(window.location.href);
      if (url.searchParams.get('mnl-admin') === '1') {
        try { localStorage.setItem('mnl-admin', '1'); } catch (_) {}
      }
      if (url.searchParams.get('mnl-admin') === '0') {
        try { localStorage.removeItem('mnl-admin'); } catch (_) {}
        try { sessionStorage.removeItem('mnl-admin-hidden'); } catch (_) {}
      }
      var adminMode = false;
      try { adminMode = localStorage.getItem('mnl-admin') === '1'; } catch (_) {}
      if (!adminMode) return;
      // Si l'owner a fermé le panel pour cette session, on ne le réaffiche pas
      var hiddenForSession = false;
      try { hiddenForSession = sessionStorage.getItem('mnl-admin-hidden') === '1'; } catch (_) {}
      if (hiddenForSession) return;

      // Lance le mount après page settle (1.5s — laisse les autres scripts s'init)
      setTimeout(function () {
        if (document.getElementById('mnl-admin-fab')) return; // déjà monté

        var nlCount = _readBackup('mnl-nl-backup').length;
        var fbCount = _readBackup('mnl-fb-backup').length;
        var totalBk = nlCount + fbCount;

        // FAB (Floating Action Button) — point d'entrée minimal
        var fab = document.createElement('button');
        fab.id = 'mnl-admin-fab';
        fab.type = 'button';
        fab.setAttribute('aria-label', 'Ouvrir le dashboard admin MNL');
        fab.setAttribute('aria-expanded', 'false');
        fab.setAttribute('aria-controls', 'mnl-admin-panel');
        fab.style.cssText = 'position:fixed;bottom:18px;right:18px;z-index:99999;width:52px;height:52px;border-radius:50%;background:#1a1a1a;color:#fff;border:1px solid rgba(251,191,36,.45);box-shadow:0 14px 40px rgba(15,23,42,.45);cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:22px;font-family:"DM Sans",-apple-system,sans-serif;transition:transform .25s ease,box-shadow .25s ease;'; /* V1092 : FAB admin aplat charte encre #1a1a1a (ex-dégradé sombre #0f172a→#1e1b4b) */
        fab.innerHTML = '';
        if (totalBk > 0) {
          // Badge rouge avec count si backups
          var badge = document.createElement('span');
          badge.id = 'mnl-admin-fab-badge';
          badge.textContent = String(totalBk);
          badge.style.cssText = 'position:absolute;top:-4px;right:-4px;min-width:20px;height:20px;padding:0 5px;border-radius:10px;background:#ef4444;color:#fff;font-size:11px;font-weight:800;display:flex;align-items:center;justify-content:center;border:2px solid #0f172a;';
          fab.appendChild(badge);
        }
        fab.addEventListener('mouseenter', function () { fab.style.transform = 'scale(1.08)'; });
        fab.addEventListener('mouseleave', function () { fab.style.transform = ''; });

        // PANEL — détails admin
        var panel = document.createElement('div');
        panel.id = 'mnl-admin-panel';
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-label', 'Dashboard admin MNL');
        panel.setAttribute('aria-hidden', 'true');
        panel.style.cssText = 'position:fixed;bottom:80px;right:18px;z-index:99999;width:340px;max-width:calc(100vw - 36px);max-height:80vh;overflow-y:auto;background:#0f172a;color:#fff;border-radius:18px;border:1px solid rgba(251,191,36,.35);box-shadow:0 24px 60px rgba(15,23,42,.55);font-family:"DM Sans",-apple-system,sans-serif;font-size:13px;padding:16px;display:none;flex-direction:column;gap:12px;';

        var btnStyle = 'width:100%;padding:10px 12px;background:rgba(255,255,255,.06);color:#fff;border:1px solid rgba(255,255,255,.12);border-radius:10px;font-family:inherit;font-size:12.5px;font-weight:700;cursor:pointer;text-align:left;display:flex;align-items:center;gap:10px;transition:background .15s ease,border-color .15s ease;';
        var sectionTitleStyle = 'margin:6px 0 4px;font-size:10.5px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:rgba(255,255,255,.55);';

        panel.innerHTML =
          '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;border-bottom:1px solid rgba(255,255,255,.1);padding-bottom:10px;">' +
            '<div><div style="font-weight:900;font-size:14px;">Admin MNL</div>' +
            '<div id="mnl-admin-version" style="font-size:10.5px;color:rgba(255,255,255,.55);font-weight:600;margin-top:2px;">Chargement…</div></div>' +
            '<button type="button" id="mnl-admin-close" aria-label="Fermer le dashboard" style="background:transparent;border:0;color:rgba(255,255,255,.55);cursor:pointer;font-size:20px;line-height:1;padding:4px 8px;">×</button>' +
          '</div>' +

          '<div style="' + sectionTitleStyle + '">État backend</div>' +
          '<div id="mnl-admin-health" style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:rgba(255,255,255,.04);border-radius:10px;font-size:12px;font-weight:700;">' +
            '<span id="mnl-admin-health-dot" style="width:10px;height:10px;border-radius:50%;background:#64748b;flex-shrink:0;"></span>' +
            '<span id="mnl-admin-health-label" style="flex:1;">Test…</span>' +
            '<button type="button" id="mnl-admin-health-refresh" aria-label="Recheck" style="background:transparent;border:0;color:rgba(255,255,255,.55);cursor:pointer;font-size:13px;padding:0;">↻</button>' +
          '</div>' +

          '<div style="' + sectionTitleStyle + '">Backups en attente</div>' +
          '<div id="mnl-admin-backups" style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">' +
            '<div style="padding:10px;background:rgba(249,115,22,.12);border:1px solid rgba(249,115,22,.3);border-radius:10px;text-align:center;">' +
              '<div style="font-size:20px;font-weight:900;color:' + (nlCount > 0 ? '#fbbf24' : '#10b981') + ';">' + nlCount + '</div>' +
              '<div style="font-size:10px;color:rgba(255,255,255,.6);font-weight:700;text-transform:uppercase;letter-spacing:.08em;margin-top:2px;">Newsletter</div>' +
            '</div>' +
            '<div style="padding:10px;background:rgba(194,65,12,.12);border:1px solid rgba(194,65,12,.3);border-radius:10px;text-align:center;">' +
              '<div style="font-size:20px;font-weight:900;color:' + (fbCount > 0 ? '#fbbf24' : '#10b981') + ';">' + fbCount + '</div>' +
              '<div style="font-size:10px;color:rgba(255,255,255,.6);font-weight:700;text-transform:uppercase;letter-spacing:.08em;margin-top:2px;">Feedback</div>' +
            '</div>' +
          '</div>' +

          '<div style="' + sectionTitleStyle + '">Actions rapides</div>' +
          '<button type="button" data-mnl-admin-act="launch" style="' + btnStyle + '"><span>Launch readiness audit</span></button>' +
          '<button type="button" data-mnl-admin-act="safety" style="' + btnStyle + '"><span>Safety check (backups)</span></button>' +
          '<button type="button" data-mnl-admin-act="export-nl" style="' + btnStyle + (nlCount === 0 ? 'opacity:.4;cursor:not-allowed;' : '') + '"' + (nlCount === 0 ? ' disabled' : '') + '><span>Télécharger CSV newsletter (' + nlCount + ')</span></button>' +
          '<button type="button" data-mnl-admin-act="export-fb" style="' + btnStyle + (fbCount === 0 ? 'opacity:.4;cursor:not-allowed;' : '') + '"' + (fbCount === 0 ? ' disabled' : '') + '><span>Télécharger CSV feedback (' + fbCount + ')</span></button>' +
          '<button type="button" data-mnl-admin-act="self-test" style="' + btnStyle + '"><span>Self-test runtime</span></button>' +

          '<div style="' + sectionTitleStyle + '">Marketing</div>' +
          '<button type="button" data-mnl-admin-act="launch-banner" style="' + btnStyle + '"><span>Bannière annonce site-wide</span></button>' +

          '<div style="' + sectionTitleStyle + '">Mode admin</div>' +
          '<button type="button" data-mnl-admin-act="hide-session" style="' + btnStyle + 'background:rgba(245,158,11,.12);border-color:rgba(245,158,11,.35);"><span>Cacher pour cette session</span></button>' +
          '<button type="button" data-mnl-admin-act="disable" style="' + btnStyle + 'background:rgba(239,68,68,.12);border-color:rgba(239,68,68,.35);"><span>Désactiver mode admin</span></button>';

        // Append au body
        try { document.body.appendChild(fab); document.body.appendChild(panel); } catch (_) { return; }

        // Toggle panel
        function setPanelOpen(open) {
          fab.setAttribute('aria-expanded', open ? 'true' : 'false');
          panel.setAttribute('aria-hidden', open ? 'false' : 'true');
          panel.style.display = open ? 'flex' : 'none';
        }
        fab.addEventListener('click', function () {
          setPanelOpen(panel.style.display !== 'flex');
        });
        document.getElementById('mnl-admin-close').addEventListener('click', function () { setPanelOpen(false); });
        // ESC ferme le panel
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && panel.style.display === 'flex') setPanelOpen(false);
        });

        // Health probe (live)
        function refreshHealth() {
          var dotEl = document.getElementById('mnl-admin-health-dot');
          var labelEl = document.getElementById('mnl-admin-health-label');
          var verEl = document.getElementById('mnl-admin-version');
          if (!dotEl || !labelEl) return;
          dotEl.style.background = '#64748b';
          labelEl.textContent = 'Test…';
          var ep = (window.MNL_METRICS_ENDPOINT && window.MNL_METRICS_ENDPOINT.replace(/\/api\/metrics.*$/, '/api/health'))
                   || 'https://mynutrilab-ai.vercel.app/api/health';
          var t0 = Date.now();
          fetch(ep, { method: 'GET', mode: 'cors', cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (j) {
              var lat = Date.now() - t0;
              if (j.status === 'ok') {
                dotEl.style.background = '#10b981';
                labelEl.textContent = '✓ ' + lat + 'ms · ' + (j.region || '?');
              } else {
                dotEl.style.background = '#f59e0b';
                labelEl.textContent = '' + (j.status || 'degraded') + ' · ' + lat + 'ms';
              }
              if (verEl) verEl.textContent = 'API v' + (j.version || '?') + ' · ' + (j.req_count || 0) + ' req';
            })
            .catch(function () {
              dotEl.style.background = '#ef4444';
              labelEl.textContent = '✗ unreachable';
              if (verEl) verEl.textContent = 'API offline ou CORS bloqué';
            });
        }
        refreshHealth();
        document.getElementById('mnl-admin-health-refresh').addEventListener('click', refreshHealth);

        // Action handler
        panel.addEventListener('click', async function (e) {
          var btn = e.target.closest('[data-mnl-admin-act]');
          if (!btn) return;
          var act = btn.getAttribute('data-mnl-admin-act');
          if (act === 'launch') {
            if (window.mnlToast) window.mnlToast({ icon: '', title: 'Audit en cours', sub: 'Voir la console DevTools (F12)…', type: 'info', duration: 4000 });
            if (typeof window.mnlLaunchReadiness === 'function') await window.mnlLaunchReadiness();
          } else if (act === 'safety') {
            if (typeof window.mnlSafetyCheck === 'function') window.mnlSafetyCheck();
            if (window.mnlToast) window.mnlToast({ icon: '', title: 'Safety check', sub: 'Résultats dans la console', type: 'info', duration: 3500 });
          } else if (act === 'export-nl') {
            if (typeof window.mnlExportNewsletterBackup === 'function') {
              var csv = window.mnlExportNewsletterBackup({ csv: true, download: true });
              if (csv && window.mnlToast) window.mnlToast({ icon: '✓', title: 'CSV newsletter téléchargé', sub: 'Importe dans Klaviyo puis re-ouvre le panel pour clear', type: 'success', duration: 5000 });
            }
          } else if (act === 'export-fb') {
            if (typeof window.mnlExportFeedbackBackup === 'function') {
              var csv2 = window.mnlExportFeedbackBackup({ csv: true, download: true });
              if (csv2 && window.mnlToast) window.mnlToast({ icon: '✓', title: 'CSV feedback téléchargé', sub: 'Voir Downloads', type: 'success', duration: 5000 });
            }
          } else if (act === 'self-test') {
            if (typeof window.mnlSelfTest === 'function') window.mnlSelfTest();
            if (window.mnlToast) window.mnlToast({ icon: '', title: 'Self-test runtime', sub: 'Voir la console', type: 'info', duration: 3500 });
          } else if (act === 'launch-banner') {
            // V236 : flow simple via mnlPrompt (utilise wrapper Promise V198)
            var currentCfg;
            try { currentCfg = JSON.parse(localStorage.getItem('mnl-launch-banner') || 'null'); } catch (_) {}
            var currentText = (currentCfg && currentCfg.text) || '';
            var promptOpts = {
              icon: '',
              title: 'Bannière annonce site-wide',
              message: currentText
                ? 'Modifier ou laisser vide pour désactiver. Conseil : "Lancement officiel — Premier lot livré sous 5 jours"'
                : 'Texte de la bannière (vide = désactivé). Conseil : "Lancement officiel — Premier lot livré sous 5 jours"',
              defaultValue: currentText,
              placeholder: 'Lancement officiel — Livraison offerte dès 49€',
              confirmText: currentText ? 'Mettre à jour' : 'Activer',
              cancelText: 'Annuler'
            };
            var handleResult = function (val) {
              if (val === null || val === undefined) return; // cancelled
              val = (val || '').trim().slice(0, 160);
              if (!val) {
                if (typeof window.mnlSetLaunchBanner === 'function') window.mnlSetLaunchBanner(null);
                if (window.mnlToast) window.mnlToast({ icon: '', title: 'Bannière désactivée', type: 'info', duration: 3000 });
              } else {
                if (typeof window.mnlSetLaunchBanner === 'function') {
                  window.mnlSetLaunchBanner({
                    text: val,
                    url: window.MNL_PRODUCT_URL || '/products/pre-workout-mynutrilab-personnalisable-au-mg-pres',
                    bg: 'gradient',
                    dismissible: true
                  });
                }
                if (window.mnlToast) window.mnlToast({ icon: '✓', title: 'Bannière publiée site-wide', sub: 'Visible par tous · re-click pour modifier', type: 'success', duration: 5000 });
              }
            };
            if (typeof window.mnlPrompt === 'function') {
              var p = window.mnlPrompt(promptOpts);
              if (p && typeof p.then === 'function') p.then(handleResult);
            } else {
              handleResult(window.prompt('Texte bannière (vide = OFF) :', currentText));
            }
          } else if (act === 'hide-session') {
            try { sessionStorage.setItem('mnl-admin-hidden', '1'); } catch (_) {}
            fab.remove(); panel.remove();
          } else if (act === 'disable') {
            try { localStorage.removeItem('mnl-admin'); sessionStorage.removeItem('mnl-admin-hidden'); } catch (_) {}
            fab.remove(); panel.remove();
            if (window.mnlToast) window.mnlToast({ icon: '', title: 'Mode admin désactivé', sub: 'Réactive : ?mnl-admin=1', type: 'info', duration: 4500 });
          }
        });

        // Console log discret pour rappeler l'état
        try {
          if (totalBk > 0) console.log('%cMNL Admin · ' + totalBk + ' backup(s) en attente', 'background:#f59e0b;color:#000;padding:3px 8px;border-radius:3px;font-weight:bold;', '— Click le bottom-right');
          else console.log('%cMNL Admin ON · tout green ✓', 'background:#10b981;color:#fff;padding:3px 8px;border-radius:3px;', '— mnlLaunchReadiness() pour audit complet');
        } catch (_) {}
      }, 1500);
    } catch (_) {}
  })();

  // ════════════ SCROLL RESTORATION (smart back navigation) ════════════
  // Save scroll position avant de quitter, restore au retour back/forward
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  window.addEventListener('beforeunload', function () {
    try {
      var key = 'mnl-scroll-' + window.location.pathname;
      sessionStorage.setItem(key, String(window.scrollY));
    } catch (_) {}
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      try {
        var key = 'mnl-scroll-' + window.location.pathname;
        var y = parseInt(sessionStorage.getItem(key), 10);
        if (!isNaN(y)) {
          setTimeout(function () { window.scrollTo({ top: y, behavior: 'instant' }); }, 50);
        }
      } catch (_) {}
    }
  });

  // ════════════ FLOATING LABELS (data-mnl-float wrap auto) ════════════
  // Pour <select> on track la value pour swap label
  document.addEventListener('change', function (e) {
    if (e.target.matches('.mnl-float select')) {
      e.target.classList.toggle('has-value', !!e.target.value);
    }
  });
  document.querySelectorAll('.mnl-float select').forEach(function (s) {
    s.classList.toggle('has-value', !!s.value);
  });

  // Auto-add placeholder=" " (required pour :placeholder-shown trick)
  function setupFloatingLabels() {
    document.querySelectorAll('.mnl-float input, .mnl-float textarea').forEach(function (input) {
      if (input.dataset.mnlFloatBound) return;
      input.dataset.mnlFloatBound = '1';
      if (!input.placeholder) input.placeholder = ' ';
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupFloatingLabels, 200);
  else setupFloatingLabels();

  // ════════════ TOOLTIP SMART AUTO-POSITIONING (anti-overflow + a11y focus) ════════════
  function checkTooltipOverflow(el) {
    if (el.dataset.mnlTooltipPos) return; // user-defined, skip
    var rect = el.getBoundingClientRect();
    var topNeeded = 60;
    var sideMargin = 80; // approx half tooltip width
    var vw = window.innerWidth;
    // Position : top par défaut, bottom si pas la place en haut
    if (rect.top < topNeeded) {
      el.setAttribute('data-mnl-tooltip-pos', 'bottom');
    }
    // Alignement horizontal : si trop à gauche → align left, si trop à droite → align right
    if (rect.left < sideMargin) {
      el.setAttribute('data-mnl-tooltip-align', 'left');
    } else if (rect.right > vw - sideMargin) {
      el.setAttribute('data-mnl-tooltip-align', 'right');
    }
  }
  function ensureTooltipChecked(el) {
    if (el && !el.dataset.mnlTooltipChecked) {
      el.dataset.mnlTooltipChecked = '1';
      checkTooltipOverflow(el);
    }
  }
  // Trigger sur hover ET sur focus clavier (a11y)
  document.addEventListener('mouseenter', function (e) {
    if (!e.target.closest) return;
    ensureTooltipChecked(e.target.closest('[data-mnl-tooltip]'));
    // Vague 110 : minicart hover preview — update dynamique du tooltip cart avec count + total
    var cartBtn = e.target.closest('#mnl-hd-cart-btn');
    if (cartBtn) _refreshCartTooltip(cartBtn);
  }, true);
  document.addEventListener('focusin', function (e) {
    if (!e.target.closest) return;
    ensureTooltipChecked(e.target.closest('[data-mnl-tooltip]'));
  });
  // Vague 110 : minicart preview au hover (desktop) — affiche count + total dans le tooltip natif
  // Avant : tooltip statique "Mon panier" sans info contextuelle.
  function _refreshCartTooltip(btn){
    if (!btn) return;
    try {
      // Lit le count + cached total localStorage (maintenu par cart drawer + main-cart)
      var count = parseInt(localStorage.getItem('mnl-cart-count') || '0', 10);
      var total = localStorage.getItem('mnl-cart-total-formatted') || '';
      var tip;
      if (count === 0) {
        tip = MNL_T('global.cart_empty_tip', 'Panier vide');
      } else {
        tip = count + ' article' + (count > 1 ? 's' : '');
        if (total) tip += ' · ' + total;
      }
      btn.setAttribute('data-mnl-tooltip', tip);
    } catch(_){}
  }
  // Reset à chaque resize (le viewport peut changer)
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-mnl-tooltip-checked]').forEach(function (el) {
      el.removeAttribute('data-mnl-tooltip-checked');
      el.removeAttribute('data-mnl-tooltip-pos');
      el.removeAttribute('data-mnl-tooltip-align');
    });
  });

  // ════════════ LOADING TOAST (async, with resolve/reject) ════════════
  window.mnlToastLoading = function (title, sub) {
    var t = window.mnlToast({ icon: '', title: title || MNL_T('global.toast_loading_default', 'En cours…'), sub: sub || '', type: 'info', duration: 999999 });
    t.classList.add('mnl-toast--loading');
    // Custom helpers
    t.success = function (newTitle, newSub) {
      var icon = t.querySelector('.mnl-toast__icon'); if (icon) icon.textContent = '✓';
      var titleEl = t.querySelector('.mnl-toast__title'); if (titleEl && newTitle) titleEl.textContent = newTitle;
      var subEl = t.querySelector('.mnl-toast__sub'); if (subEl && newSub) subEl.textContent = newSub;
      t.classList.remove('mnl-toast--info');
      t.classList.add('mnl-toast--success');
      setTimeout(function () { t.click(); }, 2500);
    };
    t.error = function (newTitle, newSub) {
      var icon = t.querySelector('.mnl-toast__icon'); if (icon) icon.textContent = '✗';
      var titleEl = t.querySelector('.mnl-toast__title'); if (titleEl && newTitle) titleEl.textContent = newTitle;
      var subEl = t.querySelector('.mnl-toast__sub'); if (subEl && newSub) subEl.textContent = newSub;
      t.classList.remove('mnl-toast--info');
      t.classList.add('mnl-toast--error');
      setTimeout(function () { t.click(); }, 4000);
    };
    t.update = function (newTitle, newSub) {
      var titleEl = t.querySelector('.mnl-toast__title'); if (titleEl && newTitle) titleEl.textContent = newTitle;
      var subEl = t.querySelector('.mnl-toast__sub'); if (subEl && newSub) subEl.textContent = newSub;
    };
    return t;
  };
  // Helper pour wrapper une promise
  window.mnlToastPromise = function (promise, opts) {
    opts = opts || {};
    var t = window.mnlToastLoading(opts.loading || MNL_T('global.loading_ellipsis', 'Chargement…'));
    return promise.then(function (val) {
      t.success(opts.success || MNL_T('global.toast_success_default', 'Succès !'));
      return val;
    }).catch(function (err) {
      t.error(opts.error || MNL_T('global.common_error', 'Erreur'), (err && err.message) || '');
      throw err;
    });
  };

  // ════════════ LIVE TIME RELATIVE UPDATER (data-mnl-time-relative="ISO") ════════════
  // Format un delta en label FR. Gère passé ET futur (préfixe "dans X" si futur).
  function formatRelativeFR(absDiff, isFuture) {
    var prefix = isFuture ? 'dans ' : 'il y a ';
    if (absDiff < 60) return isFuture ? MNL_T('global.time_imminent', 'imminent') : MNL_T('global.time_just_now', 'à l\'instant');
    if (absDiff < 3600) return prefix + Math.floor(absDiff / 60) + ' min';
    if (absDiff < 86400) return prefix + Math.floor(absDiff / 3600) + 'h';
    if (absDiff < 604800) return prefix + Math.floor(absDiff / 86400) + 'j';
    if (absDiff < 2592000) return prefix + Math.floor(absDiff / 604800) + ' sem';
    if (absDiff < 31536000) return prefix + Math.floor(absDiff / 2592000) + ' mois';
    var years = Math.floor(absDiff / 31536000);
    return prefix + years + ' an' + (years > 1 ? 's' : '');
  }
  function updateRelativeTimes() {
    document.querySelectorAll('[data-mnl-time-relative]').forEach(function (el) {
      var iso = el.getAttribute('data-mnl-time-relative');
      var ts = Date.parse(iso);
      if (isNaN(ts)) return;
      var diff = Math.floor((Date.now() - ts) / 1000);
      var relativeText = formatRelativeFR(Math.abs(diff), diff < 0);
      var relativeTitle = new Date(ts).toLocaleString('fr-FR');
      if (el.textContent !== relativeText) el.textContent = relativeText;
      if (el.title !== relativeTitle) el.title = relativeTitle;
    });
  }
  // Vague 61 : visibility gate (avant : tournait en onglet caché → drain batterie mobile)
  // Vague 68 : singleton anti-multiples — clear precédent si ce script s'exécute 2× (rare mais défense)
  if (window._mnlRelTimesInterval) { try { clearInterval(window._mnlRelTimesInterval); } catch (_) {} }
  window._mnlRelTimesInterval = setInterval(function(){
    if (document.visibilityState === 'visible') updateRelativeTimes();
  }, 60000);
  // Refresh une fois quand l'onglet redevient visible (sinon timestamps stale après 30 min en arrière-plan)
  if (!window._mnlRelTimesVisListener) {
    window._mnlRelTimesVisListener = function(){ if (document.visibilityState === 'visible') updateRelativeTimes(); };
    document.addEventListener('visibilitychange', window._mnlRelTimesVisListener);
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(updateRelativeTimes, 200);
  else updateRelativeTimes();

  // ════════════ CLICK-OUTSIDE UTILITY (data-mnl-click-outside-close) ════════════
  // Trigger un click sur [data-mnl-close] inside le panel
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-mnl-click-outside-close].is-open, [data-mnl-click-outside-close][open]').forEach(function (panel) {
      if (panel.contains(e.target)) return;
      // Find associated trigger to skip if click on it
      var triggerSel = panel.getAttribute('data-mnl-click-outside-trigger');
      if (triggerSel) {
        var trigger = document.querySelector(triggerSel);
        if (trigger && trigger.contains(e.target)) return;
      }
      var closeBtn = panel.querySelector('[data-mnl-close]');
      if (closeBtn) closeBtn.click();
      else { panel.classList.remove('is-open'); panel.removeAttribute('open'); }
    });
  });

  // ════════════ WEB VITALS TELEMETRY (LCP, INP, CLS, TTFB, FCP) ════════════
  // Mesure Core Web Vitals + envoie aux 3 analytics platforms (GA4, Plausible, Matomo) via le bridge.
  // INP a remplacé FID en 2024 comme métrique officielle Core Web Vital.
  // Buffer local toujours actif (utile pour mnlAudit() debug + analyse offline).
  // Vague 82 : RUM beacon → /api/metrics — endpoint built waves 78-79 recevait 0 data client.
  // sendBeacon() : non-bloquant, survit aux navigations (browser garantit la transmission).
  // Sampling 20% pour limiter coûts Vercel function invocations (RUM est volumineux).
  // Backend Vercel doit répondre rapidement et accepter du JSON via POST.
  var _vitalsBackendUrl = 'https://mynutrilab-ai.vercel.app/api/metrics';
  var _vitalsSample = Math.random() < 0.2; // 20% des sessions
  function reportVital(name, value, id) {
    try {
      var rounded = name === 'CLS' ? Math.round(value * 1000) / 1000 : Math.round(value);
      // Save to internal buffer (capped 50)
      var buf = JSON.parse(localStorage.getItem('mnl-web-vitals') || '[]');
      buf.push({ name: name, value: rounded, id: id, ts: Date.now(), path: window.location.pathname });
      if (buf.length > 50) buf = buf.slice(-50);
      localStorage.setItem('mnl-web-vitals', JSON.stringify(buf));
      // Dispatch custom event → auto-routé vers GA4 + Plausible + Matomo via le ga4Events bridge si on l'ajoute
      document.dispatchEvent(new CustomEvent('mnl:vitals:reported', { detail: { name: name, value: rounded, id: id, path: window.location.pathname } }));
      // GA4 direct (categorie Web Vitals dédiée — best practice Google)
      if (window.gtag) {
        try { window.gtag('event', 'web_vitals', { event_category: 'Web Vitals', event_label: name, value: rounded, metric_id: id, metric_value: rounded, non_interaction: true }); } catch (_) {}
      }
      // Plausible custom event (avec props)
      if (window.plausible) {
        try { window.plausible('Web Vital', { props: { metric: name, value: rounded } }); } catch (_) {}
      }
      // Vague 82 : beacon backend RUM (sample 20% des sessions)
      // Vague 84 : si offline / fetch fail, push vers Service Worker IDB queue (Background Sync replay)
      if (_vitalsSample && _vitalsBackendUrl) {
        try {
          var payload = JSON.stringify({
            type: 'web_vital',
            name: name,
            value: rounded,
            id: id || '',
            path: window.location.pathname,
            // Bucket device pour analyse (pas d'UA brut → RGPD friendly)
            device: (window.matchMedia && window.matchMedia('(max-width: 720px)').matches) ? 'mobile' : 'desktop',
            // Connection downlink si dispo (très utile pour corréler perf vs réseau)
            conn: (navigator.connection && navigator.connection.effectiveType) || 'unknown',
            ts: Date.now()
          });
          var beaconSent = false;
          if (navigator.sendBeacon) {
            // sendBeacon : non-blocking, survit à navigation. Blob avec text/plain pour éviter preflight CORS.
            var blob = new Blob([payload], { type: 'text/plain;charset=UTF-8' });
            beaconSent = navigator.sendBeacon(_vitalsBackendUrl, blob);
          }
          if (!beaconSent) {
            // Fallback fetch keepalive (Safari iOS < 14, ou sendBeacon refusé offline)
            fetch(_vitalsBackendUrl, { method: 'POST', body: payload, keepalive: true, headers: { 'Content-Type': 'text/plain' } })
              .catch(function(){
                // Vague 84 : si offline → push vers SW IDB queue (Background Sync)
                if (navigator.serviceWorker && navigator.serviceWorker.controller) {
                  try {
                    navigator.serviceWorker.controller.postMessage({
                      type: 'ENQUEUE_BEACON',
                      payload: { url: _vitalsBackendUrl, body: payload, method: 'POST', contentType: 'text/plain' }
                    });
                  } catch (_) {}
                }
              });
          }
        } catch (_) {}
      }
    } catch (_) {}
  }
  if ('PerformanceObserver' in window) {
    // LCP : Largest Contentful Paint
    try {
      new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        var last = entries[entries.length - 1];
        reportVital('LCP', last.renderTime || last.loadTime || last.startTime, last.id || '');
      }).observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (_) {}
    // FCP : First Contentful Paint (early signal)
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (e.name === 'first-contentful-paint') reportVital('FCP', e.startTime, '');
        });
      }).observe({ type: 'paint', buffered: true });
    } catch (_) {}
    // INP : Interaction to Next Paint (replaced FID en 2024 comme Core Web Vital officiel)
    // Tracke la pire interaction du parcours user
    try {
      var inpValue = 0;
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (e.interactionId && e.duration > inpValue) {
            inpValue = e.duration;
            reportVital('INP', inpValue, String(e.interactionId));
          }
        });
      }).observe({ type: 'event', buffered: true, durationThreshold: 16 });
    } catch (_) {}
    // FID legacy (pour compat dashboards anciens — sera deprecated)
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) { reportVital('FID', e.processingStart - e.startTime, e.name || ''); });
      }).observe({ type: 'first-input', buffered: true });
    } catch (_) {}
    // CLS : Cumulative Layout Shift — report final value au pagehide (best practice)
    try {
      var clsValue = 0;
      var clsEntries = [];
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (!e.hadRecentInput) { clsValue += e.value; clsEntries.push(e); }
        });
      }).observe({ type: 'layout-shift', buffered: true });
      // Report final CLS au pagehide (Google best practice)
      addEventListener('pagehide', function () { reportVital('CLS', clsValue); }, { once: true });
      // Aussi sur visibilitychange hidden (mobile : tab background)
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') reportVital('CLS', clsValue);
      });
    } catch (_) {}
  }
  // TTFB : Time To First Byte (network perf)
  // Vague 90 BUG fix : skip si TTFB négatif (Safari + Service Worker + cache hit peut retourner valeurs négatives)
  // → backend rejette `value < 0` avec 400 → pollue console + rate-limit IP.
  try {
    var nav = performance.getEntriesByType('navigation')[0];
    if (nav) {
      var ttfb = nav.responseStart - nav.requestStart;
      if (ttfb > 0 && isFinite(ttfb)) reportVital('TTFB', ttfb);
    }
  } catch (_) {}
  // LONG TASKS (>50ms blocking le main thread = ralentissement visible sur mobile)
  // Utile pour identifier quelles fonctions JS pénalisent la fluidité
  if ('PerformanceObserver' in window) {
    try {
      var longTaskCount = 0, longTaskTotal = 0;
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          longTaskCount++;
          longTaskTotal += e.duration;
        });
      }).observe({ type: 'longtask', buffered: true });
      // Report agrégé au pagehide (somme + count, pour éviter spam)
      addEventListener('pagehide', function () {
        if (longTaskCount > 0) {
          reportVital('LongTaskCount', longTaskCount);
          reportVital('LongTaskTotal', Math.round(longTaskTotal));
        }
      }, { once: true });
    } catch (_) {}
  }

  // ════════════ KEYBOARD SEQUENCES (vim-style: g+h home, g+s search, g+c cart, g+a account) ════════════
  var kbdSeqBuffer = '';
  var kbdSeqTimer;
  var kbdSeqIndicator;
  function showKbdSeq() {
    if (!kbdSeqIndicator) {
      kbdSeqIndicator = document.createElement('div');
      kbdSeqIndicator.className = 'mnl-kbd-seq-indicator';
      document.body.appendChild(kbdSeqIndicator);
    }
    kbdSeqIndicator.innerHTML = kbdSeqBuffer.split('').map(function (k) { return '<kbd>' + k.toUpperCase() + '</kbd>'; }).join(' + ');
    kbdSeqIndicator.classList.add('is-active');
  }
  function clearKbdSeq() {
    kbdSeqBuffer = '';
    if (kbdSeqIndicator) kbdSeqIndicator.classList.remove('is-active');
  }
  document.addEventListener('keydown', function (e) {
    if (e.target.matches('input,textarea,select,[contenteditable]')) return;
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    var key = e.key.toLowerCase();
    if (key === 'g' && !kbdSeqBuffer) {
      kbdSeqBuffer = 'g';
      showKbdSeq();
      clearTimeout(kbdSeqTimer);
      kbdSeqTimer = setTimeout(clearKbdSeq, 1500);
      e.preventDefault();
      return;
    }
    if (kbdSeqBuffer === 'g' && /^[a-z]$/.test(key)) {
      e.preventDefault();
      var path = null;
      if (key === 'h') path = '/';
      else if (key === 's') { window.dispatchEvent(new CustomEvent('mnl:search:open')); var sb = document.querySelector('[data-mnl-search-open]'); if (sb) sb.click(); clearKbdSeq(); return; }
      else if (key === 'c') path = '/cart';
      else if (key === 'a') path = '/pages/account'; /* Vague 150 : custom MNL account, pas Shopify generic */
      else if (key === 'p') path = '/products/pre-workout-mynutrilab-personnalisable-au-mg-pres';
      else if (key === 'l') path = '/pages/lab'; // V527 : handle réel
      else if (key === 'f') path = '/pages/faq';
      else if (key === 'w') path = '/pages/wishlist';kbdSeqBuffer += key;
      showKbdSeq();
      if (path) {
        setTimeout(function () { window.location.href = path; clearKbdSeq(); }, 200);
      } else {
        clearTimeout(kbdSeqTimer);
        kbdSeqTimer = setTimeout(clearKbdSeq, 800);
      }
    }
  });

  // ════════════ ERROR CATCHER (JS errors graceful UX) ════════════
  var errorShown = false;
  // Helper centralisé : log + dispatch + analytics
  function recordError(payload) {
    // Buffer localStorage (debug)
    try {
      var buf = JSON.parse(localStorage.getItem('mnl-errors') || '[]');
      buf.push(Object.assign({}, payload, { ts: Date.now(), path: window.location.pathname, ua: navigator.userAgent.slice(0, 80) }));
      if (buf.length > 30) buf = buf.slice(-30);
      localStorage.setItem('mnl-errors', JSON.stringify(buf));
    } catch (_) {}
    // Custom event → analytics & Sentry-like custom handlers
    try { document.dispatchEvent(new CustomEvent('mnl:error:caught', { detail: payload })); } catch (_) {}
    // GA4 exception event (standard Google Analytics 4 error tracking)
    if (window.gtag) {
      try { window.gtag('event', 'exception', { description: payload.msg, fatal: false, page: window.location.pathname }); } catch (_) {}
    }
  }
  window.addEventListener('error', function (e) {
    // Skip non-application errors (3rd-party scripts often)
    if (e.filename && (e.filename.indexOf('cdn.shopify.com') !== -1 || e.filename.indexOf('mynutrilab') === -1)) return;
    recordError({ type: 'js', msg: e.message, file: e.filename, line: e.lineno, col: e.colno, stack: (e.error && e.error.stack) ? String(e.error.stack).slice(0, 500) : '' });
    // V2.0 FIX : le bandeau visible « Petit pépin technique » ne s'affiche QU'EN debug.
    //   90% des visiteurs sont sur mobile → un toast d'erreur à la moindre exception (ex : flux SSE du chat
    //   annulé quand on réduit la fenêtre) ruine l'UX. recordError garde la trace pour le diagnostic admin.
    var _mnlErrDbg = false;
    try { _mnlErrDbg = /[?&]mnl-debug/.test(location.search) || localStorage.getItem('mnl-debug') === '1'; } catch(_){}
    if (!_mnlErrDbg) return;
    if (errorShown) return;
    errorShown = true;
    setTimeout(function () { errorShown = false; }, 8000); // Cooldown
    var banner = document.createElement('div');
    banner.className = 'mnl-error-banner';
    banner.setAttribute('role', 'alert');
    banner.innerHTML =
      '<span class="mnl-error-banner__icon" aria-hidden="true"></span>' +
      '<div class="mnl-error-banner__body">' +
        MNL_T('global.errbanner_title_html', '<p class="mnl-error-banner__title">Petit pépin technique</p>') +
        MNL_T('global.errbanner_msg_html', '<p class="mnl-error-banner__msg">On a détecté une erreur. Si ça persiste, recharge la page ou écris-nous.</p>') +
      '</div>' +
      MNL_T('global.errbanner_close_html', '<button type="button" class="mnl-error-banner__close" aria-label="Fermer">×</button>');
    document.body.appendChild(banner);
    banner.querySelector('.mnl-error-banner__close').addEventListener('click', function () { banner.remove(); });
    setTimeout(function () { if (banner.parentNode) banner.remove(); }, 8000);
  });
  window.addEventListener('unhandledrejection', function (e) {
    recordError({ type: 'promise', msg: 'Promise rejected: ' + (e.reason && e.reason.message || e.reason || 'unknown'), stack: (e.reason && e.reason.stack) ? String(e.reason.stack).slice(0, 500) : '' });
  });

  // ════════════ V593 : VISUALISEUR D'ERREURS ON-SCREEN (debug mobile/iPad sans console) ════════════
  // Activé UNIQUEMENT via ?mnl-debug=errors dans l'URL → affiche le buffer mnl-errors (lisible + copiable).
  // Invisible pour les visiteurs normaux. Sert à diagnostiquer les erreurs sur appareils sans dev-tools (iPad).
  (function () {
    try {
      if ((location.search || '').indexOf('mnl-debug=errors') === -1) return;
      function _esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
      function _renderDebug() {
        var buf = [];
        try { buf = JSON.parse(localStorage.getItem('mnl-errors') || '[]'); } catch (_) {}
        var box = document.createElement('div');
        box.id = 'mnl-debug-errors';
        box.style.cssText = 'position:fixed;inset:6px;z-index:2147483647;background:#0f172a;color:#e2e8f0;font:12px/1.55 ui-monospace,Menlo,Consolas,monospace;padding:14px;overflow:auto;border-radius:12px;box-shadow:0 12px 48px rgba(0,0,0,.7);-webkit-overflow-scrolling:touch;';
        var html = '<div style="display:flex;justify-content:space-between;align-items:center;gap:10px;margin-bottom:10px;">' +
          '<strong style="font-size:14px;">Erreurs MNL (' + buf.length + ')</strong>' +
          '<button id="mnl-dbg-x" style="background:#ef4444;color:#fff;border:none;border-radius:8px;padding:8px 14px;font-weight:800;font-family:inherit;">Fermer</button></div>';
        html += '<p style="color:#94a3b8;margin:0 0 10px;word-break:break-all;">UA : ' + _esc(navigator.userAgent) + '</p>';
        if (!buf.length) {
          html += '<p style="color:#22c55e;">Aucune erreur enregistrée. Ouvre le chat IA d\'abord (pour déclencher l\'erreur), puis recharge cette page.</p>';
        } else {
          buf.slice().reverse().forEach(function (e, i) {
            html += '<div style="border-top:1px solid #334155;padding:9px 0;">' +
              '<strong style="color:#fbbf24;">#' + (buf.length - i) + ' [' + _esc(e.type) + ']</strong> <span style="color:#64748b;">' + _esc(e.path || '') + '</span><br>' +
              '<span style="color:#f87171;font-weight:700;">' + _esc(e.msg) + '</span><br>' +
              '<span style="color:#94a3b8;">' + _esc(e.file) + ' : L' + _esc(e.line) + ':' + _esc(e.col) + '</span>' +
              (e.stack ? '<div style="color:#64748b;white-space:pre-wrap;margin-top:4px;">' + _esc(e.stack) + '</div>' : '') +
              '</div>';
          });
        }
        box.innerHTML = html;
        document.body.appendChild(box);
        var x = document.getElementById('mnl-dbg-x'); if (x) x.addEventListener('click', function () { box.remove(); });
      }
      if (document.body) _renderDebug(); else document.addEventListener('DOMContentLoaded', _renderDebug);
    } catch (_) {}
  })();

  // ════════════ RESIZE OBSERVER UTILITY (data-mnl-resize-class breakpoints) ════════════
  // <div data-mnl-resize-class data-mnl-resize-sm="320" data-mnl-resize-md="640" data-mnl-resize-lg="900">
  if ('ResizeObserver' in window) {
    var resizeObs = new ResizeObserver(function (entries) {
      entries.forEach(function (e) {
        var el = e.target;
        var w = e.contentRect.width;
        var sm = parseInt(el.getAttribute('data-mnl-resize-sm'), 10) || 0;
        var md = parseInt(el.getAttribute('data-mnl-resize-md'), 10) || 0;
        var lg = parseInt(el.getAttribute('data-mnl-resize-lg'), 10) || 0;
        el.classList.toggle('is-sm', sm && w < sm);
        el.classList.toggle('is-md', md && w >= sm && w < md);
        el.classList.toggle('is-lg', lg && w >= lg);
      });
    });
    function bindResize() {
      document.querySelectorAll('[data-mnl-resize-class]').forEach(function (el) {
        if (el.dataset.mnlResizeBound) return;
        el.dataset.mnlResizeBound = '1';
        resizeObs.observe(el);
      });
    }
    if (window.mnlOnDomChange) window.mnlOnDomChange(bindResize, 200);
    else bindResize();
  }

  // ════════════ DARK MODE TOGGLE ════════════
  // Vague 123 : système de thème enrichi — support mode "system" (auto-sync OS).
  // 3 valeurs possibles dans localStorage : 'dark' | 'light' | 'system' (ou null = défaut = system).
  // Avant : prefers-color-scheme désactivé par défaut → la marque s'imposait. Maintenant : on respecte l'OS au premier visit.
  var savedTheme;
  try { savedTheme = localStorage.getItem('mnl-theme'); } catch (_) {}
  function _systemPrefersDark(){ return !!(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches); }
  function _resolveTheme(saved){
    if (saved === 'dark' || saved === 'light') return saved;
    // null ou 'system' → suit l'OS
    return _systemPrefersDark() ? 'dark' : 'light';
  }
  // Apply initial
  var initialTheme = _resolveTheme(savedTheme);
  if (initialTheme === 'dark') document.documentElement.setAttribute('data-theme', 'dark');
  // Vague 123 : écoute les changements de prefers-color-scheme (user toggle OS settings) si mode 'system'
  if (window.matchMedia) {
    var mql = window.matchMedia('(prefers-color-scheme: dark)');
    var _osChangeListener = function(){
      var cur;
      try { cur = localStorage.getItem('mnl-theme'); } catch(_){}
      // Auto-update SEULEMENT si user est en mode 'system' (ou n'a jamais choisi)
      if (cur === null || cur === 'system') {
        var newTheme = _systemPrefersDark() ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', newTheme);
        document.dispatchEvent(new CustomEvent('mnl:theme:changed', { detail: { theme: newTheme, source: 'system' } }));
      }
    };
    try {
      if (mql.addEventListener) mql.addEventListener('change', _osChangeListener);
      else if (mql.addListener) mql.addListener(_osChangeListener); // Safari < 14
    } catch(_){}
  }
  window.mnlSetTheme = function (theme, opts) {
    // Vague 145 : opts.skipPersist = true permet le hover-preview sans écraser le choix sauvegardé
    var skipPersist = !!(opts && opts.skipPersist);
    // Accept 'system' to revert to OS preference
    if (theme === 'system') {
      if (!skipPersist) { try { localStorage.setItem('mnl-theme', 'system'); } catch (_) {} }
      var resolved = _systemPrefersDark() ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', resolved);
      var meta0 = document.querySelector('meta[name="theme-color"]:not([media])') || document.createElement('meta');
      if (!meta0.parentNode) { meta0.name = 'theme-color'; document.head.appendChild(meta0); }
      meta0.content = resolved === 'dark' ? '#0f172a' : '#ff652e';
      document.dispatchEvent(new CustomEvent('mnl:theme:changed', { detail: { theme: resolved, source: skipPersist ? 'preview' : 'system' } }));
      return;
    }
    document.documentElement.setAttribute('data-theme', theme);
    if (!skipPersist) { try { localStorage.setItem('mnl-theme', theme); } catch (_) {} }
    // Force le theme-color de la barre URL mobile (override les meta media-queries quand toggle manuel)
    var meta = document.querySelector('meta[name="theme-color"]:not([media])') || document.createElement('meta');
    if (!meta.parentNode) { meta.name = 'theme-color'; document.head.appendChild(meta); }
    meta.content = theme === 'dark' ? '#0f172a' : '#ff652e';
    document.dispatchEvent(new CustomEvent('mnl:theme:changed', { detail: { theme: theme, source: skipPersist ? 'preview' : 'user' } }));
  };
  window.mnlToggleTheme = function () {
    var current = document.documentElement.getAttribute('data-theme') || 'light';
    var next = current === 'dark' ? 'light' : 'dark';
    window.mnlSetTheme(next);
    if (window.mnlToast) window.mnlToast({ icon: next === 'dark' ? '' : '', title: MNL_T('global.theme_mode_prefix', 'Mode ') + (next === 'dark' ? MNL_T('global.theme_dark', 'sombre') : MNL_T('global.theme_light', 'clair')) + MNL_T('global.theme_enabled_suffix', ' activé'), type: 'info', duration: 2000 });
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-theme-toggle]');
    if (btn) {
      e.preventDefault();
      btn.classList.add('is-rotating');
      setTimeout(function () { btn.classList.remove('is-rotating'); }, 350);
      window.mnlToggleTheme();
      var icon = btn.querySelector('.mnl-theme-toggle__icon');
      if (icon) icon.textContent = (document.documentElement.getAttribute('data-theme') === 'dark') ? '' : '';
    }
  });
  // Init theme toggle icons
  document.querySelectorAll('[data-mnl-theme-toggle] .mnl-theme-toggle__icon').forEach(function (icon) {
    icon.textContent = (document.documentElement.getAttribute('data-theme') === 'dark') ? '' : '';
  });

  // ════════════ READ MORE / LESS (data-mnl-readmore="120" → max-height collapsed) ════════════
  function setupReadmore() {
    document.querySelectorAll('[data-mnl-readmore]').forEach(function (container) {
      if (container.dataset.mnlReadmoreBound) return;
      var collapsedHeight = parseInt(container.getAttribute('data-mnl-readmore'), 10) || 120;
      // Mesure scrollHeight AVANT d'appliquer max-height (sinon mesure tronquée)
      var naturalHeight = container.scrollHeight;
      // Skip si le contenu fit déjà — ne marque PAS comme bound (re-essai possible si DOM grandit)
      if (naturalHeight <= collapsedHeight + 5) return;
      container.dataset.mnlReadmoreBound = '1';
      container.style.maxHeight = collapsedHeight + 'px';
      container.classList.add('mnl-readmore');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mnl-readmore__btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = container.getAttribute('data-mnl-readmore-more') || MNL_T('global.readmore_more', 'Lire plus');
      var moreText = btn.textContent;
      var lessText = container.getAttribute('data-mnl-readmore-less') || MNL_T('global.readmore_less', 'Lire moins');
      container.parentNode.insertBefore(btn, container.nextSibling);
      btn.addEventListener('click', function () {
        var expanded = container.classList.toggle('is-expanded');
        btn.textContent = expanded ? lessText : moreText;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (!expanded) container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  }
  // Migré vers mnlOnDomChange (1 observer partagé au lieu de N indépendants)
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupReadmore, 300);
  else setupReadmore();

  // ════════════ FILE UPLOAD DRAG-AND-DROP (data-mnl-upload) ════════════
  function setupUploads() {
    document.querySelectorAll('[data-mnl-upload]').forEach(function (container) {
      if (container.dataset.mnlUploadBound) return;
      container.dataset.mnlUploadBound = '1';
      container.classList.add('mnl-upload');
      var maxFiles = parseInt(container.getAttribute('data-mnl-upload-max'), 10) || 5;
      var accept = container.getAttribute('data-mnl-upload-accept') || 'image/*';
      var maxSize = parseInt(container.getAttribute('data-mnl-upload-max-size'), 10) || 5; // MB
      container.innerHTML =
        '<input type="file" name="' + (container.getAttribute('data-mnl-upload-name') || 'files') + MNL_T('global.upload_input_html', '" multiple aria-label="Choisir des fichiers" accept="') + accept + '">' +
        '<div class="mnl-upload__icon" aria-hidden="true"></div>' +
        '<p class="mnl-upload__title">' + (container.getAttribute('data-mnl-upload-title') || MNL_T('global.upload_default_title', 'Glisse tes fichiers ici')) + '</p>' +
        MNL_T('global.upload_sub_prefix_html', '<p class="mnl-upload__sub">ou <strong>clique pour parcourir</strong> · max ') + maxFiles + MNL_T('global.upload_sub_files_html', ' fichiers · ') + maxSize + MNL_T('global.upload_sub_size_html', ' MB chacun</p>') +
        '<div class="mnl-upload__previews"></div>';
      var input = container.querySelector('input[type="file"]');
      var previews = container.querySelector('.mnl-upload__previews');
      var files = [];
      function renderPreviews() {
        previews.innerHTML = files.map(function (f, i) {
          var src = URL.createObjectURL(f);
          return '<div class="mnl-upload__preview" data-idx="' + i + '"><img src="' + src + '" alt=""><button type="button" class="mnl-upload__preview-remove" data-remove-idx="' + i + '" aria-label="Retirer">×</button></div>';
        }).join('');
      }
      function addFiles(newFiles) {
        Array.from(newFiles).forEach(function (f) {
          if (files.length >= maxFiles) {
            if (window.mnlToastWarn) window.mnlToastWarn(MNL_T('global.upload_limit_title', 'Limite atteinte'), MNL_T('global.upload_limit_prefix', 'Maximum ') + maxFiles + MNL_T('global.upload_files_suffix', ' fichiers'));
            return;
          }
          if (f.size > maxSize * 1024 * 1024) {
            if (window.mnlToastError) window.mnlToastError(MNL_T('global.upload_toobig_title', 'Fichier trop lourd'), f.name + MNL_T('global.upload_toobig_middle', ' fait plus de ') + maxSize + ' MB');
            return;
          }
          files.push(f);
        });
        renderPreviews();
        // Sync vers input (pour submit form)
        var dt = new DataTransfer();
        files.forEach(function (f) { dt.items.add(f); });
        input.files = dt.files;
        container.dispatchEvent(new CustomEvent('mnl:upload:change', { detail: { files: files } }));
      }
      input.addEventListener('change', function (e) {
        addFiles(e.target.files);
        input.value = ''; // reset pour permettre re-add même fichier
      });
      ['dragenter', 'dragover'].forEach(function (ev) {
        container.addEventListener(ev, function (e) { e.preventDefault(); container.classList.add('is-dragging'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        container.addEventListener(ev, function (e) { e.preventDefault(); container.classList.remove('is-dragging'); });
      });
      container.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
      });
      previews.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-remove-idx]');
        if (btn) {
          e.preventDefault();
          var idx = parseInt(btn.getAttribute('data-remove-idx'), 10);
          files.splice(idx, 1);
          renderPreviews();
          var dt = new DataTransfer();
          files.forEach(function (f) { dt.items.add(f); });
          input.files = dt.files;
        }
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupUploads, 300);
  else setupUploads();

  // ════════════ MULTISTEP FORM (data-mnl-multistep) ════════════
  function setupMultistep() {
    document.querySelectorAll('[data-mnl-multistep]').forEach(function (container) {
      if (container.dataset.mnlMultiBuilt) return;
      var steps = container.querySelectorAll('[data-mnl-multistep-step]');
      if (steps.length < 2) return; // bail AVANT de marquer built (sinon ré-essai impossible si DOM update)
      container.dataset.mnlMultiBuilt = '1';
      var labels = Array.from(steps).map(function (s) { return s.getAttribute('data-mnl-multistep-label') || MNL_T('global.multistep_default_label', 'Étape'); });
      var current = 0;
      container.classList.add('mnl-multistep');
      // Build progress bar
      var progress = document.createElement('div');
      progress.className = 'mnl-multistep__progress';
      progress.innerHTML = labels.map(function (l, i) {
        return '<div class="mnl-multistep__progress-step" data-idx="' + i + '">' +
          '<div class="mnl-multistep__progress-num">' + (i + 1) + '</div>' +
          '<p class="mnl-multistep__progress-label">' + l + '</p>' +
        '</div>';
      }).join('');
      container.insertBefore(progress, container.firstChild);
      steps.forEach(function (s) { s.classList.add('mnl-multistep__step'); });
      // Build nav
      var nav = document.createElement('div');
      nav.className = 'mnl-multistep__nav';
      nav.innerHTML = MNL_T('global.multistep_prev_html', '<button type="button" class="mnl-multistep__nav-btn mnl-multistep__nav-btn--prev" disabled>← Précédent</button>') +
        MNL_T('global.multistep_next_html', '<button type="button" class="mnl-multistep__nav-btn mnl-multistep__nav-btn--next">Suivant →</button>');
      container.appendChild(nav);
      var prevBtn = nav.querySelector('.mnl-multistep__nav-btn--prev');
      var nextBtn = nav.querySelector('.mnl-multistep__nav-btn--next');
      function updateUI() {
        steps.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        progress.querySelectorAll('.mnl-multistep__progress-step').forEach(function (p, i) {
          p.classList.toggle('is-current', i === current);
          p.classList.toggle('is-done', i < current);
        });
        prevBtn.disabled = current === 0;
        nextBtn.textContent = current === steps.length - 1 ? MNL_T('global.multistep_validate', 'Valider ✓') : MNL_T('global.multistep_next', 'Suivant →');
        nextBtn.classList.toggle('mnl-multistep__nav-btn--submit', current === steps.length - 1);
        container.dispatchEvent(new CustomEvent('mnl:multistep:change', { detail: { current: current, total: steps.length } }));
      }
      function validateCurrentStep() {
        var step = steps[current];
        var inputs = step.querySelectorAll('input[required], textarea[required], select[required]');
        var allValid = true;
        inputs.forEach(function (input) {
          if (!input.checkValidity()) { input.reportValidity(); allValid = false; }
        });
        return allValid;
      }
      prevBtn.addEventListener('click', function () { if (current > 0) { current--; updateUI(); } });
      nextBtn.addEventListener('click', function () {
        if (!validateCurrentStep()) return;
        if (current < steps.length - 1) { current++; updateUI(); }
        else container.dispatchEvent(new CustomEvent('mnl:multistep:submit', { detail: {} }));
      });
      updateUI();
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupMultistep, 300);
  else setupMultistep();

  // ════════════ ACCORDION GROUP (one open at a time) ════════════
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('[data-mnl-accordion-item] summary, [data-mnl-accordion-item] [data-mnl-accordion-header]');
    if (!summary) return;
    var item = summary.closest('[data-mnl-accordion-item]');
    var group = item.closest('[data-mnl-accordion-group]');
    if (!group) return;
    // Délai pour laisser le toggle native se faire
    setTimeout(function () {
      group.querySelectorAll('[data-mnl-accordion-item]').forEach(function (otherItem) {
        if (otherItem === item) return;
        if (otherItem.tagName.toLowerCase() === 'details') otherItem.open = false;
        else otherItem.classList.remove('is-open');
      });
    }, 0);
  });

  // ════════════ IMAGE HOTSPOTS (data-mnl-hotspots) ════════════
  function setupHotspots() {
    document.querySelectorAll('[data-mnl-hotspots]').forEach(function (container) {
      if (container.dataset.mnlHotspotsBound) return;
      container.dataset.mnlHotspotsBound = '1';
      container.classList.add('mnl-hotspots');
      var hotspots;
      try { hotspots = JSON.parse(container.getAttribute('data-mnl-hotspots')); } catch (_) { return; }
      hotspots.forEach(function (h, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mnl-hotspot';
        btn.style.left = h.x + '%';
        btn.style.top = h.y + '%';
        btn.setAttribute('aria-label', h.title || MNL_T('global.hotspot_detail_prefix', 'Détail ') + (i + 1));
        btn.innerHTML = '+' +
          '<div class="mnl-hotspot__popover" role="tooltip">' +
            (h.title ? '<p class="mnl-hotspot__popover-title">' + h.title + '</p>' : '') +
            (h.text || '') +
          '</div>';
        container.appendChild(btn);
      });
    });
  }
  document.addEventListener('click', function (e) {
    var hs = e.target.closest('.mnl-hotspot');
    if (hs) {
      e.stopPropagation();
      var was = hs.classList.contains('is-active');
      document.querySelectorAll('.mnl-hotspot.is-active').forEach(function (h) { h.classList.remove('is-active'); });
      if (!was) hs.classList.add('is-active');
    } else if (!e.target.closest('.mnl-hotspot__popover')) {
      document.querySelectorAll('.mnl-hotspot.is-active').forEach(function (h) { h.classList.remove('is-active'); });
    }
  });
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupHotspots, 300);
  else setupHotspots();

  // ════════════ SMART I18N FORMATTERS ════════════
  window.mnlFormat = {
    currency: function (cents, currency) {
      try {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
      } catch (_) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
    },
    number: function (n, opts) {
      try { return new Intl.NumberFormat('fr-FR', opts || {}).format(n); }
      catch (_) { return String(n); }
    },
    percent: function (n) {
      try { return new Intl.NumberFormat('fr-FR', { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 1 }).format(n); }
      catch (_) { return Math.round(n * 100) + '%'; }
    },
    date: function (d, opts) {
      var date = (d instanceof Date) ? d : new Date(d);
      try { return new Intl.DateTimeFormat('fr-FR', opts || { dateStyle: 'long' }).format(date); }
      catch (_) { return date.toLocaleDateString('fr-FR'); }
    },
    weight: function (g) {
      if (g >= 1000) return (g / 1000).toFixed(g % 1000 === 0 ? 0 : 1) + ' kg';
      return g + ' g';
    }
  };
  // Auto-format <span data-mnl-format-currency="cents">
  function applyAutoFormat() {
    document.querySelectorAll('[data-mnl-format-currency]:not([data-mnl-formatted])').forEach(function (el) {
      el.textContent = window.mnlFormat.currency(parseInt(el.getAttribute('data-mnl-format-currency'), 10) || 0);
      el.setAttribute('data-mnl-formatted', '1');
    });
    document.querySelectorAll('[data-mnl-format-number]:not([data-mnl-formatted])').forEach(function (el) {
      el.textContent = window.mnlFormat.number(parseFloat(el.getAttribute('data-mnl-format-number')) || 0);
      el.setAttribute('data-mnl-formatted', '1');
    });
    document.querySelectorAll('[data-mnl-format-date]:not([data-mnl-formatted])').forEach(function (el) {
      el.textContent = window.mnlFormat.date(el.getAttribute('data-mnl-format-date'));
      el.setAttribute('data-mnl-formatted', '1');
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(applyAutoFormat, 200);
  else applyAutoFormat();

  // ════════════ CARD FLIP ════════════
  document.addEventListener('click', function (e) {
    var flip = e.target.closest('[data-mnl-flip]');
    if (!flip) return;
    flip.classList.toggle('is-flipped');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      var flip = e.target.closest('[data-mnl-flip]');
      if (flip) { e.preventDefault(); flip.classList.toggle('is-flipped'); }
    }
  });

  // ════════════ TEXT-TO-SPEECH (data-mnl-tts-trigger="selector") ════════════
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-tts-trigger]');
    if (!btn) return;
    e.preventDefault();
    if (!window.speechSynthesis) {
      if (window.mnlToastWarn) window.mnlToastWarn(MNL_T('global.unsupported_title', 'Non supporté'), MNL_T('global.tts_unsupported_sub', 'Ton navigateur ne supporte pas la synthèse vocale'));
      return;
    }
    var sel = btn.getAttribute('data-mnl-tts-trigger');
    var target = sel ? document.querySelector(sel) : btn.parentNode;
    if (!target) return;
    if (btn.classList.contains('is-speaking')) {
      window.speechSynthesis.cancel();
      btn.classList.remove('is-speaking');
      return;
    }
    var text = target.textContent.trim();
    if (!text) return;
    window.speechSynthesis.cancel();
    var utt = new SpeechSynthesisUtterance(text.slice(0, 4000)); // Limit
    // Détecte la langue depuis le DOM (target/closest [lang]) sinon HTML lang sinon fr-FR
    var langSrc = target.closest('[lang]') || document.documentElement;
    utt.lang = (langSrc && langSrc.getAttribute('lang')) || 'fr-FR';
    utt.rate = parseFloat(btn.getAttribute('data-mnl-tts-rate')) || 1;
    utt.pitch = 1;
    // Vague 68 : volume baissé par défaut à 0.85 (1.0 = trop fort en bureau silencieux + accessibilité auditive)
    // + override possible via data-mnl-tts-volume="0.5" pour contenu sensible
    var volRaw = parseFloat(btn.getAttribute('data-mnl-tts-volume'));
    utt.volume = isNaN(volRaw) ? 0.85 : Math.max(0, Math.min(1, volRaw));
    utt.onstart = function () { btn.classList.add('is-speaking'); };
    utt.onend = utt.onerror = function () { btn.classList.remove('is-speaking'); };
    window.speechSynthesis.speak(utt);
  });
  // Cancel speech au quit/unload (sinon ça continue sur la page suivante en SPA-like nav)
  window.addEventListener('beforeunload', function () {
    if (window.speechSynthesis) try { window.speechSynthesis.cancel(); } catch (_) {}
  });
  window.addEventListener('pagehide', function () {
    if (window.speechSynthesis) try { window.speechSynthesis.cancel(); } catch (_) {}
  });
  // Vague 68 : pause TTS quand l'onglet devient caché (sinon continue en background, drain batterie + UX bizarre)
  document.addEventListener('visibilitychange', function () {
    if (document.hidden && window.speechSynthesis && window.speechSynthesis.speaking) {
      try { window.speechSynthesis.cancel(); } catch (_) {}
      // Reset des boutons en état "is-speaking"
      document.querySelectorAll('[data-mnl-tts-trigger].is-speaking').forEach(function(b){
        b.classList.remove('is-speaking');
      });
    }
  });

  // ════════════ REDIRECT COUNTDOWN (data-mnl-redirect="url" data-mnl-redirect-delay="5") ════════════
  function setupRedirects() {
    document.querySelectorAll('[data-mnl-redirect]').forEach(function (container) {
      if (container.dataset.mnlRedirectBound) return;
      var url = container.getAttribute('data-mnl-redirect');
      // Open-redirect protection : on accepte uniquement les URL relatives ou same-origin (anti-phishing)
      try {
        var parsed = new URL(url, window.location.origin);
        if (parsed.origin !== window.location.origin) {
          console.warn('[mnl-redirect] cross-origin URL bloquée :', url);
          return;
        }
        url = parsed.href;
      } catch (_) { return; }
      var delay = Math.max(1, parseInt(container.getAttribute('data-mnl-redirect-delay'), 10) || 5);
      var msg = container.getAttribute('data-mnl-redirect-message') || MNL_T('global.redirect_default_msg', 'Redirection dans');
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }
      container.dataset.mnlRedirectBound = '1';
      container.classList.add('mnl-redirect');
      container.innerHTML = '<span aria-hidden="true">⏱</span><span>' + esc(msg) + ' <span class="mnl-redirect__count">' + delay + MNL_T('global.redirect_cancel_html', '</span>s…</span><button type="button" class="mnl-redirect__cancel">Annuler</button>');
      var cancelBtn = container.querySelector('.mnl-redirect__cancel');
      var countEl = container.querySelector('.mnl-redirect__count');
      var remaining = delay;
      var interval = setInterval(function () {
        remaining--;
        countEl.textContent = remaining;
        if (remaining <= 0) {
          clearInterval(interval);
          window.location.href = url;
        }
      }, 1000);
      cancelBtn.addEventListener('click', function () {
        clearInterval(interval);
        container.style.display = 'none';
        if (window.mnlToast) window.mnlToast({ icon: '✓', title: MNL_T('global.redirect_cancelled', 'Redirection annulée'), type: 'info', duration: 2500 });
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupRedirects, 200);
  else setupRedirects();

  // ════════════ NAV GUARD (form unsaved → confirm before leave) ════════════
  // <form data-mnl-guard data-mnl-guard-message="Tu as des modifs non sauvées">
  function setupNavGuards() {
    document.querySelectorAll('form[data-mnl-guard]').forEach(function (form) {
      if (form.dataset.mnlGuardBound) return;
      form.dataset.mnlGuardBound = '1';
      var initialState = serializeForm(form);
      var saved = false;
      function isDirty() { return !saved && serializeForm(form) !== initialState; }
      window.addEventListener('beforeunload', function (e) {
        if (isDirty()) { e.preventDefault(); e.returnValue = ''; return ''; }
      });
      form.addEventListener('submit', function () { saved = true; });
      // Intercept clic sur lien interne quand dirty
      document.addEventListener('click', function (e) {
        if (!isDirty()) return;
        var a = e.target.closest('a[href]');
        if (!a || a.target === '_blank') return;
        var href = a.getAttribute('href');
        if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
        e.preventDefault();
        var msg = form.getAttribute('data-mnl-guard-message') || MNL_T('global.guard_default_msg', 'Tu as des modifications non sauvegardées. Quitter quand même ?');
        if (window.mnlConfirm) {
          window.mnlConfirm({
            type: 'warn',
            icon: '',
            title: MNL_T('global.guard_title', 'Modifications non sauvées'),
            message: msg,
            confirmText: MNL_T('global.guard_leave', 'Quitter sans sauver'),
            cancelText: MNL_T('global.guard_stay', 'Rester')
          }).then(function (ok) {
            if (ok) { saved = true; window.location.href = a.href; }
          });
        } else {
          /* V1255 — ce repli faisait exactement ce que le panneau asynchrone est censé éviter.
             AVANT : `saved = true; window.location.href = a.href;`. Le commentaire promettait que
             « le handler beforeunload affichera le dialog browser-natif », mais `saved = true`
             rend justement isDirty() faux (l.8527) : le garde beforeunload ne se déclenchait PLUS.
             Résultat : clic sur un lien avec un formulaire modifié = navigation immédiate, sans
             une seule question, et les modifications perdues. Le code partait du principe que
             l'utilisateur avait dit oui.
             MAINTENANT : on pose la question. Ici la boîte native est le bon outil — elle est
             SYNCHRONE et renvoie un booléen, donc la décision est prise avant la navigation.
             `saved` n'est mis à vrai que si l'utilisateur accepte de quitter ; s'il refuse, on ne
             navigue pas et le garde beforeunload reste armé pour la fois d'après. */
          if (window.confirm(msg)) {
            saved = true;
            window.location.href = a.href;
          }
        }
      }, true);
    });
  }
  function serializeForm(form) {
    var data = {};
    Array.from(form.elements).forEach(function (el) {
      if (!el.name) return;
      if (el.type === 'checkbox' || el.type === 'radio') data[el.name] = el.checked;
      else data[el.name] = el.value;
    });
    return JSON.stringify(data);
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupNavGuards, 300);
  else setupNavGuards();

  // ════════════ SPEED DIAL FAB (data-mnl-fab="[{...}]") ════════════
  // Single global click listener pour click-outside (anti memory leak)
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.mnl-fab.is-open').forEach(function (fab) {
      if (!fab.contains(e.target)) {
        fab.classList.remove('is-open');
        var b = fab.querySelector('.mnl-fab__main');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  });
  function setupFAB() {
    document.querySelectorAll('[data-mnl-fab]').forEach(function (container) {
      if (container.dataset.mnlFabBuilt) return;
      var actions;
      try { actions = JSON.parse(container.getAttribute('data-mnl-fab')); } catch (_) { return; }
      if (!Array.isArray(actions) || !actions.length) return;
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }
      // URL safety : same-origin ou relative pour éviter open redirects via FAB
      function safeUrl(u) {
        if (!u || u === '#') return '#';
        try {
          var p = new URL(u, window.location.origin);
          if (p.origin === window.location.origin) return p.href;
          return '#'; // cross-origin bloqué
        } catch (_) { return '#'; }
      }
      var mainIcon = container.getAttribute('data-mnl-fab-icon') || '+';
      container.dataset.mnlFabBuilt = '1';
      container.classList.add('mnl-fab');
      var itemsHTML = actions.map(function (a) {
        return '<a href="' + esc(safeUrl(a.url)) + '" class="mnl-fab__item"' + (a.action ? ' data-mnl-fab-action="' + esc(a.action) + '"' : '') + ' aria-label="' + esc(a.label || '') + '">' +
          '<span class="mnl-fab__item-label">' + esc(a.label || '') + '</span>' +
          '<span class="mnl-fab__item-icon" aria-hidden="true">' + esc(a.icon || '•') + '</span>' +
        '</a>';
      }).join('');
      container.innerHTML =
        '<div class="mnl-fab__items">' + itemsHTML + '</div>' +
        '<button type="button" class="mnl-fab__main" aria-label="Actions rapides" aria-expanded="false">' +
          '<span class="mnl-fab__main-icon">' + esc(mainIcon) + '</span>' +
        '</button>';
      var mainBtn = container.querySelector('.mnl-fab__main');
      mainBtn.addEventListener('click', function () {
        var open = container.classList.toggle('is-open');
        mainBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupFAB, 300);
  else setupFAB();

  // ════════════ AUTO-LINK URLS in text (data-mnl-autolink-urls) ════════════
  function autoLinkUrls() {
    document.querySelectorAll('[data-mnl-autolink-urls]').forEach(function (el) {
      if (el.dataset.mnlUrlsBound) return;
      el.dataset.mnlUrlsBound = '1';
      var urlRe = /(\b(?:https?:\/\/|www\.)[^\s<>"]{4,})/gi;
      // Walk text nodes only (don't break existing HTML)
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        if (!urlRe.test(node.textContent)) return;
        urlRe.lastIndex = 0;
        var parent = node.parentNode;
        if (!parent || parent.tagName === 'A') return;
        var span = document.createElement('span');
        // Vague 150 P0 SEC FIX : escape HTML du textContent AVANT le replace + escape l'href dans l'attribut
        // Avant : node.textContent inséré dans innerHTML sans escape → si node contient ex "<img onerror=...>" cabré
        //         ET href avec " breakait l'attribut → XSS. Maintenant : escape complet, safe partout.
        var escFn = function(s){ return String(s).replace(/[&<>"']/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; }); };
        var escapedText = escFn(node.textContent);
        span.innerHTML = escapedText.replace(urlRe, function (m) {
          var href = m.indexOf('www.') === 0 ? 'https://' + m : m;
          return '<a href="' + escFn(href) + '" target="_blank" rel="noopener noreferrer nofollow" class="mnl-link-underline" style="color:#C2410C;">' + escFn(m) + '</a>';
        });
        parent.replaceChild(span, node);
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(autoLinkUrls, 300);
  else autoLinkUrls();

  // ════════════ SEARCH RESULTS HIGHLIGHTER (data-mnl-highlight="terme") ════════════
  // Vague 102 : escape HTML du textContent AVANT le replace + innerHTML — sinon caractères `< > &`
  // du texte original (ex: "voir <a> pour plus") deviennent du HTML actif au moment du innerHTML
  // → potentiel XSS ou affichage cassé.
  function _escHtml(s){
    return String(s).replace(/[&<>"']/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; });
  }
  function highlightInElement(el, term) {
    if (!term) return;
    var safeRe = new RegExp('(' + term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (!safeRe.test(node.textContent)) return;
      safeRe.lastIndex = 0;
      var parent = node.parentNode;
      if (!parent || parent.tagName === 'MARK' || parent.classList.contains('mnl-highlight')) return;
      var span = document.createElement('span');
      // Vague 102 : escape AVANT replace pour neutraliser tout HTML dans le texte original,
      // puis re-escape le term dans le pattern (déjà fait via [.*+?^${}()|[\]\\] mais on garde la sécu).
      var escapedText = _escHtml(node.textContent);
      var escapedTerm = _escHtml(term).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var safeReEsc = new RegExp('(' + escapedTerm + ')', 'gi');
      span.innerHTML = escapedText.replace(safeReEsc, '<mark class="mnl-highlight">$1</mark>');
      parent.replaceChild(span, node);
    });
  }
  window.mnlHighlight = highlightInElement;
  document.querySelectorAll('[data-mnl-highlight]').forEach(function (el) {
    var term = el.getAttribute('data-mnl-highlight');
    if (term) highlightInElement(el, term);
  });

  // ════════════ DRAWER SYSTEM générique (data-mnl-drawer-trigger="#drawer-id") ════════════
  function ensureDrawer(id, side, title) {
    var drawer = document.getElementById(id);
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.id = id;
    drawer.className = 'mnl-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', title || MNL_T('global.panel_default_label', 'Panneau'));
    drawer.setAttribute('aria-hidden', 'true'); drawer.inert = true; // V930 (a11y) : créé fermé → inert tant qu'on n'ouvre pas (enfants hors tab-order + lecteur d'écran)
    drawer.innerHTML =
      '<div class="mnl-drawer__overlay" data-mnl-drawer-close></div>' +
      '<div class="mnl-drawer__panel mnl-drawer__panel--' + (side || 'right') + '">' +
        '<header class="mnl-drawer__header">' +
          '<h2 class="mnl-drawer__title">' + (title || '') + '</h2>' +
          MNL_T('global.drawer_close_html', '<button type="button" class="mnl-drawer__close" data-mnl-drawer-close aria-label="Fermer">×</button>') +
        '</header>' +
        '<div class="mnl-drawer__body"></div>' +
      '</div>';
    document.body.appendChild(drawer);
    return drawer;
  }
  window.mnlOpenDrawer = function (id, opts) {
    opts = opts || {};
    var drawer = ensureDrawer(id, opts.side, opts.title);
    if (opts.body) drawer.querySelector('.mnl-drawer__body').innerHTML = opts.body;
    drawer._mnlTrigger = document.activeElement; // V930 (a11y) : mémorise le déclencheur pour restaurer le focus à la fermeture (WCAG 2.4.3)
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false'); drawer.inert = false; // V930 (a11y) : ouvert → interactif + exposé
    document.body.style.overflow = 'hidden';
    // Auto-focus le premier focusable (post-animation pour bon focus visuel)
    setTimeout(function () {
      var focusable = drawer.querySelector('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusable) try { focusable.focus(); } catch (_) {}
    }, 120);
    // Browser back button → close drawer (mobile UX critical)
    if (history.pushState && !drawer.dataset.mnlHistoryPushed) {
      try {
        history.pushState({ mnlDrawer: id }, '', '');
        drawer.dataset.mnlHistoryPushed = '1';
      } catch (_) {}
    }
    document.dispatchEvent(new CustomEvent('mnl:dialog:opened', { detail: { id: id } }));
  };
  window.mnlCloseDrawer = function (id) {
    var drawer = id ? document.getElementById(id) : document.querySelector('.mnl-drawer.is-open');
    if (!drawer) { document.body.style.overflow = ''; return; }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true'); drawer.inert = true; // V930 (a11y) : fermé → inert
    if (drawer._mnlTrigger && typeof drawer._mnlTrigger.focus === 'function') { try { drawer._mnlTrigger.focus(); } catch(_){} drawer._mnlTrigger = null; } // V930 (a11y) : retour focus au déclencheur
    document.body.style.overflow = '';
    // Pop le history state si on l'avait push (sauf si déjà popped par browser back)
    if (drawer.dataset.mnlHistoryPushed && history.state && history.state.mnlDrawer === drawer.id) {
      try { history.back(); } catch (_) {}
    }
    delete drawer.dataset.mnlHistoryPushed;
    document.dispatchEvent(new CustomEvent('mnl:dialog:closed', { detail: { id: drawer.id } }));
  };
  // Listen popstate : ferme le drawer si l'utilisateur appuie sur Back du navigateur
  window.addEventListener('popstate', function () {
    var open = document.querySelector('.mnl-drawer.is-open');
    if (open && open.dataset.mnlHistoryPushed) {
      delete open.dataset.mnlHistoryPushed; // Évite double pop
      open.classList.remove('is-open');
      open.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.dispatchEvent(new CustomEvent('mnl:dialog:closed', { detail: { id: open.id } }));
    }
  });
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mnl-drawer-trigger]');
    if (trigger) {
      e.preventDefault();
      var id = trigger.getAttribute('data-mnl-drawer-trigger').replace(/^#/, '');
      window.mnlOpenDrawer(id, {
        side: trigger.getAttribute('data-mnl-drawer-side') || 'right',
        title: trigger.getAttribute('data-mnl-drawer-title') || ''
      });
      return;
    }
    if (e.target.closest('[data-mnl-drawer-close]')) {
      window.mnlCloseDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.mnl-drawer.is-open');
      if (open) window.mnlCloseDrawer(open.id);
    }
  });

  // ════════════ SIDEBAR COLLAPSIBLE (mobile filter toggle) ════════════
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.mnl-sidebar-toggle');
    if (!toggle) return;
    var targetId = toggle.getAttribute('data-mnl-sidebar-target');
    var target = targetId ? document.querySelector(targetId) : toggle.nextElementSibling;
    if (target) {
      var open = target.classList.toggle('is-open');
      toggle.classList.toggle('is-active', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  // ════════════ DATE PICKER ENHANCEMENT (data-mnl-datepicker-business-only) ════════════
  document.querySelectorAll('input[type="date"][data-mnl-datepicker-business-only]').forEach(function (input) {
    if (input.dataset.mnlDpBound) return;
    input.dataset.mnlDpBound = '1';
    // Disable past dates
    var today = new Date().toISOString().split('T')[0];
    if (!input.min) input.min = today;
    // Add hint message
    var hint = document.createElement('p');
    hint.className = 'mnl-datepicker__hint';
    input.parentNode.insertBefore(hint, input.nextSibling);
    function updateHint() {
      if (!input.value) { hint.textContent = ''; return; }
      var d = new Date(input.value);
      var day = d.getDay();
      if (day === 0 || day === 6) {
        hint.className = 'mnl-datepicker__hint mnl-datepicker__hint--unavailable';
        hint.textContent = MNL_T('global.datepicker_weekend', 'Pas de livraison le week-end. Choisis un jour ouvré.');
      } else {
        hint.className = 'mnl-datepicker__hint mnl-datepicker__hint--available';
        var formatted = window.mnlFormat ? window.mnlFormat.date(d, { weekday: 'long', day: 'numeric', month: 'long' }) : d.toLocaleDateString('fr-FR');
        hint.textContent = '✓ Disponible : ' + formatted;
      }
    }
    input.addEventListener('change', updateHint);
    updateHint();
  });

  // ════════════ QR CODE GENERATOR (canvas-based, no library) ════════════
  // Implementation simple QR via Google Chart API fallback (offline = SVG basic)
  function buildQRSvg(text, size) {
    size = size || 200;
    // Simple : utilise api.qrserver.com (sans dep, libre, https)
    var url = 'https://api.qrserver.com/v1/create-qr-code/?size=' + size + 'x' + size + '&data=' + encodeURIComponent(text) + '&margin=0';
    return '<img src="' + url + '" alt="QR code" width="' + size + '" height="' + size + '" style="display:block;width:100%;height:auto;">';
  }
  window.mnlOpenQR = function (opts) {
    opts = opts || {};
    var url = opts.url || window.location.href;
    var title = opts.title || MNL_T('global.qr_default_title', 'Partager ce lien');
    var sub = opts.sub || MNL_T('global.qr_default_sub', 'Scanne le QR code avec ton téléphone');
    var modal = document.getElementById('mnl-qr-modal');
    if (modal) modal.remove();
    modal = document.createElement('div');
    modal.id = 'mnl-qr-modal';
    modal.className = 'mnl-qr';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', title);
    modal.innerHTML =
      '<div class="mnl-qr__box">' +
        '<h3 class="mnl-qr__title">' + title + '</h3>' +
        '<p class="mnl-qr__sub">' + sub + '</p>' +
        '<div class="mnl-qr__svg">' + buildQRSvg(url, 200) + '</div>' +
        '<p class="mnl-qr__url">' + url + '</p>' +
        '<div class="mnl-qr__actions">' +
          '<button type="button" class="mnl-qr__btn mnl-qr__btn--copy" data-mnl-copy="' + url + MNL_T('global.qr_copy_html', '" data-mnl-copy-label="Lien copié">Copier</button>') +
          MNL_T('global.qr_close_html', '<button type="button" class="mnl-qr__btn mnl-qr__btn--close">Fermer</button>') +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.mnl-qr__btn--close')) {
        modal.classList.remove('is-open');
        setTimeout(function () { modal.remove(); }, 250);
      }
    });
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-qr-trigger]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-mnl-qr-trigger');
    if (!url || url === 'true') url = window.location.href;
    window.mnlOpenQR({ url: url, title: btn.getAttribute('data-mnl-qr-title') || MNL_T('global.qr_default_title', 'Partager ce lien'), sub: btn.getAttribute('data-mnl-qr-sub') });
  });

  // ════════════ ACCESSIBILITY ENHANCED MODE ════════════
  function applyA11ySettings() {
    var settings = {};
    try { settings = JSON.parse(localStorage.getItem('mnl-a11y-settings') || '{}'); } catch (_) {}
    if (settings.size) document.documentElement.setAttribute('data-mnl-a11y', settings.size);
    else document.documentElement.removeAttribute('data-mnl-a11y');
    if (settings.dyslexic) document.documentElement.setAttribute('data-mnl-a11y', 'dyslexic');
    if (settings.contrast) document.documentElement.setAttribute('data-mnl-a11y', 'contrast');
    if (settings.underline) document.documentElement.setAttribute('data-mnl-a11y-underline', 'true');
    else document.documentElement.removeAttribute('data-mnl-a11y-underline');
  }
  applyA11ySettings();

  function ensureA11yPanel() {
    var panel = document.getElementById('mnl-a11y-panel');
    if (panel) return panel;
    var settings = {};
    try { settings = JSON.parse(localStorage.getItem('mnl-a11y-settings') || '{}'); } catch (_) {}
    panel = document.createElement('div');
    panel.id = 'mnl-a11y-panel';
    panel.className = 'mnl-a11y-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', MNL_T('global.a11y_panel_label', 'Préférences accessibilité'));
    panel.innerHTML =
      MNL_T('global.a11y_title_html', '<h3 class="mnl-a11y-panel__title">♿ Accessibilité</h3>') +
      MNL_T('global.a11y_sub_html', '<p class="mnl-a11y-panel__sub">Adapte l\'affichage à tes besoins.</p>') +
      MNL_T('global.a11y_row_size_html', '<label class="mnl-a11y-panel__row mnl-switch"><span>Texte plus grand</span><input type="checkbox" data-mnl-a11y-opt="size" ') + (settings.size === 'large' ? 'checked' : '') + '><span class="mnl-switch__track"></span></label>' +
      '<label class="mnl-a11y-panel__row mnl-switch"><span>Police dyslexie-friendly</span><input type="checkbox" data-mnl-a11y-opt="dyslexic" ' + (settings.dyslexic ? 'checked' : '') + '><span class="mnl-switch__track"></span></label>' +
      MNL_T('global.a11y_row_contrast_html', '<label class="mnl-a11y-panel__row mnl-switch"><span>Contraste accentué</span><input type="checkbox" data-mnl-a11y-opt="contrast" ') + (settings.contrast ? 'checked' : '') + '><span class="mnl-switch__track"></span></label>' +
      MNL_T('global.a11y_row_underline_html', '<label class="mnl-a11y-panel__row mnl-switch"><span>Souligner tous les liens</span><input type="checkbox" data-mnl-a11y-opt="underline" ') + (settings.underline ? 'checked' : '') + '><span class="mnl-switch__track"></span></label>' +
      MNL_T('global.a11y_reset_html', '<button type="button" class="mnl-a11y-panel__reset">↻ Réinitialiser</button>');
    document.body.appendChild(panel);
    panel.addEventListener('change', function (e) {
      var checkbox = e.target.closest('[data-mnl-a11y-opt]');
      if (!checkbox) return;
      var opt = checkbox.getAttribute('data-mnl-a11y-opt');
      var current = {};
      try { current = JSON.parse(localStorage.getItem('mnl-a11y-settings') || '{}'); } catch (_) {}
      if (opt === 'size') current.size = checkbox.checked ? 'large' : null;
      else current[opt] = checkbox.checked;
      try { localStorage.setItem('mnl-a11y-settings', JSON.stringify(current)); } catch (_) {}
      applyA11ySettings();
    });
    panel.querySelector('.mnl-a11y-panel__reset').addEventListener('click', function () {
      try { localStorage.removeItem('mnl-a11y-settings'); } catch (_) {}
      panel.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
      applyA11ySettings();
    });
    return panel;
  }
  window.mnlOpenA11yPanel = function () { ensureA11yPanel().classList.add('is-open'); };
  window.mnlCloseA11yPanel = function () { var p = document.getElementById('mnl-a11y-panel'); if (p) p.classList.remove('is-open'); };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mnl-a11y-toggle]')) { e.preventDefault(); var p = ensureA11yPanel(); p.classList.toggle('is-open'); return; }
    var panel = document.getElementById('mnl-a11y-panel');
    if (panel && panel.classList.contains('is-open') && !panel.contains(e.target) && !e.target.closest('[data-mnl-a11y-toggle]')) {
      panel.classList.remove('is-open');
    }
  });

  // ════════════ BLUR-UP IMAGE LOADER (LQIP) ════════════
  // <img data-mnl-blurup src="lqip-tiny.jpg" data-mnl-blurup-full="full-hd.jpg">
  function setupBlurUp() {
    document.querySelectorAll('img[data-mnl-blurup]:not([data-mnl-blurup-bound])').forEach(function (img) {
      img.dataset.mnlBlurupBound = '1';
      var fullSrc = img.getAttribute('data-mnl-blurup-full');
      if (!fullSrc) return;
      var full = new Image();
      full.onload = function () {
        img.src = fullSrc;
        requestAnimationFrame(function () { img.classList.add('is-loaded'); });
      };
      full.src = fullSrc;
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupBlurUp, 200);
  else setupBlurUp();

  // ════════════ LOYALTY PROGRESS WIDGET (data-mnl-loyalty="pts") ════════════
  function setupLoyalty() {
    document.querySelectorAll('[data-mnl-loyalty]').forEach(function (el) {
      if (el.dataset.mnlLoyaltyBound) return;
      el.dataset.mnlLoyaltyBound = '1';
      // Clamp pts ≥ 0 (négatif = bug data, traité comme 0)
      var pts = Math.max(0, parseInt(el.getAttribute('data-mnl-loyalty'), 10) || 0);
      var tiers = [
        { name: 'Rookie', min: 0, max: 99, icon: '' },
        { name: 'Athlete', min: 100, max: 499, icon: '' },
        { name: 'Pro', min: 500, max: 999, icon: '' },
        { name: 'Elite', min: 1000, max: 2499, icon: '' },
        { name: 'Legend', min: 2500, max: Infinity, icon: '' }
      ];
      var currentTier = tiers.find(function (t) { return pts >= t.min && pts <= t.max; }) || tiers[tiers.length - 1];
      var nextTier = tiers[tiers.indexOf(currentTier) + 1];
      var pct = nextTier ? ((pts - currentTier.min) / (nextTier.min - currentTier.min)) * 100 : 100;
      el.classList.add('mnl-loyalty');
      el.innerHTML =
        '<span class="mnl-loyalty__icon" aria-hidden="true">' + currentTier.icon + '</span>' +
        '<div class="mnl-loyalty__body">' +
          '<div class="mnl-loyalty__head"><span class="mnl-loyalty__tier">' + currentTier.name + '</span><span class="mnl-loyalty__pts">' + pts + ' pts</span></div>' +
          '<div class="mnl-loyalty__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(Math.max(0, Math.min(100, pct))) + '"><div class="mnl-loyalty__bar-fill" style="width:' + Math.max(0, Math.min(100, pct)) + '%"></div></div>' +
          '<p class="mnl-loyalty__next">' + (nextTier ? MNL_T('global.loyalty_next_prefix', 'Encore ') + (nextTier.min - pts) + MNL_T('global.loyalty_next_middle', ' pts pour ') + nextTier.name + ' ' + nextTier.icon : MNL_T('global.loyalty_max_level', 'Niveau max atteint ! ')) + '</p>' +
        '</div>';
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupLoyalty, 300);
  else setupLoyalty();

  // ════════════ LOCALE / CURRENCY SWITCHER ════════════
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mnl-locale-switch__btn');
    if (btn) {
      e.preventDefault();
      var sw = btn.closest('.mnl-locale-switch');
      sw.classList.toggle('is-open');
      return;
    }
    document.querySelectorAll('.mnl-locale-switch.is-open').forEach(function (sw) {
      if (!sw.contains(e.target)) sw.classList.remove('is-open');
    });
  });

  // ════════════ COMMAND PALETTE (Cmd+Shift+P / Cmd+J) ════════════
  var COMMANDS = [
    { icon: '', title: MNL_T('global.cmd_see_cart', 'Voir mon panier'), cat: MNL_T('global.cmd_cat_navigation', 'Navigation'), action: function () { window.location.href = '/cart'; } },
    { icon: '', title: MNL_T('global.cmd_configure_formula', 'Configurer ma formule'), cat: MNL_T('global.cmd_cat_action', 'Action'), action: function () { window.location.href = '/products/pre-workout-mynutrilab-personnalisable-au-mg-pres'; } },
    { icon: '', title: MNL_T('global.cmd_open_coach', 'Ouvrir le Coach IA'), cat: MNL_T('global.cmd_cat_action', 'Action'), action: function () { window.location.href = '/products/pre-workout-mynutrilab-personnalisable-au-mg-pres?open=ai'; } },
    { icon: '', title: MNL_T('global.cmd_recent_products', 'Mes produits récents'), cat: MNL_T('global.cmd_cat_navigation', 'Navigation'), action: function () { var w = document.getElementById('mnl-rv-widget'); if (w) w.click(); } },
    { icon: '♥', title: MNL_T('global.cmd_my_wishlist', 'Ma wishlist'), cat: MNL_T('global.cmd_cat_navigation', 'Navigation'), action: function () { window.location.href = '/pages/wishlist'; } },
    { icon: '', title: MNL_T('global.cmd_my_account', 'Mon compte'), cat: MNL_T('global.cmd_cat_navigation', 'Navigation'), action: function () { window.location.href = '/pages/account'; } },
    { icon: '', title: MNL_T('global.cmd_dashboard', 'Tableau de bord'), cat: MNL_T('global.cmd_cat_navigation', 'Navigation'), action: function () { window.location.href = '/pages/account'; } },
    { icon: '', title: 'FAQ', cat: MNL_T('global.cmd_cat_help', 'Aide'), action: function () { window.location.href = '/pages/faq'; } },
    { icon: '', title: MNL_T('global.cmd_lab', 'Le Lab — actifs cliniques'), cat: MNL_T('global.cmd_cat_navigation', 'Navigation'), action: function () { window.location.href = '/pages/lab'; } }, // V527 : handle réel
    { icon: '⚖', title: MNL_T('global.cmd_comparator', 'Comparatif marques'), cat: MNL_T('global.cmd_cat_navigation', 'Navigation'), action: function () { window.location.href = '/pages/comparator'; } },
    { icon: '', title: MNL_T('global.cmd_toggle_dark', 'Basculer mode sombre'), cat: MNL_T('global.cmd_cat_preference', 'Préférence'), kbd: 'g+t', action: function () { window.mnlToggleTheme(); } },
    { icon: '♿', title: MNL_T('global.a11y_panel_label', 'Préférences accessibilité'), cat: MNL_T('global.cmd_cat_preference', 'Préférence'), action: function () { window.mnlOpenA11yPanel(); } },
    { icon: '', title: MNL_T('global.cmd_cookie_prefs', 'Préférences cookies'), cat: MNL_T('global.cmd_cat_preference', 'Préférence'), action: function () { if (window.mnlOpenCookiePrefs) window.mnlOpenCookiePrefs(); } },
    { icon: '⌨', title: MNL_T('global.cmd_kbd_shortcuts', 'Voir les raccourcis clavier'), cat: MNL_T('global.cmd_cat_help', 'Aide'), kbd: '?', action: function () { if (window.mnlOpenKbdHelp) window.mnlOpenKbdHelp(); } },
    { icon: '', title: MNL_T('global.cmd_install_app', 'Installer l\'app'), cat: MNL_T('global.cmd_cat_action', 'Action'), action: function () { if (window.mnlAddNotif) window.mnlAddNotif({ icon: '', title: MNL_T('global.cmd_install_notif_title', 'Installation app'), sub: MNL_T('global.cmd_install_notif_sub', 'Cherche le prompt en bas si dispo') }); } },
    { icon: '', title: MNL_T('global.cmd_search', 'Rechercher'), cat: MNL_T('global.cmd_cat_action', 'Action'), kbd: 'cmd+k', action: function () { var sb = document.querySelector('[data-mnl-search-open]'); if (sb) sb.click(); } }
  ];
  function ensureCmdPalette() {
    var modal = document.getElementById('mnl-cmdp-modal');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'mnl-cmdp-modal';
    modal.className = 'mnl-cmdp';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', MNL_T('global.cmdp_dialog_label', 'Palette de commandes'));
    var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    modal.innerHTML =
      '<div class="mnl-cmdp__box">' +
        '<div class="mnl-cmdp__head">' +
          '<span class="mnl-cmdp__head-icon" aria-hidden="true"></span>' +
          MNL_T('global.cmdp_input_html', '<input type="text" class="mnl-cmdp__input" placeholder="Tape une commande ou une recherche…" aria-label="Recherche commande">') +
          '<span class="mnl-cmdp__shortcut">' + (isMac ? '⌘' : 'Ctrl') + 'J</span>' +
        '</div>' +
        '<div class="mnl-cmdp__list"></div>' +
      '</div>';
    document.body.appendChild(modal);
    var input = modal.querySelector('.mnl-cmdp__input');
    var list = modal.querySelector('.mnl-cmdp__list');
    var focusedIdx = 0;
    function render(filter) {
      filter = (filter || '').toLowerCase().trim();
      var matched = COMMANDS.filter(function (c) {
        return !filter || c.title.toLowerCase().indexOf(filter) !== -1 || c.cat.toLowerCase().indexOf(filter) !== -1;
      });
      list.innerHTML = matched.map(function (c, i) {
        return '<div class="mnl-cmdp__item ' + (i === focusedIdx ? 'is-focused' : '') + '" data-idx="' + i + '">' +
          '<span class="mnl-cmdp__item-icon" aria-hidden="true">' + c.icon + '</span>' +
          '<div class="mnl-cmdp__item-info">' +
            '<p class="mnl-cmdp__item-title">' + c.title + '</p>' +
            '<p class="mnl-cmdp__item-cat">' + c.cat + '</p>' +
          '</div>' +
          (c.kbd ? '<span class="mnl-cmdp__item-kbd">' + c.kbd + '</span>' : '') +
        '</div>';
      }).join('') || MNL_T('global.cmdp_empty_html', '<div style="padding:24px;text-align:center;color:#94a3b8;font-size:13px;">Aucune commande trouvée</div>');
      modal.dataset.matched = matched.length;
    }
    input.addEventListener('input', function () { focusedIdx = 0; render(input.value); });
    input.addEventListener('keydown', function (e) {
      var matchedCount = parseInt(modal.dataset.matched, 10) || 0;
      if (e.key === 'ArrowDown') { e.preventDefault(); focusedIdx = Math.min(focusedIdx + 1, matchedCount - 1); render(input.value); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); focusedIdx = Math.max(focusedIdx - 1, 0); render(input.value); }
      else if (e.key === 'Enter') {
        var item = list.querySelector('.mnl-cmdp__item.is-focused');
        if (item) {
          var filter = input.value.toLowerCase().trim();
          var matched = COMMANDS.filter(function (c) { return !filter || c.title.toLowerCase().indexOf(filter) !== -1; });
          var cmd = matched[parseInt(item.getAttribute('data-idx'), 10)];
          if (cmd && cmd.action) { window.mnlCloseCmdPalette(); cmd.action(); }
        }
      } else if (e.key === 'Escape') { window.mnlCloseCmdPalette(); }
    });
    list.addEventListener('click', function (e) {
      var item = e.target.closest('.mnl-cmdp__item');
      if (!item) return;
      var filter = input.value.toLowerCase().trim();
      var matched = COMMANDS.filter(function (c) { return !filter || c.title.toLowerCase().indexOf(filter) !== -1; });
      var cmd = matched[parseInt(item.getAttribute('data-idx'), 10)];
      if (cmd && cmd.action) { window.mnlCloseCmdPalette(); cmd.action(); }
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) window.mnlCloseCmdPalette(); });
    render('');
    return modal;
  }
  window.mnlOpenCmdPalette = function () {
    var modal = ensureCmdPalette();
    modal.classList.add('is-open');
    setTimeout(function () { modal.querySelector('.mnl-cmdp__input').focus(); }, 100);
  };
  window.mnlCloseCmdPalette = function () { var m = document.getElementById('mnl-cmdp-modal'); if (m) m.classList.remove('is-open'); };
  document.addEventListener('keydown', function (e) {
    var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    var cmd = isMac ? e.metaKey : e.ctrlKey;
    if (cmd && e.key === 'j') { e.preventDefault(); var m = document.getElementById('mnl-cmdp-modal'); m && m.classList.contains('is-open') ? window.mnlCloseCmdPalette() : window.mnlOpenCmdPalette(); }
  });

  // ════════════ PAGE READING PROGRESS (data-mnl-page-progress) ════════════
  // Vague 120 : amélioré — calcule la progression basée sur la zone de contenu (RTE article) si présente,
  // pas sur la page entière (sinon le footer comptait dans la lecture). ARIA role=progressbar + 100% milestone.
  if (document.querySelector('[data-mnl-page-progress]')) {
    var bar = document.createElement('div');
    bar.className = 'mnl-page-progress';
    bar.setAttribute('role', 'progressbar');
    bar.setAttribute('aria-label', MNL_T('global.reading_progress_label', 'Progression de lecture'));
    bar.setAttribute('aria-valuemin', '0');
    bar.setAttribute('aria-valuemax', '100');
    bar.setAttribute('aria-valuenow', '0');
    bar.innerHTML = '<div class="mnl-page-progress__fill"></div>';
    document.body.appendChild(bar);
    var fill = bar.querySelector('.mnl-page-progress__fill');
    var ticking = false;
    // Vague 120 : zone de contenu spécifique (article RTE / main) plutôt que la doc entière
    var contentArea = document.querySelector('.mnl-art__rte, [data-mnl-toc-float-scope], main article, main') || document.body;
    var fired100 = false;
    var fired50 = false;
    function _onScroll(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var pct = 0;
        try {
          var rect = contentArea.getBoundingClientRect();
          var contentTop = rect.top + window.scrollY;
          var contentEnd = contentTop + contentArea.offsetHeight;
          var viewportEnd = window.scrollY + window.innerHeight;
          // Read range : entre le top de l'article et la fin du contenu visible
          var range = (contentEnd - contentTop) - window.innerHeight * 0.4; // marge bas pour considérer "lu" avant la toute fin
          if (range > 0) {
            pct = ((viewportEnd - contentTop) / range) * 100;
          } else {
            // Fallback : full doc
            var max = document.documentElement.scrollHeight - window.innerHeight;
            pct = max > 0 ? (window.scrollY / max) * 100 : 0;
          }
          pct = Math.max(0, Math.min(100, pct));
        } catch(_){}
        fill.style.width = pct + '%';
        bar.setAttribute('aria-valuenow', Math.round(pct));
        // GA4 milestones (50% et 100%, une seule fois par session)
        if (!fired50 && pct >= 50) {
          fired50 = true;
          try { if (window.gtag) window.gtag('event', 'scroll', { percent_scrolled: 50 }); } catch(_){}
        }
        if (!fired100 && pct >= 99) {
          fired100 = true;
          try { if (window.gtag) window.gtag('event', 'scroll', { percent_scrolled: 100 }); } catch(_){}
          // V626 : toast « Article terminé / Merci pour la lecture » RETIRÉ (gadget gamey, demande user). Le tracking GA4 100% de scroll reste.
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', _onScroll, { passive: true });
    _onScroll();
  }

  // ════════════ ADBLOCK DETECTION — retiré (popup supprimé à la demande du client) ════════════

  // ════════════ BATTERY SAVER MODE (Battery Status API + saveData hint) ════════════
  function checkBatterySaver() {
    var saveData = navigator.connection && navigator.connection.saveData;
    var lowBattery = false;
    var checkBattery = function () {
      if ('getBattery' in navigator) {
        navigator.getBattery().then(function (battery) {
          lowBattery = battery.level < 0.15 && !battery.charging;
          applyMode(saveData || lowBattery);
          battery.addEventListener('levelchange', checkBattery);
          battery.addEventListener('chargingchange', checkBattery);
        });
      } else {
        applyMode(saveData);
      }
    };
    function applyMode(active) {
      document.documentElement.classList.toggle('mnl-battery-saver', active);
      // Pause non-critical animations
      if (active) {
        document.documentElement.style.setProperty('--mnl-anim-duration', '0s');
        document.querySelectorAll('video[autoplay]').forEach(function (v) { v.pause(); v.removeAttribute('autoplay'); });
      } else {
        document.documentElement.style.removeProperty('--mnl-anim-duration');
      }
    }
    checkBattery();
  }
  setTimeout(checkBatterySaver, 2000);

  // ════════════ CONFETTI (celebration moments rares — usage manuel uniquement) ════════════
  // Vague 104 : respect prefers-reduced-motion (WCAG 2.3.3) — utilisateurs sensibles aux animations
  // (motion sickness, troubles vestibulaires) ne reçoivent pas de confettis.
  window.mnlConfetti = function (opts) {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        // Fallback discret : toast léger sans particles
        if (window.mnlToast) window.mnlToast({ icon: '', title: 'Bravo !', type: 'success', duration: 2000 });
        return;
      }
    } catch(_){}
    opts = opts || {};
    var count = opts.count || 60;
    var colors = opts.colors || ['#C2410C', '#fbbf24', '#22c55e', '#3b82f6', '#a855f7'];
    var container = document.createElement('div');
    container.className = 'mnl-confetti';
    document.body.appendChild(container);
    for (var i = 0; i < count; i++) {
      var p = document.createElement('div');
      p.className = 'mnl-confetti__piece';
      p.style.left = Math.random() * 100 + 'vw';
      p.style.background = colors[Math.floor(Math.random() * colors.length)];
      p.style.animationDuration = (2.5 + Math.random() * 2) + 's';
      p.style.animationDelay = (Math.random() * 0.5) + 's';
      p.style.borderRadius = Math.random() > 0.5 ? '50%' : '1px';
      container.appendChild(p);
    }
    setTimeout(function () { container.remove(); }, 5000);
  };

  // ════════════ ANIMATED BUTTON SUCCESS STATE ════════════
  // <button data-mnl-success="Sauvé !"> → après async action, affiche check vert 1.5s
  window.mnlBtnSuccess = function (btn, msg) {
    if (!btn) return;
    var orig = btn.innerHTML;
    btn.classList.add('is-success');
    btn.innerHTML = msg || (btn.getAttribute('data-mnl-success') || 'Fait !');
    setTimeout(function () {
      btn.classList.remove('is-success');
      btn.innerHTML = orig;
    }, 1800);
  };
  // Helper auto pour boutons avec data-mnl-success-on-click="action"
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-success-on-click]');
    if (!btn) return;
    setTimeout(function () { window.mnlBtnSuccess(btn); }, 100);
  });

  // ════════════ HONEYPOT ANTI-SPAM (auto-add hidden field aux forms) ════════════
  function setupHoneypots() {
    document.querySelectorAll('form[data-mnl-honeypot]').forEach(function (form) {
      if (form.dataset.mnlHpBound) return;
      form.dataset.mnlHpBound = '1';
      var hp = document.createElement('div');
      hp.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;';
      hp.setAttribute('aria-hidden', 'true');
      hp.innerHTML = MNL_T('global.honeypot_html', '<label>Ne pas remplir<input type="text" name="mnl_hp_website" tabindex="-1" autocomplete="off"></label>');
      form.appendChild(hp);
      var startTime = Date.now();
      form.addEventListener('submit', function (e) {
        var hpValue = form.querySelector('input[name="mnl_hp_website"]').value;
        var elapsed = Date.now() - startTime;
        if (hpValue) {
          // Bot detected
          e.preventDefault();
          console.warn('[MNL] Honeypot triggered, blocked submission');
          return false;
        }
        if (elapsed < 1500) {
          // Submitted too fast (bot)
          e.preventDefault();
          if (window.mnlToastError) window.mnlToastError(MNL_T('global.antispam_title', 'Vérification'), MNL_T('global.antispam_sub', 'Patiente quelques secondes avant de soumettre'));
          return false;
        }
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupHoneypots, 300);
  else setupHoneypots();

  // ════════════ SHARE STATE URL (encode form/configurator state via query params) ════════════
  // <button data-mnl-share-state="form#configurator"> → encode tous les inputs en URL
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-share-state]');
    if (!btn) return;
    e.preventDefault();
    var sel = btn.getAttribute('data-mnl-share-state');
    var form = document.querySelector(sel);
    if (!form) { if (window.mnlToastError) window.mnlToastError(MNL_T('global.share_target_missing', 'Cible introuvable')); return; }
    var params = new URLSearchParams();
    form.querySelectorAll('input,select,textarea').forEach(function (input) {
      if (!input.name || input.type === 'password' || input.type === 'hidden') return;
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      if (input.value) params.append(input.name, input.value);
    });
    var url = window.location.origin + window.location.pathname + '?' + params.toString() + '#shared';
    // Show QR + copy
    if (window.mnlOpenQR) window.mnlOpenQR({ url: url, title: MNL_T('global.share_config_title', 'Partage cette config'), sub: MNL_T('global.share_config_sub', 'Scanne ou copie le lien') });
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.link_copied_bang', 'Lien copié !'), MNL_T('global.share_anywhere', 'Partage où tu veux')); });
  });
  // Auto-restore state si URL contient les params
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.location.search || !window.location.hash || window.location.hash !== '#shared') return;
    var form = document.querySelector('[data-mnl-share-state-target]');
    if (!form) return;
    var params = new URLSearchParams(window.location.search);
    params.forEach(function (val, key) {
      var input = form.querySelector('[name="' + key + '"]');
      if (!input) return;
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.value === val) input.checked = true;
      } else input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (window.mnlToast) window.mnlToast({ icon: '', title: MNL_T('global.config_restored_title', 'Configuration restaurée'), sub: MNL_T('global.config_restored_sub', 'Depuis lien partagé'), type: 'info' });
  });

  // ════════════ STICKY SHADOW ON STUCK (auto-detect via IntersectionObserver) ════════════
  function setupStickyShadow() {
    document.querySelectorAll('[data-mnl-sticky-shadow]').forEach(function (el) {
      if (el.dataset.mnlSsBound) return;
      el.dataset.mnlSsBound = '1';
      el.classList.add('mnl-sticky-shadow');
      // Insert sentinel above
      var sentinel = document.createElement('div');
      sentinel.style.cssText = 'position:absolute;height:1px;width:1px;left:0;top:0;visibility:hidden;';
      el.parentNode.insertBefore(sentinel, el);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          el.classList.toggle('is-stuck', !entries[0].isIntersecting);
        }, { rootMargin: '-1px 0px 0px 0px' }).observe(sentinel);
      }
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupStickyShadow, 300);
  else setupStickyShadow();

  // ════════════ SCROLL-SNAP CAROUSEL (data-mnl-carousel) ════════════
  function setupCarousels() {
    document.querySelectorAll('[data-mnl-carousel]').forEach(function (container) {
      if (container.dataset.mnlCarouselBuilt) return;
      container.dataset.mnlCarouselBuilt = '1';
      container.classList.add('mnl-carousel');
      // Wrap children in __viewport
      var slides = Array.from(container.children);
      var viewport = document.createElement('div');
      viewport.className = 'mnl-carousel__viewport';
      slides.forEach(function (slide) {
        slide.classList.add('mnl-carousel__slide');
        viewport.appendChild(slide);
      });
      container.appendChild(viewport);
      // Build dots
      var dots = document.createElement('div');
      dots.className = 'mnl-carousel__nav';
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mnl-carousel__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', MNL_T('global.carousel_slide_prefix', 'Slide ') + (i + 1));
        dot.dataset.idx = i;
        dots.appendChild(dot);
      });
      container.appendChild(dots);
      // Build prev/next buttons
      var prevBtn = document.createElement('button');
      prevBtn.type = 'button'; prevBtn.className = 'mnl-carousel__btn mnl-carousel__btn--prev'; prevBtn.innerHTML = '‹';
      prevBtn.setAttribute('aria-label', MNL_T('global.common_previous', 'Précédent'));
      var nextBtn = document.createElement('button');
      nextBtn.type = 'button'; nextBtn.className = 'mnl-carousel__btn mnl-carousel__btn--next'; nextBtn.innerHTML = '›';
      nextBtn.setAttribute('aria-label', MNL_T('global.common_next', 'Suivant'));
      container.appendChild(prevBtn); container.appendChild(nextBtn);
      // Logic
      function getSlideWidth() { return slides[0].offsetWidth + 14; }
      prevBtn.addEventListener('click', function () { viewport.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' }); });
      nextBtn.addEventListener('click', function () { viewport.scrollBy({ left: getSlideWidth(), behavior: 'smooth' }); });
      dots.addEventListener('click', function (e) {
        var dot = e.target.closest('.mnl-carousel__dot');
        if (!dot) return;
        viewport.scrollTo({ left: parseInt(dot.dataset.idx, 10) * getSlideWidth(), behavior: 'smooth' });
      });
      // Update dots on scroll + disable buttons
      function updateNav() {
        var idx = Math.round(viewport.scrollLeft / getSlideWidth());
        dots.querySelectorAll('.mnl-carousel__dot').forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        prevBtn.disabled = viewport.scrollLeft <= 5;
        nextBtn.disabled = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 5;
      }
      viewport.addEventListener('scroll', updateNav, { passive: true });
      updateNav();
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupCarousels, 300);
  else setupCarousels();

  // ════════════ HOVER LINK PREVIEW (desktop only — fetch product preview JSON) ════════════
  // V727 : DÉSACTIVÉ — le popup d'aperçu produit au survol (sur slider + tous liens produits) gênait le fondateur (« supprime le popup »). Réactivation : retirer le « false && ».
  if (false && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    var preview;
    var hoverPreviewTimer;
    var previewCache = {};
    function ensurePreview() {
      if (preview) return preview;
      preview = document.createElement('div');
      preview.className = 'mnl-hover-preview';
      preview.setAttribute('role', 'tooltip');
      document.body.appendChild(preview);
      return preview;
    }
    function showPreview(handle, x, y) {
      var p = ensurePreview();
      function render(data) {
        p.innerHTML = (data.image ? '<img class="mnl-hover-preview__img" src="' + data.image + '" alt="">' : '') +
          '<p class="mnl-hover-preview__title">' + data.title + '</p>' +
          (data.desc ? '<p class="mnl-hover-preview__sub">' + data.desc + '</p>' : '') +
          (data.price ? '<p class="mnl-hover-preview__url">' + data.price + '</p>' : '');
        // Position
        var rect = { left: x, top: y };
        var pw = 280, ph = 200;
        if (rect.left + pw + 16 > window.innerWidth) rect.left = window.innerWidth - pw - 16;
        if (rect.top + ph + 16 > window.innerHeight) rect.top = y - ph - 12;
        p.style.left = Math.max(8, rect.left) + 'px';
        p.style.top = Math.max(8, rect.top) + 'px';
        p.classList.add('is-visible');
      }
      if (previewCache[handle]) return render(previewCache[handle]);
      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (prod) {
        var data = {
          title: prod.title,
          desc: (prod.description || '').replace(/<[^>]+>/g, '').slice(0, 120) + '...',
          image: prod.featured_image,
          price: (prod.price / 100).toFixed(2).replace('.', ',') + ' €'
        };
        previewCache[handle] = data;
        render(data);
      }).catch(function () {});
    }
    function hidePreview() { if (preview) preview.classList.remove('is-visible'); }
    document.addEventListener('mouseenter', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!a || a.hasAttribute('data-mnl-no-preview')) return;
      var match = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match) return;
      var handle = match[1];
      var rect = a.getBoundingClientRect();
      clearTimeout(hoverPreviewTimer);
      hoverPreviewTimer = setTimeout(function () { showPreview(handle, rect.left, rect.bottom + 8); }, 380);
    }, true);
    document.addEventListener('mouseleave', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!a) return;
      clearTimeout(hoverPreviewTimer);
      hoverPreviewTimer = setTimeout(hidePreview, 200);
    }, true);
  }

  // ════════════ INVENTORY LIVE COUNTDOWN (data-mnl-inventory="X" data-mnl-inventory-max="Y") ════════════
  function setupInventory() {
    document.querySelectorAll('[data-mnl-inventory]').forEach(function (el) {
      if (el.dataset.mnlInventoryBuilt) return;
      el.dataset.mnlInventoryBuilt = '1';
      var stock = parseInt(el.getAttribute('data-mnl-inventory'), 10);
      var max = parseInt(el.getAttribute('data-mnl-inventory-max'), 10) || 100;
      if (isNaN(stock)) return;
      el.classList.add('mnl-inventory');
      var pct = Math.max(0, Math.min(100, (stock / max) * 100));
      var modifier = '';
      var label = '';
      var dot = '<span class="mnl-inventory__dot" aria-hidden="true"></span>';
      if (stock <= 0) {
        modifier = 'mnl-inventory--out';
        label = MNL_T('global.stock_out', 'Rupture de stock');
      } else if (stock < 10) {
        modifier = ''; // default = warning yellow
        label = MNL_T('global.stock_only_prefix', 'Plus que ') + stock + MNL_T('global.stock_in_stock_suffix', ' en stock');
      } else if (stock < 30) {
        modifier = '';
        label = stock + ' disponibles';
      } else {
        modifier = 'mnl-inventory--high';
        label = MNL_T('global.stock_in_stock', 'En stock ✓');
      }
      el.classList.add(modifier);
      el.innerHTML = dot + '<span>' + label + '</span>' + (stock > 0 && stock < 30 ? '<span class="mnl-inventory__bar"><span class="mnl-inventory__bar-fill" style="width:' + pct + '%"></span></span>' : '');
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupInventory, 300);
  else setupInventory();

  // ════════════ LAZY INTERSECTION WRAPPER (data-mnl-lazy="callback") ════════════
  // Permet d'instancier des composants lourds uniquement quand visibles
  if ('IntersectionObserver' in window) {
    var lazyObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var cbName = el.getAttribute('data-mnl-lazy');
        if (cbName && typeof window[cbName] === 'function') {
          try { window[cbName](el); } catch (err) { console.warn('[MNL Lazy]', err); }
        }
        el.dispatchEvent(new CustomEvent('mnl:lazy:visible'));
        lazyObs.unobserve(el);
      });
    }, { rootMargin: '200px 0px' });
    function bindLazy() {
      document.querySelectorAll('[data-mnl-lazy]:not([data-mnl-lazy-bound])').forEach(function (el) {
        el.dataset.mnlLazyBound = '1';
        lazyObs.observe(el);
      });
    }
    if (window.mnlOnDomChange) window.mnlOnDomChange(bindLazy, 200);
    else bindLazy();
  }

  // ════════════ STICKY CALLOUT BAR (mnlShowCallout) ════════════
  window.mnlShowCallout = function (opts) {
    opts = opts || {};
    var existing = document.getElementById('mnl-callout-bar');
    if (existing) existing.remove();
    var bar = document.createElement('div');
    bar.id = 'mnl-callout-bar';
    bar.className = 'mnl-callout';
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');
    bar.innerHTML =
      '<span class="mnl-callout__icon" aria-hidden="true">' + (opts.icon || '') + '</span>' +
      '<div class="mnl-callout__body">' +
        (opts.title ? '<p class="mnl-callout__title">' + opts.title + '</p>' : '') +
        (opts.message || '') +
      '</div>' +
      MNL_T('global.callout_close_html', '<button type="button" class="mnl-callout__close" aria-label="Fermer">×</button>');
    document.body.appendChild(bar);
    requestAnimationFrame(function () { bar.classList.add('is-visible'); });
    bar.querySelector('.mnl-callout__close').addEventListener('click', function () {
      bar.classList.remove('is-visible');
      setTimeout(function () { bar.remove(); }, 400);
    });
    if (opts.duration !== 0) {
      setTimeout(function () {
        if (bar.parentNode) {
          bar.classList.remove('is-visible');
          setTimeout(function () { if (bar.parentNode) bar.remove(); }, 400);
        }
      }, opts.duration || 7000);
    }
    return bar;
  };

  // ════════════ A/B TEST FRAMEWORK (assignment + tracking) ════════════
  // Usage : window.mnlExperiment('btn_color', { control: 0.5, variant_a: 0.5 }) → returns variant key
  window.mnlExperiment = function (name, variants) {
    if (!name || !variants) return null;
    var key = 'mnl-exp-' + name;
    var assigned;
    try { assigned = localStorage.getItem(key); } catch (_) {}
    if (assigned && variants[assigned]) return assigned;
    // Random assignment based on weights
    var rnd = Math.random();
    var cumul = 0;
    var picked = null;
    Object.keys(variants).forEach(function (v) {
      cumul += variants[v];
      if (picked === null && rnd <= cumul) picked = v;
    });
    if (!picked) picked = Object.keys(variants)[0];
    try { localStorage.setItem(key, picked); } catch (_) {}
    // Log assignment
    if (window.gtag) {
      try { window.gtag('event', 'experiment_assignment', { experiment_id: name, variant_id: picked }); } catch (_) {}
    }
    document.dispatchEvent(new CustomEvent('mnl:experiment:assigned', { detail: { name: name, variant: picked } }));
    return picked;
  };
  // Auto-apply via data-mnl-exp="name" data-mnl-exp-show-on="variant_a"
  function applyExperiments() {
    document.querySelectorAll('[data-mnl-exp][data-mnl-exp-show-on]').forEach(function (el) {
      if (el.dataset.mnlExpApplied) return;
      el.dataset.mnlExpApplied = '1';
      var name = el.getAttribute('data-mnl-exp');
      var showOn = el.getAttribute('data-mnl-exp-show-on');
      var current = null;
      try { current = localStorage.getItem('mnl-exp-' + name); } catch (_) {}
      if (current && current !== showOn) el.style.display = 'none';
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(applyExperiments, 200);
  else applyExperiments();
  // Track conversion : <button data-mnl-exp-convert="experiment_name">
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-exp-convert]');
    if (!btn) return;
    var name = btn.getAttribute('data-mnl-exp-convert');
    var variant = null;
    try { variant = localStorage.getItem('mnl-exp-' + name); } catch (_) {}
    if (variant && window.gtag) {
      try { window.gtag('event', 'experiment_conversion', { experiment_id: name, variant_id: variant }); } catch (_) {}
    }
    document.dispatchEvent(new CustomEvent('mnl:experiment:convert', { detail: { name: name, variant: variant } }));
  });

  // ════════════ AUTO FAQPage JSON-LD SCHEMA (data-mnl-faq-auto-schema container) ════════════
  // Scanne les questions/réponses dans le scope, génère le schema FAQPage pour rich snippets Google
  // Usage : <div data-mnl-faq-auto-schema data-mnl-faq-q-selector=".mnl-faq__q" data-mnl-faq-a-selector=".mnl-faq__a">
  function setupFAQSchema() {
    document.querySelectorAll('[data-mnl-faq-auto-schema]').forEach(function (container) {
      if (container.dataset.mnlFaqSchemaBuilt) return;
      container.dataset.mnlFaqSchemaBuilt = '1';
      var qSel = container.getAttribute('data-mnl-faq-q-selector') || '.mnl-faq__q, summary';
      var aSel = container.getAttribute('data-mnl-faq-a-selector') || '.mnl-faq__a, .mnl-faq__a-inner';
      var items = container.querySelectorAll(qSel);
      if (items.length < 2) return; // pas la peine pour <2 questions
      var faqs = [];
      items.forEach(function (q) {
        var qText = (q.textContent || '').trim().replace(/\s+/g, ' ').replace(/[+−×↓↑]\s*$/, '').trim();
        // Trouve la réponse : prochain élément matching aSel dans le même parent
        var parent = q.closest('[data-cat], .mnl-faq__item, details') || q.parentElement;
        if (!parent) return;
        var aEl = parent.querySelector(aSel);
        if (!aEl) return;
        var aText = (aEl.textContent || '').trim().replace(/\s+/g, ' ');
        if (qText && aText) faqs.push({ q: qText, a: aText });
      });
      if (!faqs.length) return;
      var schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': faqs.map(function (f) {
          return { '@type': 'Question', 'name': f.q, 'acceptedAnswer': { '@type': 'Answer', 'text': f.a } };
        })
      };
      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupFAQSchema, 500);
  else setupFAQSchema();

  // ════════════ RATING DISTRIBUTION CHART (data-mnl-rating-dist='{"5":120,"4":80,"3":30,"2":10,"1":7}') ════════════
  function setupRatingDist() {
    document.querySelectorAll('[data-mnl-rating-dist]').forEach(function (container) {
      if (container.dataset.mnlRdBuilt) return;
      var data;
      try { data = JSON.parse(container.getAttribute('data-mnl-rating-dist')); } catch (_) { return; }
      if (!data || typeof data !== 'object') return;
      // Coerce values en nombres (handle strings dans le JSON)
      var counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      [5, 4, 3, 2, 1].forEach(function (s) { counts[s] = parseInt(data[s], 10) || 0; });
      var total = counts[5] + counts[4] + counts[3] + counts[2] + counts[1];
      // Empty state propre si total = 0
      if (!total) {
        container.dataset.mnlRdBuilt = '1';
        container.classList.add('mnl-rating-dist', 'mnl-rating-dist--empty');
        container.innerHTML = MNL_T('global.reviews_empty_html', '<p style="text-align:center;color:#94a3b8;font-size:13px;font-weight:600;padding:14px;margin:0;">Aucun avis pour le moment</p>');
        return;
      }
      container.dataset.mnlRdBuilt = '1';
      container.classList.add('mnl-rating-dist');
      container.innerHTML = [5, 4, 3, 2, 1].map(function (star) {
        var count = counts[star];
        var pct = (count / total) * 100;
        return '<div class="mnl-rating-dist__row">' +
          '<span class="mnl-rating-dist__label">' + star + ' ★</span>' +
          '<div class="mnl-rating-dist__bar"><div class="mnl-rating-dist__bar-fill" style="width:' + pct + '%"></div></div>' +
          '<span class="mnl-rating-dist__count">' + count + '</span>' +
          '<span class="mnl-rating-dist__pct">' + Math.round(pct) + '%</span>' +
        '</div>';
      }).join('');
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupRatingDist, 300);
  else setupRatingDist();

  // ════════════ AGE GATE MODAL (legal compliance) ════════════
  // Trigger : <html data-mnl-age-gate="16"> dans theme.liquid OU window.mnlAgeGate(16)
  window.mnlAgeGate = function (minAge, opts) {
    minAge = minAge || 16;
    opts = opts || {};
    try { if (sessionStorage.getItem('mnl-age-confirmed') === '1') return Promise.resolve(true); } catch (_) {}
    return new Promise(function (resolve) {
      var modal = document.createElement('div');
      modal.id = 'mnl-age-gate';
      modal.className = 'mnl-age-gate';
      modal.setAttribute('role', 'alertdialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'mnl-age-gate-title');
      modal.innerHTML =
        '<div class="mnl-age-gate__box">' +
          '<p class="mnl-age-gate__logo">My<em>Nutri</em>Lab</p>' +
          '<h2 class="mnl-age-gate__title" id="mnl-age-gate-title">' + (opts.title || MNL_T('global.agegate_title_prefix', 'As-tu ') + minAge + MNL_T('global.agegate_title_suffix', ' ans ou plus ?')) + '</h2>' +
          '<p class="mnl-age-gate__msg">' + (opts.msg || MNL_T('global.agegate_msg_prefix', 'Nos pré-workouts contiennent de la <strong>caféine</strong> dosée selon les recommandations <strong>ANSES</strong>. Ils ne sont pas adaptés aux mineurs de moins de ') + minAge + ' ans.') + '</p>' +
          '<div class="mnl-age-gate__actions">' +
            MNL_T('global.agegate_no_html', '<button type="button" class="mnl-age-gate__btn mnl-age-gate__btn--no">Non, je suis trop jeune</button>') +
            MNL_T('global.agegate_yes_prefix_html', '<button type="button" class="mnl-age-gate__btn mnl-age-gate__btn--yes">J\'ai ') + minAge + MNL_T('global.agegate_yes_suffix_html', ' ans+</button>') +
          '</div>' +
          MNL_T('global.agegate_legal_prefix_html', '<p class="mnl-age-gate__legal">En continuant, tu confirmes avoir au moins ') + minAge + MNL_T('global.agegate_legal_suffix_html', ' ans.<br>Caféine : 200mg max par portion. Pas pendant la grossesse / allaitement.</p>') +
        '</div>';
      document.body.appendChild(modal);
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      modal.querySelector('.mnl-age-gate__btn--yes').addEventListener('click', function () {
        try { sessionStorage.setItem('mnl-age-confirmed', '1'); } catch (_) {}
        modal.classList.remove('is-open');
        setTimeout(function () { modal.remove(); }, 300);
        document.body.style.overflow = '';
        resolve(true);
      });
      modal.querySelector('.mnl-age-gate__btn--no').addEventListener('click', function () {
        window.location.href = 'https://www.google.com/'; // Redirect away
        resolve(false);
      });
    });
  };
  // Auto-trigger si <html data-mnl-age-gate="16">
  var ageGateAttr = document.documentElement.getAttribute('data-mnl-age-gate');
  if (ageGateAttr) {
    window.mnlAgeGate(parseInt(ageGateAttr, 10) || 16);
  }

  // ════════════ CART CHECKOUT PROGRESS (data-mnl-checkout-progress="step") ════════════
  function setupCheckoutProgress() {
    document.querySelectorAll('[data-mnl-checkout-progress]').forEach(function (container) {
      if (container.dataset.mnlCpBuilt) return;
      var customSteps = container.getAttribute('data-mnl-checkout-steps');
      var useIcons = !customSteps;
      var steps = customSteps
        ? customSteps.split(',').map(function (s) { return s.trim(); }).filter(Boolean)
        : [MNL_T('global.checkout_step_cart', 'Panier'), MNL_T('global.checkout_step_info', 'Informations'), MNL_T('global.checkout_step_payment', 'Paiement'), MNL_T('global.checkout_step_done', 'Confirmé')]; // V790 : emojis remplacés par SVG (demande fondateur)
      // V790 : icônes SVG par défaut (panier / document / carte / coche) — currentColor → héritent la couleur de l'étape.
      var STEP_ICONS = [
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>',
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>',
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
      ];
      if (!steps.length) return; // bail si custom steps vide
      // Clamp current dans [0, steps.length-1]
      var current = Math.max(0, Math.min(steps.length - 1, parseInt(container.getAttribute('data-mnl-checkout-progress'), 10) || 0));
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }
      container.dataset.mnlCpBuilt = '1';
      container.classList.add('mnl-checkout-progress');
      container.setAttribute('role', 'progressbar');
      container.setAttribute('aria-valuemin', '0');
      container.setAttribute('aria-valuemax', String(steps.length));
      container.setAttribute('aria-valuenow', String(current + 1));
      container.innerHTML = steps.map(function (label, i) {
        var state = i < current ? 'is-done' : (i === current ? 'is-current' : '');
        var icon = i < current ? '✓' : String(i + 1);
        var iconSvg = (useIcons && STEP_ICONS[i]) ? '<span class="mnl-checkout-progress__icon" aria-hidden="true" style="display:inline-flex;align-items:center;margin-right:2px;">' + STEP_ICONS[i] + '</span>' : '';
        var html = '<div class="mnl-checkout-progress__step ' + state + '">' +
          '<span class="mnl-checkout-progress__num">' + icon + '</span>' +
          iconSvg +
          '<span>' + esc(label) + '</span>' +
        '</div>';
        if (i < steps.length - 1) html += '<span class="mnl-checkout-progress__sep" aria-hidden="true"></span>';
        return html;
      }).join('');
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupCheckoutProgress, 300);
  else setupCheckoutProgress();

  // ════════════ SUSTAINABILITY TRACKER — V359 : DÉSACTIVÉ (greenwashing automatique) ════════════
  // Avant V359 : calculait CO₂/plastique/arbres sur stats fake non auditées (2.1 kg CO₂/pot, 14g plastique, programme "1€=1 arbre" inexistant). V222 a documenté côté page-engagements que ces chiffres étaient inventés mais la fonction restait active côté compte client. Tout user logged-in voyait des "metrics impact" basées sur du faux → greenwashing automatique = Loi Climat 2021 amende jusqu'à 80% coût campagne + DGCCRF L121-1 allégation environnementale trompeuse.
  // V359 fix : data-mnl-sustain retiré de page-account.liquid:818 + fonction guard ici pour empêcher toute réactivation accidentelle. À ré-activer post-launch UNIQUEMENT avec audit bureau d'études indépendant (Greenly, Carbo, etc.) + données vérifiables source/lot.

  // ════════════ STREAK COUNTER (gamification visites) ════════════
  function setupStreak() {
    // V626 : compteur de streak « N jours de suite » RETIRÉ — gamification de visites non-premium (no-op, même pattern que setupSustain).
    return;
    document.querySelectorAll('[data-mnl-streak]').forEach(function (container) {
      if (container.dataset.mnlStreakBuilt) return;
      container.dataset.mnlStreakBuilt = '1';
      // Calcul streak depuis localStorage
      var today = new Date().toDateString();
      var streak = 1;
      try {
        var raw = localStorage.getItem('mnl-visit-streak');
        var data = raw ? JSON.parse(raw) : null;
        if (!data || !data.last) {
          // Première visite → init streak = 1
          streak = 1;
          localStorage.setItem('mnl-visit-streak', JSON.stringify({ last: today, count: 1 }));
        } else if (data.last === today) {
          // Même jour → garde count actuel (≥1)
          streak = Math.max(1, data.count || 1);
        } else {
          var lastDate = new Date(data.last);
          var diffDays = isNaN(lastDate.getTime()) ? 99 : Math.floor((new Date(today).getTime() - lastDate.getTime()) / 86400000);
          if (diffDays === 1) {
            // Lendemain → +1
            streak = (data.count || 0) + 1;
            localStorage.setItem('mnl-visit-streak', JSON.stringify({ last: today, count: streak }));
          } else {
            // Skip jours OU date corrompue → reset à 1
            streak = 1;
            localStorage.setItem('mnl-visit-streak', JSON.stringify({ last: today, count: 1 }));
          }
        }
      } catch (_) { streak = 1; }
      var labelOverride = container.getAttribute('data-mnl-streak-label');
      container.classList.add('mnl-streak');
      container.innerHTML =
        '<span class="mnl-streak__flame" aria-hidden="true"></span>' +
        '<span class="mnl-streak__num">' + streak + '</span>' +
        '<span class="mnl-streak__lbl">' + (labelOverride || 'jour' + (streak > 1 ? 's' : '') + ' de suite') + '</span>';
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupStreak, 300);
  else setupStreak();

  // ════════════ Q&A VOTING (data-mnl-qna-vote="qa-id") ════════════
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-qna-vote]');
    if (!btn) return;
    var id = btn.getAttribute('data-mnl-qna-vote');
    if (!id) return; // évite mnl-qna-vote-null partagé entre boutons sans id
    var key = 'mnl-qna-vote-' + id;
    var voted = false;
    try { voted = localStorage.getItem(key) === '1'; } catch (_) {}
    btn.classList.toggle('is-voted', !voted);
    btn.setAttribute('aria-pressed', voted ? 'false' : 'true'); // a11y
    var countEl = btn.querySelector('.mnl-qna__vote-count');
    if (countEl) {
      var cur = parseInt(countEl.textContent, 10) || 0;
      countEl.textContent = voted ? Math.max(0, cur - 1) : cur + 1;
    }
    try { localStorage.setItem(key, voted ? '0' : '1'); } catch (_) {}
    if (window.mnlToast) window.mnlToast({ icon: voted ? '↩' : '', title: voted ? MNL_T('global.vote_removed', 'Vote retiré') : MNL_T('global.common_thanks', 'Merci !'), sub: voted ? '' : MNL_T('global.vote_thanks_sub', 'Ton vote aide la communauté'), type: 'success', duration: 2500 });
  });
  // Init aria-pressed state au load (pour les boutons déjà votés)
  document.querySelectorAll('[data-mnl-qna-vote]').forEach(function (btn) {
    var id = btn.getAttribute('data-mnl-qna-vote');
    if (!id) return;
    var voted = false;
    try { voted = localStorage.getItem('mnl-qna-vote-' + id) === '1'; } catch (_) {}
    btn.setAttribute('aria-pressed', voted ? 'true' : 'false');
    if (voted) btn.classList.add('is-voted');
  });

  // ════════════ PROGRESSIVE DISCLOSURE (data-mnl-disclose-trigger="layer-id") ════════════
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-disclose-trigger]');
    if (!btn) return;
    e.preventDefault();
    var layerId = btn.getAttribute('data-mnl-disclose-trigger');
    if (!layerId) return;
    var container = btn.closest('.mnl-disclose');
    if (!container) return;
    container.querySelectorAll('.mnl-disclose__layer').forEach(function (l) { l.classList.remove('is-active'); });
    // CSS.escape pour gérer les ids avec caractères spéciaux (sinon selector cassé/injecté)
    var safeId = (window.CSS && CSS.escape) ? CSS.escape(layerId) : layerId.replace(/["'\\]/g, '');
    var target;
    try { target = container.querySelector('[data-mnl-disclose-layer="' + safeId + '"]'); } catch (_) { return; }
    if (target) {
      target.classList.add('is-active');
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    btn.style.display = 'none'; // Hide the trigger after disclose
  });

  // ════════════ STICKY RAIL (favs/share floating buttons left side) ════════════
  // <div data-mnl-rail='[{"icon":"♡","tip":"Wishlist","action":"wishlist","handle":"X"},{"icon":"","tip":"Partager","action":"share"},{"icon":"","tip":"Imprimer","action":"print"}]'>
  function setupRail() {
    document.querySelectorAll('[data-mnl-rail]').forEach(function (container) {
      if (container.dataset.mnlRailBuilt) return;
      container.dataset.mnlRailBuilt = '1';
      var actions;
      try { actions = JSON.parse(container.getAttribute('data-mnl-rail')); } catch (_) { return; }
      container.classList.add('mnl-rail');
      container.innerHTML = actions.map(function (a) {
        var attrs = '';
        if (a.action === 'wishlist') attrs = ' data-mnl-wishlist="' + (a.handle || '') + '" data-mnl-wishlist-title="' + (a.title || '') + '"';
        else if (a.action === 'share') attrs = ' data-mnl-share-url="' + (a.url || 'true') + '"';
        else if (a.action === 'print') attrs = ' data-mnl-print';
        else if (a.action === 'qr') attrs = ' data-mnl-qr-trigger="' + (a.url || 'true') + '"';
        else if (a.url) attrs = ' onclick="window.location.href=\'' + a.url + '\'"';
        return '<button type="button" class="mnl-rail__btn"' + attrs + ' aria-label="' + (a.tip || '') + '">' +
          '<span aria-hidden="true">' + (a.icon || '•') + '</span>' +
          '<span class="mnl-rail__btn-tip">' + (a.tip || '') + '</span>' +
        '</button>';
      }).join('');
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupRail, 300);
  else setupRail();

  // ════════════ TIP ROTATOR (data-mnl-tip-rotator='["Tip 1","Tip 2","Tip 3"]') ════════════
  function setupTipRotator() {
    document.querySelectorAll('[data-mnl-tip-rotator]').forEach(function (container) {
      if (container.dataset.mnlTipBuilt) return;
      container.dataset.mnlTipBuilt = '1';
      var tips;
      try { tips = JSON.parse(container.getAttribute('data-mnl-tip-rotator')); } catch (_) { return; }
      if (!Array.isArray(tips) || !tips.length) return;
      var idx = 0;
      container.classList.add('mnl-tip-rotator');
      function render() {
        container.innerHTML =
          '<span class="mnl-tip-rotator__icon" aria-hidden="true"></span>' +
          '<div class="mnl-tip-rotator__body">' +
            MNL_T('global.tip_label_html', '<p class="mnl-tip-rotator__label">Le savais-tu ?</p>') +
            '<p class="mnl-tip-rotator__text" key="' + idx + '">' + tips[idx] + '</p>' +
          '</div>' +
          '<span class="mnl-tip-rotator__nav">' +
            MNL_T('global.tip_prev_html', '<button type="button" class="mnl-tip-rotator__nav-btn" data-tip-prev aria-label="Précédent">‹</button>') +
            MNL_T('global.tip_next_html', '<button type="button" class="mnl-tip-rotator__nav-btn" data-tip-next aria-label="Suivant">›</button>') +
          '</span>';
        container.querySelector('[data-tip-prev]').addEventListener('click', function () { idx = (idx - 1 + tips.length) % tips.length; render(); });
        container.querySelector('[data-tip-next]').addEventListener('click', function () { idx = (idx + 1) % tips.length; render(); });
      }
      render();
      // Respect prefers-reduced-motion : pas d'auto-rotation, l'utilisateur navigue manuellement
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) return;
      // Auto-rotate every 8s
      var intervalMs = parseInt(container.getAttribute('data-mnl-tip-interval'), 10) || 8000;
      var auto = null;
      function startAuto(){
        if (auto) return;
        auto = setInterval(function () {
          // Vague 61 : guard memory leak (si container démonté par section reload Shopify)
          if (!document.body.contains(container)) { clearInterval(auto); auto = null; return; }
          if (document.visibilityState !== 'visible') return;
          idx = (idx + 1) % tips.length;
          render();
        }, intervalMs);
      }
      function stopAuto(){ if (auto) { clearInterval(auto); auto = null; } }
      startAuto();
      // Pause on hover + focus, RESUME on leave (vague 61 fix : avant pas de reprise → rotator mort après 1er hover)
      container.addEventListener('mouseenter', stopAuto);
      container.addEventListener('focusin', stopAuto);
      container.addEventListener('mouseleave', startAuto);
      container.addEventListener('focusout', startAuto);
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupTipRotator, 300);
  else setupTipRotator();

  // ════════════ MULTI-SELECT DROPDOWN (data-mnl-multiselect) ════════════
  // <div data-mnl-multiselect data-mnl-multiselect-options='[{"v":"red","l":"Rouge"},{"v":"blue","l":"Bleu"}]' data-mnl-multiselect-name="colors">
  function setupMultiSelects() {
    document.querySelectorAll('[data-mnl-multiselect]').forEach(function (container) {
      if (container.dataset.mnlMsBuilt) return;
      var name = container.getAttribute('data-mnl-multiselect-name') || 'multi';
      var placeholder = container.getAttribute('data-mnl-multiselect-placeholder') || MNL_T('global.select_placeholder', 'Sélectionner');
      var options;
      try { options = JSON.parse(container.getAttribute('data-mnl-multiselect-options') || '[]'); } catch (_) { return; }
      if (!Array.isArray(options) || !options.length) return;
      // XSS guard : escape labels/values dans le DOM (innerHTML insertion)
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[c]; }); }
      container.dataset.mnlMsBuilt = '1';
      container.classList.add('mnl-multiselect');
      var selected = [];
      var initialVal = container.getAttribute('data-mnl-multiselect-value');
      if (initialVal) selected = initialVal.split(',').filter(Boolean);
      function render() {
        container.innerHTML =
          '<button type="button" class="mnl-multiselect__btn" aria-haspopup="listbox" aria-expanded="false">' +
            '<span>' + (selected.length ? (selected.length + ' sélectionné' + (selected.length > 1 ? 's' : '')) : placeholder) + '</span>' +
            '<span style="display:inline-flex;gap:6px;align-items:center;">' +
              '<span class="mnl-multiselect__count" data-count="' + selected.length + '">' + selected.length + '</span>' +
              '<span class="mnl-multiselect__caret">▼</span>' +
            '</span>' +
          '</button>' +
          '<div class="mnl-multiselect__panel" role="listbox" aria-multiselectable="true">' +
            options.map(function (opt) {
              var isSel = selected.indexOf(opt.v) !== -1;
              return '<div class="mnl-multiselect__option ' + (isSel ? 'is-selected' : '') + '" role="option" aria-selected="' + isSel + '" data-value="' + esc(opt.v) + '">' +
                '<span class="mnl-multiselect__check" aria-hidden="true"></span>' +
                '<span>' + esc(opt.l) + '</span>' +
              '</div>';
            }).join('') +
            (selected.length ? MNL_T('global.multiselect_clear_html', '<div class="mnl-multiselect__divider"></div><div class="mnl-multiselect__clear">Effacer la sélection</div>') : '') +
          '</div>' +
          '<input type="hidden" name="' + esc(name) + '" value="' + esc(selected.join(',')) + '">';
      }
      render();
      container.addEventListener('click', function (e) {
        var btn = e.target.closest('.mnl-multiselect__btn');
        if (btn) {
          e.stopPropagation();
          var isOpen = container.classList.contains('is-open');
          document.querySelectorAll('.mnl-multiselect.is-open').forEach(function (m) { m.classList.remove('is-open'); m.querySelector('.mnl-multiselect__btn').setAttribute('aria-expanded', 'false'); });
          if (!isOpen) { container.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
          return;
        }
        var opt = e.target.closest('.mnl-multiselect__option');
        if (opt) {
          e.stopPropagation();
          var v = opt.getAttribute('data-value');
          var idx = selected.indexOf(v);
          if (idx > -1) selected.splice(idx, 1);
          else selected.push(v);
          render();
          container.classList.add('is-open'); container.querySelector('.mnl-multiselect__btn').setAttribute('aria-expanded', 'true');
          container.dispatchEvent(new CustomEvent('mnl:multiselect:change', { detail: { value: selected } }));
          return;
        }
        var clr = e.target.closest('.mnl-multiselect__clear');
        if (clr) { selected = []; render(); container.classList.add('is-open'); container.dispatchEvent(new CustomEvent('mnl:multiselect:change', { detail: { value: [] } })); }
      });
    });
  }
  document.addEventListener('click', function () {
    document.querySelectorAll('.mnl-multiselect.is-open').forEach(function (m) {
      m.classList.remove('is-open');
      var btn = m.querySelector('.mnl-multiselect__btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  });
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupMultiSelects, 300);
  else setupMultiSelects();

  // ════════════ SHAKE ERROR ANIMATION HELPER ════════════
  window.mnlShake = function (el) {
    if (!el) return;
    el.classList.remove('mnl-shake');
    void el.offsetWidth; // reflow trick
    el.classList.add('mnl-shake');
    setTimeout(function () { el.classList.remove('mnl-shake'); }, 600);
    if (navigator.vibrate) navigator.vibrate([60, 40, 60]);
  };

  // ════════════ ANIMATED PRICE CHANGE (data-mnl-price-watch) ════════════
  // Quand le textContent change → animate (up/down si numeric)
  if ('MutationObserver' in window) {
    document.querySelectorAll('[data-mnl-price-watch]').forEach(function (el) {
      if (el.dataset.mnlPwBound) return;
      el.dataset.mnlPwBound = '1';
      var lastValue = parseFloat((el.textContent || '').replace(/[^\d,.\-]/g, '').replace(',', '.'));
      new MutationObserver(function () {
        var current = parseFloat((el.textContent || '').replace(/[^\d,.\-]/g, '').replace(',', '.'));
        if (isNaN(current) || isNaN(lastValue)) { lastValue = current; return; }
        if (current === lastValue) return;
        var direction = current > lastValue ? 'up' : 'down';
        el.classList.remove('mnl-price-change', 'mnl-price-change--up', 'mnl-price-change--down');
        void el.offsetWidth;
        el.classList.add('mnl-price-change', 'mnl-price-change--' + direction);
        setTimeout(function () { el.classList.remove('mnl-price-change', 'mnl-price-change--' + direction); }, 600);
        lastValue = current;
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  // ════════════ SPLIT BUTTON (auto via .mnl-split + .mnl-split__caret) ════════════
  document.addEventListener('click', function (e) {
    var caret = e.target.closest('.mnl-split__caret');
    if (caret) {
      e.stopPropagation();
      var split = caret.closest('.mnl-split');
      var isOpen = split.classList.contains('is-open');
      document.querySelectorAll('.mnl-split.is-open').forEach(function (s) { s.classList.remove('is-open'); });
      if (!isOpen) split.classList.add('is-open');
      return;
    }
    document.querySelectorAll('.mnl-split.is-open').forEach(function (s) {
      if (!s.contains(e.target)) s.classList.remove('is-open');
    });
  });

  // ════════════ SPEECH-TO-TEXT (data-mnl-stt-target="#input") ════════════
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-stt-target]');
    if (!btn) return;
    e.preventDefault();
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) { if (window.mnlToastWarn) window.mnlToastWarn(MNL_T('global.unsupported_title', 'Non supporté'), MNL_T('global.stt_unsupported_sub', 'Ton navigateur ne supporte pas la reconnaissance vocale')); return; }
    // SpeechRecognition exige un contexte sécurisé (HTTPS)
    if (!window.isSecureContext) { if (window.mnlToastWarn) window.mnlToastWarn(MNL_T('global.stt_https_title', 'HTTPS requis'), MNL_T('global.stt_https_sub', 'Reconnaissance vocale nécessite une connexion sécurisée')); return; }
    var sel = btn.getAttribute('data-mnl-stt-target');
    var input;
    try { input = document.querySelector(sel); } catch (_) { return; } // protect contre selector invalide
    if (!input) return;
    if (btn.classList.contains('is-listening')) {
      if (btn._mnlRec) try { btn._mnlRec.stop(); } catch (_) {}
      return;
    }
    var rec = new SR();
    rec.lang = btn.getAttribute('data-mnl-stt-lang') || document.documentElement.getAttribute('lang') || 'fr-FR';
    rec.interimResults = true;
    rec.continuous = false;
    btn.classList.add('is-listening');
    btn._mnlRec = rec;
    // Timeout safety : auto-stop après 30s pour ne pas garder le micro ouvert
    var timeoutId = setTimeout(function () { try { rec.stop(); } catch (_) {} }, 30000);
    rec.onresult = function (event) {
      var transcript = '';
      for (var i = 0; i < event.results.length; i++) transcript += event.results[i][0].transcript;
      input.value = transcript;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    };
    rec.onend = function () { clearTimeout(timeoutId); btn.classList.remove('is-listening'); btn._mnlRec = null; };
    rec.onerror = function (ev) {
      clearTimeout(timeoutId); btn.classList.remove('is-listening'); btn._mnlRec = null;
      var msg = (ev && ev.error === 'not-allowed') ? MNL_T('global.mic_denied', 'Microphone refusé') : MNL_T('global.mic_error', 'Erreur micro');
      if (window.mnlToastError) window.mnlToastError(msg, MNL_T('global.mic_check_perms', 'Vérifie les autorisations'));
    };
    try { rec.start(); } catch (_) { btn.classList.remove('is-listening'); clearTimeout(timeoutId); }
  });

  // ════════════ SOUND FX TOGGLE (subtle UI sounds opt-in) ════════════
  var sfxEnabled = false;
  try { sfxEnabled = localStorage.getItem('mnl-sfx-enabled') === '1'; } catch (_) {}
  function applySfxToggle(toggle) {
    toggle.classList.toggle('is-on', sfxEnabled);
    toggle.innerHTML = (sfxEnabled ? '' : '') + ' <span>Sons UI ' + (sfxEnabled ? 'ON' : 'OFF') + '</span>';
  }
  document.querySelectorAll('[data-mnl-sfx-toggle]').forEach(function (toggle) {
    toggle.classList.add('mnl-sfx-toggle');
    applySfxToggle(toggle);
    toggle.addEventListener('click', function () {
      sfxEnabled = !sfxEnabled;
      try { localStorage.setItem('mnl-sfx-enabled', sfxEnabled ? '1' : '0'); } catch (_) {}
      applySfxToggle(toggle);
      if (sfxEnabled) window.mnlPlaySfx('toggle');
    });
  });
  // Vague 104 : singleton AudioContext anti-leak (avant : nouveau context créé à chaque appel —
  // Chrome cap 6 contexts/page → erreur silencieuse après 6 SFX → SFX inopérants jusqu'au reload).
  // Maintenant : 1 context lazy + suspend automatique après inactivité pour économiser CPU/batterie.
  var _mnlAudioCtx = null;
  var _mnlAudioCtxIdleTimer = null;
  function _getAudioCtx() {
    try {
      if (!_mnlAudioCtx) {
        var AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        _mnlAudioCtx = new AC();
      }
      if (_mnlAudioCtx.state === 'suspended') {
        // resume nécessaire après user gesture / autoplay policy
        _mnlAudioCtx.resume().catch(function(){});
      }
      // Schedule suspend après 30s d'inactivité (économise CPU mobile + batterie)
      if (_mnlAudioCtxIdleTimer) clearTimeout(_mnlAudioCtxIdleTimer);
      _mnlAudioCtxIdleTimer = setTimeout(function(){
        if (_mnlAudioCtx && _mnlAudioCtx.state === 'running') {
          _mnlAudioCtx.suspend().catch(function(){});
        }
      }, 30000);
      return _mnlAudioCtx;
    } catch(_) { return null; }
  }
  window.mnlPlaySfx = function (type) {
    if (!sfxEnabled) return;
    var ctx = _getAudioCtx();
    if (!ctx) return;
    try {
      var osc = ctx.createOscillator();
      var gain = ctx.createGain();
      var freq = { click: 440, success: 880, error: 220, toggle: 660 }[type] || 440;
      var dur = type === 'success' ? .15 : .08;
      osc.frequency.value = freq;
      osc.type = 'sine';
      osc.connect(gain); gain.connect(ctx.destination);
      gain.gain.setValueAtTime(.08, ctx.currentTime);
      osc.start(); osc.stop(ctx.currentTime + dur);
      gain.gain.exponentialRampToValueAtTime(.001, ctx.currentTime + dur);
    } catch (_) {}
  };
  // Vague 104 : expose pour autres callers (workout timer L3433 etc.)
  window._mnlGetAudioCtx = _getAudioCtx;

  // ════════════ ONLINE SYNC INDICATOR (data-mnl-sync-when-online callback) ════════════
  var pendingSync = [];
  window.mnlAddSyncTask = function (task) {
    pendingSync.push(task);
    if (navigator.onLine) trySync();
  };
  function showSyncIndicator(text, syncing) {
    var el = document.getElementById('mnl-sync-indicator');
    if (!el) {
      el = document.createElement('div');
      el.id = 'mnl-sync-indicator';
      el.className = 'mnl-sync-indicator';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = '<span class="mnl-sync-indicator__dot" aria-hidden="true"></span><span>' + text + '</span>';
    el.classList.toggle('mnl-sync-indicator--syncing', !!syncing);
    el.classList.add('is-active');
    setTimeout(function () { el.classList.remove('is-active'); }, 3000);
  }
  function trySync() {
    if (!pendingSync.length) return;
    showSyncIndicator(MNL_T('global.sync_running', 'Sync en cours…'), true);
    var tasks = pendingSync.slice();
    pendingSync = [];
    Promise.allSettled(tasks.map(function (t) { return t(); })).then(function (results) {
      var ok = results.filter(function (r) { return r.status === 'fulfilled'; }).length;
      showSyncIndicator(MNL_T('global.sync_ok_prefix', '✓ Sync OK (') + ok + '/' + tasks.length + ')', false);
    });
  }
  window.addEventListener('online', trySync);

  // ════════════ PARTICLE BURST API (success moments unique) ════════════
  window.mnlParticleBurst = function (opts) {
    opts = opts || {};
    var x = opts.x || window.innerWidth / 2;
    var y = opts.y || window.innerHeight / 2;
    var count = opts.count || 30;
    var colors = opts.colors || ['#C2410C', '#fbbf24', '#22c55e', '#3b82f6'];
    var container = document.querySelector('.mnl-particles') || (function () {
      var c = document.createElement('div');
      c.className = 'mnl-particles';
      document.body.appendChild(c);
      return c;
    })();
    for (var i = 0; i < count; i++) {
      var p = document.createElement('div');
      p.className = 'mnl-particle';
      p.style.background = colors[Math.floor(Math.random() * colors.length)];
      p.style.left = x + 'px';
      p.style.top = y + 'px';
      var angle = (Math.PI * 2 * i) / count + Math.random() * 0.5;
      var dist = 50 + Math.random() * 100;
      var dx = Math.cos(angle) * dist;
      var dy = Math.sin(angle) * dist + Math.random() * 50; // slight gravity
      p.style.transition = 'transform .9s cubic-bezier(.16,.84,.44,1), opacity .9s ease';
      container.appendChild(p);
      requestAnimationFrame(function (el, dx, dy) {
        return function () {
          el.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.4)';
          el.style.opacity = '0';
        };
      }(p, dx, dy));
      setTimeout(function (el) { return function () { el.remove(); }; }(p), 1000);
    }
  };

  // ════════════ OTP INPUT (data-mnl-otp data-mnl-otp-length="6") ════════════
  function setupOTPInputs() {
    document.querySelectorAll('[data-mnl-otp]').forEach(function (container) {
      if (container.dataset.mnlOtpBuilt) return;
      container.dataset.mnlOtpBuilt = '1';
      var len = parseInt(container.getAttribute('data-mnl-otp-length'), 10) || 6;
      var name = container.getAttribute('data-mnl-otp-name') || 'otp';
      container.classList.add('mnl-otp');
      var inputs = '';
      for (var i = 0; i < len; i++) {
        // autocomplete="one-time-code" sur le premier input → iOS auto-remplit depuis le SMS reçu
        var ac = (i === 0) ? ' autocomplete="one-time-code"' : ' autocomplete="off"';
        inputs += '<input type="text" inputmode="numeric" maxlength="1" pattern="[0-9]" class="mnl-otp__input" data-idx="' + i + '" aria-label="Chiffre ' + (i + 1) + '"' + ac + '>';
      }
      container.innerHTML = inputs + '<input type="hidden" name="' + name + '">';
      var fields = container.querySelectorAll('.mnl-otp__input');
      var hidden = container.querySelector('input[type="hidden"]');
      function updateHidden() {
        var val = Array.from(fields).map(function (f) { return f.value; }).join('');
        hidden.value = val;
        if (val.length === len) {
          container.dispatchEvent(new CustomEvent('mnl:otp:complete', { detail: { value: val } }));
        }
      }
      fields.forEach(function (input, i) {
        input.addEventListener('input', function (e) {
          var val = input.value.replace(/\D/g, '').slice(0, 1);
          input.value = val;
          input.classList.toggle('is-filled', !!val);
          if (val && i < len - 1) fields[i + 1].focus();
          updateHidden();
        });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Backspace' && !input.value && i > 0) fields[i - 1].focus();
          else if (e.key === 'ArrowLeft' && i > 0) fields[i - 1].focus();
          else if (e.key === 'ArrowRight' && i < len - 1) fields[i + 1].focus();
        });
        input.addEventListener('paste', function (e) {
          e.preventDefault();
          var paste = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '').slice(0, len);
          paste.split('').forEach(function (c, k) {
            if (fields[k]) { fields[k].value = c; fields[k].classList.add('is-filled'); }
          });
          if (fields[paste.length]) fields[paste.length].focus();
          else fields[len - 1].focus();
          updateHidden();
        });
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupOTPInputs, 300);
  else setupOTPInputs();
  // Mark error helper
  window.mnlOtpError = function (container) {
    if (typeof container === 'string') container = document.querySelector(container);
    if (!container) return;
    container.querySelectorAll('.mnl-otp__input').forEach(function (i) { i.classList.add('is-error'); });
    setTimeout(function () { container.querySelectorAll('.mnl-otp__input').forEach(function (i) { i.classList.remove('is-error'); }); }, 800);
  };

  // ════════════ BOTTOM SHEET MOBILE ════════════
  // Usage : window.mnlOpenSheet('id', { title, body })
  function ensureSheet(id, title) {
    var sheet = document.getElementById(id);
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.id = id;
    sheet.className = 'mnl-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', title || MNL_T('global.panel_default_label', 'Panneau'));
    sheet.innerHTML =
      '<div class="mnl-sheet__overlay" data-mnl-sheet-close></div>' +
      '<div class="mnl-sheet__panel">' +
        '<div class="mnl-sheet__handle" aria-hidden="true"></div>' +
        '<header class="mnl-sheet__head">' +
          '<h2 class="mnl-sheet__title">' + (title || '') + '</h2>' +
          MNL_T('global.sheet_close_html', '<button type="button" class="mnl-sheet__close" data-mnl-sheet-close aria-label="Fermer">×</button>') +
        '</header>' +
        '<div class="mnl-sheet__body"></div>' +
      '</div>';
    document.body.appendChild(sheet);
    // Drag-to-dismiss
    var panel = sheet.querySelector('.mnl-sheet__panel');
    var startY = 0, currentY = 0, dragging = false;
    panel.addEventListener('touchstart', function (e) {
      // Only if touch starts on handle area or top of panel
      var rect = panel.getBoundingClientRect();
      if (e.touches[0].clientY - rect.top > 80) return;
      startY = e.touches[0].clientY;
      dragging = true;
      panel.classList.add('is-dragging');
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      currentY = e.touches[0].clientY - startY;
      if (currentY > 0) panel.style.transform = 'translateY(' + currentY + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      panel.classList.remove('is-dragging');
      if (currentY > 100) window.mnlCloseSheet(id);
      else panel.style.transform = '';
      currentY = 0;
    });
    return sheet;
  }
  window.mnlOpenSheet = function (id, opts) {
    opts = opts || {};
    var sheet = ensureSheet(id, opts.title);
    if (opts.body) sheet.querySelector('.mnl-sheet__body').innerHTML = opts.body;
    if (opts.title) sheet.querySelector('.mnl-sheet__title').textContent = opts.title;
    sheet.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  window.mnlCloseSheet = function (id) {
    var sheet = id ? document.getElementById(id) : document.querySelector('.mnl-sheet.is-open');
    if (sheet) {
      sheet.classList.remove('is-open');
      var panel = sheet.querySelector('.mnl-sheet__panel');
      if (panel) panel.style.transform = '';
    }
    document.body.style.overflow = '';
  };
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mnl-sheet-trigger]');
    if (trigger) {
      e.preventDefault();
      window.mnlOpenSheet(trigger.getAttribute('data-mnl-sheet-trigger').replace(/^#/, ''), {
        title: trigger.getAttribute('data-mnl-sheet-title') || ''
      });
      return;
    }
    if (e.target.closest('[data-mnl-sheet-close]')) window.mnlCloseSheet();
  });

  // ════════════ CIRCULAR PROGRESS (data-mnl-circular="75" data-mnl-circular-label="Progression") ════════════
  function setupCircular() {
    document.querySelectorAll('[data-mnl-circular]').forEach(function (container) {
      if (container.dataset.mnlCircBuilt) return;
      container.dataset.mnlCircBuilt = '1';
      var pct = parseFloat(container.getAttribute('data-mnl-circular')) || 0;
      pct = Math.max(0, Math.min(100, pct));
      var label = container.getAttribute('data-mnl-circular-label') || '';
      var color1 = container.getAttribute('data-mnl-circular-color1') || '#C2410C';
      var color2 = container.getAttribute('data-mnl-circular-color2') || '#ea580c';
      var size = container.classList.contains('mnl-circular--lg') ? 120 : 80;
      var radius = (size - 16) / 2;
      var circumference = 2 * Math.PI * radius;
      var offset = circumference - (pct / 100) * circumference;
      var gradId = 'mnl-circular-grad-' + Math.random().toString(36).slice(2, 8);
      container.classList.add('mnl-circular');
      container.innerHTML =
        '<svg viewBox="0 0 ' + size + ' ' + size + '">' +
          '<defs><linearGradient id="' + gradId + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="' + color1 + '"/><stop offset="100%" stop-color="' + color2 + '"/></linearGradient></defs>' +
          '<circle class="mnl-circular__bg" cx="' + (size / 2) + '" cy="' + (size / 2) + '" r="' + radius + '"></circle>' +
          '<circle class="mnl-circular__fg" cx="' + (size / 2) + '" cy="' + (size / 2) + '" r="' + radius + '" stroke="url(#' + gradId + ')" stroke-dasharray="' + circumference + '" stroke-dashoffset="' + circumference + '"></circle>' +
        '</svg>' +
        '<div class="mnl-circular__label">' +
          '<div class="mnl-circular__num">' + Math.round(pct) + '%</div>' +
          (label ? '<div class="mnl-circular__sub">' + label + '</div>' : '') +
        '</div>';
      // Animate fill
      var fg = container.querySelector('.mnl-circular__fg');
      requestAnimationFrame(function () { fg.style.strokeDashoffset = offset; });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupCircular, 300);
  else setupCircular();

  // ════════════ AUTO-SAVE INDICATOR (data-mnl-autosave) ════════════
  // <span data-mnl-autosave></span> + utilise window.mnlAutosaveSet('saved'|'saving'|'error'|'idle', element)
  window.mnlAutosaveSet = function (state, el) {
    if (!el) el = document.querySelector('[data-mnl-autosave]');
    if (!el) return;
    el.classList.remove('mnl-autosave--saved', 'mnl-autosave--saving', 'mnl-autosave--error');
    el.classList.add('mnl-autosave');
    var icon = '', text = '';
    if (state === 'saved') { icon = '✓'; text = MNL_T('global.autosave_saved', 'Sauvé'); el.classList.add('mnl-autosave--saved'); }
    else if (state === 'saving') { icon = '⟳'; text = MNL_T('global.autosave_saving', 'Sauvegarde…'); el.classList.add('mnl-autosave--saving'); }
    else if (state === 'error') { icon = ''; text = MNL_T('global.common_error', 'Erreur'); el.classList.add('mnl-autosave--error'); }
    else { text = MNL_T('global.autosave_modified', 'Modifié'); }
    el.innerHTML = '<span class="mnl-autosave__icon" aria-hidden="true">' + icon + '</span><span>' + text + '</span>';
  };
  // Auto-init idle
  document.querySelectorAll('[data-mnl-autosave]').forEach(function (el) { window.mnlAutosaveSet('idle', el); });

  // ════════════ INLINE CONFIRMATION ("Are you sure?" pattern) ════════════
  // <button data-mnl-inline-confirm="Tu confirmes ?" data-mnl-inline-confirm-action="..."> Supprimer </button>
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mnl-inline-confirm]');
    if (!btn) return;
    if (!btn.classList.contains('is-confirming')) {
      e.preventDefault();
      e.stopPropagation();
      var origText = btn.textContent;
      btn.dataset.mnlOrigText = origText;
      btn.textContent = btn.getAttribute('data-mnl-inline-confirm') || MNL_T('global.inline_confirm', 'Confirmer ?');
      btn.classList.add('is-confirming');
      // Auto-revert après 3.5s
      var revertTimer = setTimeout(function () {
        btn.classList.remove('is-confirming');
        btn.textContent = origText;
      }, 3500);
      btn.dataset.mnlRevertTimer = revertTimer;
      // Click ailleurs revert
      var dismissOnce = function (ev) {
        if (!btn.contains(ev.target)) {
          btn.classList.remove('is-confirming');
          btn.textContent = origText;
          clearTimeout(revertTimer);
          document.removeEventListener('click', dismissOnce, true);
        }
      };
      setTimeout(function () { document.addEventListener('click', dismissOnce, true); }, 50);
    } else {
      // 2nd click = action confirmed
      clearTimeout(parseInt(btn.dataset.mnlRevertTimer, 10));
      btn.classList.remove('is-confirming');
      btn.textContent = btn.dataset.mnlOrigText || btn.textContent;
      btn.dispatchEvent(new CustomEvent('mnl:confirm:proceed', { bubbles: true }));
    }
  }, true);

  // ════════════ HASH ANCHOR COPY (deep link sections) ════════════
  // <h2 data-mnl-anchor="section-id">Titre</h2> → ajoute lien copy
  function setupAnchors() {
    document.querySelectorAll('[data-mnl-anchor]').forEach(function (el) {
      if (el.dataset.mnlAnchorBuilt) return;
      var id = el.getAttribute('data-mnl-anchor');
      if (!el.id && id) el.id = id;
      if (!el.id) return; // bail si pas d'id, possible re-essai si DOM update
      el.dataset.mnlAnchorBuilt = '1';
      var a = document.createElement('a');
      a.href = '#' + el.id;
      a.className = 'mnl-anchor-link';
      a.setAttribute('aria-label', MNL_T('global.anchor_label', 'Lien direct vers cette section'));
      a.title = MNL_T('global.anchor_title', 'Copier le lien vers cette section');
      a.innerHTML = '';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var url = window.location.origin + window.location.pathname + '#' + el.id;
        var label = (el.textContent || '').trim().slice(0, 40);
        // Fallback robuste : navigator.clipboard puis execCommand
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url).then(function () {
            if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.link_copied', 'Lien copié'), MNL_T('global.anchor_section_prefix', 'Section : ') + label);
          }).catch(function () {});
        } else {
          // Fallback execCommand pour HTTP / vieux navigateurs
          var input = document.createElement('input');
          input.value = url; input.style.cssText = 'position:fixed;top:-9999px;opacity:0';
          document.body.appendChild(input); input.select();
          try { document.execCommand('copy'); } catch (_) {}
          document.body.removeChild(input);
          if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.link_copied', 'Lien copié'), MNL_T('global.anchor_section_prefix', 'Section : ') + label);
        }
        history.replaceState(null, '', '#' + el.id);
      });
      el.insertBefore(a, el.firstChild);
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupAnchors, 300);
  else setupAnchors();

  // ════════════ INLINE EDIT TEXT (data-mnl-inline-edit) ════════════
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-mnl-inline-edit]');
    if (!el || el.classList.contains('is-editing')) return;
    el.classList.add('mnl-inline-edit', 'is-editing');
    el.contentEditable = 'true';
    el.focus();
    // Select all text
    var range = document.createRange();
    range.selectNodeContents(el);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    var origText = el.textContent;
    var commit = function () {
      el.classList.remove('is-editing');
      el.contentEditable = 'false';
      var newText = el.textContent.trim();
      if (newText !== origText) {
        el.dispatchEvent(new CustomEvent('mnl:inline-edit:change', { bubbles: true, detail: { old: origText, new: newText } }));
      }
    };
    el.addEventListener('blur', commit, { once: true });
    el.addEventListener('keydown', function (kev) {
      if (kev.key === 'Enter') { kev.preventDefault(); el.blur(); }
      else if (kev.key === 'Escape') { el.textContent = origText; el.blur(); }
    });
  });

  // ════════════ PULL-TO-REFRESH (data-mnl-ptr) ════════════
  function setupPTR() {
    document.querySelectorAll('[data-mnl-ptr]').forEach(function (container) {
      if (container.dataset.mnlPtrBuilt) return;
      container.dataset.mnlPtrBuilt = '1';
      container.classList.add('mnl-ptr');
      var indicator = document.createElement('div');
      indicator.className = 'mnl-ptr__indicator';
      indicator.setAttribute('aria-label', MNL_T('global.ptr_pull', 'Tirer pour rafraîchir'));
      indicator.innerHTML = '↓';
      // Préserve la position si déjà absolute/relative/fixed (anti-régression layout)
      var computed = window.getComputedStyle(container).position;
      if (computed === 'static') container.style.position = 'relative';
      container.appendChild(indicator);
      var startY = 0, currentY = 0, pulling = false, refreshTimer = null;
      function resetIndicator() {
        clearTimeout(refreshTimer);
        indicator.classList.remove('is-pulling', 'is-refreshing');
        indicator.style.transform = '';
        indicator.innerHTML = '↓';
      }
      container.addEventListener('touchstart', function (e) {
        if (container.scrollTop > 0) return;
        // Si refresh en cours → cancel le timer + reset propre avant de re-pull
        if (refreshTimer) resetIndicator();
        startY = e.touches[0].clientY;
        pulling = true;
      }, { passive: true });
      container.addEventListener('touchmove', function (e) {
        if (!pulling) return;
        currentY = e.touches[0].clientY - startY;
        if (currentY > 0 && currentY < 150) {
          indicator.classList.add('is-pulling');
          indicator.style.transform = 'translateX(-50%) translateY(' + Math.min(60, currentY * .5) + 'px) rotate(' + (currentY * 2) + 'deg)';
        }
      }, { passive: true });
      container.addEventListener('touchend', function () {
        if (!pulling) return;
        pulling = false;
        if (currentY > 80) {
          indicator.classList.remove('is-pulling');
          indicator.classList.add('is-refreshing');
          indicator.innerHTML = '⟳';
          container.dispatchEvent(new CustomEvent('mnl:ptr:refresh'));
          refreshTimer = setTimeout(resetIndicator, 2000);
        } else {
          indicator.classList.remove('is-pulling');
          indicator.style.transform = '';
        }
        currentY = 0;
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupPTR, 300);
  else setupPTR();

  // ════════════ FLOATING TOC right side (data-mnl-toc-float scope) ════════════
  function setupFloatingTOC() {
    var container = document.querySelector('[data-mnl-toc-float]');
    if (!container || container.dataset.mnlTocFloatBuilt) return;
    var scope = document.querySelector(container.getAttribute('data-mnl-toc-float-scope') || 'main') || document;
    // Auto-slugify h2/h3 sans id pour que le TOC fonctionne sur du RTE/blog
    if (container.hasAttribute('data-mnl-toc-autoslug')) {
      var seen = {};
      scope.querySelectorAll('h2, h3').forEach(function (h) {
        if (h.id) return;
        var slug = (h.textContent || '').toLowerCase()
          .normalize('NFD').replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'h';
        if (seen[slug]) { seen[slug]++; slug += '-' + seen[slug]; } else { seen[slug] = 1; }
        h.id = slug;
      });
    }
    var headings = scope.querySelectorAll('h2[id], h3[id]');
    if (headings.length < 3) return;
    container.dataset.mnlTocFloatBuilt = '1';
    container.classList.add('mnl-toc-float');
    container.innerHTML = '<ul class="mnl-toc-float__list">' +
      Array.from(headings).map(function (h) {
        var label = h.textContent.trim().slice(0, 30);
        return '<li><a href="#' + h.id + '" class="mnl-toc-float__item" data-target="' + h.id + '">' +
          '<span class="mnl-toc-float__dot" aria-hidden="true"></span>' +
          '<span>' + label + '</span>' +
        '</a></li>';
      }).join('') +
    '</ul>';
    // Active section observer
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            container.querySelectorAll('.mnl-toc-float__item').forEach(function (a) { a.classList.remove('is-active'); });
            var active = container.querySelector('[data-target="' + e.target.id + '"]');
            if (active) active.classList.add('is-active');
          }
        });
      }, { rootMargin: '-20% 0px -65% 0px' }).observe(headings[0]);
      headings.forEach(function (h) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            container.querySelectorAll('.mnl-toc-float__item').forEach(function (a) { a.classList.remove('is-active'); });
            var active = container.querySelector('[data-target="' + h.id + '"]');
            if (active) active.classList.add('is-active');
          }
        }, { rootMargin: '-30% 0px -55% 0px' }).observe(h);
      });
    }
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupFloatingTOC, 300);
  else setupFloatingTOC();

  // ════════════ PASSWORD STRENGTH METER + SHOW/HIDE ════════════
  function setupPasswords() {
    document.querySelectorAll('input[type="password"][data-mnl-password]').forEach(function (input) {
      if (input.dataset.mnlPwBound) return;
      input.dataset.mnlPwBound = '1';
      var wrap = document.createElement('div');
      wrap.className = 'mnl-password';
      input.parentNode.insertBefore(wrap, input);
      wrap.appendChild(input);
      input.classList.add('mnl-password__input');
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'mnl-password__toggle';
      toggle.setAttribute('aria-label', MNL_T('global.pwd_show_label', 'Afficher le mot de passe'));
      toggle.textContent = MNL_T('global.pwd_show', 'Voir');
      wrap.appendChild(toggle);
      toggle.addEventListener('click', function () {
        var isPwd = input.type === 'password';
        input.type = isPwd ? 'text' : 'password';
        toggle.textContent = isPwd ? MNL_T('global.pwd_hide', 'Cacher') : MNL_T('global.pwd_show', 'Voir');
        toggle.setAttribute('aria-label', isPwd ? MNL_T('global.pwd_hide_label', 'Cacher le mot de passe') : MNL_T('global.pwd_show_label', 'Afficher le mot de passe'));
        input.focus();
      });
      // Strength meter
      if (input.hasAttribute('data-mnl-password-strength')) {
        var meter = document.createElement('div');
        meter.className = 'mnl-password__strength';
        meter.innerHTML = '<div class="mnl-password__strength-bar"></div><div class="mnl-password__strength-bar"></div><div class="mnl-password__strength-bar"></div><div class="mnl-password__strength-bar"></div>';
        wrap.appendChild(meter);
        var label = document.createElement('p');
        label.className = 'mnl-password__strength-label';
        wrap.appendChild(label);
        function evaluate() {
          var pwd = input.value;
          var score = 0;
          if (pwd.length >= 8) score++;
          if (pwd.length >= 12) score++;
          if (/[A-Z]/.test(pwd) && /[a-z]/.test(pwd)) score++;
          if (/\d/.test(pwd) && /[^A-Za-z\d]/.test(pwd)) score++;
          var bars = meter.querySelectorAll('.mnl-password__strength-bar');
          bars.forEach(function (b, i) {
            b.classList.remove('is-active-1', 'is-active-2', 'is-active-3', 'is-active-4');
            if (i < score) b.classList.add('is-active-' + score);
          });
          var labels = ['', MNL_T('global.pwd_strength_weak', 'Faible'), MNL_T('global.pwd_strength_medium', 'Moyen'), MNL_T('global.pwd_strength_strong', 'Fort'), MNL_T('global.pwd_strength_excellent', 'Excellent')];
          var classes = ['', 'mnl-password__strength-label--weak', 'mnl-password__strength-label--medium', 'mnl-password__strength-label--strong', 'mnl-password__strength-label--excellent'];
          label.className = 'mnl-password__strength-label ' + classes[score];
          label.textContent = pwd ? (labels[score] || '') : '';
        }
        input.addEventListener('input', evaluate);
        evaluate();
      }
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupPasswords, 300);
  else setupPasswords();

  // ════════════ INPUT CLEAR BUTTON (data-mnl-clearable) ════════════
  function setupClearables() {
    document.querySelectorAll('input[data-mnl-clearable], textarea[data-mnl-clearable]').forEach(function (input) {
      if (input.dataset.mnlClBound) return;
      input.dataset.mnlClBound = '1';
      var wrap = input.closest('.mnl-input-clear') || (function () {
        var w = document.createElement('div');
        w.className = 'mnl-input-clear';
        input.parentNode.insertBefore(w, input);
        w.appendChild(input);
        return w;
      })();
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mnl-input-clear__btn';
      btn.setAttribute('aria-label', MNL_T('global.clearfield_label', 'Effacer le champ'));
      btn.innerHTML = '×';
      wrap.appendChild(btn);
      function update() { wrap.classList.toggle('has-value', !!input.value); }
      function clearInput() {
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      }
      input.addEventListener('input', update);
      btn.addEventListener('click', clearInput);
      // Keyboard : Esc dans l'input = clear (UX standard cmd palette / search)
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && input.value) { e.preventDefault(); clearInput(); }
      });
      update();
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupClearables, 300);
  else setupClearables();

  // ════════════ INTERNATIONAL PHONE INPUT (with flag picker) ════════════
  var COUNTRIES_PHONE = [
    { code: '+33', name: MNL_T('global.country_fr', 'France'), flag: '', iso: 'FR' },
    { code: '+32', name: MNL_T('global.country_be', 'Belgique'), flag: '', iso: 'BE' },
    { code: '+352', name: MNL_T('global.country_lu', 'Luxembourg'), flag: '', iso: 'LU' },
    { code: '+41', name: MNL_T('global.country_ch', 'Suisse'), flag: '', iso: 'CH' },
    { code: '+34', name: MNL_T('global.country_es', 'Espagne'), flag: '', iso: 'ES' },
    { code: '+39', name: MNL_T('global.country_it', 'Italie'), flag: '', iso: 'IT' },
    { code: '+49', name: MNL_T('global.country_de', 'Allemagne'), flag: '', iso: 'DE' },
    { code: '+351', name: MNL_T('global.country_pt', 'Portugal'), flag: '', iso: 'PT' },
    { code: '+44', name: MNL_T('global.country_gb', 'Royaume-Uni'), flag: '', iso: 'GB' },
    { code: '+1', name: MNL_T('global.country_us_ca', 'USA / Canada'), flag: '', iso: 'US' }
  ];
  function setupPhoneIntl() {
    document.querySelectorAll('[data-mnl-phone-intl]').forEach(function (container) {
      if (container.dataset.mnlPhBuilt) return;
      container.dataset.mnlPhBuilt = '1';
      var name = container.getAttribute('data-mnl-phone-intl-name') || 'phone';
      var defaultIso = container.getAttribute('data-mnl-phone-intl-default') || 'FR';
      var defaultCountry = COUNTRIES_PHONE.find(function (c) { return c.iso === defaultIso; }) || COUNTRIES_PHONE[0];
      container.classList.add('mnl-phone-intl');
      container.style.position = 'relative';
      container.innerHTML =
        MNL_T('global.phone_country_btn_html', '<button type="button" class="mnl-phone-intl__country" aria-haspopup="listbox" aria-expanded="false" aria-label="Choisir le pays">') +
          '<span class="mnl-phone-intl__flag">' + defaultCountry.flag + '</span>' +
          '<span class="mnl-phone-intl__code">' + defaultCountry.code + '</span>' +
          '<span class="mnl-phone-intl__caret">▼</span>' +
        '</button>' +
        MNL_T('global.phone_input_html', '<input type="tel" class="mnl-phone-intl__input" placeholder="6 12 34 56 78" autocomplete="tel" data-mnl-format="phone-fr" aria-label="Numéro de téléphone">') +
        '<input type="hidden" name="' + name + '" value="' + defaultCountry.code + '">' +
        '<div class="mnl-phone-intl__panel" role="listbox">' +
          COUNTRIES_PHONE.map(function (c) {
            return '<div class="mnl-phone-intl__option" data-iso="' + c.iso + '" data-code="' + c.code + '" data-flag="' + c.flag + '">' +
              '<span class="mnl-phone-intl__flag">' + c.flag + '</span>' +
              '<span>' + c.name + '</span>' +
              '<span class="mnl-phone-intl__option-code">' + c.code + '</span>' +
            '</div>';
          }).join('') +
        '</div>';
      var btn = container.querySelector('.mnl-phone-intl__country');
      var phoneInput = container.querySelector('.mnl-phone-intl__input');
      var hidden = container.querySelector('input[type="hidden"]');
      var panel = container.querySelector('.mnl-phone-intl__panel');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        document.querySelectorAll('.mnl-phone-intl.is-open').forEach(function (p) { if (p !== container) p.classList.remove('is-open'); });
        container.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', container.classList.contains('is-open') ? 'true' : 'false');
      });
      panel.addEventListener('click', function (e) {
        var opt = e.target.closest('.mnl-phone-intl__option');
        if (!opt) return;
        var code = opt.getAttribute('data-code');
        var flag = opt.getAttribute('data-flag');
        btn.querySelector('.mnl-phone-intl__flag').textContent = flag;
        btn.querySelector('.mnl-phone-intl__code').textContent = code;
        hidden.value = code;
        container.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        phoneInput.focus();
        container.dispatchEvent(new CustomEvent('mnl:phone-intl:change', { detail: { code: code, flag: flag } }));
      });
      // Sync phone value to hidden (full international)
      phoneInput.addEventListener('input', function () {
        hidden.value = btn.querySelector('.mnl-phone-intl__code').textContent + ' ' + phoneInput.value;
      });
    });
  }
  document.addEventListener('click', function () {
    document.querySelectorAll('.mnl-phone-intl.is-open').forEach(function (p) {
      p.classList.remove('is-open');
      var btn = p.querySelector('.mnl-phone-intl__country');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  });
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupPhoneIntl, 300);
  else setupPhoneIntl();

  // ════════════ TIMELINE COMPONENT (data-mnl-timeline JSON) ════════════
  function setupTimelines() {
    document.querySelectorAll('[data-mnl-timeline]').forEach(function (container) {
      if (container.dataset.mnlTlBuilt) return;
      container.dataset.mnlTlBuilt = '1';
      var data;
      try { data = JSON.parse(container.getAttribute('data-mnl-timeline')); } catch (_) { return; }
      if (!Array.isArray(data)) return;
      container.classList.add('mnl-timeline');
      container.innerHTML = data.map(function (item) {
        return '<div class="mnl-timeline__item ' + (item.milestone ? 'mnl-timeline__item--milestone' : '') + '">' +
          '<div class="mnl-timeline__dot" aria-hidden="true"></div>' +
          (item.date ? '<span class="mnl-timeline__date">' + item.date + '</span>' : '') +
          (item.title ? '<h3 class="mnl-timeline__title">' + item.title + '</h3>' : '') +
          (item.desc ? '<p class="mnl-timeline__desc">' + item.desc + '</p>' : '') +
        '</div>';
      }).join('');
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupTimelines, 300);
  else setupTimelines();

  // ════════════ INLINE PAGE FEEDBACK (data-mnl-feedback="page-id") ════════════
  // Attributs supportés :
  //  - data-mnl-feedback-q : question custom
  //  - data-mnl-feedback-thanks : message de remerciement custom
  //  - Évent dispatché : 'mnl:feedback:submitted' (detail = { page, vote, comment })
  function setupFeedback() {
    // V556 : widget « Cette page t'a aidé ? » DÉSACTIVÉ (demande user).
    // On ne construit plus rien ; les conteneurs [data-mnl-feedback] sont masqués via CSS.
    return;
    document.querySelectorAll('[data-mnl-feedback]').forEach(function (container) {
      if (container.dataset.mnlFbBuilt) return;
      container.dataset.mnlFbBuilt = '1';
      var pageId = container.getAttribute('data-mnl-feedback');
      var question = container.getAttribute('data-mnl-feedback-q') || MNL_T('global.pagefeedback_question', 'Cette page t\'a-t-elle aidé ?');
      var thanks = container.getAttribute('data-mnl-feedback-thanks') || MNL_T('global.pagefeedback_thanks', '✓ Merci pour ton retour !');
      // Skip si déjà votés
      try { if (localStorage.getItem('mnl-feedback-' + pageId)) return; } catch (_) {}
      container.classList.add('mnl-feedback');
      container.innerHTML =
        '<p class="mnl-feedback__title">' + question + '</p>' +
        '<div class="mnl-feedback__btns">' +
          MNL_T('global.pagefeedback_yes_html', '<button type="button" class="mnl-feedback__btn" data-vote="yes">Oui</button>') +
          MNL_T('global.pagefeedback_no_html', '<button type="button" class="mnl-feedback__btn" data-vote="no">Pas vraiment</button>') +
        '</div>' +
        MNL_T('global.pagefeedback_textarea_html', '<textarea class="mnl-feedback__textarea" placeholder="Dis-nous ce qu\'on peut améliorer (optionnel)"></textarea>') +
        '<p class="mnl-feedback__thanks">' + thanks + '</p>';
      function submit(vote, comment) {
        try { localStorage.setItem('mnl-feedback-' + pageId, JSON.stringify({ vote: vote, comment: comment || '', ts: Date.now() })); } catch (_) {}
        // Vague 91 : POST backend Vercel (avant : fetch('/api/feedback') → 404 silencieux car endpoint
        // est sur vercel.app, pas sur mynutrilab.com → tous les feedbacks perdus).
        // Utilise window.MNL_FEEDBACK_ENDPOINT (configurable via layout) OU dérive de metrics endpoint OU fallback hardcoded.
        var feedbackUrl = window.MNL_FEEDBACK_ENDPOINT
          || (window.MNL_METRICS_ENDPOINT ? window.MNL_METRICS_ENDPOINT.replace(/\/api\/metrics.*$/, '/api/feedback') : null)
          || 'https://mynutrilab-ai.vercel.app/api/feedback';
        // Vague 230 : helper pour stocker le feedback en localStorage si le réseau échoue
        // (récupérable via window.mnlExportFeedbackBackup() depuis la console DevTools).
        var _backupFb = function (reason) {
          try {
            var bk = JSON.parse(localStorage.getItem('mnl-fb-backup') || '[]');
            bk.push({ page: pageId, vote: vote, comment: comment || '', ts: Date.now(), reason: reason || 'unknown' });
            localStorage.setItem('mnl-fb-backup', JSON.stringify(bk.slice(-100)));
          } catch (_) {}
        };
        try {
          // Beacon en priorité (survit au navigateur fermé)
          var payload = JSON.stringify({ page: pageId, vote: vote, comment: comment || '' });
          var sent = false;
          if (navigator.sendBeacon) {
            try { sent = navigator.sendBeacon(feedbackUrl, new Blob([payload], { type: 'application/json' })); } catch(_) { sent = false; }
          }
          if (!sent) {
            fetch(feedbackUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: payload,
              keepalive: true,
              mode: 'cors'
            }).then(function (r) {
              // Vague 230 : backup si endpoint répond mais en erreur (5xx, 4xx hors 200/202)
              if (r && r.status >= 500) _backupFb('http_5xx_' + r.status);
              else if (r && r.status >= 400 && r.status !== 401) _backupFb('http_4xx_' + r.status);
            }).catch(function (err) {
              // Vague 230 : backup si fetch fail (network/CORS/DNS)
              _backupFb('network_' + ((err && err.name) || 'unknown'));
            });
          }
        } catch (e) {
          // Vague 230 : backup si exception synchrone (storage full, beacon throw, etc.)
          _backupFb('throw_' + ((e && e.name) || 'unknown'));
        }
        // Custom event pour analytics tiers (GA4, Plausible, Matomo, etc.)
        document.dispatchEvent(new CustomEvent('mnl:feedback:submitted', { detail: { page: pageId, vote: vote, comment: comment || '' } }));
      }
      container.addEventListener('click', function (e) {
        var btn = e.target.closest('.mnl-feedback__btn');
        if (!btn) return;
        var vote = btn.getAttribute('data-vote');
        if (vote === 'no') {
          container.classList.add('is-detail');
          var ta = container.querySelector('.mnl-feedback__textarea');
          ta.focus();
          if (ta.dataset.mnlFbSubmitted) return;
          ta.dataset.mnlFbSubmitted = '1';
          ta.addEventListener('blur', function () {
            container.classList.add('is-submitted');
            submit(vote, ta.value);
          }, { once: true });
        } else {
          container.classList.add('is-submitted');
          submit(vote);
          if (window.mnlToastSuccess) window.mnlToastSuccess(MNL_T('global.common_thanks', 'Merci !'), MNL_T('global.pagefeedback_toast_sub', 'Ton retour est précieux'));
        }
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupFeedback, 300);
  else setupFeedback();

  // ════════════ NUMBER INPUT WITH STEPPERS (data-mnl-num) ════════════
  function setupNumInputs() {
    document.querySelectorAll('input[type="number"][data-mnl-num]').forEach(function (input) {
      if (input.dataset.mnlNumBound) return;
      input.dataset.mnlNumBound = '1';
      var wrap = document.createElement('div');
      wrap.className = 'mnl-num';
      input.parentNode.insertBefore(wrap, input);
      wrap.appendChild(input);
      var min = parseFloat(input.min) || 0;
      var max = parseFloat(input.max) || 999;
      var step = parseFloat(input.step) || 1;
      var steppers = document.createElement('div');
      steppers.className = 'mnl-num__steppers';
      steppers.innerHTML = '<button type="button" class="mnl-num__step" data-step="up" aria-label="Augmenter">▲</button><button type="button" class="mnl-num__step" data-step="down" aria-label="Diminuer">▼</button>';
      wrap.appendChild(steppers);
      function update(delta) {
        var cur = parseFloat(input.value) || 0;
        var next = Math.max(min, Math.min(max, cur + delta));
        input.value = next;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        steppers.querySelector('[data-step="up"]').disabled = (next >= max);
        steppers.querySelector('[data-step="down"]').disabled = (next <= min);
      }
      steppers.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-step]');
        if (!btn) return;
        update(btn.getAttribute('data-step') === 'up' ? step : -step);
      });
      // Init disabled state correctement (avant : up/down toujours enabled au load)
      update(0);
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupNumInputs, 300);
  else setupNumInputs();

  // ════════════ COLOR PICKER (data-mnl-color-picker="['#C2410C','#fbbf24',...]") ════════════
  function setupColorPickers() {
    document.querySelectorAll('[data-mnl-color-picker]').forEach(function (container) {
      if (container.dataset.mnlCpBuilt) return;
      var colors;
      try { colors = JSON.parse(container.getAttribute('data-mnl-color-picker')); } catch (_) { return; }
      if (!Array.isArray(colors) || !colors.length) return;
      // Filtre les couleurs valides (anti-CSS-injection : whitelist hex/rgb/named simples)
      var validColor = /^(#[0-9a-fA-F]{3,8}|rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*[\d.]+\s*\)|[a-zA-Z]+)$/;
      colors = colors.filter(function (c) { return typeof c === 'string' && validColor.test(c.trim()); });
      if (!colors.length) return;
      var initial = container.getAttribute('data-mnl-color-picker-value') || colors[0];
      if (!validColor.test(String(initial).trim())) initial = colors[0];
      var name = container.getAttribute('data-mnl-color-picker-name') || 'color';
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[c]; }); }
      container.dataset.mnlCpBuilt = '1';
      container.classList.add('mnl-color-picker');
      container.innerHTML = colors.map(function (c) {
        return '<button type="button" class="mnl-color-picker__swatch ' + (c === initial ? 'is-active' : '') + '" style="background:' + c + ';" data-color="' + esc(c) + '" aria-label="Couleur ' + esc(c) + '"></button>';
      }).join('') + '<input type="hidden" name="' + esc(name) + '" value="' + esc(initial) + '">';
      container.addEventListener('click', function (e) {
        var sw = e.target.closest('.mnl-color-picker__swatch');
        if (!sw) return;
        container.querySelectorAll('.mnl-color-picker__swatch').forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
        container.querySelector('input[type="hidden"]').value = sw.getAttribute('data-color');
        container.dispatchEvent(new CustomEvent('mnl:color:change', { detail: { color: sw.getAttribute('data-color') } }));
      });
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupColorPickers, 300);
  else setupColorPickers();

  // ════════════ SLIDER SINGLE VALUE (data-mnl-slider) ════════════
  function setupSliders() {
    document.querySelectorAll('[data-mnl-slider]').forEach(function (container) {
      if (container.dataset.mnlSlBuilt) return;
      container.dataset.mnlSlBuilt = '1';
      var min = parseFloat(container.getAttribute('data-mnl-slider-min'));
      if (isNaN(min)) min = 0;
      var max = parseFloat(container.getAttribute('data-mnl-slider-max'));
      if (isNaN(max)) max = 100;
      var step = parseFloat(container.getAttribute('data-mnl-slider-step'));
      if (isNaN(step) || step <= 0) step = 1;
      var value = parseFloat(container.getAttribute('data-mnl-slider-value'));
      if (isNaN(value)) value = min; // fix : value=0 légitime devenait min avant
      var label = container.getAttribute('data-mnl-slider-label') || MNL_T('global.slider_default_label', 'Valeur');
      var suffix = container.getAttribute('data-mnl-slider-suffix') || '';
      var name = container.getAttribute('data-mnl-slider-name') || 'slider';
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }
      container.classList.add('mnl-slider');
      container.innerHTML =
        '<div class="mnl-slider__label"><span>' + esc(label) + '</span><span class="mnl-slider__value">' + value + esc(suffix) + '</span></div>' +
        '<input type="range" name="' + esc(name) + '" min="' + min + '" max="' + max + '" step="' + step + '" value="' + value + '" aria-label="' + esc(label) + '">';
      var input = container.querySelector('input');
      var valEl = container.querySelector('.mnl-slider__value');
      function update() {
        var v = parseFloat(input.value);
        var pct = max > min ? ((v - min) / (max - min)) * 100 : 0;
        input.style.backgroundImage = 'linear-gradient(90deg,#E84E1B 0%,#E84E1B ' + pct + '%,#e2e8f0 ' + pct + '%)';
        valEl.textContent = v + suffix;
        container.dispatchEvent(new CustomEvent('mnl:slider:change', { detail: { value: v } }));
      }
      input.addEventListener('input', update);
      update();
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupSliders, 300);
  else setupSliders();

  // ════════════ AUDIO PLAYER WIDGET (data-mnl-audio="src.mp3" data-mnl-audio-title="Title") ════════════
  // Liste partagée + 1 seul listener visibilitychange (anti memory leak)
  var mnlAudioInstances = [];
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) mnlAudioInstances.forEach(function (a) { if (!a.paused) a.pause(); });
  });
  function setupAudioPlayers() {
    document.querySelectorAll('[data-mnl-audio]').forEach(function (container) {
      if (container.dataset.mnlAuBuilt) return;
      var src = container.getAttribute('data-mnl-audio');
      if (!src) return;
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }
      var title = container.getAttribute('data-mnl-audio-title') || MNL_T('global.audio_default_title', 'Audio');
      container.dataset.mnlAuBuilt = '1';
      container.classList.add('mnl-audio');
      container.innerHTML =
        '<button type="button" class="mnl-audio__play" aria-label="Lire ' + esc(title) + '">▶</button>' +
        '<div style="flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;">' +
          '<p class="mnl-audio__title">' + esc(title) + '</p>' +
          '<p class="mnl-audio__time">0:00 / 0:00</p>' +
        '</div>' +
        '<div class="mnl-audio__progress" role="slider" aria-label="Position lecture" tabindex="0"><div class="mnl-audio__progress-fill"></div></div>';
      var audio = new Audio(src);
      audio.preload = 'metadata';
      var playBtn = container.querySelector('.mnl-audio__play');
      var time = container.querySelector('.mnl-audio__time');
      var progress = container.querySelector('.mnl-audio__progress');
      var fill = container.querySelector('.mnl-audio__progress-fill');
      function fmt(s) { if (!isFinite(s)) return '0:00'; var m = Math.floor(s / 60); var ss = Math.floor(s % 60); return m + ':' + (ss < 10 ? '0' : '') + ss; }
      audio.addEventListener('timeupdate', function () {
        if (audio.duration && isFinite(audio.duration)) {
          fill.style.width = (audio.currentTime / audio.duration * 100) + '%';
        }
        time.textContent = fmt(audio.currentTime) + ' / ' + fmt(audio.duration);
      });
      audio.addEventListener('play', function () { playBtn.textContent = '⏸'; playBtn.setAttribute('aria-label', MNL_T('global.audio_pause_prefix', 'Pause ') + title); });
      audio.addEventListener('pause', function () { playBtn.textContent = '▶'; playBtn.setAttribute('aria-label', MNL_T('global.audio_play_prefix', 'Lire ') + title); });
      audio.addEventListener('ended', function () { playBtn.textContent = '↻'; playBtn.setAttribute('aria-label', MNL_T('global.audio_replay_prefix', 'Rejouer ') + title); });
      function toggle() {
        if (audio.ended) { audio.currentTime = 0; audio.play(); }
        else if (audio.paused) audio.play();
        else audio.pause();
      }
      playBtn.addEventListener('click', toggle);
      // Keyboard : Espace sur la barre de progression pour play/pause + Arrows pour seek ±5s
      progress.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); if (isFinite(audio.duration)) audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); audio.currentTime = Math.max(0, audio.currentTime - 5); }
      });
      progress.addEventListener('click', function (e) {
        if (!audio.duration || !isFinite(audio.duration)) return;
        var rect = progress.getBoundingClientRect();
        audio.currentTime = ((e.clientX - rect.left) / rect.width) * audio.duration;
      });
      // Track pour visibilitychange global (au lieu d'1 listener par instance)
      mnlAudioInstances.push(audio);
    });
  }
  if (window.mnlOnDomChange) window.mnlOnDomChange(setupAudioPlayers, 300);
  else setupAudioPlayers();

  // ════════════ TEXT SCRAMBLE EFFECT (data-mnl-scramble="Texte final") ════════════
  // Effet hacker-style sur intersection. Respect prefers-reduced-motion.
  var scrambleChars = '!<>-_\\/[]{}—=+*^?#';
  var scrambleReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function scrambleAnimate(el, finalText) {
    // Si reduced-motion : affiche directement le texte final sans animation
    if (scrambleReducedMotion) { el.textContent = finalText; return; }
    var current = '';
    var i = 0;
    var interval = setInterval(function () {
      current = '';
      for (var j = 0; j < finalText.length; j++) {
        if (j < i) current += finalText[j];
        else current += scrambleChars[Math.floor(Math.random() * scrambleChars.length)];
      }
      el.textContent = current;
      i += 0.5;
      if (i >= finalText.length) {
        clearInterval(interval);
        el.textContent = finalText;
      }
    }, 30);
  }
  if ('IntersectionObserver' in window) {
    var scrambleObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var finalText = el.getAttribute('data-mnl-scramble') || el.textContent;
        scrambleAnimate(el, finalText);
        scrambleObs.unobserve(el);
      });
    }, { threshold: 0.5 });
    function bindScramble() {
      document.querySelectorAll('[data-mnl-scramble]:not([data-mnl-scramble-bound])').forEach(function (el) {
        el.dataset.mnlScrambleBound = '1';
        el.classList.add('mnl-scramble');
        scrambleObs.observe(el);
      });
    }
    if (window.mnlOnDomChange) window.mnlOnDomChange(bindScramble, 300);
    else bindScramble();
  }

  // ════════════ ANIMATED STATS COUNTER (intersection observer) ════════════
  if ('IntersectionObserver' in window) {
    function animateStat(el) {
      var target = parseFloat(el.dataset.statTarget || el.textContent.replace(/[^\d.]/g, '')) || 0;
      var duration = parseInt(el.dataset.statDuration || '1200', 10);
      var suffix = el.dataset.statSuffix || '';
      var prefix = el.dataset.statPrefix || '';
      var decimals = (target % 1 !== 0) ? 1 : 0;
      var start = performance.now();
      function tick(now) {
        var p = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
        var v = (target * eased).toFixed(decimals);
        el.textContent = prefix + v + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    var statObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !e.target.dataset.statAnimated) {
          e.target.dataset.statAnimated = '1';
          animateStat(e.target);
          statObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-stat-target], .mnl-stat-num').forEach(function (el) {
      statObs.observe(el);
    });
  }

  // [SUPPRIMÉ] Doublon back-to-top : la version active est setupBackToTop() ligne ~3515 (vague 9).
  // Cette version créait un 2ᵉ bouton avec même id mnl-back-top (HTML invalide : duplicate id).

  // ════════════ PAGE TRANSITIONS (turbo-link feel pour internal nav) ════════════
  // Vague 103 : reset auto si navigation annulée (Ctrl-click intercepté, popup blocker, fetch error).
  // Avant : classes `mnl-page-leaving` + `is-active` stuck → barre + opacity restaient à l'écran
  //         jusqu'au refresh. Maintenant : timeout 5s + cleanup sur pageshow (BFCache restoration).
  function setupPageTransitions() {
    var loadingBar = document.createElement('div');
    loadingBar.className = 'mnl-page-loading-bar';
    loadingBar.setAttribute('role', 'progressbar');
    loadingBar.setAttribute('aria-label', MNL_T('global.pageload_label', 'Chargement de la page'));
    loadingBar.hidden = true;
    document.body.appendChild(loadingBar);
    var resetTimer = null;
    var startTimer = null;
    function _resetTransition(){
      if (resetTimer) { clearTimeout(resetTimer); resetTimer = null; }
      if (startTimer) { clearTimeout(startTimer); startTimer = null; }
      document.body.classList.remove('mnl-page-leaving');
      loadingBar.classList.remove('is-active');
      loadingBar.hidden = true;
    }
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.startsWith('#') || /^(mailto:|tel:|javascript:|sms:)/i.test(href)) return;
      if ((link.target && link.target !== '_self') || link.hasAttribute('download') || link.hasAttribute('data-no-transition')) return;
      // Skip si modifier (Ctrl/Cmd/Shift) → ouvre dans nouvel onglet, pas de transition
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      // Check internal link
      try {
        var url = new URL(href, window.location.href);
        if (url.origin !== window.location.origin) return;
        // Skip if same page
        if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      } catch (_) { return; }
      _resetTransition();
      startTimer = setTimeout(function () {
        startTimer = null;
        if (e.defaultPrevented) return;
        loadingBar.hidden = false;
        loadingBar.classList.add('is-active');
        resetTimer = setTimeout(_resetTransition, 5000);
      }, 120);
    });
    // Vague 103 : cleanup sur pageshow (BFCache restoration) — quand l'user revient via Back,
    // les classes appliquées avant unload sont restaurées par le BFCache → on les retire.
    window.addEventListener('pageshow', _resetTransition);
    window.addEventListener('pagehide', _resetTransition);
    // Aussi : cleanup au load complet (sécurité ceinture-bretelles)
    window.addEventListener('load', _resetTransition);
  }
  setupPageTransitions();

  function updateCartBadge(eventOrCart) {
    var badge = document.getElementById('mnl-bnav-cart-badge');
    if (!badge) return;
    // Vague 107 : si event detail contient déjà le cart, skip le fetch (le main-cart/cart-drawer le passe)
    var directCart = eventOrCart && eventOrCart.detail && typeof eventOrCart.detail.item_count === 'number' ? eventOrCart.detail : null;
    function _apply(cart){
      var count = (cart && cart.item_count) || 0;
      if (count > 0) { badge.textContent = count; badge.hidden = false; }
      else { badge.textContent = ''; badge.hidden = true; }
      try { localStorage.setItem('mnl-cart-count', String(count)); } catch(_){}
    }
    if (directCart) {
      _apply(directCart);
      return;
    }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(_apply)
      .catch(function () {});
  }
  document.addEventListener('mnl:cart:updated', updateCartBadge);

  // ════════════ SCROLL PROGRESS BAR (top of viewport) ════════════
  function buildScrollProgress() {
    if (document.getElementById('mnl-scroll-progress')) return;
    var bar = document.createElement('div');
    bar.id = 'mnl-scroll-progress';
    bar.className = 'mnl-scroll-progress';
    bar.innerHTML = '<div class="mnl-scroll-progress__fill" id="mnl-scroll-progress-fill"></div>';
    document.body.appendChild(bar);
    var fill = bar.querySelector('.mnl-scroll-progress__fill');
    function update() {
      var docH = (document.documentElement.scrollHeight - window.innerHeight) || 1;
      var pct = Math.min(100, Math.max(0, (window.pageYOffset / docH) * 100));
      fill.style.width = pct.toFixed(1) + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }
  buildScrollProgress();

  // ════════════ WISHLIST SYSTEM v2 (toggle button + public APIs) ════════════
  // NB : getWishlist() est déjà défini ligne ~806 (système heart toggle). On réutilise pour éviter
  // le shadowing par hoisting qui causait des bugs (1 fonction écrasait l'autre dans le même IIFE).
  var WISH_KEY = 'mnl-wishlist'; // même clé que le système v1 → données partagées
  function setWishlist(arr) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(arr)); } catch (_) {}
    updateWishlistToggle();
    // Dispatch event pour cohérence avec le système v1 (ligne 809 saveWishlist)
    try { document.dispatchEvent(new CustomEvent('mnl:wishlist:updated', { detail: arr })); } catch (_) {}
  }
  window.mnlAddToWishlist = function (handle, title) {
    var w = getWishlist();
    if (w.some(function (x) { return x.handle === handle; })) return false;
    w.unshift({ handle: handle, title: title || handle, ts: Date.now() });
    if (w.length > 20) w = w.slice(0, 20);
    setWishlist(w);
    return true;
  };
  window.mnlRemoveFromWishlist = function (handle) {
    var w = getWishlist().filter(function (x) { return x.handle !== handle; });
    setWishlist(w);
  };
  window.mnlIsInWishlist = function (handle) {
    return getWishlist().some(function (x) { return x.handle === handle; });
  };
  function updateWishlistToggle() {
    var t = document.getElementById('mnl-wishlist-toggle');
    if (!t) return;
    var count = getWishlist().length;
    if (count > 0) {
      t.classList.add('is-active');
      var c = t.querySelector('.mnl-wishlist-toggle__count');
      if (c) c.textContent = count;
    } else {
      t.classList.remove('is-active');
    }
  }
  function buildWishlistToggle() {
    if (document.getElementById('mnl-wishlist-toggle')) return;
    var btn = document.createElement('button');
    btn.id = 'mnl-wishlist-toggle';
    btn.type = 'button';
    btn.className = 'mnl-wishlist-toggle';
    btn.setAttribute('aria-label', MNL_T('global.wl_list_favorites', 'Mes favoris'));
    btn.title = MNL_T('global.wl_list_favorites', 'Mes favoris');
    btn.innerHTML = '<span class="mnl-wishlist-toggle__count">0</span>';
    btn.addEventListener('click', function () {
      var w = getWishlist();
      if (!w.length) return;
      var html = MNL_T('global.wl_panel_title_prefix_html', '<h3 style="font-size:22px;font-weight:900;letter-spacing:-.02em;margin:0 0 14px;">Tes favoris (') + w.length + ')</h3>';
      html += '<div style="display:flex;flex-direction:column;gap:8px;">';
      w.forEach(function (item) {
        html += '<a href="/products/' + item.handle + '" style="display:flex;align-items:center;justify-content:space-between;padding:12px 14px;background:rgba(15,23,42,.04);border-radius:12px;text-decoration:none;color:#0f172a;"><span><strong style="font-size:14px;">' + item.title + '</strong></span><span style="font-size:14px;color:#C2410C;">→</span></a>';
      });
      html += '</div>';
      // Open in news-popup style
      var existing = document.getElementById('mnl-news-popup');
      if (existing) existing.remove();
      var popup = document.createElement('div');
      popup.id = 'mnl-news-popup';
      popup.className = 'mnl-news-popup is-open';
      popup.innerHTML = MNL_T('global.wl_panel_shell_html', '<div class="mnl-news-popup__panel" style="text-align:left;"><button type="button" class="mnl-news-popup__close" aria-label="Fermer">×</button>') + html + '</div>';
      document.body.appendChild(popup);
      popup.querySelector('.mnl-news-popup__close').addEventListener('click', function () { popup.remove(); });
      popup.addEventListener('click', function (e) { if (e.target === popup) popup.remove(); });
    });
    document.body.appendChild(btn);
    updateWishlistToggle();
  }
  buildWishlistToggle();

  // ════════════ SEARCH OVERLAY (Cmd+K / Ctrl+K) ════════════
  var SEARCH_DATA = [
    // V345 : "Configure en 2 min" + "7 questions" obsolète (Coach IA = 11Q en 3-5 min, V285/V287/V301/V344). Aligné sur promesse globale "au mg près".
    { cat: MNL_T('global.search_cat_products', 'Produits'), icon: '', title: MNL_T('global.search_pw_title', 'Pré-Workout sur-mesure'), sub: MNL_T('global.search_pw_sub', 'Configure ta formule au mg près'), url: window.MNL_PRODUCT_URL },
    { cat: MNL_T('global.search_cat_tools', 'Outils'), icon: '', title: 'Coach IA', sub: MNL_T('global.search_coach_sub', 'Assistant Claude AI · 11 questions structurées'), action: 'openAI' },
    { cat: MNL_T('global.search_cat_tools', 'Outils'), icon: '', title: MNL_T('global.search_config_title', 'Configurateur expert'), sub: MNL_T('global.search_config_sub', 'Mode pro, dose par dose'), url: window.MNL_PRODUCT_URL + '?open=config' },
    { cat: MNL_T('global.search_cat_brand', 'Marque'), icon: '', title: MNL_T('global.search_story_title', 'Notre histoire'), sub: MNL_T('global.search_story_sub', 'Pourquoi MyNutriLab'), url: '/pages/notre-histoire' },
    { cat: MNL_T('global.search_cat_brand', 'Marque'), icon: '', title: MNL_T('global.search_lab_title', 'Le Lab — actifs'), sub: MNL_T('global.search_lab_sub', '11 actifs cliniques détaillés'), url: '/pages/lab' }, // V527 : handle réel
    // V940 : entrée « Athlètes ambassadeurs » → /pages/ambassadeurs SUPPRIMÉE (page dépubliée = 404)
    { cat: MNL_T('global.search_cat_brand', 'Marque'), icon: '', title: MNL_T('global.search_pledges_title', 'Engagements'), sub: MNL_T('global.search_pledges_sub', 'Marque française · Transparence'), url: '/pages/engagements' }, // V516
    { cat: MNL_T('global.search_cat_help', 'Aide'), icon: '', title: 'FAQ', sub: MNL_T('global.search_faq_sub', 'Questions fréquentes'), url: '/pages/faq' },
    { cat: MNL_T('global.search_cat_help', 'Aide'), icon: '', title: MNL_T('global.search_shipping_title', 'Livraison & retours'), sub: MNL_T('global.search_shipping_sub', 'Préparation sous 4 j ouvrés + transport · relais gratuit dès 49€, domicile dès 110€'), url: '/pages/livraison' },
    { cat: MNL_T('global.search_cat_help', 'Aide'), icon: '', title: MNL_T('global.search_contact_title', 'Contact'), sub: MNL_T('global.search_contact_sub', 'On te répond sous 24h'), url: '/pages/contact' },
    { cat: MNL_T('global.search_cat_account', 'Compte'), icon: '', title: MNL_T('global.search_cart_title', 'Mon panier'), sub: MNL_T('global.search_cart_sub', 'Voir mes articles'), url: '/cart' },
    { cat: MNL_T('global.search_cat_account', 'Compte'), icon: '', title: MNL_T('global.search_account_title', 'Mon compte'), sub: MNL_T('global.search_account_sub', 'Commandes · adresses'), url: '/pages/account' }
  ];
  function openSearchOverlay() {
    if (document.getElementById('mnl-search-overlay')) {
      document.getElementById('mnl-search-overlay').classList.add('is-open');
      var inp = document.getElementById('mnl-search-overlay-input');
      if (inp) setTimeout(function () { inp.focus(); }, 100);
      return;
    }
    var ov = document.createElement('div');
    ov.id = 'mnl-search-overlay';
    ov.className = 'mnl-search-overlay';
    ov.setAttribute('role', 'dialog');
    ov.innerHTML = MNL_T('global.search_overlay_html', '\
      <div class="mnl-search-overlay__panel">\
        <div class="mnl-search-overlay__inputbox">\
          <span class="mnl-search-overlay__icon"></span>\
          <input type="text" class="mnl-search-overlay__input" id="mnl-search-overlay-input" placeholder="Rechercher un produit, une page, un actif…" autocomplete="off" spellcheck="false">\
          <span class="mnl-search-overlay__shortcut">ESC</span>\
        </div>\
        <div class="mnl-search-overlay__results" id="mnl-search-overlay-results"></div>\
        <div class="mnl-search-overlay__hint"><span><kbd>↑</kbd><kbd>↓</kbd> naviguer · <kbd>↵</kbd> ouvrir</span><span>Powered by MNL Search</span></div>\
      </div>');
    document.body.appendChild(ov);
    var input = document.getElementById('mnl-search-overlay-input');
    var results = document.getElementById('mnl-search-overlay-results');
    var activeIdx = 0;
    function renderResults(query) {
      var q = (query || '').toLowerCase().trim();
      var filtered = q ? SEARCH_DATA.filter(function (it) {
        return it.title.toLowerCase().indexOf(q) !== -1 ||
               it.sub.toLowerCase().indexOf(q) !== -1 ||
               it.cat.toLowerCase().indexOf(q) !== -1;
      }) : SEARCH_DATA;
      if (!filtered.length) {
        results.innerHTML = MNL_T('global.search_noresult_prefix_html', '<p style="text-align:center;color:#64748b;padding:24px;font-size:14px;">Aucun résultat pour "<strong>') + window.mnlEscapeHtml(q) + '</strong>"</p>';
        return;
      }
      var byCat = {};
      filtered.forEach(function (it) { (byCat[it.cat] = byCat[it.cat] || []).push(it); });
      var html = '';
      var idx = 0;
      Object.keys(byCat).forEach(function (cat) {
        html += '<div class="mnl-search-overlay__cat">' + cat + '</div>';
        byCat[cat].forEach(function (it) {
          html += '<button type="button" class="mnl-search-overlay__item" data-search-idx="' + idx + '" data-search-url="' + (it.url || '') + '" data-search-action="' + (it.action || '') + '">' +
                  '<div class="mnl-search-overlay__item-icon">' + it.icon + '</div>' +
                  '<div class="mnl-search-overlay__item-body"><h4 class="mnl-search-overlay__item-title">' + it.title + '</h4><p class="mnl-search-overlay__item-sub">' + it.sub + '</p></div>' +
                  '<span class="mnl-search-overlay__item-arrow">→</span>' +
                  '</button>';
          idx++;
        });
      });
      results.innerHTML = html;
      activeIdx = 0;
      updateActive();
      results.querySelectorAll('[data-search-idx]').forEach(function (b) {
        b.addEventListener('click', function () { goToItem(b); });
      });
    }
    function updateActive() {
      var items = results.querySelectorAll('[data-search-idx]');
      items.forEach(function (b, i) { b.classList.toggle('is-active', i === activeIdx); });
      var current = items[activeIdx];
      if (current) current.scrollIntoView({ block: 'nearest' });
    }
    function goToItem(btn) {
      var url = btn.dataset.searchUrl;
      var action = btn.dataset.searchAction;
      closeOverlay();
      if (action === 'openAI' && typeof window.mnlOpenAI === 'function') window.mnlOpenAI();
      else if (url) window.location.href = url;
    }
    function closeOverlay() {
      ov.classList.remove('is-open');
      setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 250);
    }
    input.addEventListener('input', function () { renderResults(input.value); });
    input.addEventListener('keydown', function (e) {
      var items = results.querySelectorAll('[data-search-idx]');
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, items.length - 1); updateActive(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, 0); updateActive(); }
      else if (e.key === 'Enter') { e.preventDefault(); if (items[activeIdx]) goToItem(items[activeIdx]); }
      else if (e.key === 'Escape') { e.preventDefault(); closeOverlay(); }
    });
    ov.addEventListener('click', function (e) { if (e.target === ov) closeOverlay(); });
    requestAnimationFrame(function () { ov.classList.add('is-open'); });
    setTimeout(function () { input.focus(); }, 200);
    renderResults('');
  }

  // Keyboard shortcut Cmd/Ctrl + K
  document.addEventListener('keydown', function (e) {
    if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
      // Skip si on est dans le coach overlay (qui a son propre Cmd+K)
      var coachOverlay = document.getElementById('mnl-ai-overlay');
      if (coachOverlay && coachOverlay.classList.contains('is-open')) return;
      e.preventDefault();
      openSearchOverlay();
    }
  });

  // ════════════ KONAMI CODE EASTER EGG (bonus discount) ════════════
  var konamiSeq = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
  var konamiPos = 0;
  document.addEventListener('keydown', function (e) {
    if (e.key === konamiSeq[konamiPos]) {
      konamiPos++;
      if (konamiPos === konamiSeq.length) {
        konamiPos = 0;
        try {
          if (sessionStorage.getItem('mnl-konami-unlocked')) return;
          sessionStorage.setItem('mnl-konami-unlocked', '1');
          sessionStorage.setItem('mnl-promo-code', 'KONAMI20');
          fetch('/discount/KONAMI20', { method: 'GET', credentials: 'same-origin' }).catch(function () {});
        } catch (_) {}
        // Toast confetti
        var t = document.createElement('div');
        t.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#E84E1B;color:#fff;padding:24px 40px;border-radius:20px;font-size:24px;font-weight:900;letter-spacing:-.02em;box-shadow:0 24px 60px rgba(194,65,12,.5);z-index:99999;animation:konami-pop .6s cubic-bezier(.34,1.56,.64,1);';
        t.innerHTML = MNL_T('global.konami_html', 'KONAMI CODE !<br><small style="font-size:14px;font-weight:600;opacity:.9;">Code KONAMI20 = -20% appliqué</small>');
        var style = document.createElement('style');
        style.textContent = '@keyframes konami-pop{0%{opacity:0;transform:translate(-50%,-50%) scale(.3)}100%{opacity:1;transform:translate(-50%,-50%) scale(1)}}';
        document.head.appendChild(style);
        document.body.appendChild(t);
        setTimeout(function () { t.remove(); }, 4000);
      }
    } else { konamiPos = 0; }
  });
})();

/* ════════ TRUST STRIP STICKY (auto-injected sous header) ════════ */
(function () {
  if (window.__mnlTrustStripInit) return;
  window.__mnlTrustStripInit = true;

  // Skip if user closed it this session
  try { if (sessionStorage.getItem('mnl-trust-closed')) return; } catch (_) {}

  // Vague 89 BUG fix : skip si le header a déjà sa propre promo bar (.mnl-hd-promo).
  // Évite le DOUBLE bandeau (trust strip JS + header promo bar Theme Editor empilés).
  // Le header promo bar (configurable via Theme Editor → Header → 3 messages rotatifs)
  // est plus contrôlable et intégré, donc on lui laisse la priorité.
  function init() {
    if (document.querySelector('.mnl-trust-strip')) return;
    if (document.querySelector('.mnl-hd-promo')) {
      /* Vague 155 : silence log info en prod — info inutile pour user, pollue console */
      return;
    }
    // Vague 236 : suppression du duplicate "Made in France" (était présent ligne 11359 ET 11361, même message visuel),
    // ajout de 3 items launch-spécifiques (support réactif, rétractation 14j, première fois rassurance).
    // Ordre repensé : trust visuel (FR/livraison/conformité) → social proof (IA/vegan) → payment safety.
    var items = [
      { i: '', t: MNL_T('global.trust_made_in_france_html', '<strong>Marque française</strong> · Laboratoire certifié ISO 22000') }, // V516
      { i: '', t: MNL_T('global.trust_shipping_html', 'Préparation sous <strong>4 jours ouvrés</strong> + transport · Point relais offert dès 49€ · Domicile dès 110€') },
      { i: '', t: MNL_T('global.trust_actives_html', '<strong>11 actifs transparents</strong> · Dosés au mg près') },
      { i: '', t: MNL_T('global.trust_doses_html', '<strong>Dosages cliniques</strong> · Études publiées') },
      { i: '', t: MNL_T('global.trust_ai_html', 'Formule <strong>personnalisée IA</strong> au mg près') },
      { i: '', t: MNL_T('global.trust_vegan_html', '100% <strong>vegan</strong>, sans gluten, sans lactose') },
      { i: '↩', t: MNL_T('global.trust_warranty_html', '<strong>Garantie légale</strong> · produit défectueux remplacé') },
      { i: '', t: MNL_T('global.trust_payment_html', 'Paiement <strong>100% sécurisé</strong> · CB, Apple Pay, PayPal') },
      { i: '✉', t: MNL_T('global.trust_support_html', 'Support via le <strong>formulaire de contact</strong> · réponse sous 24h') }
    ];
    var strip = document.createElement('div');
    strip.className = 'mnl-trust-strip';
    var html = '<div class="mnl-trust-strip__track">';
    // Duplicate items for seamless loop
    for (var loop = 0; loop < 2; loop++) {
      for (var i = 0; i < items.length; i++) {
        html += '<div class="mnl-trust-strip__item"><span class="mnl-trust-strip__item-icon">' + items[i].i + '</span><span>' + items[i].t + '</span></div>';
      }
    }
    html += MNL_T('global.trust_close_html', '</div><button class="mnl-trust-strip__close" aria-label="Fermer">×</button>');
    strip.innerHTML = html;

    // Insert after header (try multiple selectors)
    var header = document.querySelector('header.mnl-hd, header[role="banner"], .header-wrapper, header, body > .shopify-section:first-child');
    if (header && header.parentNode) {
      header.parentNode.insertBefore(strip, header.nextSibling);
    } else {
      document.body.insertBefore(strip, document.body.firstChild);
    }

    var closeBtn = strip.querySelector('.mnl-trust-strip__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        strip.style.transition = 'opacity .3s ease, max-height .3s ease';
        strip.style.overflow = 'hidden';
        strip.style.opacity = '0';
        strip.style.maxHeight = '0';
        try { sessionStorage.setItem('mnl-trust-closed', '1'); } catch (_) {}
        setTimeout(function () { strip.remove(); }, 350);
      });
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(init, 100);
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

/* ════════ V236 — LAUNCH ANNOUNCEMENT BAR (owner-configurable top banner) ════════
   Bandeau fin tout en haut, AU-DESSUS du header — visible immédiatement.
   Activation : l'owner configure via admin dashboard OU directement console :
     localStorage.setItem('mnl-launch-banner', JSON.stringify({
       text: 'Lancement officiel — Premier lot livré sous 5 jours',
       url: '/products/pre-workout-mynutrilab-personnalisable-au-mg-pres',
       bg: 'gradient',  // 'gradient' | 'solid-dark' | 'solid-accent'
       dismissible: true
     }));
   Désactivation : localStorage.removeItem('mnl-launch-banner');
   Visiteur peut dismiss (sessionStorage) si dismissible=true. ZERO bandeau si pas de config. */
(function _launchBanner() {
  if (window.__mnlLaunchBannerInit) return;
  window.__mnlLaunchBannerInit = true;

  function init() {
    var raw, cfg;
    try { raw = localStorage.getItem('mnl-launch-banner'); } catch (_) { return; }
    if (!raw) return;
    try { cfg = JSON.parse(raw); } catch (_) { return; }
    if (!cfg || typeof cfg.text !== 'string' || !cfg.text.trim()) return;
    var text = cfg.text.slice(0, 160); // cap longueur (un bandeau trop long casse la mise en page mobile)

    // Skip si user a dismiss cette session (et bannière dismissible)
    if (cfg.dismissible !== false) {
      try { if (sessionStorage.getItem('mnl-launch-banner-closed') === '1') return; } catch (_) {}
    }
    if (document.getElementById('mnl-launch-banner')) return;

    // Background style
    var bg;
    switch (cfg.bg) {
      case 'solid-dark': bg = '#0f172a'; break;
      case 'solid-accent': bg = '#C2410C'; break;
      default: bg = '#E84E1B'; // V1034 : aplat V974 (ex-dégradé jaune→orange)
    }

    var bar = document.createElement('div');
    bar.id = 'mnl-launch-banner';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', MNL_T('global.announcement_label', 'Annonce'));
    bar.style.cssText = [
      'position:relative',
      'z-index:99996',
      'background:' + bg,
      'color:#fff',
      'padding:9px 14px',
      'text-align:center',
      'font-family:"DM Sans",-apple-system,sans-serif',
      'font-size:13px',
      'font-weight:700',
      'letter-spacing:-.005em',
      'line-height:1.4',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'gap:12px',
      'box-shadow:0 1px 0 rgba(0,0,0,.05)',
      'animation:mnl-banner-slide-down .35s ease-out'
    ].join(';');

    // Escape HTML pour éviter XSS si owner met du HTML brut
    function _esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }
    var safeText = _esc(text);
    var html = '<span style="flex:1;max-width:1100px;">';
    if (cfg.url && typeof cfg.url === 'string' && /^(\/|https?:\/\/)/.test(cfg.url)) {
      html += '<a href="' + _esc(cfg.url) + '" style="color:#fff;text-decoration:none;border-bottom:1px dotted rgba(255,255,255,.55);padding-bottom:1px;">' + safeText + '</a>';
    } else {
      html += safeText;
    }
    html += '</span>';
    if (cfg.dismissible !== false) {
      html += MNL_T('global.announcement_close_html', '<button type="button" aria-label="Fermer l\'annonce" data-mnl-banner-close style="background:transparent;border:0;color:rgba(255,255,255,.75);cursor:pointer;font-size:18px;line-height:1;padding:0 4px;flex-shrink:0;">×</button>');
    }
    bar.innerHTML = html;

    // CSS keyframes pour slide-down (one-time injection)
    if (!document.getElementById('mnl-launch-banner-keyframes')) {
      var st = document.createElement('style');
      st.id = 'mnl-launch-banner-keyframes';
      st.textContent = '@keyframes mnl-banner-slide-down{from{transform:translateY(-100%);opacity:0}to{transform:translateY(0);opacity:1}}' +
        '@media (max-width:520px){#mnl-launch-banner{font-size:12px !important;padding:8px 10px !important;}}' +
        '@media (prefers-reduced-motion:reduce){#mnl-launch-banner{animation:none !important}}';
      document.head.appendChild(st);
    }

    // Insert avant le header (vraiment tout en haut du body)
    try { document.body.insertBefore(bar, document.body.firstChild); } catch (_) { return; }

    // Dismiss handler
    var closeBtn = bar.querySelector('[data-mnl-banner-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        try { sessionStorage.setItem('mnl-launch-banner-closed', '1'); } catch (_) {}
        bar.style.transition = 'opacity .25s ease,max-height .25s ease,padding .25s ease';
        bar.style.overflow = 'hidden';
        bar.style.maxHeight = bar.offsetHeight + 'px';
        requestAnimationFrame(function () {
          bar.style.maxHeight = '0';
          bar.style.opacity = '0';
          bar.style.paddingTop = '0';
          bar.style.paddingBottom = '0';
        });
        setTimeout(function () { try { bar.remove(); } catch (_) {} }, 280);
      });
    }
  }

  // Helper exposé pour admin dashboard / console
  window.mnlSetLaunchBanner = function (cfg) {
    if (cfg === null || cfg === undefined) {
      try { localStorage.removeItem('mnl-launch-banner'); sessionStorage.removeItem('mnl-launch-banner-closed'); } catch (_) {}
      var existing = document.getElementById('mnl-launch-banner');
      if (existing) existing.remove();
      try { console.log('%cLaunch banner désactivé', 'color:#10b981;font-weight:bold;'); } catch (_) {}
      return true;
    }
    if (typeof cfg === 'string') cfg = { text: cfg };
    if (!cfg || typeof cfg.text !== 'string' || !cfg.text.trim()) {
      try { console.warn('mnlSetLaunchBanner: text manquant ou invalide'); } catch (_) {}
      return false;
    }
    try {
      localStorage.setItem('mnl-launch-banner', JSON.stringify(cfg));
      sessionStorage.removeItem('mnl-launch-banner-closed'); // reset dismiss pour ré-afficher
    } catch (_) { return false; }
    // Retire l'existant puis re-monte
    var existing2 = document.getElementById('mnl-launch-banner');
    if (existing2) existing2.remove();
    init();
    try { console.log('%cLaunch banner activé', 'color:#C2410C;font-weight:bold;', cfg.text); } catch (_) {}
    return true;
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(init, 80);
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

/* ════════ COOKIE BANNER (RGPD/CNIL conforme + Consent Mode v2) ════════ */
(function () {
  if (window.__mnlCookieInit) return;
  window.__mnlCookieInit = true;

  // V537 : propage le consentement de NOTRE bandeau granulaire vers l'API Customer Privacy de Shopify.
  // Single source of truth = le bandeau MNL custom (le natif Shopify est désactivé en admin côté marchand).
  // Sans ce sync, Shopify ignore le choix fait dans notre bandeau → soit collecte first-party sans consentement
  // (régions hors-UE), soit blocage permanent du tracking Shopify (UE). Existence-check + try/catch = zéro risque
  // si l'API n'est pas prête ou absente. Bonus : poser le consent ici fait disparaître un éventuel bandeau natif résiduel.
  window.mnlSyncShopifyConsent = function (p) {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.setTrackingConsent !== 'function') return;
      cp.setTrackingConsent({
        analytics: !!(p && p.analytics),
        marketing: !!(p && p.marketing),
        preferences: !!(p && p.preferences),
        sale_of_data: !!(p && p.marketing)
      }, function () {});
    } catch (_) {}
  };

  // V584 : DOUBLE BANNIÈRE — suppression défensive du bandeau cookies NATIF Shopify (#shopify-pc__banner).
  // Contexte : le design veut UNE seule bannière (la nôtre, custom + granulaire). Le natif Shopify est censé
  // être désactivé en admin (Customer privacy → Cookie banner), mais s'il reste activé, l'utilisateur voit
  // DEUX bandeaux. On le masque ici dès qu'on sait qu'on a (a) notre bannière qui va s'afficher, ou (b) un
  // consentement déjà valide (aucune bannière nécessaire). Dans les deux cas le natif est redondant.
  // Sécurité : on NE masque le natif qu'aux points de décision (jamais avant) → si une exception survient
  // dans l'IIFE, on n'a rien masqué et le natif reste comme filet de sécurité (zéro état "aucune bannière").
  // Le natif est juste masqué visuellement (display:none) — l'API window.Shopify.customerPrivacy reste active
  // et reçoit le consentement via mnlSyncShopifyConsent, donc aucune perte de conformité côté Shopify.
  function _hideNativePc() {
    try {
      var els = document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner');
      var found = false;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (!el) continue;
        if (el.style.getPropertyValue('display') !== 'none') {
          el.style.setProperty('display', 'none', 'important');
          el.setAttribute('aria-hidden', 'true');
        }
        found = true;
      }
      return found;
    } catch (_) { return false; }
  }
  function _watchAndHideNative() {
    _hideNativePc(); // tout de suite (si déjà injecté)
    try {
      if (!window.MutationObserver) {
        [200, 500, 1000, 2000, 3500].forEach(function (d) { setTimeout(_hideNativePc, d); });
        return;
      }
      // Le natif Shopify s'injecte de façon asynchrone → observer pour le masquer à l'instant T.
      var obs = new MutationObserver(function () { _hideNativePc(); });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { try { obs.disconnect(); } catch (_) {} }, 6000); // borne : 6s puis stop
    } catch (_) {
      [200, 500, 1000, 2000, 3500].forEach(function (d) { setTimeout(_hideNativePc, d); });
    }
  }
  // Re-synchronise le consentement déjà stocké vers l'API Shopify (cas visiteur de retour) pour que
  // Shopify connaisse le choix et n'ait aucune raison de ré-afficher son bandeau natif.
  function _resyncShopifyFromStorage() {
    try {
      if (window.mnlConsent) {
        var consent = window.mnlConsent.read();
        if (consent.valid) window.mnlSyncShopifyConsent({ analytics: consent.analytics, marketing: consent.marketing, preferences: consent.preferences });
        return;
      }
      var prefs = null;
      try { prefs = JSON.parse(localStorage.getItem('mnl-cookie-prefs') || 'null'); } catch (_) {}
      if (prefs && typeof prefs === 'object') {
        window.mnlSyncShopifyConsent({ analytics: !!prefs.analytics, marketing: !!prefs.marketing, preferences: !!prefs.preferences });
        return;
      }
      var rawC = localStorage.getItem('mnl-cookie-consent');
      var st = null;
      try {
        var pc = JSON.parse(rawC);
        st = (pc && pc.state) ? pc.state : ((rawC === 'accepted' || rawC === 'rejected') ? rawC : null);
      } catch (_) { st = (rawC === 'accepted' || rawC === 'rejected') ? rawC : null; }
      if (st === 'accepted') window.mnlSyncShopifyConsent({ analytics: true, marketing: true, preferences: true });
      else if (st === 'rejected') window.mnlSyncShopifyConsent({ analytics: false, marketing: false, preferences: false });
    } catch (_) {}
  }

  // CNIL : durée de conservation max 13 mois (Délibération CNIL 2020-091).
  // Vague 73 : Différenciation TTL accept vs reject (recommandation CNIL : refus = re-prompt min 6 mois)
  var CONSENT_TTL_MS_ACCEPT = 13 * 30 * 24 * 60 * 60 * 1000; // 13 mois pour accept
  var CONSENT_TTL_MS_REJECT = 6 * 30 * 24 * 60 * 60 * 1000;  // 6 mois pour reject (re-prompt plus tôt mais pas avant)
  var CONSENT_VERSION = window.mnlConsent ? window.mnlConsent.version : '2026.05.1'; // bump à chaque modif des termes / wording / politique
  try {
    var raw = localStorage.getItem('mnl-cookie-consent');
    if (raw) {
      // Migration : ancien format = string brute. Nouveau = JSON {state, ts, version}
      var parsed;
      try { parsed = JSON.parse(raw); } catch(_) { parsed = null; }
      if (parsed && parsed.state && parsed.ts) {
        // Vague 73 : si version stockée différente de la version actuelle = re-prompt (CNIL : preuve consent à LA BONNE version)
        if (parsed.version && parsed.version !== CONSENT_VERSION) {
          localStorage.removeItem('mnl-cookie-consent');
          localStorage.removeItem('mnl-cookie-prefs');
          localStorage.removeItem('mnl-events');
        } else {
          var ttl = parsed.state === 'accepted' ? CONSENT_TTL_MS_ACCEPT : CONSENT_TTL_MS_REJECT;
          if (Date.now() - parsed.ts < ttl && (!window.mnlConsent || window.mnlConsent.read().valid)) { _resyncShopifyFromStorage(); _watchAndHideNative(); return; } // consentement encore valide → aucune bannière
          // Expiré → on supprime et on ré-affiche la bannière
          localStorage.removeItem('mnl-cookie-consent');
          localStorage.removeItem('mnl-cookie-prefs');
          localStorage.removeItem('mnl-events');
        }
      } else if (raw === 'accepted' || raw === 'rejected') {
        // Ancien format sans timestamp : on assume qu'il vient de juste maintenant pour ne pas re-demander immédiatement
        localStorage.setItem('mnl-cookie-consent', JSON.stringify({state: raw, ts: Date.now(), version: CONSENT_VERSION}));
        _resyncShopifyFromStorage(); _watchAndHideNative(); return;
      }
    }
  } catch (_) { return; }

  // À ce stade : aucun consentement valide stocké → NOTRE bannière custom va s'afficher (show() à 1.8s).
  // Le bandeau natif Shopify est donc redondant → on le masque (filet : seulement après cette décision).
  _watchAndHideNative();

  function applyConsent(state) {
    // Vague 57 : dispatch event pour permettre à theme.liquid de charger Meta Pixel + Clarity
    // (qui ne supportent PAS Consent Mode v2 et doivent être chargés à la volée).
    if (state === 'accepted') {
      try { window.dispatchEvent(new CustomEvent('mnl:consent:granted')); } catch(_) {}
    } else {
      try { window.dispatchEvent(new CustomEvent('mnl:consent:denied')); } catch(_) {}
    }
    // V537 : propage à l'API Customer Privacy de Shopify (accept simple = toutes catégories)
    try { window.mnlSyncShopifyConsent({ analytics: state === 'accepted', marketing: state === 'accepted', preferences: state === 'accepted' }); } catch (_) {}
    if (!window.gtag) return;
    try {
      if (state === 'accepted') {
        window.gtag('consent', 'update', {
          'functionality_storage': 'granted',
          'personalization_storage': 'granted',
          'ad_storage': 'granted',
          'ad_user_data': 'granted',
          'ad_personalization': 'granted',
          'analytics_storage': 'granted'
        });
      } else {
        // Explicit deny pour conformité CNIL : "refuser doit être aussi simple qu'accepter"
        window.gtag('consent', 'update', {
          'functionality_storage': 'denied',
          'personalization_storage': 'denied',
          'ad_storage': 'denied',
          'ad_user_data': 'denied',
          'ad_personalization': 'denied',
          'analytics_storage': 'denied'
        });
      }
    } catch (_) {}
  }

  function show() {
    if (document.querySelector('.mnl-cookie')) return;
    var box = document.createElement('div');
    box.className = 'mnl-cookie';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-label', MNL_T('global.cookie_banner_label', 'Bandeau de consentement aux cookies'));
    box.setAttribute('aria-live', 'polite');
    // Vague 94 : ajout bouton "Personnaliser" au même niveau visuel que Refuser/Accepter
    // CNIL : recommande 3 CTAs équivalents (Refuser / Personnaliser / Accepter) plutôt que cacher
    // le granulaire dans le footer. Avant : seulement 2 boutons → CNIL strict considère ça comme nudge vers accept.
    // V904 (fondateur 2026-06-18) : refonte en MODALE CENTRÉE (maquette fondateur) — contenu enveloppé dans
    // .mnl-cookie__box (carte), .mnl-cookie devient le backdrop centré. Icône cookie orange + titre/texte premium.
    // Les 3 boutons + data-action (reject/custom/accept) sont INCHANGÉS → la logique RGPD du handler reste valide.
    box.innerHTML = '<div class="mnl-cookie__box" tabindex="-1">' +
      MNL_T('global.cookie_banner_title_html', '<p class="mnl-cookie__title"><span class="mnl-cookie__ico" aria-hidden="true"><svg viewBox="0 0 24 24" width="34" height="34"><circle cx="12" cy="12" r="9.2" fill="#F97316" fill-opacity=".16" stroke="#F97316" stroke-width="1.6"/><circle cx="9" cy="9.4" r="1.1" fill="#F97316"/><circle cx="14.6" cy="9" r=".95" fill="#F97316"/><circle cx="15.1" cy="14.2" r="1.2" fill="#F97316"/><circle cx="9.4" cy="14.6" r="1" fill="#F97316"/><circle cx="12" cy="12" r=".7" fill="#F97316"/></svg></span>Nous utilisons des cookies</p>') +
      '<p class="mnl-cookie__text">' +
        MNL_T('global.cookie_banner_full_html', '<span class="mnl-cookie__text--full">Afin d\'améliorer ton expérience sur MyNutriLab, nous utilisons des cookies pour mesurer l\'audience, personnaliser ta navigation et optimiser nos services. Tu peux modifier tes préférences à tout moment dans notre <a href="/policies/privacy-policy">politique de confidentialité</a>.</span>') +
        MNL_T('global.cookie_banner_short_html', '<span class="mnl-cookie__text--short">Cookies pour mesurer l\'audience et améliorer ta navigation. Réglables à tout moment — <a href="/policies/privacy-policy">confidentialité</a>.</span>') +
      '</p>' +
      '<div class="mnl-cookie__btns">' +
        MNL_T('global.cookie_banner_reject_html', '<button type="button" class="mnl-cookie__btn mnl-cookie__btn--reject" data-action="reject" aria-label="Refuser tous les cookies non essentiels">Refuser</button>') +
        MNL_T('global.cookie_banner_custom_html', '<button type="button" class="mnl-cookie__btn mnl-cookie__btn--custom" data-action="custom" aria-label="Personnaliser mes choix de cookies">Personnaliser</button>') +
        MNL_T('global.cookie_banner_accept_html', '<button type="button" class="mnl-cookie__btn mnl-cookie__btn--accept" data-action="accept" aria-label="Accepter tous les cookies">Accepter</button>') +
      '</div>' +
    '</div>';
    document.body.appendChild(box);
    // V904 : place le focus dans la modale (a11y) sans piéger — l'user peut toujours Refuser en 1 clic
    try { requestAnimationFrame(function(){ var _bx = box.querySelector('.mnl-cookie__box'); if (_bx) _bx.focus(); }); } catch (_) {}
    requestAnimationFrame(function () { box.classList.add('is-visible'); });

    box.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-action');
      // Vague 94 : "Personnaliser" → ouvre la modale granulaire existante (cookie-prefs)
      // sans enregistrer de consentement (le banner reste, l'user choisira dans la modale)
      if (action === 'custom') {
        if (typeof window.mnlOpenCookiePrefs === 'function') {
          window.mnlOpenCookiePrefs();
        } else {
          // Fallback : envoie vers la policy page (peu probable mais safe)
          window.location.href = '/policies/privacy-policy';
        }
        return;
      }
      var consentState = action === 'accept' ? 'accepted' : 'rejected';
      try { localStorage.setItem('mnl-cookie-prefs', JSON.stringify({ preferences: consentState === 'accepted', analytics: consentState === 'accepted', marketing: consentState === 'accepted' })); } catch (_) {}
      // CNIL : on stocke avec timestamp + version pour preuve audit (vague 73)
      try { localStorage.setItem('mnl-cookie-consent', JSON.stringify({state: consentState, ts: Date.now(), version: CONSENT_VERSION})); } catch (_) {}
      // Vague 73 : audit trail history (max 5 derniers consents — preuve CNIL en cas de litige)
      try {
        var hist = JSON.parse(localStorage.getItem('mnl-consent-history') || '[]');
        hist.push({ state: consentState, ts: Date.now(), version: CONSENT_VERSION, ua: navigator.userAgent.slice(0, 80) });
        if (hist.length > 5) hist = hist.slice(-5);
        localStorage.setItem('mnl-consent-history', JSON.stringify(hist));
      } catch (_) {}
      // Vague 94 : si refus, purge les cookies tiers analytics existants (ga_*, _ga, _gid, _fbp)
      // RGPD art. 21 : droit d'opposition implique suppression effective des trackers, pas juste arrêt futur.
      if (consentState === 'rejected') {
        try {
          var clearKeys = ['_ga', '_gid', '_gat', '_fbp', '_fbc', '_hjid', '_hjSessionUser', '_hjFirstSeen', '_clck', '_clsk'];
          var hostParts = location.hostname.split('.');
          var rootDomain = hostParts.length >= 2 ? '.' + hostParts.slice(-2).join('.') : location.hostname;
          clearKeys.forEach(function(k){
            // Cookie : expire en passé pour purge (besoin domain match)
            document.cookie = k + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
            document.cookie = k + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=' + location.hostname;
            document.cookie = k + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=' + rootDomain;
            // localStorage analytics keys courantes
            try { localStorage.removeItem(k); } catch(_){}
          });
          // Cookies préfixés (_ga_XXXX pour GA4 measurement IDs)
          document.cookie.split(';').forEach(function(c){
            var name = c.split('=')[0].trim();
            if (/^_ga_/.test(name) || /^_uet/.test(name) || /^_pin_/.test(name)) {
              document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
              document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=' + rootDomain;
            }
          });
          document.dispatchEvent(new CustomEvent('mnl:consent:denied'));
        } catch(_){}
      }
      applyConsent(consentState);
      // V904 : la box est désormais le backdrop plein écran → fondu en opacité seul (plus de translateY).
      box.style.opacity = '0';
      box.style.transition = 'opacity .3s ease';
      setTimeout(function () { box.remove(); }, 300);
    });
  }

  // Permet à l'utilisateur de revenir sur son choix depuis politique de confidentialité
  window.mnlResetCookieConsent = function() {
    try { localStorage.removeItem('mnl-cookie-consent'); } catch (_) {}
    try { localStorage.removeItem('mnl-cookie-prefs'); localStorage.removeItem('mnl-events'); } catch (_) {}
    try { window.dispatchEvent(new CustomEvent('mnl:consent:denied')); } catch (_) {}
    window.location.reload();
  };

  // Delay 1.8s for non-blocking UX
  setTimeout(function () {
    if (document.readyState === 'complete' || document.readyState === 'interactive') show();
    else document.addEventListener('DOMContentLoaded', show);
  }, 1800);
})();

/* ════════ EXIT INTENT POPUP (desktop only) ════════ */
(function () {
  if (window.__mnlExitInit) return;
  window.__mnlExitInit = true;
  try {
    if (!window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches) return;
    var acquisitionPath = (location.pathname || '').replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
    if (/^\/(?:products|cart|checkout|checkouts|account)(?:\/|$)/.test(acquisitionPath)) return;
    if (/^\/pages\/(?:formule-|lab(?:\/|$)|atelier(?:\/|$)|abonnement(?:\/|$))/.test(acquisitionPath)) return;
  } catch (_) { return; }
  // Audit UX/CRO 2026-07-12 : garde de chemin — JAMAIS sur panier/checkout/compte (même exclusion que la popup
  // newsletter .mnl-news-popup) ni sur les pages d'atterrissage pub /pages/formule- (zéro friction avant l'ATC).
  try {
    var _exitPath = location.pathname || '';
    if (/^\/(cart|checkout|account)/.test(_exitPath)) return;
    // V1028 (chantier D audit, validé fondateur 2026-07-16) : les pages /pages/formule- ne sont plus
    // exclues en bloc — la capture y est autorisée UNIQUEMENT sur le vrai exit-intent desktop
    // (souris qui quitte le viewport = visiteur qui part de toute façon). Le fallback tactile 45s/60%
    // reste bloqué sur ces pages par le garde [data-mnl-native-atc] dans show() : la friction
    // pré-ATC sur le trafic pub mobile (décision 2026-07-12) est préservée.
  } catch (_) {}
  // V906 : skip mobile RETIRÉ — le popup de sortie (refondu « image 2 », responsive 2 colonnes→empilé) s'affiche
  // aussi sur mobile via le fallback 45s (mouseleave ne déclenche pas au tactile). Le popup PDP .mnl-pp3-exit est
  // désactivé en parallèle (preworkout-product-page-v3.liquid) pour éviter un doublon de popup de sortie.
  // if (window.matchMedia('(pointer:coarse)').matches) return; // (ancien skip mobile)
  // V907 : persistance 7 JOURS (localStorage) — après fermeture OU inscription, ne plus réafficher pendant 7 jours.
  var _EXIT_DISMISS_KEY = 'mnl-exit-dismissed', _EXIT_DISMISS_MS = 7 * 864e5;
  function _exitDismissed(){ try { var t = parseInt(localStorage.getItem(_EXIT_DISMISS_KEY) || '0', 10); return !!t && (Date.now() - t) < _EXIT_DISMISS_MS; } catch (_) { return false; } }
  function _setExitDismissed(){ try { localStorage.setItem(_EXIT_DISMISS_KEY, String(Date.now())); } catch (_) {} }
  var _isCoarse = false; try { _isCoarse = window.matchMedia('(pointer:coarse)').matches; } catch (_) {}
  try {
    if (_exitDismissed()) return;
    if (localStorage.getItem('mnl-exit-converted')) return;
    // Vague 149 : check aussi la clé de l'exit popup PDP v3 (anti-superposition 2 overlays)
    if (sessionStorage.getItem('mnl-pp3-exit-shown')) return;
    // Vague 143 : skip aussi si user a déjà activé la newsletter dans ses prefs
    // (UX honest : ne pas redemander un code promo NL à quelqu'un qui est déjà abonné)
    try {
      var prefs = JSON.parse(localStorage.getItem('mnl-account-prefs') || '{}');
      if (prefs && prefs.newsletter === true) return;
    } catch(_){}
    // Skip aussi si user logged-in (customer Shopify a déjà son email — pas besoin du popup acquisition)
    // V1212b : window.Shopify.customer n'existe PAS côté storefront — Shopify ne l'expose jamais. Ce test
    // était donc toujours faux et la modale « −10 € sur votre 1re commande » s'affichait aussi aux clients
    // connectés. On utilise les deux signaux réellement publiés : __MNL_HDR_CFG.isCustomer (header) et la
    // porte d'éligibilité V1212 (qui couvre en plus l'invité déjà identifié sur l'appareil).
    if ((window.__MNL_HDR_CFG || {}).isCustomer) return;
    if (typeof window.mnlFirstOrderEligible === 'function' && !window.mnlFirstOrderEligible()) return;
  } catch (_) {}

  var triggered = false;
  // V536 : anti-empilement — ne JAMAIS afficher le popup exit par-dessus un autre overlay déjà ouvert
  // (bandeau cookies, tour onboarding, drawer menu/panier/recherche, chat IA, autre modale).
  // Avant : si la souris quittait le haut pendant le tour ou le bandeau cookies, on empilait 2-3 overlays
  // sombres → 1ère impression cassée. On bail AVANT de poser `triggered` → le popup pourra s'afficher
  // plus tard (au prochain mouseleave) une fois l'autre overlay fermé. Zéro suppression permanente.
  function _mnlOverlayVisible(el){
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0; // fonctionne aussi pour position:fixed (offsetParent serait null)
  }
  function _otherOverlayOpen(){
    try {
      // Bandeau consentement cookies (légal — doit être traité en premier). V953 (audit) : inclure AUSSI le bandeau custom .mnl-cookie (avant : seul le bandeau natif Shopify était testé → l'exit-intent pouvait s'empiler par-dessus le consentement légal au 1er contact).
      if (_mnlOverlayVisible(document.querySelector('#shopify-pc__banner, .shopify-pc__banner__dialog, .shopify-pc__banner, .mnl-cookie.is-visible'))) return true;
      // Tour onboarding actif
      if (_mnlOverlayVisible(document.querySelector('.mnl-tour-overlay.is-active'))) return true;
      // Un drawer header est ouvert (menu/panier/recherche/compte) → body verrouillé
      if (document.body.classList.contains('mnl-hd-locked')) return true;
      // V554 : configurateur / picker PDP ouvert → body.mnl-open (préworkout-configurator-v2). N'a ni role="dialog" ni mnl-hd-locked, donc échappait au garde → l'exit-intent WELCOME15 pouvait s'empiler par-dessus le flux de configuration (bug repéré en QA visuelle).
      if (document.body.classList.contains('mnl-open')) return true;
      // Chat IA ouvert
      if (_mnlOverlayVisible(document.querySelector('.mnl-ai.is-open, #mnlAiPanel.is-open, .mnl-ai-bubble.is-open'))) return true;
      // Autre modale générique ouverte (dialog visible)
      if (_mnlOverlayVisible(document.querySelector('[role="dialog"].is-open, [role="dialog"].is-visible'))) return true;
    } catch (_) {}
    return false;
  }
  function show(isRealExit) {
    if (!isRealExit || document.visibilityState !== 'visible') return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches) return;
    if (triggered) return;
    // V896 (fondateur 2026-06-16) — ANTI-SUPERPOSITION : respecte les flags posés par la popup exit PDP (.mnl-pp3-exit) ET par soi-même. AVANT, show() ne faisait que SET ces clés sans jamais les LIRE → sur la PDP les DEUX popups exit (.mnl-exit globale + .mnl-pp3-exit) s'affichaient en même temps. La popup PDP lisait déjà ces flags ; on rend la globale symétrique.
    try { if (_exitDismissed() || sessionStorage.getItem('mnl-pp3-exit-shown') === '1') return; } catch (_) {}
    // Audit UX/CRO 2026-07-12 + V1028 : sur une page à ATC natif (14 pages formule data-mnl-native-atc),
    // seul le VRAI exit-intent desktop passe (isRealExit) — le fallback temps/scroll reste bloqué
    // (zéro friction pré-ATC sur le trafic pub, mais on capture quand le visiteur part vraiment).
    try { if (!isRealExit && document.querySelector('[data-mnl-native-atc]')) return; } catch (_) {}
    // Audit UX/CRO 2026-07-12 : élan d'achat — pas de popup dans les 30 s suivant une interaction CTA
    // (même signal window._mnlLastCtaTs que la popup newsletter, posé par le listener click global).
    try { if (window._mnlLastCtaTs && (Date.now() - window._mnlLastCtaTs) < 30000) return; } catch (_) {}
    if (_otherOverlayOpen()) return; // V536 : ne pas empiler — réessai au prochain trigger
    triggered = true;
    // V907 : marque « vu » → persistance 7 jours (cross-session) + flag session anti-doublon (popup PDP désactivée, flag conservé par sécurité)
    _setExitDismissed();
    try { sessionStorage.setItem('mnl-pp3-exit-shown', '1'); } catch (_) {}

    var box = document.createElement('div');
    box.className = 'mnl-exit';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-labelledby', 'mnl-exit-title');
    // V569 : email-gated discount → on capte l'email (liste de lancement Klaviyo) AVANT de révéler le code.
    var _exitTs = Math.floor(Date.now() / 1000); // anti-bot time-gate
    // V906 (fondateur 2026-06-18) : refonte au design « maquette » 2 colonnes (offre −10€ à gauche, formulaire à droite).
    // Classes du formulaire INCHANGÉES (mnl-exit__form/__hp/__input/__btn/__msg) → le handler plus bas reste valide.
    // Checkbox de consentement RETIRÉE (le handler la skippe : `if (_consent && !_consent.checked)`) ; l'opt-in = la
    // soumission du mail + la mention « Pas de spam. Désinscription en un clic. » + lien confidentialité (info RGPD).
    // V907 (fondateur 2026-06-18) : finition maquette — icône cadeau (gauche), VRAI logo (settings.logo sinon lockup
    // officiel du header), icône enveloppe dans le champ, lien « Non merci » sous la carte, lignes déco discrètes.
    box.innerHTML = '<div class="mnl-exit__box" role="document">' +
      MNL_T('global.exit_close_html', '<button class="mnl-exit__close" type="button" aria-label="Fermer la fenêtre">×</button>') +
      '<div class="mnl-exit__left">' +
        '<span class="mnl-exit__deco" aria-hidden="true"></span>' +
        MNL_T('global.exit_badge_html', '<span class="mnl-exit__badge">Offre de bienvenue</span>') +
        '<span class="mnl-exit__gift" aria-hidden="true"><svg viewBox="0 0 24 24" width="46" height="46" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg></span>' +
        MNL_T('global.exit_big_html', '<span class="mnl-exit__big">−10 €</span>') +
        /* V1215 : fenetre GLOBALE (toutes pages, y compris le configurateur bascule en abonnement), qui ne
           connait pas le mode d'achat choisi. Formulation vraie dans les DEUX cas : en abonnement
           MNL10 ne vaut que pour la 1re livraison (recurringCycleLimit = 1). */
        /* V1317 (fondateur 17/08) : la mention « — ou votre 1re livraison en abonnement » est RETIREE
           de l'ecran : « commande » couvre les deux cas, la precision mangeait le message. La regle
           commerciale ne change PAS (MNL10 vaut toujours en abo, 1re livraison seulement, cf. V1215
           ci-dessus) — ne pas reintroduire la mention sans redemander au fondateur. */
        MNL_T('global.exit_bigsub_html', '<span class="mnl-exit__big-sub">sur ta 1<sup>re</sup> commande d’au moins 39 €</span>') +
        MNL_T('global.exit_chip_html', '<span class="mnl-exit__chip">Code envoyé par e-mail</span>') +
        MNL_T('global.exit_note_html', '<p class="mnl-exit__note">Une offre réservée aux nouveaux clients.</p>') +
      '</div>' +
      '<div class="mnl-exit__right">' +
        '<div class="mnl-exit__brand">' +'<span class="mnl-exit__logo mnl-logo-v" aria-hidden="true"><svg viewBox="0 0 282 512" xmlns="http://www.w3.org/2000/svg"><path fill="#101418" d="M0 0L0 364L48 334L48 100L141 178L233 100L233 257L280 214L280 0L141 116ZM66 146L66 512L107 512L107 263L217 392L217 146L174 183L174 257L105 183ZM130 329L130 512L281 512L249 451L180 451L180 384Z"/></svg></span><span class="mnl-exit__brand-name">My<em>Nutri</em>Lab</span>'+
        '</div>' +
        MNL_T('global.exit_tag_html', '<span class="mnl-exit__tag">Avant de nous quitter</span>') +
        MNL_T('global.exit_title_html', '<h3 class="mnl-exit__title" id="mnl-exit-title">Un dernier boost<br>avant de partir ?</h3>') +
        MNL_T('global.exit_text_html', '<p class="mnl-exit__text">Inscris-toi et reçois ton code de réduction immédiatement par e-mail.</p>') +
        '<form class="mnl-exit__form" novalidate>' +
          '<input type="text" class="mnl-exit__hp" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;">' +
          '<div class="mnl-exit__field">' +
            '<span class="mnl-exit__field-ico" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg></span>' +
            MNL_T('global.exit_input_html', '<input type="email" class="mnl-exit__input" placeholder="ton.email@exemple.com" required maxlength="100" autocomplete="email" aria-label="Ton adresse e-mail">') +
          '</div>' +
          MNL_T('global.exit_submit_html', '<button type="submit" class="mnl-exit__btn">Recevoir mon code <span>−10 €</span></button>') +
        '</form>' +
        MNL_T('global.exit_secure_html', '<p class="mnl-exit__secure"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:0 0 auto"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Pas de spam. Désinscription en un clic. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Confidentialité</a></p>') +
        '<p class="mnl-exit__msg" role="status" aria-live="polite"></p>' +
      '</div>' +
    '</div>';
    document.body.appendChild(box);
    // V907 : verrou du scroll de la page tant que le popup est ouvert
    var _prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    // V907 : mémorise le focus courant pour le restaurer à la fermeture (a11y)
    var _prevFocus = document.activeElement;
    requestAnimationFrame(function () { box.classList.add('is-visible'); });

    function close() {
      _setExitDismissed(); // V907 : ne plus réafficher pendant 7 jours (fermeture OU inscription)
      box.style.opacity = '0';
      document.documentElement.style.overflow = _prevOverflow || '';
      document.removeEventListener('keydown', _escH);
      setTimeout(function () { box.remove(); }, 300);
      try { if (_prevFocus && _prevFocus.focus) _prevFocus.focus(); } catch (_) {}
    }
    // V907 : Échap ferme + Tab PIÉGÉ dans le popup (focus trap WCAG)
    var _escH = function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = Array.prototype.filter.call(
          box.querySelectorAll('button, a[href], input:not([type="hidden"]):not(.mnl-exit__hp)'),
          function (el) { return !el.disabled && (el.offsetWidth > 0 || el.offsetHeight > 0); }
        );
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', _escH);
    box.querySelector('.mnl-exit__close').addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });

    var _form = box.querySelector('.mnl-exit__form');
    var _input = box.querySelector('.mnl-exit__input');
    var _hp = box.querySelector('.mnl-exit__hp');
    var _consent = box.querySelector('.mnl-exit__consent-cb');
    var _msg = box.querySelector('.mnl-exit__msg');
    setTimeout(function () { try { _input.focus({ preventScroll: true }); } catch (_) {} }, 420);
    _input.addEventListener('input', function () { _input.classList.remove('is-invalid'); if (_msg) _msg.textContent = ''; });
    function _err(t) { if (_msg) { _msg.textContent = '' + t; _msg.style.color = '#fca5a5'; } if (_input) _input.classList.add('is-invalid'); }

    function _backup(email, reason) {
      try { var bk = JSON.parse(localStorage.getItem('mnl-nl-backup') || '[]'); bk.push({ email: email, ts: Date.now(), reason: reason }); localStorage.setItem('mnl-nl-backup', JSON.stringify(bk.slice(-50))); } catch (_) {}
    }

    // Révèle le code MNL10 (succès Klaviyo, ou best-effort si l'API est indispo — l'email reste sauvegardé en backup local)
    function _reveal() {
      var p = box.querySelector('.mnl-exit__box');
      if (!p) return;
      p.classList.add('is-reveal'); // V906 : état succès = colonne unique centrée (override du layout 2 colonnes)
      // V1216 : même correction que le pop-up newsletter — surface globale, aucune connaissance du panier.
      // « −10€ sur votre 1ère commande » se lisait comme « achat unique uniquement » devant un client
      // en train de prendre un abonnement, alors que MNL10 y ouvre droit sur la 1ʳᵉ livraison (et sur elle seule).
      p.innerHTML = MNL_T('global.exit_ok_close_html', '<button class="mnl-exit__close" aria-label="Fermer">×</button>') +
        '<div class="mnl-exit__icon"><svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:block;margin:0 auto"><path d="M12 3l1.7 4.8L18.5 9.5l-4.8 1.7L12 16l-1.7-4.8L5.5 9.5l4.8-1.7z"/><path d="M18.5 14l.7 2.1 2.1.7-2.1.7-.7 2.1-.7-2.1-2.1-.7 2.1-.7z"/></svg></div>' +
        MNL_T('global.exit_ok_title_html', '<h3 class="mnl-exit__title">C\'est dans la boîte !</h3>') +
        MNL_T('global.exit_ok_text_html', '<p class="mnl-exit__text">Ton code <strong>MNL10</strong> = −10&nbsp;€ sur ta 1ʳᵉ commande — valable aussi en abonnement (1ʳᵉ livraison). On te l\'envoie aussi par email.</p>') +
        '<div class="mnl-exit__code" data-code="MNL10">MNL10</div>' +
        '<a href="' + (window.MNL_PRODUCT_URL || '/products/pre-workout-mynutrilab-personnalisable-au-mg-pres') + MNL_T('global.exit_ok_cta_html', '?discount=MNL10" class="mnl-exit__btn">J\'utilise mon code</a>') +
        MNL_T('global.exit_ok_skip_html', '<button type="button" class="mnl-exit__skip">Plus tard</button>');
      p.querySelector('.mnl-exit__close').addEventListener('click', close);
      p.querySelector('.mnl-exit__skip').addEventListener('click', close);
      var c = p.querySelector('.mnl-exit__code');
      if (c) c.addEventListener('click', function () {
        try { navigator.clipboard.writeText('MNL10'); c.textContent = MNL_T('global.copied_check', '✓ Copié !'); setTimeout(function () { c.textContent = 'MNL10'; }, 1500); } catch (_) {}
        try { sessionStorage.setItem('mnl-promo-code', 'MNL10'); } catch (_) {}
        fetch('/discount/MNL10', { method: 'GET', credentials: 'same-origin' }).catch(function () {});
      });
      try {
        localStorage.setItem('mnl-exit-converted', '1');
        var ap = JSON.parse(localStorage.getItem('mnl-account-prefs') || '{}'); ap.newsletter = true; localStorage.setItem('mnl-account-prefs', JSON.stringify(ap));
      } catch (_) {}
      try { if (window.gtag) window.gtag('event', 'generate_lead', { source: 'exit_intent', currency: 'EUR', value: 10 }); } catch (_) {}
    }

    _form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (_hp && _hp.value) { _reveal(); return; } // honeypot rempli = bot → succès silencieux
      if ((Math.floor(Date.now() / 1000) - _exitTs) < 2) { _reveal(); return; } // submit < 2s = bot
      var email = (_input.value || '').trim().toLowerCase();
      if (!email) { _err(MNL_T('global.news_err_email_required', 'Email obligatoire')); _input.focus(); return; }
      var ok = window.mnlValidEmail ? window.mnlValidEmail(email) : /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email);
      if (!ok) { _err(MNL_T('global.exit_err_email_format', 'Format email invalide')); _input.focus(); return; }
      if (_consent && !_consent.checked) { _err(MNL_T('global.exit_err_consent', 'Coche la case de consentement')); return; }
      var sb = _form.querySelector('.mnl-exit__btn');
      // V907 : état CHARGEMENT visible (spinner + « Envoi… ») + anti double-soumission (bouton désactivé)
      if (sb) { if (sb.disabled) return; sb.disabled = true; sb.classList.add('is-loading'); sb.setAttribute('aria-busy', 'true'); sb.innerHTML = MNL_T('global.exit_sending_html', '<span class="mnl-exit__spin" aria-hidden="true"></span>Envoi…'); }
      var payload = { data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email, properties: { source: 'exit-intent' } } } }, custom_source: 'exit-intent' }, relationships: { list: { data: { type: 'list', id: 'Vb2fRV' } } } } };
      var kc = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var kt = kc ? setTimeout(function () { try { kc.abort(); } catch (_) {} }, 8000) : null;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XGJcGC', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(payload), signal: kc ? kc.signal : undefined
      }).then(function (r) {
        if (kt) clearTimeout(kt);
        if (r.status !== 202 && r.status !== 200) _backup(email, 'exit_klaviyo_' + r.status);
        _reveal();
      }).catch(function () {
        if (kt) clearTimeout(kt);
        _backup(email, 'exit_network');
        _reveal();
      });
    });
  }

  // Trigger DESKTOP : la souris quitte le haut du viewport (exit-intent), après ≥8s sur la page.
  document.addEventListener('mouseleave', function (e) {
    if (e.clientY <= 0 && !triggered) {
      if (performance && performance.now && performance.now() < 8000) return;
      show(true); // V1028 : vrai exit-intent — autorisé aussi sur les pages formule
    }
  });

})();

/* ════════ DETECT GEOLOC + AFFICHE FLAG (header optionnel) ════════ */
(function () {
  if (window.__mnlGeoInit) return;
  window.__mnlGeoInit = true;
  try {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    var flag = '', country = 'EU';
    if (tz.indexOf('Paris') !== -1) { flag = ''; country = 'FR'; }
    else if (tz.indexOf('Brussels') !== -1) { flag = ''; country = 'BE'; }
    else if (tz.indexOf('Geneva') !== -1 || tz.indexOf('Zurich') !== -1) { flag = ''; country = 'CH'; }
    else if (tz.indexOf('Luxembourg') !== -1) { flag = ''; country = 'LU'; }
    else if (tz.indexOf('Madrid') !== -1) { flag = ''; country = 'ES'; }
    else if (tz.indexOf('Rome') !== -1) { flag = ''; country = 'IT'; }
    else if (tz.indexOf('Berlin') !== -1) { flag = ''; country = 'DE'; }
    window.mnlGeo = { flag: flag, country: country, tz: tz };
  } catch (_) {}
})();

(function retireLegacyMnlServiceWorker() {
  var state = window.mnlServiceWorkerState = {
    supported: !!navigator.serviceWorker,
    cleanup: 'pending',
    removed: 0,
    protectedRegistrations: 0,
    legacyController: false
  };

  function isLegacy(worker) {
    if (!worker || !worker.scriptURL) return false;
    try {
      var url = new URL(worker.scriptURL, window.location.origin);
      return url.origin === window.location.origin && /\/mnl-sw\.js$/.test(url.pathname);
    } catch (_) { return false; }
  }

  function purgeLegacyCaches() {
    if (!window.caches) return Promise.resolve();
    return window.caches.keys().then(function (names) {
      return Promise.all(names.filter(function (name) {
        return name.indexOf('mnl-cache-') === 0 || name.indexOf('mnl-img-cache-') === 0 || name === 'mnl-notif-quota-v1';
      }).map(function (name) { return window.caches.delete(name); }));
    });
  }

  function cleanup() {
    Promise.resolve().then(function () {
      return navigator.serviceWorker.getRegistrations();
    }).then(function (registrations) {
      return Promise.all(registrations.map(function (registration) {
        var workers = [registration.active, registration.waiting, registration.installing].filter(Boolean);
        if (!workers.length || !workers.every(isLegacy)) {
          if (workers.some(isLegacy)) state.protectedRegistrations++;
          return;
        }
        return registration.unregister().then(function (removed) {
          if (removed) state.removed++;
        });
      }));
    }).then(purgeLegacyCaches).then(function () {
      state.legacyController = isLegacy(navigator.serviceWorker.controller);
      state.cleanup = state.protectedRegistrations ? 'partial' : 'complete';
    }).catch(function () {
      state.legacyController = isLegacy(navigator.serviceWorker.controller);
      state.cleanup = 'failed';
    });
  }

  if (!state.supported || typeof navigator.serviceWorker.getRegistrations !== 'function') {
    state.cleanup = 'unsupported';
    return;
  }
  state.legacyController = isLegacy(navigator.serviceWorker.controller);
  if (document.readyState === 'complete') setTimeout(cleanup, 2000);
  else window.addEventListener('load', function () { setTimeout(cleanup, 2000); }, { once: true });
})();

(function networkStatus() {
  window.addEventListener('online', function () {
    if (window.mnlToast) window.mnlToast({ icon: '', title: MNL_T('global.net_back_online_title', 'De retour en ligne'), type: 'success' });
  });
  window.addEventListener('offline', function () {
    if (window.mnlToast) window.mnlToast({
      icon: '',
      title: MNL_T('global.net_offline_title', 'Hors ligne'),
      sub: MNL_T('global.net_offline_retry', 'Connexion interrompue. Réessaie tes actions lorsque le réseau est rétabli.'),
      type: 'info'
    });
  });
})();

/* V626 : « Challenge du jour » RETIRÉ — toast quotidien type quête gamer (« 50 pompes (+25 pts) », « Parraine 1 ami (+500 pts) », « Story Insta (+100 pts) ») avec des points fictifs (aucun backend). Non-premium + trompeur. */

/* ════════ BIRTHDAY DETECTION (offer -20% on customer birthday) ════════ */
(function () {
  if (window.__mnlBdayInit) return;
  window.__mnlBdayInit = true;})();

/* ════════ FREE SHIPPING PROGRESS (auto inject in cart drawer) ════════ */
(function () {
  if (window.__mnlShipProgInit) return;
  window.__mnlShipProgInit = true;
  var THRESHOLD = 4900; // 49€ in cents

  function inject() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price || 0;
        var pct = Math.min(100, (total / THRESHOLD) * 100);
        var remaining = Math.max(0, THRESHOLD - total) / 100;

        // Find cart drawer if any
        var targets = document.querySelectorAll('cart-drawer, .cart-drawer, [data-cart-drawer], #CartDrawer, .drawer__inner');
        if (!targets.length) return;

        targets.forEach(function (target) {
          // Remove existing
          var existing = target.querySelector('.mnl-ship-prog');
          if (existing) existing.remove();

          var bar = document.createElement('div');
          bar.className = 'mnl-ship-prog' + (pct >= 100 ? ' is-unlocked' : '');
          var topText = pct >= 100
            ? MNL_T('global.shipbar_unlocked_html', '<span><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-2px;margin-right:4px"><path d="M12 3l1.7 4.8L18.5 9.5l-4.8 1.7L12 16l-1.7-4.8L5.5 9.5l4.8-1.7z"/></svg>Point relais offert débloqué !</span><span>≥ 49€</span>')
            : MNL_T('global.shipbar_remaining_prefix_html', '<span>Plus que <strong>') + remaining.toFixed(2) + MNL_T('global.shipbar_remaining_suffix_html', '€</strong> pour le point relais offert</span><span>') + Math.round(pct) + '%</span>';
          bar.innerHTML = '<div class="mnl-ship-prog__top">' + topText + '</div>' +
            '<div class="mnl-ship-prog__bar"><div class="mnl-ship-prog__fill" style="width:' + pct + '%"></div></div>';

          // Insert at top of drawer content
          var firstChild = target.firstElementChild;
          if (firstChild) target.insertBefore(bar, firstChild);
          else target.appendChild(bar);
        });
      }).catch(function () {});
  }

  // Run on load + on cart updates
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(inject, 600);
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(inject, 600); });
  }
  document.addEventListener('cart:updated', inject);
  document.addEventListener('mnl:cart:updated', inject);
  // Vague 56 : écoute l'event central mnl:cart:mutated (au lieu de wrapper fetch ici — doublon avant).
  document.addEventListener('mnl:cart:mutated', function(){ setTimeout(inject, 300); });
})();

/* ════════════════════════════════════════════════════════════════════
   V248.1 ROLLBACK — NProgress top bar désactivée
   Raison : peut intercepter des clicks sur des liens qui devraient ouvrir
   un drawer/modal au lieu de naviguer (cart, AI overlay, etc.), causant
   un "stuck loading bar" visible. À réactiver plus tard avec exclusions
   précises via [data-mnl-no-nprogress] sur les liens spéciaux.
   ════════════════════════════════════════════════════════════════════ */

/* ════════════════════════════════════════════════════════════════════
   V234 — MOBILE FLOATING CTA (site-wide conversion booster)
   ════════════════════════════════════════════════════════════════════
   Apparait sur mobile uniquement, après scroll > 500px, sur les pages NON-produit
   (la PDP a son propre sticky-atc snippet). Objectif : capturer les visiteurs
   sociale qui scrollent la home/blog/collection sans voir de CTA persistant.

   Conditions d'apparition :
     - matchMedia max-width 720px OU pointer:coarse
     - Path NE commence PAS par /products/ ou /cart ou /checkouts ou /account
     - Cart vide (count = 0 — si déjà des articles, l'user est en cours d'achat)
     - sessionStorage 'mnl-mcta-dismissed' != '1'
     - sessionStorage 'mnl-mcta-clicked' != '1' (anti-spam : ne réapparait pas si déjà cliqué)
     - prefers-reduced-motion respecté

   Dismissable via × (sticky session). Auto-hide si user ouvre AI chat ou drawer cart.
   ════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__mnlMobileCtaInit) return;
  window.__mnlMobileCtaInit = true;

  function shouldShow() {
    // 1. Mobile only
    var isMobile = (window.matchMedia && window.matchMedia('(max-width: 720px), (pointer: coarse)').matches) || window.innerWidth < 720;
    if (!isMobile) return false;
    // 2. Skip pages avec leur propre CTA fixe ou en flow d'achat
    var path = (window.location.pathname || '').toLowerCase();
    var skipPaths = ['/products/', '/cart', '/checkouts/', '/checkout', '/account', '/policies/', '/admin'];
    if (skipPaths.some(function (p) { return path.indexOf(p) === 0; })) return false;
    // V999u (bug hunt) : les 14 pages formule ont LEUR propre barre d'achat sticky (z 9990) — la pastille (z 99988) la recouvrait et masquait prix + Ajouter au panier.
    if (path.indexOf('/pages/formule-') === 0) return false;
    // 3. Skip si dismissed/clicked cette session
    try {
      if (sessionStorage.getItem('mnl-mcta-dismissed') === '1') return false;
      if (sessionStorage.getItem('mnl-mcta-clicked') === '1') return false;
    } catch (_) {}
    // 4. Skip si cart pas vide (user en cours achat → on ne re-pousse pas)
    try {
      var cartCount = parseInt(localStorage.getItem('mnl-cart-count') || '0', 10);
      if (cartCount > 0) return false;
    } catch (_) {}
    return true;
  }

  function buildCta() {
    if (document.getElementById('mnl-mobile-cta')) return;

    var productUrl = window.MNL_PRODUCT_URL || '/products/pre-workout-mynutrilab-personnalisable-au-mg-pres';
    // Append ?open=picker pour ouvrir direct le configurateur quand on arrive sur la PDP
    var ctaUrl = productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'open=picker&utm_source=mnl-mobile-cta';

    var bar = document.createElement('div');
    bar.id = 'mnl-mobile-cta';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', MNL_T('global.mcta_label', 'Configurer ta formule'));
    bar.style.cssText = [
      'position:fixed',
      'bottom:14px',
      'left:50%',
      'transform:translateX(-50%) translateY(140%)',
      'z-index:99988', /* below cookie banner (99999) et notif center mais au-dessus du contenu */
      'display:flex',
      'align-items:center',
      'gap:10px',
      'padding:9px 12px 9px 14px',
      'background:#ffffff',
      'color:#0f172a',
      'border-radius:100px',
      'box-shadow:0 14px 40px rgba(15,23,42,.20),0 3px 10px rgba(15,23,42,.10)',
      'font-family:"DM Sans",-apple-system,sans-serif',
      'font-size:13px',
      'font-weight:700',
      'max-width:calc(100vw - 28px)',
      'border:1px solid #E5E8EC', /* V1037 : charte Coach */
      'transition:transform .45s cubic-bezier(.34,1.56,.64,1),opacity .3s ease',
      'opacity:0'
      /* V1266 : la déclaration will-change (transform + opacity) est RETIRÉE
         (11/11 du recensement, voir mnl-motion.css §8.2). Ce bandeau reste
         affiché tant que l'acheteur ne le ferme pas : la couche GPU vivait donc
         aussi longtemps que la page, alors que la seule animation est le montage
         (450 ms, une fois). */
    ].join(';');

    bar.innerHTML =
      '<a href="' + ctaUrl + '" data-mnl-mcta-link style="display:inline-flex;align-items:center;gap:11px;text-decoration:none;color:#0f172a;flex:1;min-width:0;padding:4px 0;">' +
        '<span aria-hidden="true" style="flex-shrink:0;background:#101418;width:34px;height:34px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;box-shadow:0 2px 7px rgba(16,20,24,.25);">' + /* V1037 : charte Coach */
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="4" x2="14" y2="4"/><line x1="10" y1="4" x2="3" y2="4"/><line x1="21" y1="12" x2="12" y2="12"/><line x1="8" y1="12" x2="3" y2="12"/><line x1="21" y1="20" x2="16" y2="20"/><line x1="12" y1="20" x2="3" y2="20"/><line x1="14" y1="2" x2="14" y2="6"/><line x1="8" y1="10" x2="8" y2="14"/><line x1="16" y1="18" x2="16" y2="22"/></svg>' +
        '</span>' +
        '<span style="display:flex;flex-direction:column;line-height:1.2;min-width:0;flex:1;">' +
          MNL_T('global.mcta_title_html', '<span style="font-size:13px;font-weight:900;letter-spacing:-.01em;color:#0f172a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">Configure ta formule</span>') +
          MNL_T('global.mcta_sub_html', '<span style="font-size:10.5px;font-weight:600;color:#1a1a1a;letter-spacing:.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">Coach IA · relais offert dès 49€</span>') + /* V1037 : charte Coach */
        '</span>' +
        '<span aria-hidden="true" style="flex-shrink:0;padding-right:4px;display:inline-flex;"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#101418" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></span>' + /* V1037 : charte Coach */
      '</a>' +
      MNL_T('global.mcta_close_html', '<button type="button" data-mnl-mcta-close aria-label="Masquer le bouton" style="background:rgba(15,23,42,.06);border:0;color:#94a3b8;cursor:pointer;width:24px;height:24px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;padding:0;line-height:1;"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button>');

    try { document.body.appendChild(bar); } catch (_) { return; }

    // Mount animation (RAF pour vraie transition)
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bar.style.opacity = '1';
        bar.style.transform = 'translateX(-50%) translateY(0)';
      });
    });

    // Track click → marque clicked pour pas re-spam dans la session + analytics
    bar.querySelector('[data-mnl-mcta-link]').addEventListener('click', function () {
      try { sessionStorage.setItem('mnl-mcta-clicked', '1'); } catch (_) {}
      try { if (window.gtag) window.gtag('event', 'mnl_mobile_cta_click', { page_path: window.location.pathname }); } catch (_) {}
    });

    // Dismiss button
    bar.querySelector('[data-mnl-mcta-close]').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      try { sessionStorage.setItem('mnl-mcta-dismissed', '1'); } catch (_) {}
      bar.style.opacity = '0';
      bar.style.transform = 'translateX(-50%) translateY(140%)';
      setTimeout(function () { try { bar.remove(); } catch (_) {} }, 350);
      try { if (window.gtag) window.gtag('event', 'mnl_mobile_cta_dismiss', {}); } catch (_) {}
    });

    // Auto-hide quand AI chat ou cart drawer s'ouvre (évite superposition)
    document.addEventListener('mnl:ai:opened', hideTemp);
    document.addEventListener('mnl:cart:opened', hideTemp);
    function hideTemp() {
      bar.style.opacity = '0';
      bar.style.transform = 'translateX(-50%) translateY(140%)';
      bar.style.pointerEvents = 'none';
    }
    document.addEventListener('mnl:ai:closed', showAgain);
    document.addEventListener('mnl:cart:closed', showAgain);
    function showAgain() {
      if (!shouldShow()) return;
      bar.style.opacity = '1';
      bar.style.transform = 'translateX(-50%) translateY(0)';
      bar.style.pointerEvents = '';
    }
  }

  function destroyCta() {
    var el = document.getElementById('mnl-mobile-cta');
    if (el) el.remove();
  }

  function init() {
    if (!shouldShow()) return;
    var shown = false;

    function maybeShow() {
      if (shown) return;
      if (window.scrollY > 500) {
        shown = true;
        buildCta();
        window.removeEventListener('scroll', maybeShow);
      }
    }
    window.addEventListener('scroll', maybeShow, { passive: true });
    // Si la page est déjà scrollée au load (back-navigation), check immédiat
    setTimeout(maybeShow, 800);

    // Si cart évolue (user ajoute via AI ou ailleurs) → destroy le CTA car objectif atteint
    document.addEventListener('mnl:cart:mutated', function () {
      try {
        var c = parseInt(localStorage.getItem('mnl-cart-count') || '0', 10);
        if (c > 0) destroyCta();
      } catch (_) {}
    });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(init, 600);
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 600); });
  }
})();


/* ═══ V984 — MOTION SYSTEM : reveal en cascade au scroll ═══
   Pose data-mnl-reveal sur les cartes/blocs listés puis les révèle à l'entrée du viewport
   (stagger 55ms par vague de 6). html.mnl-motion gate l'opacité 0 → sans JS, tout reste
   visible. Les éléments déjà dans le viewport à l'init sont révélés immédiatement (pas de
   flash), et un garde-fou 4s révèle tout ce qu'un IO défaillant aurait oublié. */
(function(){
  try {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var SEL = [
      '.mnl-obj__card', '.mnl-formulas__card', '.mnl-prodcards__card', '.mnl-prodcards__media',
      '.mnl-pp3-persona', '.mnl-pp3-gloss-card', '.mnl-pp3-study', '.mnl-pp3-pillar',
      '.mnl-faq__item', '.mnl-how__step', '.mnl-actus__card', '.mnl-fhub__card',
      '.mnl-sport__ing-card', '.mnl-why-card'
    ].join(',');
    var els = Array.prototype.slice.call(document.querySelectorAll(SEL));
    if (!els.length) return;
    document.documentElement.classList.add('mnl-motion');
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function(el, i){
      el.setAttribute('data-mnl-reveal', '');
      el.style.setProperty('--mnl-reveal-delay', ((i % 6) * 55) + 'ms');
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) {
        // déjà visible à l'init → reveal immédiat (léger fondu d'entrée, pas d'attente IO)
        requestAnimationFrame(function(){ el.classList.add('is-in'); });
      } else {
        io.observe(el);
      }
    });
    // Garde-fou : rien ne doit JAMAIS rester invisible
    setTimeout(function(){
      document.querySelectorAll('[data-mnl-reveal]:not(.is-in)').forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight || 800)) el.classList.add('is-in');
      });
    }, 4000);
  } catch(_){}
})();
